import { getStoreExperience as R, useSocial as Te, useUserStore as O, RoundButton as B, setUser as le, getUser as $, LabelInput as W, useStoreExperience as z, useStoreHUD as ie, setStoreHUD as oe, getPlayersStore as on, BorderButton as ui, SCENE_AUDIO_LIST as an, getStoreHUD as Ls, socialTunnel as hi, SimpleTextButton as et, LabelButton as sn, playerDidControl as fi, setStoreExperience as tt, inactivityDrag as Is, postMessageById as $s, structuredCloneSafe as Ts, IconArrow as mi, getURLRoot as gi, PostItSharingEditModal as Ns, Whiteboard as As } from "@utsubo/experience";
import { shallow as rn } from "zustand/shallow";
import { create as ln } from "zustand";
import { css as xi, createGlobalStyle as Es, styled as l, ThemeProvider as Ds, keyframes as bt, StyleSheetManager as zs } from "styled-components";
import { useEffect as w, useState as m, useRef as k, forwardRef as wt, useContext as Q, createContext as Be, useMemo as Y, Suspense as q, useCallback as ee, createRef as Ps, memo as ce, useLayoutEffect as ue, lazy as _s } from "react";
import { jsx as t, jsxs as d, Fragment as T } from "react/jsx-runtime";
import { useTranslation as x, useStoreI18n as ve, useLanguageProvider as js, getStoreI18n as ae, setStoreI18n as Fs } from "@utsubo/i18n";
import { getRealtime as he, useRealtime as yt, useStoreTencent as We, sendEmoji as Os, getStorePeers as cn, sendPaintColor as Bs, setRealtime as Us, sendPaintSize as Rs, useStorePeers as Ce, getStoreTencent as Hs, sendChat as Ws } from "@utsubo/realtime";
import { useSafeExternalImgUrl as Ne, shared as Ae, useStoreUbo as Vs, FaceTracking as Zs, setStoreRenderer as Ve, useDetectDevice as nt, useVideoStore as vi, useStoreRenderer as Gs, setVideo as qs } from "@utsubo/renderer";
import { useEvent as j, emitEvent as b, onEvent as Ct, offEvent as kt } from "@utsubo/events";
import * as bi from "react-device-detect";
import { suspend as dn } from "suspend-react";
import { useThirdPersonStore as pn, getThirdPersonStore as St, teleportPlayer as Ys, setThirdPersonStore as wi, usePhysicStore as yi, offsetScalerMin as Ks, offsetScalerMax as Js, getPhysic as Mt } from "@utsubo/oni";
import * as it from "three";
import { Vector3 as Lt } from "three";
import fe, { Toaster as Xs } from "react-hot-toast";
import { createPortal as Qs } from "react-dom";
import { subscribeWithSelector as er } from "zustand/middleware";
import { getStoreUI as ot, useStoreUI as Ee, setStoreUI as ke, setLocalStorage as tr, assets as nr } from "@utsubo/ui";
import { useGesture as Ci } from "@use-gesture/react";
import ir from "js-confetti";
import { ResponsiveContainer as un, AreaChart as ki, ReferenceLine as hn, Tooltip as Si, XAxis as Mi, YAxis as Li, Area as fn, BarChart as or, Bar as Ii } from "recharts";
const ar = process.env.NODE_ENV || "development", Ue = ar === "development", $i = Ue ? "https://billing.stripe.com/p/login/test_28o01ubRVgxZd7WcMM" : "https://billing.stripe.com/p/login/8wM8xy0HOcpE6iI9AA", Ti = Ue ? "prod_O0Mn9jZ8A1pZuj" : "prod_O0MO3JiLD6SUIY", sr = Ue ? "price_1NEM4GFzvnhAZiSUgcnZdcOL" : "price_1NELg7FzvnhAZiSUZ0DpID9l", rr = "", Ni = Ue ? "prod_O0MpGRAJXHMnXN" : "prod_O0MRvQaAwyirLG", lr = Ue ? "price_1NEM5RFzvnhAZiSUu9cM6SJ0" : "price_1NELirFzvnhAZiSUpI26yrK8", cr = "", dr = [{ label: "English", value: "en-US" }, { label: "Japanese", value: "ja-JP" }, { label: "Francais", value: "fr-FR" }], pr = [{ label: "USD", value: "USD" }, { label: "JPY", value: "JPY" }, { label: "EUR", value: "EUR" }], Ai = [{ id: "light", tier: 0, name: "light-plan", desc: "light-plan-desc", productId: Ti, monthlyPriceId: sr, yearlyPriceId: rr, audioCall: true, videoCall: false, screenShare: false, maxMembers: 20, maxGuests: 5, maxOffices: 1, maxStorage: 5120, maxFileSizePerUpload: 50, featuresList: [["up-to-members", { members: 20 }], "unlimited-audio", "one-office", ["guest-simultaneous", { guests: 5 }], ["storage-file", { size: 5 }]] }, { id: "standard", tier: 1, name: "standard-plan", desc: "standard-plan-desc", productId: Ni, monthlyPriceId: lr, yearlyPriceId: cr, audioCall: true, videoCall: true, screenShare: true, maxMembers: 50, maxGuests: 20, maxOffices: 3, maxStorage: 20480, maxFileSizePerUpload: 250, featuresList: [["up-to-members", { members: 50 }], "unlimited-audio-video", ["up-to-offices", { offices: 3 }], ["guest-simultaneous", { guests: 20 }], ["storage-file", { size: 20 }]] }], be = (e) => Ai.find((n) => n.productId === e), ur = (e) => ["visa", "mastercard", "amex", "discover", "jcb", "diners", "cirrus", "maestro"].includes(e), hr = 7, fr = 7, mr = 9, gr = 9, xr = 10, vr = 10, br = 12, wr = 12, yr = 1e3, Cr = 1e3, kr = 1250, Sr = 1250, Mr = 1400, Lr = 1400, Ir = 1700, $r = 1700, Ei = { "office-light-plan-yearly": hr, "office-light-plan-monthly": fr, "office-standard-plan-yearly": xr, "office-standard-plan-monthly": vr, "office-light-plan-yearly-full": mr, "office-light-plan-monthly-full": gr, "office-standard-plan-yearly-full": br, "office-standard-plan-monthly-full": wr }, Tr = { "office-light-plan-yearly": yr, "office-light-plan-monthly": Cr, "office-standard-plan-yearly": Mr, "office-standard-plan-monthly": Lr, "office-light-plan-yearly-full": kr, "office-light-plan-monthly-full": Sr, "office-standard-plan-yearly-full": Ir, "office-standard-plan-monthly-full": $r }, Nr = (e) => {
  switch (e) {
    case "USD":
      return Ei;
    case "JPY":
      return Tr;
    default:
      return Ei;
  }
}, Ar = (e) => {
  switch (e) {
    case "USD":
      return "$";
    case "JPY":
      return "¥";
    case "EUR":
      return "€";
    default:
      return "$";
  }
}, Di = (e, n, i, o) => {
  C((a) => {
    const s = a.gongsData[e].reactions[i] || { total: 0, [n]: 0 }, r = s[n] || 0;
    return a.gongsData[e].seen.includes(n) || a.gongsData[e].seen.push(n), { gongsData: { ...a.gongsData, [e]: { ...a.gongsData[e], reactions: { ...a.gongsData[e].reactions, [i]: { ...s, total: s.total + o, [n]: r + o } } } } };
  });
}, zi = "password", Er = "guest", Dr = "login", mn = /* @__PURE__ */ ln((e, n) => ({ forceShowLoader: false, hiderLoading: process.env.NODE_ENV !== "development", riggedOn: true, cameraOnMeeting: false, screenShareEnabled: true, openModal: "", simpleModalOpened: null, blockSendMessage: false, socialBarOpened: false, openChat: false, lastQuickEmoji: 3, hideUI: process.env.NODE_ENV !== "development", renderEmoji: false, adminPanelOpen: false, mediaDeviceShared: false, waitingScreen: false, showGateModal: false, accessType: zi, hideHighlightTooltip: false, isDemo: false, convsList: [], currentConvId: "", unreadDM: {}, incrementReaction: Di, convsData: {}, isOnline: true, serverErrors: [], showSpinnerLoader: false, showTutorial: false, tutorialMove: false, showJoystickTutorial: false, subMenuOffice: "", chatOfficeFullscreen: false, showCameraQuickSettings: false, showContextMenu: null, setWorkspaceDoc: (i) => {
  if (i) {
    let { productId: o } = i;
    process.env.NODE_ENV === "production" && o === "prod_O0MpGRAJXHMnXN" && (o = "prod_O0MRvQaAwyirLG");
    const a = /* @__PURE__ */ be(o);
    i.plan = a, e({ workspaceDoc: i });
  }
}, sharedFiles: [], notificationQueue: [] })), S = (e, n) => mn(e, n || rn);
Object.assign(S, mn);
const { getState: N, setState: C } = mn, zr = [{ keys: ["Enter"], fn: () => {
  R().focusingInput || setTimeout(() => {
    C({ openChat: true, showControlModal: false });
  });
}, up: false }], Pi = { colors: { primary: "#fff", highlight: "#093cbe" }, fonts: { default: 'Open Sans, "Helvetica Neue", Helvetica, Arial, sans-serif', secondary: 'Mundial, "Helvetica Neue", Helvetica, Arial, sans-serif' }, opacityUI: 0.7, headline3: `font-size: 18px;
              line-height: 25px;
              letter-spacing: 0.1em;`, headline4: `font-size: 16px;
              line-height: 30px;
              letter-spacing: 0.1em;`, headline5: `font-weight: 600;
              font-size: 12px;
              line-height: 12px;`, bodyText1: `font-weight: 600;
              font-size: 13px;
              line-height: 18px;
              letter-spacing: 0.03em;`, bodyText2: `font-weight: 600;
              font-size: 11px;
              line-height: 18px;
              letter-spacing: 0.03em;`, bodyText3: `font-size: 11px;
              line-height: 15px;
              letter-spacing: 0.03em;`, bodyText4: `font-size: 9px;
              line-height: 12px;
              letter-spacing: 0.03em;` }, Pr = xi`
  body {
    background: transparent;
    // background: #2d2d2d;
    color: ${(e) => e.theme.colors.primary};
    font-family: ${(e) => e.theme.fonts.default};
    touch-action: manipulation;
    overflow: hidden;
  }

  body.hideCursor {
    cursor: none;
  }

  .secfont {
    font-family: ${(e) => e.theme.fonts.secondary};
  }

  :root {
    --app-height: 100vh;
  }
  ::before,
  ::after,
  * {
    box-sizing: border-box;
  }

  * {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-tap-highlight-color: transparent;
  }

  input,
  textarea {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section {
    display: block;
  }
  *[hidden] {
    display: none;
  }
  body {
    line-height: 1.5;
  }
  menu,
  ol,
  ul,
  li {
    list-style: none;
    list-style-type: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  b,
  strong {
    font-weight: bolder;
  }
  select {
    text-transform: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  button {
    cursor: pointer;
    background: transparent;
    background-image: none;
  }
  button:focus {
    outline: 0;
  }
  ::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }
  img,
  video {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  @supports (padding: max(0px)) {
    body,
    header,
    footer {
      padding-left: min(0vmin, env(safe-area-inset-left));
      padding-right: min(0vmin, env(safe-area-inset-right));
    }
  }

  .abs-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  input:focus {
    outline: none;
  }

  a:active,
  a:focus,
  a:visited,
  a {
    color: #fff;
    text-decoration: none;
  }

  h3 {
    font-family: ${(e) => e.theme.fonts.secondary};
    ${(e) => e.theme.headline3}
  }

  h4 {
    ${(e) => e.theme.headline4}
    font-family: ${(e) => e.theme.fonts.secondary};
  }

  h5 {
    ${(e) => e.theme.headline5}
  }

  p {
    ${(e) => e.theme.bodyText2}
  }

  button {
    color: ${(e) => e.theme.colors.primary};
  }

  /* Fix safari lazy loading images alt is displayed */
  img {
    font-size: 0;
    border: 0;
    outline: 0;
    clip-path: inset(1px);
    user-select: none;
  }

  .flx-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .w-100 {
    width: 100%;
  }

  .pb-30 {
    padding-bottom: 30px;
  }

  textarea {
    outline: none;
    border: none;
  }

  .secFontTxtXs {
    font-family: ${(e) => e.theme.fonts.secondary};
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
  }

  .secFontTxtSml {
    font-family: ${(e) => e.theme.fonts.secondary};
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;
  }

  .secFontTxtSmlLight {
    font-family: ${(e) => e.theme.fonts.secondary};
    font-weight: 200;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1em;
  }

  .secFontTxtMed {
    font-family: ${(e) => e.theme.fonts.secondary};
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.04em;
  }

  .secFontTxtBig {
    font-family: ${(e) => e.theme.fonts.secondary};
    font-weight: 600;
    font-size: 19px;
    line-height: 26px;
    letter-spacing: 0.1em;
  }

  .normalTxt {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.03em;
  }

  .markdown {
    a {
      color: #f33182;
      text-decoration: underline;
      @media all and (pointer: fine) {
        transition: opacity 0.2s ease;
        &:hover {
          opacity: 0.7;
        }
      }
    }

    em {
      font-style: italic;
    }

    code {
      color: #ffc400;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 0.05em;
      background: #1e1e1e;
      border-radius: 5px;
      padding: 2px 5px;
      border: 1px solid #444;
    }

    ul,
    ol {
      padding: 0 0 0 15px;
    }

    ul {
      li {
        list-style: disc;
      }
    }

    ol {
      li {
        padding: 0 0 0 10px;
        list-style: decimal;
        &::marker {
          margin: 0;
        }
      }
    }
  }
`, _i = Es`${Pr}`, ji = () => (w(() => {
  const e = document.head, n = /* @__PURE__ */ document.createElement("link"), i = /* @__PURE__ */ document.createElement("link");
  return n.type = "text/css", n.rel = "stylesheet", n.href = "https://use.typekit.net/hfl0mlj.css", i.type = "text/css", i.rel = "stylesheet", i.href = "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&display=swap", e.appendChild(n), e.appendChild(i), () => {
    e.removeChild(n), e.removeChild(i);
  };
}, []), null), M = new Proxy({}, { get(e, n) {
  return "https://cdn.utsubo.io/ui/0-0-268" + (n.startsWith("/") ? n : "/" + n);
} }), Fi = () => {
  const { t: e } = /* @__PURE__ */ x("office"), [n] = /* @__PURE__ */ S((a) => [a.notificationQueue]), [i, o] = /* @__PURE__ */ Te((a) => [a.isElectron, a.send]);
  return w(() => {
    if (!("Notification" in window) || !n.length || !n.length)
      return;
    const a = /* @__PURE__ */ n.slice(0);
    C({ notificationQueue: [] }), a.forEach(async ({ title: s, body: r, params: c }) => {
      await Notification.requestPermission();
      const p = new Notification(e(s, c), { body: e(r, c), icon: M["/icons/notification-icon.png"], image: M["/icons/notification-icon.png"] });
      p.addEventListener("click", () => {
        window.focus(), p.close(), i && o("focus");
      });
    });
  }, [n]), null;
}, we = ({ label: e, tr: n = "office" }) => {
  const { t: i } = /* @__PURE__ */ x(n);
  return t(_r, { className: "error", children: i(e) });
}, _r = l.p`
  color: #f33182;
  font-size: 12px;
`;
function jr({ mic: e }) {
  const [n, i] = /* @__PURE__ */ m(null), o = /* @__PURE__ */ k(null);
  return w(() => {
    async function a() {
      if (e) {
        const s = { audio: { deviceId: { exact: e } } };
        try {
          const r = await navigator.mediaDevices.getUserMedia(s);
          he().userMediaUpdate(true), i(r);
        } catch (r) {
          he().userMediaUpdate(true), console.log("Error getting user media:", r);
        }
      } else
        i(null);
    }
    a();
  }, [e]), w(() => {
    if (n) {
      const a = new AudioContext(), s = /* @__PURE__ */ a.createMediaStreamSource(n), r = /* @__PURE__ */ a.createAnalyser();
      s.connect(r);
      const c = o.current, p = /* @__PURE__ */ c.getContext("2d"), u = () => {
        const h = r.frequencyBinCount, f = new Uint8Array(h);
        r.getByteFrequencyData(f);
        let v = c.width;
        const g = c.height;
        p.fillStyle = "#424242", p.fillRect(0, 0, c.width, c.height), p.fillStyle = "#49E162", v = f[0] * 2, p.fillRect(0, 0, v, g), requestAnimationFrame(u);
      };
      u();
    }
  }, [n]), t(Fr, { ref: o });
}
const Fr = l.canvas`
  width: 100%;
  height: 100%;
  border-radius: 99px;
`, gn = ({ kind: e, label: n, type: i, selected: o, icon: a, accessAllowed: s }) => {
  const { t: r } = /* @__PURE__ */ x("common"), [c, p] = /* @__PURE__ */ m([]);
  w(() => {
    async function h() {
      const v = /* @__PURE__ */ (await navigator.mediaDevices.enumerateDevices()).filter((g) => g.kind === e);
      p(v);
    }
    return navigator.mediaDevices.addEventListener("devicechange", h), h(), () => {
      navigator.mediaDevices.removeEventListener("devicechange", h);
    };
  }, [s, e]);
  const u = /* @__PURE__ */ We((h) => h.changeDevice);
  return d(Vr, { className: `${c.length > 0 ? "active" : ""}`, children: [t("img", { src: M[`/icons/select-${a}.svg`], alt: a }), c.length > 0 ? d("select", { defaultValue: o || "default", onClick: (h) => {
    s || (h.preventDefault(), navigator.mediaDevices.getUserMedia({ [i === "video" ? "video" : "audio"]: true }).then((f) => {
      he().userMediaUpdate(i !== "video", i === "video");
    }));
  }, onChange: (h) => {
    le({ media: { ...$().media, [i]: h.target.value } }), localStorage.setItem(`preferred${i}`, h.target.value), u(i, e, h.target.value);
  }, children: [c.length === 0 ? t("option", { value: "", children: r(n) }) : null, c.map((h) => t("option", { value: h.deviceId, children: h.label }, h.deviceId))] }) : null, t("svg", { width: "9", height: "7", viewBox: "0 0 9 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t("path", { d: "M1.05859 1.8335L4.47018 5.34846L7.88177 1.8335", stroke: "white", strokeWidth: "1.64706", strokeLinecap: "round", strokeLinejoin: "round" }) })] });
}, Or = ({ camera: e }) => {
  const [n, i] = /* @__PURE__ */ m(null), o = /* @__PURE__ */ k(null);
  return w(() => {
    async function a() {
      if (e) {
        const s = { video: { deviceId: { exact: e } } };
        try {
          const r = await navigator.mediaDevices.getUserMedia(s);
          he().userMediaUpdate(false, true), i(r);
        } catch (r) {
          console.error("Error getting user media:", r);
        }
      } else
        i(null);
    }
    a();
  }, [e]), w(() => {
    n && (o.current.srcObject = n);
  }, [n]), t(Ur, { children: n ? t("div", { ref: o }) : null });
}, Oi = ({ camera: e, mic: n, speaker: i }) => {
  const [o, a] = /* @__PURE__ */ yt((s) => [s.audioAccessEnabled, s.videoAccessEnabled]);
  return d(Hr, { className: "dsl", children: [t(gn, { kind: "videoinput", type: "video", icon: "camera", label: "select_camera", selected: e, accessAllowed: a }), t(gn, { kind: "audiooutput", type: "speaker", icon: "speaker", label: "select_speaker", selected: i, accessAllowed: o }), t(gn, { icon: "mic", type: "mic", kind: "audioinput", label: "select_mic", selected: n, accessAllowed: o })] });
}, Bi = ({ fromGateModal: e = true, action: n }) => {
  const { t: i } = /* @__PURE__ */ x("common"), [o, a, s] = /* @__PURE__ */ O((g) => [g.media.mic, g.media.speaker, g.media.video]);
  console.log("mic", o);
  const [r, c] = /* @__PURE__ */ m(false), [p, u] = /* @__PURE__ */ m(false), h = async () => {
    try {
      const g = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      he().userMediaUpdate(true, true);
      const y = await navigator.mediaDevices.enumerateDevices(), L = /* @__PURE__ */ y.filter((E) => E.kind === "videoinput"), I = /* @__PURE__ */ y.filter((E) => E.kind === "audioinput"), A = /* @__PURE__ */ y.filter((E) => E.kind === "audiooutput");
      le({ media: { video: L[0].deviceId, mic: I[0].deviceId, speaker: A[0].deviceId } }), console.log("Media stream received:", g), u(true), C({ mediaDeviceShared: true }), c(true);
    } catch (g) {
      console.log("Error requesting user media:", g), u(false);
    }
  };
  w(() => {
    r || h();
  }, [r]);
  const [f, v] = /* @__PURE__ */ m(false);
  return w(() => {
    setTimeout(() => {
      v(true);
    }, 1);
  }, []), d(T, { children: [d(Br, { className: f ? "show" : "", children: [t(Or, { camera: s }), d(Rr, { children: [t("p", { className: "secfont", children: i("mic_tester") }), t(Wr, { children: o ? t(jr, { mic: o }) : null })] })] }), t(Vi, { children: d(Zr, { className: f ? "show" : "", children: [t(te, { title: "audio_video_setup", desc: "audio_video_setup_desc" }), t(Oi, { camera: s, mic: o, speaker: a }), t("div", { className: "rb", children: t(B, { label: e ? "next" : "close", onClick: n, cls: "white", arrow: e }) })] }) })] });
}, Br = l.div`
  display: flex;
  flex-direction: column;
  width: 412px;
  background: #333333;

  transform: translate3d(-100%, 0, 0);
  transition: transform 0.3s ease 0s;

  @media all and (max-width: 860px) {
    width: 350px;
  }

  @media all and (max-width: 720px) {
    max-width: 100%;
    min-width: 100%;
  }

  &.show {
    transform: translate3d(0, 0, 0);
    transition: transform 0.6s ease 0.2s;
  }
`, Ur = l.div`
  background-color: #111;
  height: 100%;
  div {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`, Rr = l.div`
  padding: 35px 40px;
  p {
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    padding: 0 0 8px;
  }
`, Hr = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, Wr = l.div`
  width: 100%;
  height: 13px;
  background: #424242;
  border-radius: 99px;
`, Vr = l.div`
  position: relative;
  pointer-events: none;

  img,
  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  img {
    width: 22px;
    height: auto;
    left: 20px;
  }

  svg {
    right: 20px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  select {
    outline: none;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;
    background: transparent;
    color: #fff;

    width: 100%;
    height: 52px;

    border: 1px solid #eeeeee;
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-overflow: ellipsis;
  }

  &.active {
    pointer-events: all;
    svg {
      opacity: 1;
    }
  }

  @media all and (pointer: fine) {
    select {
      &:hover {
        background: #424242;
      }
    }
  }
`, Zr = l.div`
  h1,
  p,
  .rb,
  .dsl > div {
    opacity: 0;
    transform: translate3d(0, 60px, 0);
    transition: opacity 0.2s ease 0s, transform 0.4s ease 0s;
  }

  &.show {
    h1,
    p,
    .rb,
    .dsl > div {
      opacity: 1;
      transform: translate3d(0, 0, 0);
      transition: opacity 0.5s ease 0.2s, transform 0.5s ease 0.2s;
    }
    p {
      transition-delay: 0.25s, 0.25s;
    }
    .dsl > div {
      &:nth-child(1) {
        transition-delay: 0.3s, 0.3s;
      }
      &:nth-child(2) {
        transition-delay: 0.35s, 0.35s;
      }
      &:nth-child(3) {
        transition-delay: 0.4s, 0.4s;
      }
    }
    .rb {
      transition-delay: 0.45s, 0.45s;
    }
  }
`, Gr = [{ name: "facebook", icon: "/icons/facebook.svg" }, { name: "twitter", icon: "/icons/twitter.svg" }, { name: "google", icon: "/icons/google.svg" }, { name: "apple", icon: "/icons/apple.svg" }, { name: "microsoft", icon: "/icons/microsoft.svg" }], qr = ({ data: e, onClick: n = () => {
} }) => {
  const { t: i } = /* @__PURE__ */ x("common");
  return d(Kr, { onClick: () => {
    n(), C({ showLoginModal: false });
  }, className: e.name, children: [t("img", { src: M[e.icon], alt: e.name }), t("span", { children: i(`${e.name}-login`) })] });
}, Ui = ({ authFunctions: e = {}, data: n = Gr }) => t(Yr, { children: n.map((i, o) => t("li", { children: t(qr, { data: i, onClick: e[i.name] }) }, o)) });
l.div`
  h4 {
    text-align: center;
    padding: 0 0 15px;
  }
`;
const Yr = l.ul`
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: 237px;
`, Kr = l.button`
  position: relative;
  display: flex;

  align-items: center;
  padding: 12px 20px;
  gap: 15px;
  width: 100%;
  height: 48px;
  border-radius: 48px;

  font-family: 'Mundial';
  font-weight: 600;
  font-size: 14px;
  line-height: 13px;
  letter-spacing: 0.05em;

  img {
    clip-path: none;
  }

  img,
  span {
    position: relative;
    z-index: 1;
  }

  &.facebook {
    background: #1877f2;
    img {
      width: 24px;
    }
  }

  &.twitter {
    background: #489be9;
    img {
      width: 23px;
    }
  }

  &.google {
    background: #cb4023;
    img {
      width: 23px;
    }
  }

  &.apple {
    background: #000;
    img {
      width: 24px;
    }
  }

  &.microsoft {
    background: #00a4ef;
    img {
      width: 24px;
    }
  }

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 1px;
      left: 1px;
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      border-radius: 48px;
      background: #2d2d2d;
      z-index: 0;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    &:hover::before {
      opacity: 1;
    }
  }
`, xn = /* @__PURE__ */ wt(({ placeholder: e = "", type: n = "text", defaultVal: i = "" }, o) => {
  const { t: a } = /* @__PURE__ */ x();
  return t(Jr, { ref: o, type: n, defaultValue: i, placeholder: a(e) });
}), Jr = l.input`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 0 20px;
  isolation: isolate;
  background: transparent;

  color: #fff;

  border: 1px solid #eeeeee;
  border-radius: 5px;
  pointer-events: all;

  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
`, Ri = ({ cls: e = "" }) => null;
l.div`
  display: block;
  width: 200px;
  height: 92px;
  background: red;
  margin: 0 auto;
  &.pb {
    padding: 0 0 20px;
  }
`;
const Xr = ({ checkPasswordCb: e }) => {
  const [n, i] = /* @__PURE__ */ m(""), o = /* @__PURE__ */ S((h) => h.accessType), a = /* @__PURE__ */ O((h) => h.name), s = /* @__PURE__ */ k(null), r = () => {
    C({ waitingScreen: true });
  }, c = async () => {
    await e(s.current.value) ? r() : (i("wrong_password"), s.current.focus());
  }, p = async () => {
    const { setPublic: h } = /* @__PURE__ */ N(), { id: f } = /* @__PURE__ */ $();
    await h({ property: "name", value: s.current.value, userId: f }) ? r() : (i("incorrect_name"), s.current.focus());
  }, u = (h) => {
    document.activeElement === s.current && h.key === "Enter" && (o === "password" ? c() : o === "guest" && p());
  };
  return w(() => (document.addEventListener("keydown", u, false), () => {
    document.removeEventListener("keydown", u, false);
  })), d(T, { children: [t(xn, { type: o === "password" ? "password" : "text", ref: s, defaultVal: o !== "password" ? a : "", placeholder: `enter_${o === "password" ? "password" : "name"}` }), t(B, { cls: "white", label: "next", onClick: () => {
    o === "password" ? c() : o === "guest" && p();
  } }), n.length > 0 ? t(tl, { children: n }) : null] });
}, Qr = (e) => {
  const n = /* @__PURE__ */ Q(at), i = /* @__PURE__ */ S((o) => o.accessType);
  return d(el, { children: [t(Ri, {}), t(te, { title: `${i}_title`, desc: `${i}_desc` }), i === "login" ? t(Ui, {}) : t(Xr, { api: n, ...e })] });
}, el = l.div`
  position: relative;
`, tl = l.p`
  position: absolute;
  bottom: -30px;
  left: 0;
  right: 0;
  text-align: center;
  color: red;
  font-size: 12px;
  width: 100%;
  padding: 0 20px;
`, nl = () => {
  const e = /* @__PURE__ */ S((o) => o.mediaDeviceShared), n = /* @__PURE__ */ Q(at), { t: i } = /* @__PURE__ */ x("common");
  return e ? null : d(al, { children: [d("div", { className: "rdctxt", children: [t("h5", { children: i("request_device_title") }), t("p", { children: i("request_device_desc") })] }), t(B, { label: "enable", onClick: () => n.setMediaDeviceStep(true), arrow: false, cls: "white nomw" })] });
}, il = () => {
  Q(at);
  const e = "timeout";
  return t(Hi, { children: d("div", { children: [t(te, { title: `${e}_title`, desc: `${e}_desc` }), t(rl, {}), t(B, { label: "back-btn", onClick: () => {
    C({ waitingScreen: false });
  }, cls: "white", arrow: false })] }) });
}, ol = () => {
  const e = /* @__PURE__ */ S((n) => n.gateAccessDenied);
  return t("div", { children: e ? t(il, {}) : d(T, { children: [t(Hi, { children: d("div", { children: [t(Ri, { cls: "pb" }), t(te, { title: "waiting_title", desc: "waiting_desc" }), t(sl, { children: d("div", { children: [t("i", {}), t("i", {}), t("i", {}), t("i", {}), t("i", {}), t("i", {}), t("i", {})] }) })] }) }), t(nl, {})] }) });
}, Hi = l.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (max-width: 720px) {
    padding: 60px 0;
  }
`, al = l.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 0 -50px;
  background: #333333;
  padding: 30px;
  .rdctxt {
    width: 100%;
  }

  @media all and (max-width: 800px) {
    margin: 0 -20px;
    padding: 20px;
  }
`, sl = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0 0;
  div {
    display: flex;
    gap: 6px;
  }
  i {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    background: #fff;
  }

  // animate each dots from left to right opacity 0.1 to 1

  @keyframes dot1 {
    0% {
      opacity: 0.1;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.1;
    }
  }

  div {
    i:nth-child(1) {
      animation: 1.2s ease-in-out 0s infinite normal none running dot1;
    }
    i:nth-child(2) {
      animation: 1.2s ease-in-out 0.2s infinite normal none running dot1;
    }
    i:nth-child(3) {
      animation: 1.2s ease-in-out 0.4s infinite normal none running dot1;
    }
    i:nth-child(4) {
      animation: 1.2s ease-in-out 0.6s infinite normal none running dot1;
    }
    i:nth-child(5) {
      animation: 1.2s ease-in-out 0.8s infinite normal none running dot1;
    }
    i:nth-child(6) {
      animation: 1.2s ease-in-out 1s infinite normal none running dot1;
    }
    i:nth-child(7) {
      animation: 1.2s ease-in-out 1.2s infinite normal none running dot1;
    }
  }
`, rl = l.div`
  height: 20px;
`, ll = () => {
  const [e, n] = /* @__PURE__ */ m(false);
  return w(() => {
    const i = /* @__PURE__ */ setTimeout(() => {
      n(true);
    }, 1);
    return () => {
      clearTimeout(i);
    };
  }, []), t(cl, { className: e ? "show" : "", children: t("img", { src: "/placeholder/gate.jpg", alt: "gate" }) });
}, cl = l.div`
  width: 100%;
  max-width: 412px;
  background: #2d2d2d;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
    transform: translate3d(-100%, 0, 0);
  }

  &.show {
    img {
      transform: translate3d(0, 0, 0);
    }
  }
`, te = ({ title: e, desc: n, tr: i = "common" }) => {
  const { t: o } = /* @__PURE__ */ x(i);
  return d(ml, { className: "tdc", children: [e ? t("h1", { className: "secFontTxtBig", dangerouslySetInnerHTML: { __html: o(e) } }) : null, n ? t("p", { className: "normalTxt", dangerouslySetInnerHTML: { __html: o(n) } }) : null] });
}, at = /* @__PURE__ */ Be(null), dl = ({ hasCover: e, ...n }) => {
  const i = /* @__PURE__ */ Q(at), o = /* @__PURE__ */ S((a) => a.waitingScreen);
  return i.mediaDeviceStep ? t(Bi, { action: () => {
    i.setMediaDeviceStep(false), C({ waitingScreen: true });
  } }) : d(T, { children: [e ? t(ll, {}) : null, t(Vi, { className: o ? "waiting" : "", children: o ? t(ol, {}) : t(Qr, { ...n }) })] });
}, pl = (e) => {
  const [n, i] = /* @__PURE__ */ m(false), o = /* @__PURE__ */ S((s) => s.showGateModal), a = /* @__PURE__ */ Y(() => ({ mediaDeviceStep: n, setMediaDeviceStep: i }), [n]);
  return o ? t(vn, { className: "show", children: t(at.Provider, { value: a, children: t(ul, { children: t(hl, { children: t(fl, { children: t(dl, { hasCover: true, ...e }) }) }) }) }) }) : null;
}, vn = l.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: #2d2d2d;
    opacity: 0;
    z-index: 0;
    transition: opacity 0.3s ease 0.2s;
  }

  &.show {
    pointer-events: all;
    &::before {
      opacity: 0.8;
      transition-delay: 0s;
    }

    .blm {
      transform: translate3d(0, 0, 0);
      opacity: 1;
      transition: transform 0.3s ease 0.4s, opacity 0s ease 0.3s;
    }
  }
`, ul = l.div`
  position: relative;
  z-index: 1;
  overflow: auto;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (max-height: 650px), all and (max-width: 720px) {
    align-items: flex-start;
  }
`, hl = l.div`
  position: relative;
  z-index: 1;
  padding: 10px 5px;

  @media all and (max-width: 620px) {
    padding: 0;
  }
`, fl = l.div`
  display: flex;
  position: relative;
  min-height: 544px;
  border-radius: 10px;
  background: #2d2d2d;
  pointer-events: all;
  overflow: hidden;

  @media all and (max-width: 720px) {
    flex-direction: column;
    min-height: auto;
    & > div {
      &:first-child {
        order: 2;
      }
    }
  }

  @media all and (max-width: 620px) {
    border-radius: 0;
  }
`, Wi = l.div`
  position: absolute;
  bottom: -50px;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  transform: translate3d(0, -50px, 0);
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.2s ease;

  button {
    text-transform: uppercase;
  }
`, ml = l.div`
  h1 {
    text-transform: uppercase;
  }

  a {
    text-decoration: underline;
  }

  p {
    span.small {
      padding: 4px 0 0;
      display: block;
      font-size: 11px;
      line-height: 16px;
      opacity: 0.8;
    }
  }
`, Vi = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  min-width: 412px;
  max-width: 412px;

  &.waiting {
    padding: 0;
    & > div {
      height: 100%;
    }
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    padding: 0 50px;
    button {
      margin: 0 auto;
    }
    &.nop {
      padding: 0;
    }
  }

  @media all and (max-width: 800px) {
    min-width: 352px;
    max-width: 352px;
    & > div {
      padding: 0 20px;
    }
  }

  @media all and (max-width: 720px) {
    padding: 60px 0;
    max-width: 100%;
    min-width: 100%;
  }
`, bn = /* @__PURE__ */ wt((e, n) => {
  const [i, o] = /* @__PURE__ */ m(false);
  return d(gl, { children: [t("input", { type: i ? "text" : "password", ref: n, defaultValue: e?.defaultValue, onChange: e?.onChange ? (a) => e.onChange(a.target.value) : null }), t(xl, { onClick: () => o(!i), children: t("img", { src: M[`/icons/password-${i ? "show" : "hide"}.svg`], alt: `password ${i ? "show" : "hide"}` }) })] });
});
bn.displayName = "PasswordInput";
const gl = l.div`
  position: relative;
  input {
    padding-right: 60px;
  }
`, xl = l.button`
  position: absolute;
  top: 0;
  right: 4px;
  height: 100%;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  img {
    width: 15px;
    height: auto;
    clip-path: none;
  }
`, It = () => t(Tl, { children: t("img", { src: M["/office/loading.webp"], alt: "loading" }) }), vl = () => {
  const e = /* @__PURE__ */ S((i) => i.gateAccessDenied), n = "timeout";
  return t($l, { children: e ? t(te, { title: `${n}_title`, desc: `${n}_desc`, tr: "common" }) : d(T, { children: [t(It, {}), t(te, { title: "waiting_title", desc: "waiting_desc", tr: "common" })] }) });
}, bl = ({ onCheckPasword: e, microverseId: n, passwordRequired: i }) => {
  const [o, a] = /* @__PURE__ */ m(false), [s, r] = /* @__PURE__ */ m(false), c = /* @__PURE__ */ k(null), p = /* @__PURE__ */ k(null), [u, h] = /* @__PURE__ */ m(false), f = /* @__PURE__ */ O((I) => I.name), v = async () => {
    if (h(false), !g)
      return;
    a(true);
    const { setPublic: I, checkOfficePassword: A } = /* @__PURE__ */ N(), { id: E } = /* @__PURE__ */ $();
    if (I({ property: "name", value: c.current.value, userId: E }), i) {
      const { success: D } = await A(n, p.current.value);
      e(D), D || h("password-incorrect"), a(false);
      return;
    }
    h(false), a(false);
  }, g = () => c.current.value.length > 0 && (i ? p.current.value.length > 0 : true), y = () => {
    r(true);
  }, L = (I) => {
    document.activeElement === c.current && I.key === "Enter" && v();
  };
  return w(() => (document.addEventListener("keydown", L, false), () => {
    document.removeEventListener("keydown", L, false);
  })), w(() => {
    r(true);
  }, [f]), d(Ml, { children: [t(W, { label: "your-name", children: t("input", { ref: c, id: "your-name", type: "text", placeholder: "", onChange: (I) => {
    y();
  }, defaultValue: f }) }), i ? t(W, { label: "office-password", children: t(bn, { ref: p, id: "office-password", type: "password", placeholder: "", onChange: (I) => {
    y();
  } }) }) : null, t(B, { label: "guest-login", cls: "blue", onClick: v, disable: !s || o, tr: "office" }), u ? t(we, { label: u }) : null] });
}, wl = ({ user: e, onLoginClick: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return t(Il, { children: !e || e?.isAnonymous ? d(T, { children: [i("already-have-account"), t("br", {}), t("a", { href: "#", onClick: () => {
    n();
  }, children: `${i("already-have-account-link")}` })] }) : t(T, { children: t("span", { className: "sml", dangerouslySetInnerHTML: { __html: i("connected-as", { email: e.email }) } }) }) });
}, yl = ({ microverseId: e, onLoginClick: n, passwordRequired: i, onCheckPasword: o, user: a }) => {
  const [s, r] = /* @__PURE__ */ S((p) => [p.workspaceDoc, p.waitingScreen]), c = /* @__PURE__ */ Ne(s && s.logoUuid ? `${Ae.workspaceStorage}workspacelogo.webp?v=${s.logoUuid}` : null, null);
  return t(kl, { children: d(Sl, { children: [t(Ll, { children: c ? t("img", { src: c, alt: "logo" }) : null }), t("h2", { children: s?.name }), r ? t(vl, {}) : t(bl, { microverseId: e, passwordRequired: i, onCheckPasword: o }), t(wl, { user: a, onLoginClick: n })] }) });
}, Cl = (e) => t(q, { fallback: null, children: t(yl, { ...e }) }), kl = l.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: all;
`, Sl = l.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 50px 50px;
  gap: 24px;
  isolation: isolate;
  background: #2d2d2d;
  border-radius: 10px;
  max-width: 400px;

  h2 {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 33px;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.02em;
  }

  @media all and (max-width: 500px) {
    padding: 60px 20px 50px;
  }
`, Ml = l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 15px;

  p {
    text-align: center;
  }

  label {
    text-align: center;
  }
  input {
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: #2d2d2d;
    min-width: 280px;
    width: 100%;
  }
`, Ll = l.div`
  position: absolute;
  width: 75px;
  height: 75px;
  left: 50%;
  top: -40px;
  transform: translateX(-50%);
  background: #2d2d2d;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 5px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
  }
`, Il = l.p`
  font-family: 'Mundial';
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  line-height: 22px;

  .sml {
    display: block;
    font-size: 14px;
    line-height: 18px;

    a {
      font-size: 14px;
    }
  }

  a {
    position: relative;
    display: inline-block;
    font-weight: 600;
    padding: 2px 0;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #fff;
      opacity: 1;
      transition: transform 0.2s ease;
      transform: scaleX(1) translateZ(0);
    }

    @media all and (pointer: fine) {
      &:hover:after {
        transform: scaleX(0) translateZ(0);
      }
    }
  }
`, $l = l.div`
  text-align: center;
`, Tl = l.div`
  overflow: hidden;
  position: relative;
  width: 70px;
  height: 70px;
  margin: 0 auto;
  img {
    min-width: 5250px;
    height: 70px;
    position: absolute;
    top: 0;
    left: 0;

    clip-path: none;

    animation: sprite-animation 2s steps(75) infinite;
  }
`, Nl = ({ label: e, opaque: n } = {}) => {
  const { t: i } = /* @__PURE__ */ x("common");
  return t(Al, { opaque: n ? "true" : "false", children: d("div", { children: [t(It, {}), t("p", { children: i(e || "waiting_title") })] }) });
}, De = ({ forceDisplay: e }) => {
  const [n, i] = /* @__PURE__ */ Te((s) => [s.isElectron, s.on]);
  j("showSpinnerLoader", (s) => {
    C({ showSpinnerLoader: !!s, spinnerLoaderOptions: typeof s == "object" ? s : null });
  }), w(() => {
    n && i("emitEvent", ([s, r]) => {
      s === "showSpinnerLoader" && C({ showSpinnerLoader: !!r, spinnerLoaderOptions: typeof r == "object" ? r : null });
    });
  }, [n]);
  const [o, a] = /* @__PURE__ */ S((s) => [s.showSpinnerLoader, s.spinnerLoaderOptions]);
  return o || e ? t(Nl, { ...a }) : null;
}, Al = l.div`
  position: fixed;
  inset: 0;
  z-index: 99999;
  pointer-events: all;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(45, 45, 45, ${(e) => e.opaque === "true" ? "1.0" : "0.9"});

  text-align: center;

  p {
    padding: 10px 0 0;
    letter-spacing: 0.05em;
  }
`, my = "", El = ({ children: e, disableGlobalEffects: n }) => d(Ds, { theme: Pi, children: [t(_i, {}), t(ji, {}), t(zl, { children: e }), !n && t(De, {}), t(Fi, {})] }), Dl = (e) => {
  const n = /* @__PURE__ */ ve((i) => i.lang);
  js(e || n, e);
}, Zi = ({ children: e, ...n }) => (Dl(), t(q, { fallback: null, children: t(El, { ...n, children: e }) })), zl = l.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 2;
`, Gi = () => t("svg", { className: "icheck", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 29", children: t("path", { d: "m2 15.9712 10.9096 10.9096 24.971-24.97093", stroke: "#fff", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }) }), qi = () => t("svg", { width: "27", height: "18", viewBox: "0 0 27 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t("path", { d: "M13.7948 7.43899L2.01238 15.2427C1.07628 15.8627 1.50716 17.3438 2.62364 17.3438H24.3763C25.4791 17.3438 25.9198 15.8922 25.0097 15.2577L13.7948 7.43899ZM13.7948 7.43899V7.11518C13.7948 6.45244 14.3694 5.93983 14.9367 5.59727C15.596 5.19919 16.038 4.46692 16.038 3.62946C16.038 2.3671 15.0337 1.34375 13.7948 1.34375C12.5559 1.34375 11.5516 2.3671 11.5516 3.62946", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }) }), J = { EMOJI: "emoji", EMOTE: "emote", MENU: "menu", AVATAR: "avatar", PORTAL: "portal", PROFIL: "profil", PAINT: "paint" }, Yi = (e) => {
  localStorage.setItem("tutorial", true), b("tracking", { event: "custom_event", category: "tutorial", label: "finish-tutorial" });
}, Ki = () => {
  b("help-toast", { label: "customize-avatar-toast", closeTime: 7, actions: [{ icon: t(qi, {}), onClick: () => {
    b("open-tab", "avatar"), C({ openModal: J.MENU }), b("tracking", { event: "click", category: "help-toast", label: "open-avatar-customization" }), b("close-toast");
  } }] });
}, Pl = () => d(Fl, { className: "secfont", children: [t($t, { className: "nomr", children: t("span", { children: "W" }) }), d(Ol, { children: [t($t, { className: "nomr", children: t("span", { children: "A" }) }), t($t, { className: "nomr", children: t("span", { children: "S" }) }), t($t, { className: "nomr", children: t("span", { children: "D" }) })] })] }), _l = ({ show: e, hide: n }) => {
  const { t: i } = /* @__PURE__ */ x("common"), o = /* @__PURE__ */ S((a) => a.tutorialMove);
  return w(() => {
    if (o)
      return;
    const a = () => {
      C({ tutorialMove: true }), kt("downCtrl", a), kt("upCtrl", a), kt("rightCtrl", a), kt("leftCtrl", a), b("tracking", { event: "custom_event", category: "tutorial", label: "move-complete" });
    };
    Ct("downCtrl", a), Ct("upCtrl", a), Ct("rightCtrl", a), Ct("leftCtrl", a);
  }, [o]), d(jl, { className: `${e ? "show" : ""} ${n ? "hide" : ""}`, children: [t(Pl, {}), t("h3", { className: "secFontTxtMed", children: t("span", { dangerouslySetInnerHTML: { __html: i("tutorial-keyboard") } }) })] });
}, jl = l.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: center;

  h3 {
    overflow: hidden;
    span {
      display: block;
      transform: translate3d(0, 100%, 0);
      transition: transform 0.4s ease;
    }
  }

  &.show {
    .nomr span {
      opacity: 1;
      transform: translate3d(0, 0px, 0);
    }
    .nomr {
      transform: scaleX(1) translateZ(0);
    }
  }

  &.hide {
    transition: transform 0.5s ease;
    transform: translate3d(0, calc(-100% - 80px), 0) !important;
  }
`, Fl = l.div`
  display: flex;
  flex-wrap: wrap;
  width: 156px;
  margin: 0 auto;
  justify-content: center;
`, Ol = l.div`
  display: flex;
  padding: 7px 0 0;
  gap: 6px;
  width: 100%;
  justify-content: space-between;
`, $t = l.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 7px;

  font-size: 17px;
  line-height: 17px;

  transform: scaleX(0) translateZ(0);
  transition: transform 0.5s cubic-bezier(0.25, 0.005, 0.24, 0.905) 0.1s;
  overflow: hidden;

  &::before {
    content: ' ';
    position: absolute;
    top: 3px;
    right: 5px;
    width: 38px;
    height: 39px;
    left: 5px;
    top: 3px;
    border-radius: 7px;

    background: radial-gradient(
      150% 150% at 100% -8.93%,
      rgba(255, 255, 255, 0) 35.2%,
      rgba(255, 255, 255, 0.24) 100%
    );
  }

  span {
    position: relative;
    z-index: 1;
    display: block;
    opacity: 0;
    transform: translate3d(0, 15px, 0);
    transition: transform 0.5s cubic-bezier(0.25, 0.005, 0.24, 0.905) 0.35s,
      opacity 0.3s cubic-bezier(0.25, 0.005, 0.24, 0.905) 0.35s;
  }
  &.nomr {
    margin: 0;
  }
  &.sbck {
    min-width: 144px;
    margin: 0 auto;
  }
  svg {
    margin: 0 7px 0 0;
  }
`, Bl = ({ colorPaint: e }) => {
  const n = /* @__PURE__ */ k(null), i = /* @__PURE__ */ k(null), o = /* @__PURE__ */ k(null), a = /* @__PURE__ */ k(null), s = /* @__PURE__ */ k(null), r = /* @__PURE__ */ k(null), c = /* @__PURE__ */ k(null), p = /* @__PURE__ */ k(null), u = /* @__PURE__ */ k(null), h = (I, A, E, D, F) => {
    const H = 1 - F, _ = F * F, P = H * H, U = P * H, X = _ * F, ne = U * 0 + 3 * P * F * I + 3 * H * _ * E + X * 1, Fe = U * 0 + 3 * P * F * A + 3 * H * _ * D + X * 1;
    return { x: ne, y: Fe };
  }, f = (I, A, E, D, F, H = 10) => {
    let _ = F;
    for (let P = 0; P < H; P++) {
      const U = h(I, A, E, D, _).x, X = (h(I, A, E, D, _ + 0.01).x - U) / 0.01;
      _ -= (U - F) / X;
    }
    return h(I, A, E, D, _).y;
  }, v = (I) => f(0, 0, 0.58, 1, I), g = (I, A) => {
    a.current.style.opacity = "0";
    const E = 1300;
    n.current.animate([{ strokeDashoffset: I }, { strokeDashoffset: 0 }], { duration: E, fill: "forwards", easing: "ease-out" }), i.current.animate([{ strokeDashoffset: A }, { strokeDashoffset: 0 }], { duration: E, fill: "forwards", easing: "ease-out" }).onfinish = () => {
      s.current.animate([{ transform: "scale(0)" }, { transform: "scale(0)" }], { duration: 0, fill: "forwards" }).onfinish = () => {
        setTimeout(() => {
          p.current && (p.current.classList.remove("show"), u.current.classList.remove("show"), y(I, A, 0));
        }, 2e3);
      };
    };
    let D;
    const F = (H) => {
      D || (D = H);
      const _ = H - D, P = /* @__PURE__ */ Math.min(_ / E, 1), U = /* @__PURE__ */ n.current.getPointAtLength(v(P) * I);
      o.current.setAttribute("transform", `translate(${-30 + U.x},${-120 + U.y})`), _ < E && requestAnimationFrame(F);
    };
    requestAnimationFrame(F);
  }, y = (I, A, E) => {
    a.current.style.opacity = "1", r.current.style.opacity = "0", c.current.style.opacity = "0", setTimeout(() => {
      p.current && (p.current.classList.add("show"), u.current.classList.add("show"));
    }, E || 10), o.current.setAttribute("transform", `translate(${-30 + 26.05},${-120 + 122.154})`);
    const F = E + 700;
    setTimeout(() => {
      c.current && (c.current.style.opacity = "1");
    }, F), s.current.animate([{ transform: "scale(0)" }, { transform: "scale(1)" }], { duration: 300, fill: "forwards", easing: "ease-out", delay: F }).onfinish = () => {
      setTimeout(() => {
        r.current && (r.current.style.opacity = "1", g(I, A));
      }, 300);
    };
  };
  w(() => {
    const I = /* @__PURE__ */ n.current.getTotalLength();
    n.current.style.strokeDasharray = `${I} ${I}`, n.current.style.strokeDashoffset = I;
    const A = /* @__PURE__ */ i.current.getTotalLength();
    i.current.style.strokeDasharray = `${A} ${A}`, i.current.style.strokeDashoffset = A, y(I, A, 500);
  }, []);
  const L = "#dddddd";
  return d("svg", { width: "150", height: "117", viewBox: "0 0 204 159", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [d("g", { ref: a, className: "circle", style: { transition: "opacity 0.1s ease" }, children: [t("circle", { ref: s, cx: "25.0156", cy: "124", r: "20", fill: e, style: { transformOrigin: "12% 75%", transform: "scale(0)" } }), t("g", { className: "bcr", ref: u, children: t("circle", { cx: "25.0156", cy: "124", r: "24", stroke: "white", strokeWidth: "2" }) })] }), d("g", { ref: r, children: [t("path", { ref: n, d: "M26.0508 122.154C42.8417 93.05 94.8937 33.0783 168.774 26.0261", stroke: e, strokeWidth: "40", strokeLinecap: "round" }), t("path", { mask: "url(#maskPaintAnim)", fillRule: "evenodd", clipRule: "evenodd", d: "M166.304 0.119572C180.613 -1.24626 193.319 9.24602 194.685 23.5547C196.051 37.8635 185.559 50.5702 171.25 51.936C140.757 54.8468 113.933 68.7796 92.283 86.131C70.5197 103.573 55.4137 123.346 48.5971 135.162C41.4142 147.612 25.4983 151.882 13.048 144.699C0.597668 137.516 -3.67245 121.601 3.51044 109.15C13.4848 91.8614 32.8003 67.0968 59.7308 45.5137C86.7739 23.8404 122.917 4.26106 166.304 0.119572ZM193.014 23.7143C191.736 10.3287 179.849 0.513356 166.463 1.79107C123.493 5.89283 87.6503 25.2898 60.7809 46.824C34.017 68.2735 14.8374 92.877 4.96485 109.989C-1.75462 121.636 2.24 136.526 13.8871 143.245C25.5342 149.964 40.4232 145.97 47.1427 134.323C54.0612 122.331 69.303 102.396 91.2329 84.8208C113.058 67.3297 140.181 53.2149 171.09 50.2645C184.476 48.9868 194.291 37.0999 193.014 23.7143Z", fill: "white" })] }), t("mask", { id: "maskPaintAnim", children: t("path", { ref: i, d: "M27.0508 123.154C43.8417 94.05 95.8937 34.0783 169.774 27.0261", stroke: "#fff", strokeWidth: "55", strokeLinecap: "round" }) }), t("g", { ref: p, className: "imr", children: d("g", { ref: o, className: "mouse", children: [t("path", { d: "M41.0748 152.988L34.0896 134.361C33.7882 133.557 34.5732 132.772 35.3771 133.074L54.0042 140.059C54.788 140.353 54.8854 141.422 54.1676 141.853L49.9718 144.37C49.4139 144.705 49.3191 145.475 49.7792 145.935L52.7626 148.918C53.1531 149.309 53.1531 149.942 52.7626 150.332L52.0555 151.039L51.3484 151.747C50.9579 152.137 50.3247 152.137 49.9342 151.747L46.9507 148.763C46.4907 148.303 45.7208 148.398 45.3861 148.956L42.8686 153.152C42.438 153.869 41.3687 153.772 41.0748 152.988Z", fill: "white", stroke: "black", strokeWidth: "2" }), d("g", { ref: c, className: "hcr", children: [t("path", { d: "M29.4223 128.808L25.8867 125.273", stroke: L, strokeWidth: "2", strokeLinecap: "round" }), t("path", { d: "M28.0547 135.172H23.0547", stroke: L, strokeWidth: "2", strokeLinecap: "round" }), t("path", { d: "M35.5 127.729V122.729", stroke: L, strokeWidth: "2", strokeLinecap: "round" })] })] }) })] });
}, Ul = () => {
  const e = /* @__PURE__ */ k(false), n = /* @__PURE__ */ z((i) => i.mouseDown);
  return w(() => {
    !n && e.current && C({ tutorialPaint: true }), n && (e.current = true);
  }, [n]), null;
}, Rl = ({ show: e, hide: n }) => {
  const { t: i } = /* @__PURE__ */ x("common"), [o] = /* @__PURE__ */ S((a) => [a.colorPaint || "#ffffff"]);
  return d(Hl, { className: `${e ? "show" : ""} ${n ? "hide" : ""}`, children: [t(Bl, { colorPaint: o }), t("h3", { className: "secFontTxtMed", children: t("span", { dangerouslySetInnerHTML: { __html: i("tutorial-paint") } }) }), t(Ul, {})] });
}, Hl = l.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: center;

  h3 {
    overflow: hidden;
    span {
      display: block;
      transform: translate3d(0, 100%, 0);
      transition: transform 0.4s ease;
    }
  }

  .hcr {
    transition: opacity 0.1s ease;
  }

  &.hide {
    transition: transform 0.5s ease;
    transform: translate3d(0, calc(-100% - 80px), 0) !important;
  }

  .imr,
  .bcr {
    transform: translate3d(90px, 10px, 0);
    opacity: 0;
    &.show {
      transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1), opacity 0s ease;
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
`, Wl = ({ show: e }) => t(ql, { className: `success ${e ? "show" : ""}`, children: t("div", { children: t(Gi, {}) }) }), Ji = ({ show: e, success: n, children: i }) => d(Gl, { className: `card ${e ? "show" : ""}`, children: [i, t(Wl, { show: n })] }), Xi = ({ forceActive: e = false }) => {
  const [n, i, o, a] = /* @__PURE__ */ S((f) => [f.showTutorial, f.tutorialMove, f.uiSettings?.isPaintGame, f.tutorialPaint]), [s, r] = /* @__PURE__ */ m(e), [c, p] = /* @__PURE__ */ m(false), u = () => {
    p(true), setTimeout(() => {
      C({ showTutorial: false, hideUI: false }), setTimeout(() => {
        Ki();
      }, 500);
    }, 600);
  }, h = () => {
    Yi(), setTimeout(u, 1400);
  };
  return w(() => {
    n && r(true), (i && !o || o && a && i) && h();
  }, [i, n, a]), t(Vl, { className: `${s ? "show" : ""} ${c ? "animateout" : ""} ${o ? "split" : ""}`, children: d(Zl, { className: "sc", children: [t(Ji, { show: s, success: i, children: t(_l, { show: s, hide: i || c }) }), o ? t(Ji, { show: s, success: a, children: t(Rl, { show: s, hide: a || c }) }) : null] }) });
}, Vl = l.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px;
  pointer-events: none;
  visibility: hidden;

  &.split {
    .sc {
      max-width: 700px;
      justify-content: space-between;
    }
  }

  h3 {
    text-align: center;
  }

  &.show {
    visibility: visible;
    .skb,
    h3 span {
      transform: translate3d(0, 0, 0);
    }

    h3 span {
      transition-delay: 0.4s;
    }

    .skb {
      transition-delay: 0.5s;
    }
  }

  &.animateout {
    .card {
      &::before {
        transition-delay: 0.05s;
        transform: scaleY(0) translateZ(0);
      }
    }

    .success {
      transform: translate3d(0, calc(-100% - 60px), 0);
      transition-delay: 0s;
    }

    .skb {
      transform: translate3d(0, calc(-100% - 60px), 0);
      transition-delay: 0s;
    }
  }
`, Zl = l.div`
  display: flex;
  width: 100%;
  justify-content: center;
`, Gl = l.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 254px;
  height: 272px;

  border-radius: 10px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(45, 45, 45, 0.98);
    border-radius: 10px;
    z-index: 0;
    transform: scaleY(0) translateZ(0);
    transform-origin: top center;
    transition: transform 0.6s ease 0.1s;
  }

  &.show {
    &::before {
      transition-delay: 0s;
      transform: scaleY(1) translateZ(0);
    }
    /* & > div {
      transform: translate3d(0, 0, 0);
      transition-delay: 0.3s;
    } */
  }
`, ql = l.div`
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 96px;
    height: 96px;
    background: rgba(255, 255, 255, 0.1);
    border: 1.2px solid #ffffff;
    border-radius: 50%;
    svg {
      width: 36px;
      path {
        stroke-dasharray: 1000;
        stroke-dashoffset: 1000;
        transition: stroke-dashoffset 0.5s ease 0.6s;
      }
    }
  }

  transform: translate3d(0, calc(100% - 60px), 0);

  &.show {
    visibility: visible;
    transition: transform 0.5s ease 0.1s;
    transform: translate3d(0, 0, 0);

    .icheck {
      path {
        stroke-dashoffset: 940;
      }
    }
  }
`;
l.div`
  position: absolute;
  right: 70px;
  top: 55px;
  transition: transform 0.5s ease;
  transform: translate3d(0, calc(-100% - 60px), 0);
  button {
    pointer-events: all;
  }
`;
const K = (e) => {
  if (process.env.NODE_ENV === "development") {
    const n = /* @__PURE__ */ S((i) => i[e]);
    return n !== void 0 ? n : bi[e];
  } else
    return bi[e];
}, wn = () => {
  const e = /* @__PURE__ */ K("isMobile"), [n, i] = /* @__PURE__ */ m(1080);
  return w(() => {
    if (typeof window < "u") {
      const o = () => {
        i(window.innerWidth);
      };
      return e || window.addEventListener("resize", o), i(window.innerWidth), () => {
        window.removeEventListener("resize", o);
      };
    }
  }, [e]), e || n < 921;
}, yn = () => {
  const [e, n] = /* @__PURE__ */ z((o) => [o.isAdmin, o.live]);
  return Y(() => {
    const o = n?.find((a) => a.userId === $().id)?.role === "anchor";
    return e || o;
  }, [e, n]);
}, Qi = { NATIVE: "native", APPLE: "apple", TWITTER: "twitter", GOOGLE: "google", FACEBOOK: "facebook" }, Se = { NEUTRAL: "neutral", LIGHT: "1f3fb", MEDIUM_LIGHT: "1f3fc", MEDIUM: "1f3fd", MEDIUM_DARK: "1f3fe", DARK: "1f3ff" }, V = { SUGGESTED: "suggested", SMILEYS_PEOPLE: "smileys_people", ANIMALS_NATURE: "animals_nature", FOOD_DRINK: "food_drink", TRAVEL_PLACES: "travel_places", ACTIVITIES: "activities", OBJECTS: "objects", SYMBOLS: "symbols", FLAGS: "flags" }, Yl = [Se.NEUTRAL, Se.LIGHT, Se.MEDIUM_LIGHT, Se.MEDIUM, Se.MEDIUM_DARK, Se.DARK];
Object.entries(Se).reduce((e, [n, i]) => (e[i] = n, e), {});
const Kl = /* @__PURE__ */ Yl.reduce((e, n) => Object.assign(e, { [n]: n }), {}), Cn = "https://cdn.utsubo.io/ui/emojis/", kn = { name: "n", unified: "u", variations: "v", added_in: "a" };
function Ze(e) {
  return e[kn.name] ?? [];
}
function Jl(e) {
  return e ? Ze(e)[0] : "";
}
function Xl(e) {
  const n = /* @__PURE__ */ e.split("-"), [i] = /* @__PURE__ */ n.splice(1, 1);
  return Kl[i] ? n.join("-") : e;
}
function st(e, n) {
  const i = e[kn.unified];
  return !n || !ec(e) ? i : tc(e, n) ?? i;
}
function Ql(e, n) {
  return e?.[n] ?? [];
}
function eo(e, n) {
  return `${Cn}${e}.webp`;
}
function to(e) {
  return e[kn.variations] ?? [];
}
function ec(e) {
  return to(e).length > 0;
}
function tc(e, n) {
  return n ? to(e).find((i) => i.includes(n)) : st(e);
}
function nc(e, n) {
  if (!n)
    return;
  const i = {};
  if (e.reduce((a, s) => (ic[st(s)] = s, a), i), i[n])
    return i[n];
  const o = /* @__PURE__ */ Xl(n);
  return i[o];
}
async function Ge() {
  return await (await fetch(M["/json/emojis.json"], { mode: "cors" })).json();
}
const ic = async () => {
  const e = await Ge();
  return Object.values(e).flat();
}, Tt = [{ endsAt: 204, category: "smileys_people" }, { endsAt: 348, category: "animals_nature" }, { endsAt: 480, category: "food_drink" }, { endsAt: 698, category: "travel_places" }, { endsAt: 784, category: "activities" }, { endsAt: 1039, category: "objects" }, { endsAt: 1260, category: "symbols" }, { endsAt: 1529, category: "flags" }], oc = (e, n) => {
  e || console.error("emojis not loaded yet!");
  const i = Tt.find((s) => n < s.endsAt)?.category || "smileys_people", o = /* @__PURE__ */ parseFloat(n);
  return e[i].find((s) => s.id === o);
}, Sn = (e, n) => {
  e || console.error("emojis not loaded yet!");
  const i = Tt.find((s) => n < s.endsAt)?.category || "smileys_people", o = /* @__PURE__ */ parseFloat(n), a = /* @__PURE__ */ e[i].find((s) => s.id === o);
  return `${Cn}${a?.u}.webp`;
}, ac = async (e) => {
  const n = await Ge(), i = Tt.find((s) => e < s.endsAt)?.category || "smileys_people", o = /* @__PURE__ */ parseFloat(e), a = /* @__PURE__ */ n[i].find((s) => s.id === o);
  return `${Cn}${a?.u}.webp`;
}, sc = async (e) => {
  const n = Tt.find((s) => e < s.endsAt)?.category || "smileys_people", i = await Ge(), o = /* @__PURE__ */ parseFloat(e);
  return i[n].find((s) => s.id === o).u;
};
function rc(e) {
  const n = [];
  for (const i of e)
    n.push(i.codePointAt(0));
  return n.map((i) => `${i.toString(16).padStart(4, "0")}`).join(", ");
}
const lc = (e) => rc(e), no = (e) => eo(e), cc = (e, n) => {
  const i = {};
  return e.reduce((o, a) => (Ze(a).forEach((r, c) => {
    Ze(a)[c] = n(r);
  }), Ze(a).flat().join("").replace(/[^a-zA-Za-zA-Z\d\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\d]/g, "").split("").forEach((r) => {
    o[r] = o[r] ?? {}, o[r][st(a)] = a;
  }), o), i), i;
}, dc = ({ data: e, current: n, setCurrent: i, show: o }) => {
  const { t: a } = /* @__PURE__ */ x();
  return t("li", { children: d(pc, { onClick: () => {
    i(n), b("tracking", { event: "click", category: "tab-view", label: `switch to ${e.label}` });
  }, className: n === o ? "active" : "", children: [t("h5", { className: "secFontTxtXs", children: a(e.label) }), t("div", { className: "bg" })] }) });
}, pc = l.button`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  text-transform: uppercase;

  padding: 10px 0 12px;

  h5 {
    position: relative;
    z-index: 1;
    opacity: 0.5;
    transition: opacity 0.3s ease;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: #2d2d2d;
    border-radius: 32px;
    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;
    transform: scaleX(0) translateZ(0);
    opacity: 0;
  }

  &.active {
    pointer-events: none;
    h5 {
      opacity: 1;
    }
    .bg {
      transition-duration: 0.4s, 0s;
      transform: scaleX(1) translateZ(0);
      opacity: 1;
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      h5 {
        opacity: 1;
      }
    }
  }
`, io = /* @__PURE__ */ Be(null), oo = ({ data: e, isScrolling: n, setCurrent: i, current: o }) => t(fc, { className: `secfont ${n ? "hide" : ""}`, children: e.map((a, s) => t(dc, { current: s, setCurrent: i, show: o, data: a }, s)) }), uc = ({ data: e }) => {
  const [n, i] = /* @__PURE__ */ m(0), [o, a] = /* @__PURE__ */ m(false), s = /* @__PURE__ */ Y(() => ({ setIsScrolling: a }), [a]);
  return t(io.Provider, { value: s, children: d(hc, { children: [t(oo, { data: e, isScrolling: o, setCurrent: i, current: n }), e.map((r, c) => t(mc, { className: n === c ? "show" : "", children: e[c]?.content }, c))] }) });
}, hc = l.div`
  position: relative;
  height: 100%;
`, fc = l.ul`
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  display: flex;
  padding: 2px;
  gap: 2px;
  background: rgba(45, 45, 45, 0.3);
  border-radius: 999px;
  z-index: 2;
  transform: translate3d(0, 0, 0);
  transition: transform 0.4s ease;

  li {
    flex: 1;
  }

  &.hide {
    transform: translate3d(0, calc(-100% - 25px), 0);
  }
`, mc = l.div`
  height: 100%;
  display: none;
  &.show {
    display: block;
  }
  .cntscroll {
    padding: 60px 0 0;
  }
`, Nt = /* @__PURE__ */ Be(null), At = ({ placeholder: e, setText: n, tr: i = "common" }) => {
  const [o, a] = /* @__PURE__ */ m(false), { t: s } = /* @__PURE__ */ x(i), r = /* @__PURE__ */ K("isMobile"), c = /* @__PURE__ */ ee(() => {
    a(true);
  }, []), p = /* @__PURE__ */ ee(() => {
    a(false);
  }, []), u = /* @__PURE__ */ ee((h) => {
    const f = h.target.value;
    n(f);
  }, [n]);
  return d(vc, { className: `search-ctn ${r ? "sp" : ""}`, children: [t("img", { src: M["/icons/search.svg"], alt: "search", className: o ? "focus" : "" }), t("input", { type: "text", placeholder: s(e), onFocus: c, onBlur: p, onChange: u })] });
}, ao = ({ children: e, searchPlaceholder: n }) => {
  const i = /* @__PURE__ */ k(null), [o, a] = /* @__PURE__ */ m(""), s = /* @__PURE__ */ Y(() => ({ text: o }), [o]), r = /* @__PURE__ */ Q(io), c = /* @__PURE__ */ ee(() => {
    if (r) {
      const p = i.current, { scrollTop: u } = p;
      r.setIsScrolling(u > 60);
    }
  }, [r]);
  return w(() => {
    const p = i.current;
    return p.addEventListener("scroll", c), () => {
      p.removeEventListener("scroll", c);
    };
  }, [c]), t(Nt.Provider, { value: s, children: d(gc, { children: [t(xc, { ref: i, className: "cntscroll", children: e }), t(At, { setText: a, placeholder: n })] }) });
}, gc = l.div`
  position: relative;
  height: 100%;
  max-height: 100%;
  padding: 0 0 58px;
`, xc = l.div`
  height: 100%;
  max-height: 100%;
  overflow: auto;
`, vc = l.div`
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: #2d2d2d;
  z-index: 2;

  img {
    position: absolute;
    left: 18px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    width: 21px;
    height: auto;
    opacity: 0.6;
    transition: opacity 0.2s ease;
    clip-path: none;
    &.focus {
      opacity: 1;
    }
  }

  input {
    color: #fff;
    width: 100%;
    height: 58px;
    padding: 0 20px 0 54px;
    background: transparent;
    font-size: 13px;
    line-height: 18px;
    &::placeholder {
      font-size: 13px;
    }
  }

  &.sp {
    input {
      font-size: 16px;
    }
  }
`, Mn = /* @__PURE__ */ ln((e) => ({ activeSkinTone: Se.NEUTRAL, emojisThatFailedToLoad: /* @__PURE__ */ new Set(), filterRef: Ps(), isPastInitialLoad: true, searchTerm: /* @__PURE__ */ new Set(), suggestedUpdated: Date.now(), setIsPastInitialLoad: (n) => e({ isPastInitialLoad: n }), updateSuggested: () => e({ suggestedUpdated: Date.now() }) })), Re = (e, n) => Mn(e, n || rn);
Object.assign(Re, Mn);
const { getState: bc, setState: Ln } = Mn;
function wc() {
  const [e] = /* @__PURE__ */ Re((n) => [n.filterRef]);
  return function n(i) {
    if (typeof i == "function")
      return n(i(e.current));
    e.current = i;
  };
}
function yc() {
  const [e, n] = /* @__PURE__ */ Re((r) => [r.filterRef, r.searchTerm]), i = /* @__PURE__ */ wc(), o = /* @__PURE__ */ Cc(), { t: a } = /* @__PURE__ */ x();
  return { onChange: s, searchTerm: n, t: a };
  function s(r) {
    const c = e.current, p = /* @__PURE__ */ r.toLowerCase();
    if (c?.[p] || p.length <= 1)
      return o($c(p));
    const u = /* @__PURE__ */ Ic(p, c);
    if (!u)
      return o(p);
    i((h) => Object.assign(h, { [p]: kc(u, p) })), o(p);
  }
}
function Cc() {
  return function(n) {
    requestAnimationFrame(() => {
      Ln({ searchTerm: n && n?.toLowerCase() });
    });
  };
}
function kc(e, n, i) {
  const o = {};
  for (const a in e) {
    const s = e[a];
    Sc(s, n) && (o[a] = s);
  }
  return o;
}
function Sc(e, n) {
  return Ze(e).some((i) => i.includes(n));
}
function Mc() {
  const [e, n] = /* @__PURE__ */ Re((i) => [i.filterRef, i.searchTerm]);
  return (i) => Lc(i, e.current, n);
}
function Lc(e, n, i) {
  return !n || !i ? false : !n[i]?.[e];
}
function Ic(e, n) {
  if (!n)
    return null;
  if (n[e])
    return n[e];
  const i = /* @__PURE__ */ Object.keys(n).sort((o, a) => a.length - o.length).find((o) => e.includes(o));
  return i ? n[i] : null;
}
function $c(e) {
  return !e || typeof e != "string" ? "" : e.trim().toLowerCase();
}
const In = "https://cdn.utsubo.io/ui/emojis/", so = "/emotes/webp/", ro = [{ category: "dance-cat", items: [{ name: "raisehands" }, { name: "dance", emojis: [1718, 1719, 1720, 1721, 1722] }, { name: "partyhandsup" }, { name: "lightstickwaving" }, { name: "cheering1", emojis: [1561] }, { name: "cheering2" }, { name: "clap", emojis: [1560] }, { name: "confetti", emojis: [705] }] }, { category: "emotion-cat", items: [{ name: "laugh", emojis: [4, 6, 7, 30] }, { name: "love", emojis: [14, 15, 17, 128, 129, 130, 131, 132, 133, 134, 135, 136, 138, 140, 141, 142, 143, 144, 145, 146, 147, 148, 1562] }, { name: "crying", emojis: [89, 88, 1616, 1617, 1618] }, { name: "shocked", emojis: [32] }, { name: "shrugging", emojis: [1643, 1644, 1645] }] }, { category: "action-cat", items: [{ name: "bow", emojis: [1637, 1638, 1639] }, { name: "correct", emojis: [1159, 1160, 1161, 1162, 1625, 1626, 1627] }, { name: "wrong", emojis: [116, 1164, 1622, 1623, 1624] }, { name: "thankyou" }, { name: "thinkcrossarm" }, { name: "thumb", emojis: [1554] }, { name: "hello", emojis: [1530] }, { name: "kneelidle" }, { name: "pickphone", emojis: [859, 858, 857, 856, 1547] }, { name: "pray", emojis: [1566] }, { name: "raisehand", emojis: [1531, 1532, 1533, 1631, 1632, 1633] }, { name: "seiza" }] }, { category: "exercice-cat", items: [{ name: "taiso01" }, { name: "taiso02" }, { name: "taiso03" }, { name: "taiso04" }, { name: "taiso05" }, { name: "taiso06" }, { name: "taiso07" }, { name: "taiso08" }, { name: "taiso09" }, { name: "taiso10" }, { name: "taiso11" }, { name: "taiso12" }] }], Tc = (e) => {
  const n = ro.find((i) => i.items.find((o) => o.emojis?.includes(e)))?.items.find((i) => i.emojis?.includes(e))?.name;
  n && $n(n);
}, $n = (e) => {
  const n = $().id;
  b(`ctrl_${e}`), b(`anim_${n}`, { name: e }), b("register-action-log", { type: "emote", emoteName: e }), b("tracking", { event: "custom_event", category: "emote", label: e });
}, lo = ({ show: e, cls: n = "" }) => {
  const { t: i } = /* @__PURE__ */ x("common");
  return t(Nc, { className: `${e ? "show" : ""} ${n}`, children: d("div", { children: [t("img", { src: M["/icons/no-result.svg"], alt: "no-result", loading: "lazy" }), t("h5", { children: i("no-result") })] }) });
}, Nc = l.div`
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  display: none;
  text-align: center;

  h5 {
    padding: 18px 0 0;
  }

  img {
    width: 37px;
    margin: 0 auto;
    clip-path: none;
  }

  &.show {
    display: flex;
    img {
      animation: fadeIn 3s ease-in-out infinite;
    }

    &.hide {
      padding: 60px 0 0;
    }
  }
`, ze = { [V.SUGGESTED]: { category: V.SUGGESTED, name: "frequently-used" }, [V.SMILEYS_PEOPLE]: { category: V.SMILEYS_PEOPLE, name: "smileys" }, [V.ANIMALS_NATURE]: { category: V.ANIMALS_NATURE, name: "animals" }, [V.FOOD_DRINK]: { category: V.FOOD_DRINK, name: "food-drink" }, [V.TRAVEL_PLACES]: { category: V.TRAVEL_PLACES, name: "travel-place" }, [V.ACTIVITIES]: { category: V.ACTIVITIES, name: "activities" }, [V.OBJECTS]: { category: V.OBJECTS, name: "objects" }, [V.SYMBOLS]: { category: V.SYMBOLS, name: "symbols" }, [V.FLAGS]: { category: V.FLAGS, name: "flags" } };
function co(e) {
  return e.category;
}
function Ac(e) {
  return e.name;
}
function Ec() {
  const e = /* @__PURE__ */ Mc(), n = /* @__PURE__ */ Re((i) => i.emojisThatFailedToLoad);
  return (i) => {
    const o = /* @__PURE__ */ st(i), a = /* @__PURE__ */ n.has(o), s = /* @__PURE__ */ e(o);
    return { failedToLoad: a, filteredOut: s, hidden: a || s };
  };
}
function Dc(e) {
  return e.split("-").map((n) => String.fromCodePoint(parseInt(n, 16))).join("");
}
const zc = ({ emoji: e, unified: n, hidden: i, hiddenOnSearch: o, emojiStyle: a, emojis: s, size: r, lazyLoad: c, getEmojiUrl: p }) => {
  const u = /* @__PURE__ */ Q(po), h = /* @__PURE__ */ k(null);
  return t(Fc, { ref: h, hidden: i || o, className: `${i || o ? "hidden" : ""}`, "data-unified": n, "aria-label": Jl(e), "data-full-name": Ze(e), onClick: () => {
    u({ emoji: e });
  }, children: t(Pc, { unified: n, emoji: e, size: r, emojis: s, emojiStyle: a, lazyLoad: c, getEmojiUrl: p }) });
}, Pc = ({ emoji: e, emojis: n, unified: i, emojiStyle: o, size: a, lazyLoad: s, getEmojiUrl: r = eo }) => {
  const c = {};
  a && (c.width = c.height = c.fontSize = `${a}px`);
  const p = e || nc(n, i);
  return p ? t(T, { children: o === Qi.NATIVE ? t(_c, { unified: i, style: c }) : t(jc, { unified: i, style: c, emoji: p, emojiStyle: o, lazyLoad: s, getEmojiUrl: r }) }) : null;
}, _c = ({ unified: e, style: n }) => t("span", { className: "epr-emoji-native", "data-unified": e, style: n, children: Dc(e) }), jc = ({ emoji: e, unified: n, emojiStyle: i, style: o, lazyLoad: a = true, getEmojiUrl: s }) => {
  return t("div", { width: "43px", height: "43px", style: { display: "block", width: "43px", height: "43px", backgroundImage: `url(${s(n, i)})`, backgroundSize: "contain", backgroundRepeat: "no-repeat" }, loading: a ? "lazy" : "eager", onError: r });
  function r() {
    const c = bc().emojisThatFailedToLoad;
    Ln({ emojisThatFailedToLoad: c.add(n) });
  }
}, Fc = l.div`
  &.hidden {
    display: none;
  }
  cursor: pointer;
  width: 43px;

  @media all and (pointer: fine) {
    img {
      transition: opacity 0.3s ease;
    }
    &:hover {
      img {
        opacity: 0.7;
      }
    }
  }
`, Oc = ({ listRef: e }) => {
  const n = /* @__PURE__ */ Re((a) => a.searchTerm), [i, o] = /* @__PURE__ */ m(false);
  return w(() => {
    if (e?.current) {
      const a = /* @__PURE__ */ Array.from(e.current.children).every((s) => s.classList.contains("hidden"));
      o(a);
    }
  }, [e, n]), t(Vc, { className: i ? "show" : "", children: t(lo, { show: true }) });
}, Bc = ({ emojis: e, chat: n }) => {
  const i = /* @__PURE__ */ k(null), o = /* @__PURE__ */ k([ze[V.SMILEYS_PEOPLE], ze[V.ANIMALS_NATURE], ze[V.FOOD_DRINK], ze[V.TRAVEL_PLACES], ze[V.ACTIVITIES], ze[V.OBJECTS], ze[V.SYMBOLS], ze[V.FLAGS]]);
  return d(T, { children: [t(Oc, { listRef: i }), t(Hc, { ref: i, className: n ? "chat" : "", children: o.current.map((a, s) => {
    const r = /* @__PURE__ */ co(a);
    return t(Uc, { emojis: e, index: s, category: r, categoryConfig: a }, r);
  }) })] });
};
function Uc({ emojis: e, index: n, category: i, categoryConfig: o }) {
  const a = /* @__PURE__ */ Ec(), s = /* @__PURE__ */ Re((u) => u.isPastInitialLoad), [r] = [Se.NEUTRAL], [c, p] = /* @__PURE__ */ Y(() => {
    const u = !s && n > 1 ? [] : Ql(e, i), h = [];
    let f = 0;
    for (let v = 0; v < u.length; v++) {
      const g = u[v], y = /* @__PURE__ */ st(g, r), { failedToLoad: L, filteredOut: I, hidden: A } = /* @__PURE__ */ a(g);
      A && f++, y && h.push({ emoji: g, unified: y, hidden: L, hiddenOnSearch: I, emojiStyle: Qi.APPLE });
    }
    return [h, f];
  }, [r, i, e, n, a, s]);
  return t(Rc, { categoryConfig: o, hidden: p >= c.length, children: c.map((u) => t(zc, { emojis: e, ...u }, u.unified)) });
}
const Rc = ({ categoryConfig: e, children: n, hidden: i, hiddenOnSearch: o }) => {
  const a = /* @__PURE__ */ co(e), s = /* @__PURE__ */ Ac(e), { t: r } = /* @__PURE__ */ x("common");
  return d("li", { className: `${i ? "hidden" : ""} ${o ? "hiddenOnSearch" : ""}`, "data-name": a, "aria-label": s, children: [t("h5", { className: "secFontTxtXs", children: r(s) }), t(Wc, { children: n })] });
}, Hc = l.ul`
  padding: 0 20px;

  &.chat {
    padding: 0;
    li:first-child h5 {
      padding-top: 0;
    }
  }

  li.hidden,
  li.hiddenOnSearch {
    display: none;
  }

  h5 {
    text-transform: uppercase;
    padding: 15px 0;
  }
`, Wc = l.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 15px;
`, Vc = l.div`
  display: none;
  padding: 60px 0;
  &.show {
    display: block;
  }
`, Z = ({ title: e, children: n, cls: i = "" }) => {
  const { t: o } = /* @__PURE__ */ x("common");
  return d(Zc, { className: i, children: [t("h4", { className: "secFontTxtXs", children: o(e) }), n] });
}, Zc = l.div`
  position: relative;
  padding: 25px 20px 15px;

  &.hide {
    display: none;
  }

  h4 {
    position: relative;
    padding: 0 0 20px;
    text-transform: uppercase;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -20px;
      width: 6px;
      height: 31px;
      background: #2d2d2d;
      border-radius: 0px 0px 30px 0px;
    }
  }
`, po = /* @__PURE__ */ Be(null), Gc = /* @__PURE__ */ ce(() => {
  const e = /* @__PURE__ */ Q(Nt), { onChange: n } = /* @__PURE__ */ yc();
  return w(() => {
    e && n(e.text);
  }, [e?.text]), null;
}), Tn = (e, n) => {
  const i = $().id, o = /* @__PURE__ */ oc(e, n), a = /* @__PURE__ */ no(o?.u);
  b(`player_${i}_emote`, a), Os(n), b("register-action-log", { type: "emoji", emojiId: o?.u }), Tc(n);
}, uo = ({ emojis: e, chat: n }) => {
  const i = /* @__PURE__ */ ee(({ emoji: o }) => {
    const a = `${n ? "chat" : "emote"}:emoji`;
    n ? b(a, o) : (C({ lastQuickEmoji: o.id }), Tn(e, o.id)), b("tracking", { event: "click", category: a, label: o });
  }, [n, e]);
  return d(po.Provider, { value: i, children: [t(Gc, {}), t(Bc, { emojis: e, chat: n })] });
}, ho = ({ show: e, chat: n = false }) => {
  const { t: i } = /* @__PURE__ */ x(), o = /* @__PURE__ */ dn(async () => {
    const s = await Ge();
    return N().uiSettings?.filterEmojis && (s.objects = [], s.symbols = [], s.travel_places = [], s.activities = [], s.animals_nature = [], s.food_drink = [], s.smileys_people = s.smileys_people.slice(0, 100)), s;
  }, ["emojis_2"]), a = /* @__PURE__ */ k(cc(Object.values(o).flat(), i));
  return w(() => {
    Ln({ filterRef: a });
  }, []), e ? t(ao, { searchPlaceholder: "search-emoji", children: n ? t(Z, { title: "emoji", children: t(uo, { emojis: o, chat: n }) }) : t(uo, { emojis: o, chat: n }) }) : null;
}, qc = /* @__PURE__ */ bt(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]), Et = l.div`
  border: 2px solid rgba(0, 0, 0, 0.1);
  width: 16px;
  height: 16px;
  padding: 6px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: ${qc} 0.7s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -8px;
  margin-top: -8px;
`, ge = ({ icon: e, visual: n, action: i, label: o, analytics: a, cls: s = "", shortcut: r = "", disabled: c = false, mouseDown: p = null, mouseUp: u = null, show: h = true, tr: f = "common", loading: v = false }) => {
  const g = /* @__PURE__ */ k(null), { t: y } = /* @__PURE__ */ x(f), L = /* @__PURE__ */ K("isMobile"), I = /* @__PURE__ */ ee(() => {
    s.includes("camera") && C({ showCameraQuickSettings: true }), !(L || s === "showtooltip") && C({ hideHighlightTooltip: true });
  }, [L, s]), A = /* @__PURE__ */ ee(() => {
    s.includes("camera") && C({ showCameraQuickSettings: false }), L || C({ hideHighlightTooltip: false });
  }, [L]), E = /* @__PURE__ */ ee(() => {
    g.current && g.current.blur(), i && (i(), b("tracking", { event: "click", category: "menu-shortcut", label: a }));
  }, [i, a, g]), D = /* @__PURE__ */ ee(() => {
    p && p();
  }, [p]), F = /* @__PURE__ */ ee(() => {
    g.current && g.current.blur(), u && u();
  }, [u, g]);
  return d(Yc, { className: `${v ? "loading" : ""} ${c ? "disable" : ""} ${h ? "active" : ""} ${s} ${L ? "sp" : ""}`, ref: g, onMouseOver: L ? null : I, onMouseOut: L ? null : A, onClick: E, onPointerDown: D, onMouseDown: D, onMouseUp: F, onPointerUp: F, children: [o ? t(Jc, { className: "tt secfont", children: t("span", { children: y(o) }) }) : null, t(Kc, { className: "cbn", children: v ? t(Et, {}) : d(T, { children: [e || n || null, !L && r !== "" ? t(Xc, { className: "sv secfont", children: r }) : null] }) })] });
}, Yc = l.button`
  pointer-events: all;
  position: relative;
  display: block;
  padding: 7px 4px;
  transition: transform 0.3s ease;
  transform: scale(0) translateZ(0);
  &.disable {
    pointer-events: none;
    opacity: 0.5;
  }
  &.active {
    transform: scale(1) translateZ(0);
    & > div::before {
      opacity: 0.85;
    }

    &.showtooltip {
      .tt {
        transition-delay: 0s;
        transition-duration: 0.3s;
        transform: translate3d(-50%, 0, 0) scaleX(1);
        span {
          transform: translate3d(0, 0, 0);
          transition-delay: 0.2s;
          transition-duration: 0.2s;
        }
      }
    }
  }

  &.huddle {
    padding: 5px;
    .cbn {
      width: 40px;
      height: 40px;
    }
  }

  .icn-msg {
    width: 100%;
  }

  .icn-mic,
  .icn-webcam,
  .icn-ss {
    width: 28px;
  }

  .icn-paint {
    width: 18px;
    height: auto;
  }

  &.sp {
    .tt {
      top: auto;
      bottom: -23px;
    }
  }

  &.quickemoji {
    user-select: none;
    img {
      pointer-events: none;
      width: 28px;
      transform: rotate(-15deg);
    }
  }

  &.highlight {
    & > div::before {
      background: #5f5a5a;
    }
  }

  @media (pointer: fine) {
    & > div::before {
      transition: transform 0.2s ease;
    }
    &:hover {
      & > div::before {
        opacity: 0.85;
      }
      .tt {
        transition-delay: 0s;
        transition-duration: 0.3s;
        transform: translate3d(-50%, 0, 0) scaleX(1);
        span {
          transform: translate3d(0, 0, 0);
          transition-delay: 0.2s;
          transition-duration: 0.2s;
        }
      }
    }
  }

  @media all and (max-width: 768px) {
    padding: 7px;
    .icn-menu {
      width: 13px;
    }
    .icn-emote {
      width: 15px;
    }

    .abs-center {
      width: 25px;
    }

    .icn-tps {
      width: 9px;
    }

    .icn-fps {
      width: 15px;
    }

    .icn-portal {
      width: 18px;
    }

    .icn-paint {
      width: 14px;
    }

    &.quickemoji {
      .sv {
        left: -5px;
        bottom: -5px;
      }
      img {
        width: 18px;
      }
    }

    .icn-menu,
    .icn-emote,
    .icn-mic,
    .abs-center,
    .icn-tps,
    .icn-fps,
    .icn-portal {
      height: auto;
    }
  }

  @media all and (max-width: 374px) {
    padding: 7px 2px;
  }
`, Kc = l.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    background: #2d2d2d;
    opacity: ${(e) => e.theme.opacityUI};
    transition: opacity 0.3s ease;
  }

  img {
    border-radius: 100%;
  }

  img,
  .icn {
    position: relative;
    z-index: 1;
  }

  @media all and (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`, Jc = l.div`
  position: absolute;
  top: -23px;
  left: 50%;
  white-space: nowrap;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 32px;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  color: #fff;
  transform: translate3d(-50%, 0, 0) scaleX(0);
  transition: transform 0s ease 0s;
  transform-origin: center center;
  overflow: hidden;
  pointer-events: none;
  span {
    display: block;
    padding: 7px 15px;
    transform: translate3d(0, 100%, 0);
    transition: transform 0s ease;
  }
`, Xc = l.div`
  user-select: none;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d2d2d;
  border: 1px solid #595353;
  border-radius: 3px;
  font-size: 9px;
  line-height: 9px;
`, Qc = ({ emojis: e, lastEmoji: n }) => t("img", { src: Sn(e, n), alt: "emoji" }), fo = ({ show: e }) => {
  const n = /* @__PURE__ */ dn(async () => await Ge(), ["emojis"]), i = /* @__PURE__ */ k(null), o = /* @__PURE__ */ S((c) => c.lastQuickEmoji), a = () => {
    Tn(n, o);
  }, s = (c, p) => {
    a(), clearInterval(i.current), i.current = setInterval(a, 400), p || document.addEventListener("mouseup", r, { once: true });
  }, r = () => {
    clearInterval(i.current);
  };
  return w(() => () => {
    r();
  }), j("quick-emoji", ({ up: c }) => {
    c ? s({}, true) : r();
  }), t(ge, { cls: "quickemoji", analytics: "emoji-shorcut-btn", icon: t(Qc, { emojis: n, lastEmoji: o }), label: "tooltip-emoji-shortcut", show: e, shortcut: "F", action: null, mouseDown: s, mouseUp: r });
}, ed = ({ cls: e }) => d("svg", { className: e, width: "13", height: "16", viewBox: "0 0 15 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M14 18.1995V14.9476C14 13.3931 12.7398 12.1328 11.1852 12.1328H3.81483C2.26024 12.1328 1 13.3931 1 14.9476V18.1995", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("circle", { cx: "7.41363", cy: "5.56939", r: "4.26958", stroke: "white", strokeWidth: "1.2" })] }), td = ({ cls: e }) => d("svg", { className: e, width: "21", height: "16", viewBox: "0 0 24 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M12.0957 1.40918V4.92667", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M17.7237 2.46409L16.7596 5.81103", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M23.0001 5.63049L20.8283 8.0928", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M1.54346 5.27832L3.16022 7.74035", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M6.46777 2.46387L7.38327 5.62926", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M21.5932 12.5516C19.0998 9.58493 15.6086 7.74121 11.7442 7.74121C7.87981 7.74121 4.3886 9.58493 1.89526 12.5516", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M11.7441 17.5893C13.4925 17.5893 14.9098 16.172 14.9098 14.4235C14.9098 14.3349 14.9062 14.247 14.899 14.1601C14.8739 13.8558 14.4512 13.7935 14.1864 13.9455C13.9756 14.0666 13.7313 14.1358 13.4709 14.1358C12.6761 14.1358 12.0319 13.4916 12.0319 12.6968C12.0319 12.4363 12.1011 12.192 12.2221 11.9813C12.3742 11.7165 12.3119 11.2937 12.0075 11.2686C11.9207 11.2615 11.8328 11.2578 11.7441 11.2578C9.9957 11.2578 8.57837 12.6751 8.57837 14.4235C8.57837 16.172 9.9957 17.5893 11.7441 17.5893Z", fill: "white" })] }), nd = () => t("svg", { className: "abs-center", width: "36", height: "30", viewBox: "0 0 38 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t("path", { d: "M29 1H34C35.6569 1 37 2.34315 37 4V6.5M9 1H4C2.34315 1 1 2.34315 1 4V6.5M37 25.5V28C37 29.6569 35.6569 31 34 31H29M1 25.5V28C1 29.6569 2.34315 31 4 31H9", stroke: "white", strokeWidth: "1.2", strokeDasharray: "1 2" }) }), mo = /* @__PURE__ */ ce(({ fps: e }) => d(T, { children: [t(nd, {}), e ? t(td, { cls: "icn icn-fps" }) : t(ed, { cls: "icn icn-tps" })] }));
mo.displayName = "icon";
const id = ({ show: e }) => {
  const n = /* @__PURE__ */ pn((i) => i.firstPerson);
  return t(ge, { analytics: "switch-camera-btn", show: e, icon: t(mo, { fps: n }), label: "tooltip-camera", action: () => {
    St().setNextCameraMode();
  } });
}, Dt = ({ show: e, huddleBar: n }) => {
  const [i, o, a] = /* @__PURE__ */ ie((f) => [f.currentUserScreenShareActive, f.inScreenshare, f.inCall]), [s, r] = /* @__PURE__ */ We((f) => [f.startScreenShare, f.stopScreenShare]), c = /* @__PURE__ */ S((f) => f.workspaceDoc?.plan?.videoCall), [p, u] = /* @__PURE__ */ m(false), h = /* @__PURE__ */ ee(async () => {
    u(true), i ? (await r(), oe({ currentUserScreenShareActive: false })) : (await s(), oe({ currentUserScreenShareActive: true })), u(false);
  }, [i, s, r]);
  return t(ge, { cls: n ? "huddle" : "", disabled: !a || o && !i || !c || p, loading: p, visual: t("img", { src: M[`/icons/sharescreen-${i ? "on" : "off"}.svg`], alt: "screenshare", className: "icn-ss" }), label: `screenshare-${i ? "on" : "off"}`, show: e, action: h, tr: "office" });
}, zt = ({ show: e, huddleBar: n }) => {
  const i = /* @__PURE__ */ O((c) => c.settings.privacy.micEnabled), [o, a] = /* @__PURE__ */ m(false), s = /* @__PURE__ */ We((c) => c.setMutedState), r = /* @__PURE__ */ ee(async () => {
    const c = /* @__PURE__ */ cn().peers.get($().id), { settings: p } = /* @__PURE__ */ $(), u = !p.privacy.micEnabled;
    p.privacy.micEnabled = u, a(true), u && !he().audioAccessEnabled && he().userMediaUpdate(true), b("setSettings", { privacy: { micEnabled: p.privacy.micEnabled } }), le({ settings: p }), c && await s(u), a(false);
  }, []);
  return t(ge, { cls: n ? "huddle" : "", loading: o, disabled: o, visual: t("img", { className: "icn-mic", src: M[`/icons/mic-${i ? "on" : "off"}.svg`], alt: "mic" }), label: `mute-${i ? "on" : "off"}`, show: e, action: () => {
    r();
  }, tr: "office" });
}, od = new it.Color(), go = /* @__PURE__ */ ce(({ color: e }) => d("svg", { className: "icn icn-paint", width: "18", height: "25", viewBox: "0 0 18 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M17 16.7194C17 21.0441 13.4183 24.55 9 24.55C4.58172 24.55 1 21.0441 1 16.7194C1 12.5864 7.94102 7.43055 8.90563 1.74469C8.92177 1.64951 9.12022 1.64341 9.14137 1.73761C10.4188 7.42627 17 12.5847 17 16.7194Z", stroke: "white", strokeWidth: "0.64" }), t("path", { d: "M15.4028 16.0941C15.4028 19.7534 12.5374 22.7199 9.00279 22.7199C6.48485 22.7199 4.30653 21.2145 3.26172 19.0257C10.6023 22.15 11.4023 11.75 15.4028 16.0941Z", fill: e })] }));
go.displayName = "icon";
const ad = ({ show: e }) => {
  const [n, i, o, a] = /* @__PURE__ */ S((u) => [u.openModal === J.PAINT, u.hideHighlightTooltip, u.colorPaint || null, u.paintLazer || false]), s = /* @__PURE__ */ O((u) => u.id), r = /* @__PURE__ */ Vs((u) => u.playerBrushReferences), [c, p] = /* @__PURE__ */ m(false);
  return w(() => {
    if (s !== "tempId") {
      let u = null;
      if (o)
        u = o;
      else {
        const f = ["#ff00dd", "#40ff40", "#1cfefe", "#ffff1b", "#7636f9", "#ffba11", "#da0909"];
        u = f[Math.floor(Math.random() * f.length)], C({ colorPaint: u });
      }
      r.current[s] || (r.current[s] = {}), r.current[s].color = u;
      const h = /* @__PURE__ */ od.set(u).toArray([]);
      r.current[s].colorArr = h, r.current[s].lazer = a ? 1 : 0, Bs(`${u},${a ? 1 : 0}`), b("brush_color", { playerId: $().id, color: u, colorArr: h, lazer: a ? 1 : 0 });
    }
  }, [s, o, a]), t(ge, { analytics: "paint-btn", cls: !c && !i ? "showtooltip" : "", icon: t(go, { color: o }), label: "tooltip-paint", show: e, disabled: n, action: () => {
    C({ openModal: J.PAINT }), p(true);
  } });
}, Nn = () => {
  const e = /* @__PURE__ */ K("isMobile"), [n, i] = /* @__PURE__ */ m(false);
  return w(() => {
    function o() {
      const a = window.innerWidth <= 600 || window.innerHeight <= 800;
      i(e && a);
    }
    return o(), window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, [e]), n;
}, sd = ({ cls: e }) => d("svg", { className: e, width: "31", height: "25", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M15.4688 24.0005L15.4687 1.00009", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M19.4687 19.2276L21.9207 21.0129C22.3958 21.3588 23.0626 21.0194 23.0626 20.4318L23.0626 3.85007C23.0626 3.26246 22.3958 2.92314 21.9207 3.26901L19.4687 5.05427", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M11.4687 5.05461L9.01677 3.26934C8.54173 2.92347 7.87494 3.26279 7.87494 3.8504L7.87494 20.4322C7.87494 21.0198 8.54173 21.3591 9.01676 21.0132L11.4687 19.228", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M26.7777 7.77279C26.486 7.93009 26.3771 8.29404 26.5344 8.58569C26.6917 8.87735 27.0557 8.98627 27.3473 8.82897L26.7777 7.77279ZM28.8776 7.32195L28.5928 6.79386L28.8776 7.32195ZM26.7777 17.228L28.5928 18.2069L29.1624 17.1507L27.3473 16.1718L26.7777 17.228ZM30.5376 17.0462L30.5375 7.95457L29.3375 7.95457L29.3376 17.0462L30.5376 17.0462ZM28.5928 6.79386L26.7777 7.77279L27.3473 8.82897L29.1624 7.85004L28.5928 6.79386ZM30.5375 7.95457C30.5375 6.95631 29.4714 6.31999 28.5928 6.79386L29.1624 7.85004C29.2415 7.80737 29.3375 7.86467 29.3375 7.95457L30.5375 7.95457ZM28.5928 18.2069C29.4714 18.6808 30.5376 18.0445 30.5376 17.0462L29.3376 17.0462C29.3376 17.1361 29.2415 17.1934 29.1624 17.1507L28.5928 18.2069Z", fill: "white" }), t("path", { d: "M4.15981 17.2277C4.45147 17.0704 4.56039 16.7065 4.40309 16.4148C4.24579 16.1231 3.88184 16.0142 3.59019 16.1715L4.15981 17.2277ZM2.0599 17.6785L2.34471 18.2066L2.0599 17.6785ZM4.15981 7.7725L2.34471 6.79357L1.77509 7.84975L3.59019 8.82868L4.15981 7.7725ZM0.39995 7.95428L0.39995 17.0459L1.59995 17.0459L1.59995 7.95428L0.39995 7.95428ZM2.34471 18.2066L4.15981 17.2277L3.59019 16.1715L1.77509 17.1504L2.34471 18.2066ZM0.39995 17.0459C0.39995 18.0442 1.46609 18.6805 2.34471 18.2066L1.77509 17.1504C1.69596 17.1931 1.59995 17.1358 1.59995 17.0459L0.39995 17.0459ZM2.34471 6.79357C1.46609 6.3197 0.39995 6.95602 0.39995 7.95428L1.59995 7.95428C1.59995 7.86438 1.69596 7.80708 1.77509 7.84975L2.34471 6.79357Z", fill: "white" })] }), xo = /* @__PURE__ */ ce(() => t(sd, { cls: "icn icn-portal" }));
xo.displayName = "icon";
const vo = ({ show: e }) => {
  const [n, i] = /* @__PURE__ */ m(false), [o, a] = /* @__PURE__ */ S((r) => [r.openModal === J.PORTAL, r.hideHighlightTooltip]), s = /* @__PURE__ */ Nn();
  return w(() => {
    o && i(true);
  }, [o]), t(ge, { cls: !n && !a ? "showtooltip" : "", analytics: "portal-btn", icon: t(xo, {}), label: "tooltip-portal", show: e, disabled: o, action: () => {
    C({ openModal: J.PORTAL }), s && C({ hideUI: true });
  } });
}, rd = ({ cls: e }) => d("svg", { className: e, width: "21", height: "16", viewBox: "0 0 24 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M1.52002 13.2891C4.24081 15.8799 7.92296 17.4702 11.9766 17.4702C16.0302 17.4702 19.7123 15.8799 22.4331 13.2891", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("circle", { cx: "4.55787", cy: "2.96071", r: "1.44313", fill: "white", stroke: "white", strokeWidth: "1.2" }), t("circle", { cx: "19.3103", cy: "2.96071", r: "1.44313", fill: "white", stroke: "white", strokeWidth: "1.2" })] }), bo = /* @__PURE__ */ ce(() => t(rd, { cls: "icn icn-emote" }));
bo.displayName = "icon";
const wo = ({ show: e }) => {
  const n = /* @__PURE__ */ S((o) => o.openModal === J.EMOTE), i = /* @__PURE__ */ Nn();
  return t(ge, { analytics: "emote-btn", icon: t(bo, {}), label: "tooltip-emote", show: e, disabled: n, action: () => {
    C({ openModal: n ? "" : J.EMOTE }), i && C({ hideUI: true });
  } });
}, Pt = ({ show: e, huddleBar: n }) => {
  const i = /* @__PURE__ */ We((p) => p.toggleVideoCall), o = /* @__PURE__ */ K("isMobile"), a = /* @__PURE__ */ S((p) => p.showCameraQuickSettings), [s, r] = /* @__PURE__ */ m(false), c = /* @__PURE__ */ ee(async () => {
    const p = /* @__PURE__ */ cn().peers.get($().id);
    r(true);
    const { settings: u } = /* @__PURE__ */ $();
    u.privacy.videoEnabled ? (u.privacy.trackingEnabled = false, u.privacy.videoEnabled = false) : u.privacy.trackingEnabled ? N().workspaceDoc?.plan?.videoCall ? u.privacy.videoEnabled = true : (u.privacy.trackingEnabled = false, u.privacy.videoEnabled = false) : u.privacy.trackingEnabled = true, p && N().workspaceDoc?.plan?.videoCall && await i($().id, u.privacy.videoEnabled), b("setSettings", { privacy: { videoEnabled: !!u.privacy.videoEnabled, trackingEnabled: !!u.privacy.trackingEnabled } }), le({ settings: u }), r(false);
  }, []);
  return t(ge, { visual: t(ld, {}), loading: s, disabled: s, show: e, action: () => {
    o ? C({ showCameraQuickSettings: !a }) : c();
  }, tr: "office", cls: `camera ${o && a ? "highlight" : ""} ${n ? "huddle" : ""}` });
}, ld = () => {
  const e = /* @__PURE__ */ O((o) => o.settings.privacy.videoEnabled), n = /* @__PURE__ */ O((o) => o.settings.privacy.trackingEnabled), i = /* @__PURE__ */ S((o) => o.workspaceDoc?.plan?.videoCall);
  return d(cd, { children: [t(dd, { className: e && i ? "show" : "" }), t("img", { className: "icn-webcam", src: M[`/icons/cam-${e || n ? "on" : "off"}.svg`], alt: "camera" })] });
}, cd = l.div`
  position: relative;
  width: 28px;
  height: 28px;
`, dd = l.div`
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  right: 20.59%;
  top: 17.65%;
  background: #ffb46f;
  opacity: 0;
  transition: opacity 0.3s ease;

  &.show {
    opacity: 1;
  }
`, pd = ({ cls: e }) => d("svg", { className: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 40", children: [t("circle", { cx: "15.4793", cy: "18.4251", r: "1.21757", stroke: "#fff", strokeWidth: ".812" }), t("circle", { cx: "20.4715", cy: "18.4251", r: "1.21757", stroke: "#fff", strokeWidth: ".812" }), t("circle", { cx: "25.4637", cy: "18.4251", r: "1.21757", stroke: "#fff", strokeWidth: ".812" }), t("path", { d: "M30.562 18.8049c0 2.7896-1.1528 5.3099-3.0081 7.1105 1.0904 1.1994 2.3689 2.7975 2.3689 2.7975H20.654c-5.472 0-9.9079-4.436-9.9079-9.908 0-5.472 4.4359-9.90793 9.9079-9.90793 5.472 0 9.908 4.43593 9.908 9.90793Z", stroke: "#fff", strokeWidth: ".812" })] }), yo = /* @__PURE__ */ ce(() => t(pd, { cls: "icn icn-msg" }));
yo.displayName = "icon";
const ud = ({ show: e }) => t(ge, { analytics: "chat-btn", icon: t(yo, {}), label: "tooltip-chat", show: e, action: () => {
  C({ openChat: true, hideUI: true });
} }), Co = /* @__PURE__ */ ce(() => t("svg", { className: "icn icn-menu", width: "21", height: "15", viewBox: "0 0 21 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t("path", { d: "M1.56006 1H19.5601M1.56006 7.74074H19.5601M1.56006 14H19.5601", stroke: "#FCFCFC", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }) }));
Co.displayName = "icon";
const hd = ({ show: e }) => {
  const n = /* @__PURE__ */ S((o) => o.openModal === J.MENU), i = /* @__PURE__ */ Nn();
  return t(ge, { analytics: "menu-btn", icon: t(Co, {}), label: "tooltip-menu", show: e, disabled: n, action: () => {
    C({ openModal: n ? "" : J.MENU }), i && C({ hideUI: true });
  } });
}, ko = ({ forceActive: e = false, callEnabled: n }) => {
  const i = /* @__PURE__ */ K("isMobile"), [o, a, s] = /* @__PURE__ */ S((u) => [u.hideUI, u.isDemo, u.uiSettings]), r = e || !o, c = /* @__PURE__ */ yn(), p = /* @__PURE__ */ wn();
  return d(fd, { className: i ? "sp" : "", children: [p ? t(ud, { show: r }) : null, t(q, { fallback: null, children: t(fo, { show: r }) }), t(wo, { show: r }), n || c ? d(T, { children: [t(Pt, { show: r }), t(zt, { show: r }), p ? null : t(Dt, { show: r })] }) : null, p ? t("div", { className: "spacer" }) : null, a && !s?.hidePortalButton ? t(vo, { show: r }) : null, s?.isPaintGame ? t(ad, { show: r }) : null, !(n && p) && !s?.disableCameraChange ? t(id, { show: r }) : null, t(hd, { show: r })] });
}, fd = l.div`
  position: fixed;
  z-index: 1;
  display: flex;
  gap: 16px;
  bottom: 33px;
  right: 36px;

  .spacer {
    width: 100%;
    pointer-events: none;
  }

  button {
    &.active {
      &:nth-last-child(0) {
        transition-delay: 0s;
      }
      &:nth-last-child(1) {
        transition-delay: 0.05s;
      }
      &:nth-last-child(2) {
        transition-delay: 0.1s;
      }
      &:nth-last-child(3) {
        transition-delay: 0.15s;
      }
      &:nth-last-child(4) {
        transition-delay: 0.2s;
      }
      &:nth-last-child(5) {
        transition-delay: 0.25s;
      }
      &:nth-last-child(6) {
        transition-delay: 0.3s;
      }
      &:nth-last-child(7) {
        transition-delay: 0.35s;
      }
    }
  }

  @media all and (max-width: 1048px) {
    gap: 6px;
    right: 26px;
  }

  @media all and (max-width: 920px) {
    left: 26px;
  }

  @media all and (max-width: 768px) {
    gap: 0;
  }

  &.sp {
    gap: 0;
    left: 17px;
    right: 17px;
    bottom: auto;
    top: 13px;

    @media all and (max-width: 374px) {
      left: 11px;
      right: 11px;
    }
  }
`, An = ({ size: e, lineSize: n }) => d(md, { className: "highlight", size: e, children: [t(_t, { size: n }), t(_t, { size: n }), t(_t, { size: n }), t(_t, { size: n })] }), So = "#2979FF", Mo = "#FF1744", Lo = "#FFFF8D", Io = "#B2FF59", md = l.div`
  position: relative;
  pointer-events: none;
  width: ${(e) => e.size}px;
  min-width: ${(e) => e.size}px;
  overflow: visible;
  border-radius: 50%;
  box-shadow: inset 0 0 8px rgba(255, 255, 255, 0.4),
    0 0 12px rgba(255, 255, 255, 0.8);

  /* Keep ratio on resize*/
  &::before {
    content: '';
    float: left;
    padding-top: 100%;
  }
`, _t = l.div`
  display: block;
  position: absolute;
  border-radius: 50%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 0.8;
  mix-blend-mode: screen;
  filter: brightness(120%);
  animation-name: spinAround;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  animation-fill-mode: both;
  animation-timing-function: linear;

  &:nth-of-type(1) {
    box-shadow: inset 1px 0 0 1px ${So},
      ${(e) => e.size}px 0 0 ${(e) => e.size}px ${So};
    animation-direction: reverse;
    transform-origin: 49.6% 49.8%;
  }

  &:nth-of-type(2) {
    box-shadow: inset 1px 0 0 1px ${Mo},
      ${(e) => e.size}px 0px 0 ${(e) => e.size}px ${Mo};
    transform-origin: 49.5% 49.8%;
  }

  &:nth-of-type(3) {
    box-shadow: inset 1px 0 0 1px ${Lo},
      0 ${(e) => e.size}px 0 ${(e) => e.size}px ${Lo};
    transform-origin: 49.8% 49.8%;
  }

  &:nth-of-type(4) {
    box-shadow: inset 1px 0 0 1px ${Io},
      0 ${(e) => e.size}px 0 ${(e) => e.size}px ${Io};
    transform-origin: 49.7% 49.7%;
  }
`, gd = () => {
  const [e] = /* @__PURE__ */ S((n) => [n.showJoystickTutorial]);
  return t(To, { className: e ? "show" : "", children: t("div", { children: t(An, { size: 70, lineSize: 2 }) }) });
}, $o = () => {
  const [e, n, i, o] = /* @__PURE__ */ S((h) => [h.showTutorial, h.tutorialMove, h.uiSettings?.isPaintGame, h.tutorialPaint]), [a, s] = /* @__PURE__ */ m(false), r = () => {
    C({ showJoystickTutorial: true }), b("message-toast", { message: "tutorial-joystick" });
  }, c = () => {
    C({ showTutorialPaint: true }), b("message-toast", { message: "tutorial-paint-sp" });
  }, p = () => {
    b("tracking", { event: "custom_event", category: "tutorial", label: "move-complete" }), u();
  }, u = () => {
    Yi(), C({ showTutorial: false, hideUI: false }), setTimeout(() => {
      Ki();
    }, 500);
  };
  return w(() => {
    e && s(true), n ? i ? o ? p() : c() : p() : e && (n || r());
  }, [n, e, o, i]), t(xd, { className: a ? "show" : "", children: t(gd, {}) });
}, xd = l.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  display: none;
  .skb {
    display: none;
  }
  &.show {
    display: block;
    .skb {
      transform: translate3d(0, 0, 0);
      transition-delay: 0.2s;
    }
  }
`, To = l.div`
  position: absolute;
  bottom: 45px;
  left: 45px;

  &.paint {
    bottom: 100px;
    left: auto;
    right: 100px;
  }

  & > div {
    display: flex;
    transform: scale(0) translateZ(0);
    transition: transform 0.5s ease;
  }

  &.show {
    & > div {
      transform: scale(1) translateZ(0);
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.46, 1.13);
    }
  }
`, vd = (e, n) => {
  const i = /* @__PURE__ */ k(e), o = /* @__PURE__ */ k(false), a = /* @__PURE__ */ k(null);
  function s() {
    o.current ? (clearInterval(a.current), a.current = setInterval(() => {
      i.current = Math.max(i.current - 250, 0), s();
    }, 250)) : !o.current && i.current !== e && clearInterval(a.current), i.current === 0 && (clearInterval(a.current), o.current = false, n && n());
  }
  function r(u) {
    u && (i.current = u), o.current = true, s();
  }
  function c() {
    o.current = false, clearInterval(a.current);
  }
  function p() {
    i.current = e, o.current = false;
  }
  return { run: s, time: i, start: r, pause: c, reset: p };
}, bd = ({ children: e, onClick: n }) => d(wd, { onClick: n, children: [t("div", { className: "icn", children: e }), t(An, { size: 54, lineSize: 1 })] }), wd = l.button`
  position: relative;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  svg {
    transform: rotate(15deg);
    width: 32px;
    height: auto;
  }

  .highlight {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media all and (pointer: fine) {
    .icn {
      transform: scale(1) translateZ(0);
      transition: transform 0.6s ease;
    }
    &:hover {
      .icn {
        transform: scale(1.1) translateZ(0);
      }
    }
  }
`, yd = ({ actions: e }) => t(T, { children: e.map((n, i) => t(bd, { onClick: n.onClick, children: n.icon }, i)) }), Cd = ({ data: e, close: n }) => {
  const { t: i } = /* @__PURE__ */ x("common"), o = /* @__PURE__ */ K("isMobile"), { start: a, pause: s } = /* @__PURE__ */ vd(7e3, () => {
    b("close-toast");
  });
  return w(() => {
    e?.closeTime && !n && a(e.closeTime * 1e3);
  }, [e, n, a]), d(kd, { className: e && !n ? "show" : "", onMouseEnter: o ? null : () => {
    s();
  }, onMouseLeave: o ? null : () => {
    a();
  }, children: [t("h3", { className: "secFontTxtSml", dangerouslySetInnerHTML: { __html: i(e?.label) } }), e?.actions ? t(yd, { actions: e?.actions }) : null] });
}, No = () => {
  const [e, n] = /* @__PURE__ */ m(null), [i, o] = /* @__PURE__ */ m(false);
  return j("help-toast", (a) => {
    o(false), n(a);
  }), j("close-toast", () => {
    o(true);
  }), t(Cd, { data: e, close: i });
}, kd = l.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 30px;
  gap: 30px;

  z-index: 1;

  position: fixed;
  left: 50%;
  bottom: 40px;

  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 10px;

  transform: translate3d(-50%, calc(100% + 45px), 0);
  transition: transform 0.5s cubic-bezier(0.535, -0.18, 0.735, 0.045);
  pointer-events: none;

  &.show {
    pointer-events: all;
    transform: translate3d(-50%, 0, 0);
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.46, 1.13);
  }

  @media all and (max-width: 1300px) {
    bottom: 120px;
    transform: translate3d(-50%, calc(100% + 125px), 0);
  }

  @media all and (max-width: 760px) {
    display: none;
  }

  @media all and (max-width: 580px) {
    min-width: auto;
    width: calc(100% - 40px);
    left: 20px;
    right: 20px;
    bottom: 80px;
    transform: translate3d(0, calc(100% + 85px), 0);
    padding: 20px 15px;
    justify-content: space-between;

    h3 {
      font-size: 14px;
      line-height: 19px;
    }
    &.show {
      transform: translate3d(0, 0, 0);
    }
  }

  @media all and (max-width: 374px) {
    width: calc(100% - 10px);
    left: 5px;
    right: 5px;
  }
`;
l.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #ffffff;
  transition: transform 0.01s ease;
  transform: scaleX(0) translateZ(0);
  transform-origin: left center;
`;
const Sd = ({ data: e, setData: n }) => {
  const [i, o] = /* @__PURE__ */ m(false), { t: a } = /* @__PURE__ */ x("common"), s = () => {
    o(false), setTimeout(() => {
      n(null);
    }, 300);
  };
  return w(() => {
    e && o(true), e?.timeClose && setTimeout(s, e?.timeClose);
  }, [e, n]), j("message-toast-close", s), t(Ld, { className: `${i ? "show" : ""}`, children: t("div", { children: t("p", { dangerouslySetInnerHTML: { __html: a(e?.message) } }) }) });
}, Ao = ({ initialData: e = null }) => {
  const [n, i] = /* @__PURE__ */ m(e);
  return j("message-toast", (o) => {
    i(o);
  }), t(Md, { children: t(Sd, { data: n, setData: i }) });
}, Md = l.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
  bottom: 20px;

  pointer-events: none;
`, Ld = l.div`
  display: block;
  padding: 9px 30px;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 99px;

  transform: translate3d(0, calc(100% + 22px), 0);
  transition: transform 0.5s ease;

  &.show {
    transform: translate3d(0, 0, 0);
  }
`, Id = () => d("svg", { width: "396", height: "70", viewBox: "0 0 396 70", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M56.0138 42.5321V2.04302H40.0758V42.5321C40.0758 47.0523 38.8588 50.3189 36.9655 52.4216C35.1094 54.483 32.2979 55.768 28.3546 55.768C24.4496 55.768 21.6347 54.5009 19.7687 52.4458C17.8691 50.3537 16.6333 47.0906 16.6333 42.5321V2.04302H0.695312V42.5321C0.695312 50.6945 3.2695 57.5806 8.2169 62.4247C13.1565 67.2611 20.1386 69.7459 28.3546 69.7459C36.5705 69.7459 43.5526 67.2611 48.4922 62.4247C53.4396 57.5806 56.0138 50.6945 56.0138 42.5321Z", fill: "white" }), t("path", { d: "M87.5259 16.3772V68.5876H103.464V24.8897L95.4785 16.3772H123.6V2.04302H67.301V16.3772H87.5259Z", fill: "white" }), t("path", { d: "M167.542 23.4992L168.067 25.8214H184.548L183.992 22.368C182.812 15.041 179.455 9.56741 174.548 5.97149C169.697 2.41651 163.592 0.884766 157.172 0.884766C149.71 0.884766 143.612 3.00787 139.328 6.65047C135.025 10.3088 132.721 15.3688 132.721 20.7926C132.721 27.7866 135.439 32.466 139.688 35.5439C143.691 38.4446 148.854 39.763 153.422 40.7551C154.303 40.9465 155.158 41.1257 155.987 41.2994C159.728 42.0827 162.923 42.7518 165.422 43.9071C166.87 44.5769 167.838 45.312 168.448 46.1246C169.024 46.8907 169.428 47.9177 169.428 49.4816C169.428 51.3099 168.74 52.6775 167.404 53.6784C165.964 54.756 163.511 55.5899 159.756 55.5899C156.151 55.5899 153.512 54.7596 151.65 53.4214C149.817 52.1038 148.474 50.1066 147.77 47.2532L147.211 44.9874H130.828L131.53 48.5434C132.902 55.5048 136.203 60.9066 141.204 64.525C146.159 68.1102 152.507 69.7459 159.667 69.7459C166.766 69.7459 173.215 67.963 177.962 64.2893C182.795 60.5496 185.634 55.0162 185.634 48.1452C185.634 41.0656 182.936 36.296 178.694 33.147C174.682 30.1689 169.512 28.8212 164.919 27.8457C163.793 27.6065 162.708 27.3898 161.668 27.1821C158.197 26.4887 155.221 25.8943 152.84 24.8897C151.37 24.2693 150.417 23.5973 149.833 22.8808C149.299 22.2262 148.926 21.3585 148.926 19.9908C148.926 18.5139 149.493 17.4283 150.589 16.6191C151.785 15.7367 153.829 15.0408 156.905 15.0408C160.019 15.0408 162.278 15.7581 163.896 17.005C165.499 18.2405 166.808 20.2539 167.542 23.4992Z", fill: "white" }), t("path", { d: "M252.93 42.5321V2.04302H236.992V42.5321C236.992 47.0523 235.775 50.3189 233.882 52.4216C232.026 54.483 229.215 55.768 225.271 55.768C221.366 55.768 218.551 54.5009 216.685 52.4458C214.786 50.3537 213.55 47.0906 213.55 42.5321V2.04302H197.612V42.5321C197.612 50.6945 200.186 57.5806 205.134 62.4247C210.073 67.2611 217.055 69.7459 225.271 69.7459C233.487 69.7459 240.469 67.2611 245.409 62.4247C250.356 57.5806 252.93 50.6945 252.93 42.5321Z", fill: "white" }), t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M268.138 2.04302V68.5876H296.421C303.529 68.5876 309.599 66.9095 313.952 63.393C318.391 59.8061 320.694 54.5856 320.694 48.3234C320.694 44.1804 319.52 40.4174 317.124 37.3469C315.852 35.717 314.28 34.3379 312.45 33.2151C315.605 30.2685 317.309 26.2116 317.309 21.5054C317.309 15.5521 314.892 10.5518 310.512 7.11174C306.21 3.7333 300.26 2.04302 293.392 2.04302H268.138ZM293.124 15.9318C296.084 15.9318 298.073 16.6822 299.267 17.6791C300.397 18.6212 301.103 20.0154 301.103 22.04C301.103 23.7881 300.459 25.097 299.31 26.0302C298.095 27.016 296.045 27.7918 292.946 27.7918H284.076V15.9318H293.124ZM295.173 41.5024C298.608 41.5024 300.958 42.3345 302.383 43.4576C303.728 44.518 304.489 46.0166 304.489 48.0561C304.489 50.1693 303.736 51.7201 302.504 52.7831C301.227 53.8852 299.152 54.6989 296.153 54.6989H284.076V41.5024H295.173Z", fill: "white" }), t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M363.578 69.7459C373.221 69.7459 381.325 66.5121 387.001 60.3957C392.653 54.3053 395.603 45.6748 395.603 35.4044C395.603 25.1348 392.653 16.4652 387.009 10.3329C381.339 4.17211 373.234 0.884766 363.578 0.884766C353.841 0.884766 345.711 4.1673 340.036 10.3329C334.389 16.4688 331.464 25.1409 331.464 35.4044C331.464 45.6686 334.39 54.3018 340.045 60.3957C345.725 66.5168 353.855 69.7459 363.578 69.7459ZM363.578 55.4117C358.447 55.4117 354.585 53.5559 351.947 50.3502C349.249 47.0724 347.581 42.0707 347.581 35.4044C347.581 28.6895 349.251 23.639 351.954 20.3267C354.597 17.0889 358.458 15.219 363.578 15.219C368.697 15.219 372.532 17.0871 375.152 20.319C377.835 23.6294 379.487 28.6813 379.487 35.4044C379.487 42.0791 377.837 47.0821 375.159 50.3579C372.544 53.5576 368.708 55.4117 363.578 55.4117Z", fill: "white" })] }), Eo = ({ fixed: e = true }) => {
  const [n, i] = /* @__PURE__ */ S((s) => [s.hideUI, s.uiSettings]), o = /* @__PURE__ */ ve((s) => s.lang), a = !i?.isPaintGame;
  return d($d, { className: `${e ? "fixed" : ""} ${n ? "" : "show"}`, href: a ? `https://konpi.${o === "en" ? "com" : "jp"}` : "https://utsubo.co", target: "_blank", rel: "noreferrer", children: [t("p", { children: "POWERED BY" }), a ? t("img", { src: M["/icons/logo.svg"], alt: "KONPI", loading: "lazy", width: "36px", height: "18px" }) : t(Id, {})] });
}, $d = l.a`
  pointer-events: all;
  display: flex;
  gap: 4px;
  white-space: nowrap;

  &.fixed {
    position: fixed;
    left: 40px;
    bottom: 10px;
    z-index: 1;

    transform: translate3d(0, 40px, 0);
    transition: transform 0.6s ease;

    &.show {
      transform: translate3d(0, 0, 0);
      transition-delay: 0.25s;
    }

    @media all and (max-width: 1024px) {
      left: 30px;
    }
  }

  img {
    clip-path: none;
  }

  svg {
    width: 50px;
    height: auto;
  }

  p,
  img,
  svg {
    opacity: 0.7;
  }

  @media all and (pointer: fine) {
    p,
    img,
    svg {
      transition: opacity 0.2s ease;
    }
    &:hover {
      p,
      img,
      svg {
        opacity: 1;
      }
    }
  }
`, Do = l.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  position: relative;
  width: 100%;
  cursor: pointer;
  ${(e) => e.theme.bodyText3}

  h5 {
    display: block;
    padding: 0 0 5px;
  }

  &.disabled {
    opacity: 0.4;
    cursor: default;
  }

  &.nolabel {
    height: 34px;
    margin: 0;
    padding: 0 60px 0 0;
  }
`, zo = l.input`
  position: absolute;
  opacity: 0;
`, Td = l.span`
  position: relative;
  display: block;
  height: 26px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 80px;
  span {
    position: absolute;
    display: block;
    width: 34px;
    height: 18px;
    background: rgba(105, 255, 92, 0.4);
    border-radius: 130px;
    left: 4px;
    top: 4px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
  }

  &::before {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #fafafa;
    border-radius: 80px;
    opacity: 0.7;
    transition: opacity 0.3s ease;
  }

  &:after {
    z-index: 1;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ffffff;
    transform: translate3D(calc(-50% - 7px), -50%, 0);
    transition: transform 0.3s ease;
  }
  &.active {
    &::before,
    span {
      opacity: 1;
    }
    &:after {
      transform: translate3D(calc(-50% + 7px), -50%, 0);
    }
  }
`, Nd = ({ defaultChecked: e, click: n, disabled: i, children: o, ...a }) => {
  const s = /* @__PURE__ */ k(null);
  return d(Do, { ...a, className: `${i ? "disabled" : ""} ${o ? "" : "nolabel"}`, children: [o, t(zo, { type: "checkbox", ref: s, defaultChecked: e, ...i ? { disabled: true } : {}, onClick: () => {
    n(), s.current && s.current.blur();
  } }), t(Td, { className: `checkmark ${e ? "active" : ""}`, children: t("span", {}) })] });
}, de = ({ show: e, click: n, label: i, description: o, disabled: a, tr: s = "common" }) => {
  const { t: r } = /* @__PURE__ */ x(s);
  return t(Nd, { defaultChecked: e, click: n, disabled: a, children: d("div", { children: [t("h5", { className: "secfont", children: r(i) }), r(o)] }) });
}, Ad = ({ label: e, tr: n = "office" }) => {
  const { t: i } = /* @__PURE__ */ x(n);
  return t(Ed, { children: t("span", { className: "secFontTxtSml", children: i(e) }) });
}, Ed = l.div`
  display: flex;
  padding: 6px 10px;
  background: #484848;
  border-radius: 40px;

  span {
    font-weight: 400;
    font-size: 11px;
    color: #ffdf6f;
  }
`, Dd = (e, n) => e.some((i) => i.deviceId === n), Po = async (e, n) => {
  const i = await navigator.mediaDevices.enumerateDevices(), o = /* @__PURE__ */ i.filter((r) => r.kind === n);
  if (!o.length)
    return null;
  if (Dd(o, e))
    return e;
  const a = /* @__PURE__ */ o.find((r) => r.deviceId === "default" || r.deviceId === "communications");
  if (a) {
    const r = /* @__PURE__ */ i.find((c) => c.groupId === a.groupId && c.deviceId !== "default" && c.deviceId !== "communications");
    if (r)
      return r.deviceId;
  }
  return i.find((r) => r.deviceId !== "default" && r.deviceId !== "communications") ? o[0].deviceId : i[0].deviceId;
}, zd = /* @__PURE__ */ bt(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]), Pd = l.div`
  border: 2px solid rgba(0, 0, 0, 0.1);
  width: 48px;
  height: 48px;
  padding: 6px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: ${zd} 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -24px;
  margin-top: -24px;
`, _o = () => t(Wd, { children: t("img", { className: "icn-webcam", src: M["/icons/cam-off.svg"], alt: "camera" }) }), _d = ({ setLoading: e, show: n, trackingEnabled: i }) => {
  const o = /* @__PURE__ */ O((c) => c.settings.privacy.videoEnabled), a = /* @__PURE__ */ O((c) => c.media?.video), s = /* @__PURE__ */ Te((c) => c.participants.size), r = /* @__PURE__ */ ee(async (c) => {
    const p = await Po(c, "videoinput");
    p !== c && le({ media: { ...$().media, video: p } });
  }, []);
  return w(() => {
    o && a && r(a);
  }, [o, a]), o || i ? t(Zs, { videoBackground: o, autAsked: () => {
    he().userMediaUpdate(false, true);
  }, tracking: !!(i && (n || s > 1)), show: n, setLoading: e, loader: t(Pd, {}), videoDeviceId: a }) : t(_o, {});
}, jd = ({ show: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ yt((a) => a.videoAccessEnabled), o = /* @__PURE__ */ O((a) => a.settings.privacy.trackingEnabled);
  return w(() => {
    !i && o && navigator.mediaDevices.getUserMedia({ video: true }).then((a) => {
      Us({ videoAccessEnabled: true }), a.getTracks().forEach((s) => s.stop());
    }).catch((a) => {
      console.error("Error accessing the camera", a);
    });
  }, [i, o]), d(Rd, { className: "preview", children: [t(Hd, { children: t(T, { children: i ? t(_d, { show: e, trackingEnabled: o }) : t(_o, {}) }) }), t("p", { className: "normalTxt", children: n(i ? "facetracking-avatar-desc" : "video-access-disabled") })] });
}, Fd = () => {
  const e = /* @__PURE__ */ O((s) => s.settings.privacy.videoEnabled), n = /* @__PURE__ */ O((s) => s.settings.privacy.trackingEnabled), i = /* @__PURE__ */ We((s) => s.toggleVideoCall), o = /* @__PURE__ */ ee(async (s) => {
    const r = /* @__PURE__ */ cn().peers.get($().id), { settings: c } = /* @__PURE__ */ $();
    c.privacy[s] = !c.privacy[s];
    const p = {};
    if (p[s] = c.privacy[s], b("setSettings", { privacy: p }), r) {
      const u = $().settings.privacy.videoEnabled;
      await i($().id, u);
    }
    le({ settings: c });
  }, []), a = /* @__PURE__ */ S((s) => s.workspaceDoc?.plan?.videoCall);
  return d(Ud, { className: "stgs", children: [t(de, { show: n, click: () => o("trackingEnabled"), label: "facetracking", description: "facetracking-desc", tr: "office" }), d("div", { children: [t(de, { show: e && a, click: () => o("videoEnabled"), label: "video-settings", description: "video-settings-desc", tr: "office", disabled: !a }), a ? null : t(Vd, { children: t(Ad, { label: "available-from-standard" }) })] })] });
}, Od = ({ active: e }) => {
  const [n, i] = /* @__PURE__ */ m(false), o = /* @__PURE__ */ K("isMobile");
  return ue(() => {
    setTimeout(() => {
      i(true);
    }, 1);
  }, []), d(Bd, { className: `${n && e ? "show" : ""} ${o ? "sp" : ""}`, onMouseEnter: (a) => {
    a.stopPropagation(), C({ showCameraQuickSettings: true });
  }, onMouseLeave: (a) => {
    a.stopPropagation(), C({ showCameraQuickSettings: false });
  }, children: [t(jd, { show: e }), t(Fd, {})] });
}, En = () => {
  const e = /* @__PURE__ */ S((a) => a.showCameraQuickSettings), [n, i] = /* @__PURE__ */ m(false), o = /* @__PURE__ */ k(null);
  return w(() => (o.current && clearTimeout(o.current), e ? i(true) : o.current = setTimeout(() => {
    i(false);
  }, 200), () => {
    o.current && clearTimeout(o.current);
  }), [e]), t(Od, { active: n });
}, Bd = l.div`
  position: fixed;
  bottom: 84px;
  right: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 374px;
  padding: 20px;
  pointer-events: none;
  z-index: 2;

  opacity: 0;
  transition: opacity 0.2s ease;

  &.show {
    opacity: 1;
    pointer-events: all;
  }

  @media all and (max-width: 767px) {
    bottom: 55px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    padding: 20px;

    &.sp {
      padding: 0;
      width: 100%;
      max-width: 480px;
    }
  }

  @media all and (max-width: 480px) {
    left: 0;
    transform: none;
    &.sp {
      .stgs {
        border-radius: 0;
      }
      .preview {
        max-width: calc(100% - 20px);
        margin: 0 auto;
      }
    }
  }
`, Ud = l.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 15px;
  background: #2d2d2d;
  border-radius: 10px;
`, Rd = l.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  gap: 10px;
  isolation: isolate;
  background: #222222;
  border-radius: 10px;
`, Hd = l.div`
  width: 100%;
  height: 175px;
  background: #000;
  border-radius: 5px;
  position: relative;
`, Wd = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  img {
    width: 70px;
    height: auto;
  }
`, Vd = l.div`
  display: flex;
  padding: 5px 0 0;
`, jo = () => {
  const e = /* @__PURE__ */ z((o) => o.microverseWaitlistLive), [n, i] = /* @__PURE__ */ m([]);
  return w(() => {
    const o = e;
    if (o.length > 0) {
      const a = o[0];
      if (n.includes(a.id))
        return;
      b("notification:guest", { user: a }), i([...n, a.id]);
    }
  }, [e, n]), null;
}, Me = () => t("svg", { className: "clsicn", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 11", children: t("path", { d: "M2.13574 10.0909 10.5773 1M1.48673 1l9.09087 9.0909", stroke: "#fff", strokeWidth: "1.2", strokeLinecap: "round" }) }), jt = ({ show: e, onClick: n }) => t(Zd, { className: `clsmbtn ${e ? "show" : ""}`, onClick: n, children: t("div", { children: t(Me, {}) }) }), Zd = l.button`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
  padding: 0 0 8px 8px;
  div {
    position: relative;
    width: 40px;
    height: 40px;
    background: #2d2d2d;

    border-bottom-left-radius: 50px 50px;
    svg {
      position: absolute;
      top: 11px;
      right: 12px;
      width: 12px;
      height: 11px;
    }
  }
`, rt = ({ isAccept: e = false, loading: n }) => t(qd, { className: e ? "accept" : "", children: n ? t(Yd, { children: t(Et, { className: "mss" }) }) : e ? t(Gi, {}) : t(Me, {}) }), qe = ({ isAccept: e, action: n, loading: i }) => t(Gd, { onClick: n, className: `${e ? "accept" : ""} ${i ? "disable" : ""}`, children: t(rt, { isAccept: e, loading: i }) }), Gd = l.button`
  padding: 0 7px;

  .mss {
    border-left-color: #f33182;
  }

  &.accept {
    .mss {
      border-left-color: #49e162;
    }
  }

  &.disable {
    pointer-events: none;
  }

  @media all and (pointer: fine) {
    svg {
      transition: stroke 0.2s ease;
    }
    div {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0) scale(0);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #f33182;
        transition: transform 0.2s ease;
      }
    }
    &.accept {
      div {
        &::before {
          background: #49e162;
        }
      }
    }

    &:hover {
      div {
        &::before {
          transform: translate3d(-50%, -50%, 0) scale(1);
        }
        svg {
          path {
            stroke: #2d2d2d;
          }
        }
      }
    }
  }
`, qd = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  border: 1.2px solid #f33182;
  border-radius: 50%;

  svg {
    position: relative;
    z-index: 1;
    width: 10px;
    height: auto;
    path {
      stroke: #f33182;
    }
  }

  &.accept {
    border-color: #49e162;

    svg {
      width: 11px;
      path {
        stroke: #49e162;
      }
    }
  }
`, Yd = l.div`
  position: relative;
  width: 16px;
  height: 16px;
`, Fo = ({ color: e = "#fff" }) => d("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 20", children: [t("path", { d: "M8.8 2.4h0c3.6 0 6.4 2.9 6.4 6.4v4.7c0 .1.1.2.2.2h0c.8 0 1.5.7 1.5 1.5h0c0 .9-.7 1.6-1.5 1.6h-13c-.9 0-1.5-.7-1.5-1.5V15c0-.7.6-1.3 1.3-1.3h0c.1 0 .1-.1.1-.1V8.9c0-3.6 2.9-6.5 6.5-6.5h0zm0 0V.7", fill: "none", stroke: e, strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t("path", { d: "M11.3 16.8c-.3 3-4.6 3-5 0", fill: "none", stroke: e, strokeWidth: "1.2" })] }), Kd = ({ toastId: e, visible: n, data: i }) => {
  const o = /* @__PURE__ */ S((c) => c.acceptUser), { t: a } = /* @__PURE__ */ x("office"), [s, r] = /* @__PURE__ */ m(false);
  return ue(() => {
    setTimeout(() => {
      r(true);
    }, 1);
  }, []), d(Go, { className: `${n && s ? "visible" : ""}`, children: [i.icon ? t(_n, { children: i.icon }) : t(Fo, { color: "#F33182" }), t("span", { children: a("guest-want-enter", { name: i.user.name || a("anonymous") }) }), i.user ? d(Jd, { children: [t(qe, { isAccept: true, action: () => {
    o("waitlist", true, i.user), fe.dismiss(e);
  } }), t(qe, { action: () => {
    o("waitlist", false, i.user), fe.dismiss(e);
  } })] }) : null] });
}, Jd = l.div`
  display: flex;
  align-items: center;
  gap: 2px;
  button {
    padding: 0 3px;
  }
`, Xd = ({ action: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i, o] = /* @__PURE__ */ m(false), [a, s] = /* @__PURE__ */ m(25), r = () => {
    o(true), e && e();
  };
  return w(() => {
    let c;
    return i ? (clearInterval(c), c = setInterval(() => {
      clearInterval(c), s(60), o(false);
    }, 1e4)) : c = setInterval(() => {
      s((p) => p - 1);
    }, 1e3), () => clearInterval(c);
  }, [i]), w(() => {
    !i && a <= 0 && r();
  }, [a, i]), d(ip, { className: i ? "" : "sb", children: [i ? t(op, { children: t(Et, {}) }) : null, t("p", { className: "secFontTxtSml", children: i ? n("reconnecting") : n("attempting-reconnect", { time: a }) }), i ? null : t(ap, { className: "secFontTxtSml", onClick: r, children: n("reconnect") })] });
}, Qd = ({ toastId: e, visible: n }) => {
  const i = /* @__PURE__ */ S((h) => h.serverErrors), { t: o } = /* @__PURE__ */ x("office"), [a, s] = /* @__PURE__ */ m(false);
  ue(() => (C({ notifServerOpen: true }), setTimeout(() => {
    s(true);
  }, 1), () => {
    C({ notifServerOpen: false });
  }), []);
  const r = /* @__PURE__ */ S((h) => h.isOnline);
  j("notification:server:close", (h) => {
    const f = N().serverErrors, v = /* @__PURE__ */ f.findIndex((g) => g.type === h.type);
    v > -1 && (f.splice(v, 1), C({ serverErrors: f })), f.length === 0 && fe.dismiss(e);
  });
  const c = r && i.length > 0, p = c ? i[0].type : "internet", u = c ? i[0].action : null;
  return d(ep, { className: `${n && a ? "visible" : ""}`, children: [d(tp, { children: [d(np, { children: [t(_n, { children: t("img", { src: M["/icons/warning.svg"], alt: "alert" }) }), t("span", { className: "secFontTxtSml", children: o(`${p}-error-title`) })] }), t("p", { className: "desc", children: o(`${p}-error-desc`) })] }), u ? t(Xd, { action: u }) : null] });
}, ep = l.div`
  position: relative;
  background: #222;
  border-radius: 10px;

  overflow: hidden;
  isolation: isolate;

  max-width: 360px;

  transition: transform 230ms cubic-bezier(0.21, 1.02, 0.73, 1),
    opacity 230ms cubic-bezier(0.21, 1.02, 0.73, 1);
  transform: translate3d(0, -20px, 0);
  opacity: 0;

  svg {
    width: 12px;
    height: auto;
    path {
      stroke-width: 2px;
    }
  }

  &.closable {
    padding-right: 58px;
  }

  &.visible {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  .desc {
    opacity: 0.9;
  }
`, tp = l.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 20px;
`, np = l.div`
  display: flex;
  gap: 8px;
  align-items: center;
`, ip = l.div`
  padding: 12px 20px;
  background-color: #111;
  display: flex;
  gap: 9px;
  align-items: center;
  p {
    font-size: 12px;
  }

  &.sb {
    justify-content: space-between;
  }
`, op = l.div`
  position: relative;
  width: 18px;
  height: 24px;

  div {
    padding: 0;
    border-left-color: #fff;
  }
`, ap = l.button`
  white-space: nowrap;
  background: #222;
  font-weight: 400;
  border: solid 1px #f33182;
  padding: 2px 7px 3px;
  border-radius: 4px;
  font-size: 12px;

  @media all and (pointer: fine) {
    transition: background-color 0.2s ease;
    &:hover {
      background: #f33182;
    }
  }
`, sp = ({ action: e, close: n }) => {
  const { t: i } = /* @__PURE__ */ x();
  return t(lp, { onClick: () => {
    e.action && e.action(), n();
  }, className: `secfont ${e.cls || ""}`, children: t("span", { children: i(e.label) }) });
}, Oo = ({ actions: e, close: n, rightAlign: i }) => t(rp, { className: i ? "right" : "", children: e.map((o, a) => t("li", { children: t(sp, { action: o, close: n }) }, a)) }), rp = l.ul`
  position: absolute;
  z-index: 10;
  top: calc(100% + 1px);
  left: 0;
  background: #1b1b1b;
  border-radius: 5px;
  overflow: hidden;

  &.right {
    left: auto;
    right: 0;
  }

  li {
    &:last-child {
      border-bottom: none;
    }
  }
`, lp = l.button`
  position: relative;
  width: 100%;
  min-width: 186px;
  text-align: left;
  overflow: hidden;
  padding: 12px 17px;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.04em;
  border: solid 1px #2d2d2d;

  span {
    position: relative;
    z-index: 1;
    white-space: nowrap;
  }

  &.warning {
    color: #f33182;
  }

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 0;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
`, lt = ({ action: e, icon: n, big: i, tooltip: o, cls: a = "", tr: s = "common", disabled: r }) => {
  const { t: c } = /* @__PURE__ */ x(s), p = /* @__PURE__ */ k();
  return d(dp, { ref: p, onClick: () => {
    p.current && p.current.blur(), e();
  }, className: `${i ? "big" : ""} ${a} ${r ? "disabled" : ""}`, children: [o ? t(pp, { className: "tt", children: t("span", { children: c(o) }) }) : null, t("div", { className: "icn", children: n })] });
}, Ft = ({ icon: e, tooltip: n, actions: i, big: o, rightAlign: a }) => {
  const [s, r] = /* @__PURE__ */ m(false), c = /* @__PURE__ */ k();
  return w(() => {
    const p = (u) => {
      c.current && !c.current.contains(u.target) && (r(false), document.removeEventListener("mousedown", p));
    };
    return s && document.addEventListener("mousedown", p), () => {
      document.removeEventListener("mousedown", p);
    };
  }, [s]), d(cp, { ref: c, className: s ? "active" : "", children: [t(lt, { icon: e, action: () => {
    r(!s);
  }, big: o }), s ? t(Oo, { actions: i, close: () => {
    r(false);
  }, rightAlign: a }) : null] });
}, cp = l.div`
  position: relative;
`, dp = l.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 7px;

  &.rotate {
    svg {
      transform: rotate(180deg);
    }
  }
  .accepticn {
    width: 12px;
    height: auto;
  }
  .sorticn {
    width: 13px;
    height: auto;
  }
  img {
    clip-path: none;
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  .icn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;

    svg {
      position: relative;
      z-index: 1;
    }
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0) scale(0.7);
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0;
      border-radius: 50%;
      transition: opacity 0.3s ease, transform 0.3s ease;
      z-index: 0;
    }
  }

  &.big {
    .icn {
      width: 34px;
      height: 34px;
    }
  }

  &.active {
    .icn {
      &::before {
        opacity: 0.4;
        transform: translate3d(-50%, -50%, 0) scale(1);
      }
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      .tt {
        opacity: 1;
        transform: translate3d(-50%, -100%, 0);
        transition: opacity 0.3s ease, transform 0.3s ease;
      }

      .icn {
        &::before {
          opacity: 0.4;
          transform: translate3d(-50%, -50%, 0) scale(1);
        }
      }
    }
  }
`, pp = l.div`
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translate3d(-50%, 0%, 0);

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.3s ease;

  span {
    display: block;
    padding: 5px 10px;
    background: #000;
    white-space: nowrap;
    border-radius: 5px;
    pointer-events: none;

    font-family: 'Mundial';
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
`, Dn = new it.Quaternion(), Bo = new it.Euler(), Uo = new it.Quaternion(), up = (e, n) => (Dn.setFromEuler(Bo.set(0, n.params.orientation, 0, "YXZ")), Uo.setFromEuler(Bo.fromArray(e.rotation)), Dn.multiply(Uo), Dn), ct = async (e, n, i) => {
  const { microverseId: o } = /* @__PURE__ */ R(), { playersMeshes: a } = /* @__PURE__ */ on(), s = a[n.id];
  if (!s) {
    b("notification:error", { message: i("user-not-online") });
    return;
  }
  if (e === "you_to_them") {
    const r = [], c = [];
    s.position.toArray(r), s.quaternion.toArray(c), Ys(r, c);
  } else if (e === "them_to_you") {
    const r = await $().user.getIdToken(), c = a[$().id];
    await fetch(`${window.location.origin}/api/${o}/request-tp`, { method: "POST", body: JSON.stringify({ guestId: n.id, destPos: c.position.toArray(), destQuat: c.quaternion.toArray() }), headers: { authorization: `Bearer ${r}` } });
  } else {
    const r = await $().user.getIdToken();
    await fetch(`${window.location.origin}/api/${o}/request-tp`, { method: "POST", body: JSON.stringify({ guestId: n.id, destPos: e.position, destQuat: up(e, e.events.find((c) => c.eventId === "teleportArea")).toArray() }), headers: { authorization: `Bearer ${r}` } });
  }
}, hp = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ S((a) => a.teleportAreas || []), o = /* @__PURE__ */ Y(() => [{ label: "you_to_them", action: () => {
    ct("you_to_them", e, n);
  } }, { label: "them_to_you", action: () => {
    ct("them_to_you", e, n);
  } }, ...i.map((a) => ({ label: a.events.find((s) => s.eventType === "teleportArea").name, action: () => {
    ct(a, e, n);
  } }))], [e, i, i.length]);
  return t(Ft, { actions: o, icon: t("img", { src: M["/icons/admin/teleport.svg"], alt: "teleport" }) });
}, fp = l.img`
  width: 100%;
  border-radius: 100%;
  height: 100%;
  object-fit: cover;
`, mp = ({ hasProfilePic: e, userId: n, profilePicUid: i, alt: o, profilePicture: a }) => {
  const s = M["/placeholder/profilepic.jpg"], r = /* @__PURE__ */ Ne(e ? `${Ae.profilePicturePath + n}/profile.webp${i ? `?v=${i}` : ""}` : s, s);
  return t(fp, { id: "preview_status_avatar", src: e ? r : a || r, onError: (c) => {
    c.target.onerror = null, c.target.src = r;
  }, alt: o });
}, Ye = ({ hasProfilePic: e, userId: n, profilePicUid: i, alt: o = "avatar", profilePicture: a }) => t(q, { fallback: null, children: t(mp, { hasProfilePic: e, userId: n, profilePicUid: i, alt: o, profilePicture: a }) }), Ot = () => {
  const [e, n, i] = /* @__PURE__ */ O((a) => [a.user, a.hasProfilePic, a.profilePicUid]), o = /* @__PURE__ */ O((a) => a.profilePicture);
  return e ? t(Ye, { hasProfilePic: n, userId: e.uid, profilePicUid: i, alt: e.name, profilePicture: o }) : null;
}, me = (e, n = "default", i, o) => {
  if (!e)
    return "N/A";
  if (typeof e == "string")
    return e;
  const a = /* @__PURE__ */ new Date(), s = new Date((e._seconds || e.seconds) * 1e3), r = a.getDate() === s.getDate() && a.getMonth() === s.getMonth() && a.getFullYear() === s.getFullYear(), c = a.getMonth() === s.getMonth(), p = a.getFullYear() === s.getFullYear(), u = o || { hour: "2-digit", minute: "2-digit", day: !r && i ? "numeric" : void 0, month: !c && i ? "short" : void 0, year: !p && i ? "numeric" : void 0, weekday: r ? void 0 : "short" };
  return new Intl.DateTimeFormat(n, u).format(s);
}, gp = ({ lastSeenByMsgId: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), { usersById: i } = /* @__PURE__ */ R();
  return t(yp, { children: t("span", { title: (() => {
    let a = "";
    return e.forEach(({ userId: s, at: r }) => {
      const c = i[s];
      c && (a += c?.name || n("anonymous"), s !== e[e.length - 1].userId && (a += `
`));
    }), a;
  })(), children: n("unread") }) });
}, xp = ({ data: e, convId: n }) => {
  const i = R().usersById[e.userId], o = /* @__PURE__ */ S((r) => r.convsData[n]?.lastSeenByMsgId[e.id]), a = i?.name?.length > 0 ? i.name : "anonymous", s = /* @__PURE__ */ Y(() => {
    if (!/<a\s/i.test(e.message))
      return e.message;
    const c = /* @__PURE__ */ new DOMParser().parseFromString(e.message, "text/html"), p = /* @__PURE__ */ c.getElementsByTagName("a");
    for (let u = 0; u < p.length; u++)
      p[u].setAttribute("target", "_blank"), p[u].setAttribute("rel", "noopener noreferrer");
    return c.body.innerHTML;
  }, [e.message]);
  return d(vp, { children: [d(bp, { children: [t("div", { className: "visual", children: t(Ye, { alt: a, hasProfilePic: i.hasProfilePic, userId: i.id, profilePicUid: i.profilePicUid }) }), d(wp, { children: [d("div", { className: "lbl", children: [t("h6", { className: "secFontTxtSml", children: a }), t("span", { className: "secFontTxtSmlLight", children: me(e.date) })] }), o ? t(gp, { lastSeenByMsgId: o }) : null] })] }), t("div", { className: "secfont markdown", dangerouslySetInnerHTML: { __html: s } })] });
}, vp = l.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  gap: 5px;

  width: 100%;

  background: #2d2d2d;
  border-radius: 10px;

  .markdown {
    p,
    strong,
    a,
    em,
    span,
    code,
    del {
      user-select: text;
    }
  }

  & > div {
    width: 100%;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.05em;

    p {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 0.05em;
    }
  }
`, bp = l.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .visual {
    min-width: 24px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    isolation: isolate;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      clip-path: none;
    }
  }
`, wp = l.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 100%;

  .lbl {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  h6 {
    font-size: 12px;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    font-size: 12px;
    text-transform: uppercase;
    opacity: 0.5;
  }
`, yp = l.div`
  span {
    font-size: 9px;
    opacity: 1;
    color: #f33182;
  }
`, dt = "/icons/status/", Ro = [{ id: "default", icon: null }, { id: "meeting", resetAfter: 3600, icon: `${dt}meeting.png` }, { id: "lunch", resetAfter: 3600, icon: `${dt}lunch.png` }, { id: "focus", icon: `${dt}working-man.png`, resetAfter: 7200 }, { id: "sick", resetAfter: "today", icon: `${dt}sick.png` }, { id: "holiday", icon: `${dt}holiday.png` }], pt = (e) => Ro.find((n) => n.id === e), Cp = ({ online: e = true }) => t($p, { className: e ? "on" : "" }), kp = () => t(Np, { className: "", children: t("img", { src: M["/emojis/1f590-fe0f.webp"], alt: "raised-hand" }) }), ut = ({ user: e, showOnline: n = true, self: i }) => {
  const [o, a, s, r, c] = /* @__PURE__ */ z((p) => {
    const u = p.usersById[e.id];
    return [u?.name, u?.id, u?.hasProfilePic, u?.profilePicUid, u?.online];
  });
  return d(Ip, { className: "avatar", children: [i ? t(Ot, {}) : t(Ye, { alt: o, hasProfilePic: s, userId: a, profilePicUid: r }), n ? t(Cp, { online: c }) : null, t(kp, {})] });
}, Sp = ({ user: e, showId: n, mainUser: i }) => {
  const o = z((s) => s.usersById[e.id]?.name) || "", { t: a } = /* @__PURE__ */ x("office");
  return t(Tp, { children: d("h5", { children: [o || e?.name || a("anonymous"), " ", i ? t("span", { className: "you", children: `(${a("you")})` }) : null, n ? d("span", { children: ["#", e.id] }) : null] }) });
}, Mp = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x(), i = z((o) => o.usersById[e.id]?.status?.id) || "default";
  return i !== "default" ? t(Ap, { children: t("img", { src: M[pt(i).icon], alt: n(i) }) }) : null;
}, Bt = ({ user: e, listId: n, showStatus: i, showId: o, mainUser: a }) => d(Lp, { children: [t(ut, { user: e }), t(Sp, { user: e, showId: o, mainUser: a }), i ? t(Mp, { user: e }) : null] }), Lp = l.div`
  display: flex;
  gap: 15px;
  align-items: center;
  overflow: hidden;
  width: 100%;
`, Ip = l.div`
  position: relative;
  min-width: 34px;
  width: 34px;
  height: 34px;
  & > img {
    border-radius: 50%;
    overflow: hidden;
    clip-path: none;
  }
`, $p = l.div`
  position: absolute;
  right: 0;
  bottom: 0;
  background: #bebebe;
  border: 1px solid #2d2d2d;
  z-index: 1;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  &.on {
    background: #49e162;
  }
`, Tp = l.div`
  display: flex;
  align-items: center;
  width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    padding: 0 0 0 5px;
    display: inline-block;
    font-weight: 200;
    letter-spacing: 0.04em;
    opacity: 0.5;
  }
`, Np = l.div`
  position: absolute;
  bottom: 0;
  left: 0;
  transform: scale(0) translateZ(0);
  transform-origin: bottom center;
  transition: transform 0.4s ease;
  img {
    width: 19px;
    height: 19px;
    left: -6px;
    top: 17px;
    transform-origin: bottom center;
  }

  &.on {
    transform: scale(1) translateZ(0);
    img {
    }
  }
`, Ap = l.div``, Ho = (e, n) => {
  const i = /* @__PURE__ */ [e, n].sort();
  return `${i[0]}_${i[1]}`;
}, zn = (e, n, i, o) => {
  C((a) => ({ convsData: { ...a.convsData, [e]: { isDM: i, messages: [], participants: n, lastSeen: {}, lastSeenByMsgId: {}, name: o } } }));
}, Ep = ({ userId: e, userName: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = /* @__PURE__ */ k(null), a = () => {
    !o.current.value || o.current.value === "" || (b("closeModal"), b("notification:custom", { message: i("message-sent-to", { name: n }), icon: d(Pn, { children: [t("img", { src: `${In}1f44b.webp`, alt: "wave" }), ","] }), canClose: false }));
  };
  return d(Pp, { children: [t("textarea", { ref: o, placeholder: i("send-quick-message") }), t("div", { className: "cmb", children: t(B, { onClick: a, label: "send", arrow: true, cls: "white", tr: "office" }) })] });
}, Wo = ({ userId: e, userName: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), [o, a] = /* @__PURE__ */ m(false), s = [{ label: "wave-option-1", action: "option-1" }, { label: "wave-option-2", action: "option-2" }, { label: "wave-option-3", action: "option-3" }, { label: "wave-option-4", action: "option-4" }], r = async ({ action: c, label: p }) => {
    if (c !== "custom-message") {
      C({ showSpinnerLoader: true });
      const u = $().id, h = /* @__PURE__ */ Ho(u, e), f = N().convsData[h];
      let v;
      f || zn(h, [u, e], true);
      const { convsData: g, sendMessage: y } = /* @__PURE__ */ N();
      g[h].messages.length || (v = N().createConv({ participants: g[h].participants.join(","), isDM: true }));
      const L = { id: `temp${g[h].messages.length}`, avatar: "/", message: `<p>${i(p)}</p>`, date: { _seconds: Date.now() / 1e3, _milliseconds: Date.now() }, saved: false, userId: u, type: "wave" };
      await v, y(h, L), C({ showSpinnerLoader: false }), b("closeModal"), b("notification:custom", { message: i("wave-sent-to", { name: n }), icon: d(Pn, { children: [t("img", { src: `${In}1f44b.webp`, alt: "wave" }), ","] }) });
    } else
      a(true);
  };
  return d(Dp, { children: [t("h2", { children: i("wave-to", { name: n }) }), o ? t(Ep, { userId: e, userName: n }) : t(zp, { children: s.map((c) => t("li", { children: t(ui, { onClick: () => {
    r(c);
  }, label: c.label, tr: "office" }) }, c.action)) })] });
}, Dp = l.div`
  h2 {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 0 0 30px;
  }
`, zp = l.ul`
  display: flex;
  flex-direction: column;
  gap: 15px;
  button {
    width: 100%;
    min-width: 400px;
  }
`, Pp = l.div`
  textarea {
    padding: 15px 20px;
    width: 100%;
    min-height: 95px;
    background: #1d1d1d;
    border-radius: 5px;
    color: #fff;
    min-width: 400px;

    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.03em;
  }

  .cmb {
    padding: 30px 0 0;
    display: flex;
    justify-content: flex-end;
    button {
      min-width: auto;
    }
  }
`, Pn = l.div`
  transform-origin: bottom center;
  animation: wave 1.5s infinite ease-in-out;
`, Vo = (e) => {
  const n = $().id;
  b("openDetailMenu", { data: "users" });
  const i = /* @__PURE__ */ Ho(n, e);
  N().convsData[i] || zn(i, [n, e], true), C({ currentConvId: i });
}, Zo = ({ user: e, mainUser: n }) => {
  const i = z((p) => p.usersById[e.playerId]?.status?.id) || "default", o = /* @__PURE__ */ pt(i), { t: a } = /* @__PURE__ */ x("office"), s = () => {
    Vo(e.id);
  }, r = () => {
    ct("you_to_them", e, a);
  }, c = [{ label: a("dm"), action: s }, { label: a("call-user-teleport", { name: e.name }), action: r }];
  if (o && o.id !== "default") {
    const p = () => {
      b("openModal", t(Wo, { userId: e.id, userName: e.name }));
    };
    c.push({ label: a("wave"), action: p });
  }
  return d(_p, { onContextMenu: (p) => {
    p.preventDefault(), C({ showContextMenu: { x: p.clientX, y: p.clientY, actions: c } });
  }, children: [t(jp, { className: N().unreadDM[e.id] ? "unread" : "", onClick: s, children: t(Bt, { user: e, listId: e.id, showStatus: true, mainUser: n }) }), n ? null : t(Fp, { className: "actions", children: t(lt, { cls: "call", icon: t("img", { src: M["/icons/phone.svg"], alt: "call" }), action: r, big: false }) })] });
}, _p = l.div`
  position: relative;
  display: flex;
  justify-content: space-between;

  @media all and (pointer: fine) {
    .actions {
      opacity: 0;
    }
    &:hover {
      .actions {
        opacity: 1;
      }
    }
  }
`, jp = l.button`
  position: relative;
  width: 100%;
  padding: 4px 50px 4px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    opacity: 0.7;
  }

  &.unread {
    h5 {
      opacity: 1;
    }
  }

  @media all and (pointer: fine) {
    & > div {
      position: relative;
      z-index: 1;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #3d3d3d;
      transform: translate3d(-100%, 0, 0);
      transition: transform 0.3s ease;
    }
    &:hover {
      &::before {
        transform: translate3d(0, 0, 0);
      }
    }
  }
`, Fp = l.div`
  position: absolute;
  z-index: 2;
  display: flex;
  gap: 5px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  transition: opacity 0.2s ease;

  .call {
    img {
      width: 16px;
      height: auto;
    }
  }
`, Op = ({ message: e }) => t("div", { className: "markdown", children: e }), Bp = ({ toastId: e, title: n, message: i, userId: o, visible: a }) => {
  const [s, r] = /* @__PURE__ */ m(false);
  return ue(() => {
    setTimeout(() => {
      r(true);
    }, 1);
  }, []), d(Up, { className: `${a && s ? "visible" : ""}`, onClick: () => {
    o && (fe.dismiss(e), N().subMenuOffice !== "users" && b("openSubMenu", "users"), setTimeout(() => {
      Vo(o);
    }, 1));
  }, children: [t("div", { style: { opacity: 0.75, fontSize: "0.75rem" }, children: n }), t(Op, { message: i })] });
}, Up = l.button`
  text-align: left;
  padding: 10px 20px;
  background: #363636;
  border-radius: 10px;
  min-width: 180px;
  pointer-events: all;

  overflow: hidden;
  isolation: isolate;

  transition: transform 230ms cubic-bezier(0.21, 1.02, 0.73, 1),
    opacity 230ms cubic-bezier(0.21, 1.02, 0.73, 1);
  transform: translate3d(0, -20px, 0);
  opacity: 0;

  &.visible {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  @media all and (pointer: fine) {
    &:hover {
      background: #2d2d2d;
    }
  }
`, Rp = ({ toastId: e, visible: n, data: i, canClose: o }) => {
  const { t: a } = /* @__PURE__ */ x(i.tr ? i.tr : "office"), [s, r] = /* @__PURE__ */ m(false);
  return ue(() => {
    setTimeout(() => {
      r(true);
    }, 1);
  }, []), d(Go, { className: `${o ? "closable" : ""} ${n && s ? "visible" : ""}`, children: [i.icon ? t(_n, { children: i.icon }) : t(Fo, { color: "#F33182" }), t("span", { children: i.tr ? a(i.message) : i.message }), i.action ? t(Hp, { onClick: i.action, children: t("span", { children: i.tr ? a(i.actionLabel) || "" : i.actionLabel }) }) : null, o ? t(Wp, { onClick: () => {
    fe.dismiss(e);
  }, children: t(Me, {}) }) : null] });
}, Ut = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = /* @__PURE__ */ $(), i = z((s) => s.usersById[n?.id]?.accountType) || 10, o = n?.isAnonymous || i === 10, a = /* @__PURE__ */ z((s) => s.isAdmin);
  return j("notification:office", ({ message: s, params: r }) => {
    fe(e(s, r));
  }), j("notification:preview", ({ title: s, message: r, userId: c, params: p }) => {
    o && !a || fe.custom((u) => t(Bp, { toastId: u.id, visible: u.visible, title: s, message: r, userId: c }), { duration: 6e3 });
  }), j("notification", ({ message: s }) => {
    fe(s);
  }), j("notification:error", ({ message: s }) => {
    fe.error(s);
  }), j("notification:custom", (s) => {
    fe.custom((r) => t(Rp, { toastId: r.id, visible: r.visible, data: s, canClose: s.canClose }), { duration: s.duration ? s.duration : 1e4 });
  }), j("notification:guest", (s) => {
    s.user && fe.custom((r) => t(Kd, { toastId: r.id, visible: r.visible, data: s }), { duration: 6e3 });
  }), j("notification:server", (s) => {
    if (s) {
      const r = N().serverErrors;
      r.length === 0 && fe.custom((p) => t(Qd, { toastId: p.id, visible: p.visible }), { duration: 1 / 0 }), r.findIndex((p) => p.type === s.type) === -1 && (r.push(s), C({ serverErrors: r }));
    }
  }), t(Xs, { position: "top-left", gutter: 5, containerStyle: { inset: "20px" }, toastOptions: { className: "", duration: 5e3, style: { background: "#363636", color: "#fff", borderRadius: "10px", boxShadow: "none", padding: "10px 20px", fontWeight: 600, fontSize: "14px", lineHeight: "17px", letterSpacing: "0.04em" } } });
}, Go = l.div`
  position: relative;
  background: #363636;
  border-radius: 10px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.04em;
  color: #fff;
  overflow: hidden;
  isolation: isolate;

  transition: transform 230ms cubic-bezier(0.21, 1.02, 0.73, 1),
    opacity 230ms cubic-bezier(0.21, 1.02, 0.73, 1);
  transform: translate3d(0, -20px, 0);
  opacity: 0;

  svg {
    width: 12px;
    height: auto;
    path {
      stroke-width: 2px;
    }
  }

  &.closable {
    padding-right: 58px;
  }

  &.visible {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`, Hp = l.button`
  position: relative;
  display: block;
  color: #49e162;
  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background: #49e162;
  }

  @media all and (pointer: fine) {
    &:after {
      transition: transform 0.2s ease;
    }
    &:hover {
      &:after {
        transform: scaleX(0) translateZ(0);
      }
    }
  }
`, Wp = l.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 39px;
  height: 37px;
  background: #222222;
  border-left: 2px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    opacity: 0.6;
    width: 10px;
    height: auto;
    transition: opacity 0.2s ease;
  }

  @media all and (pointer: fine) {
    &:hover {
      svg {
        opacity: 1;
      }
    }
  }
`, _n = l.div`
  position: relative;
  width: 17px;
  height: 17px;
  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    clip-path: none;
  }
`, Vp = () => {
  const [e, n] = /* @__PURE__ */ S((i) => [i.showTutorialPaint, i.hidePaintTutoHighlight]);
  return t(To, { className: `paint ${e && !n ? "show" : ""}`, children: t("div", { children: t(An, { size: 60, lineSize: 2 }) }) });
}, qo = () => {
  const [e] = /* @__PURE__ */ S((n) => [n.uiSettings?.isPaintGame]);
  return e ? t(Vp, {}) : null;
}, Zp = ({ selectSource: e }) => {
  const n = (a, s) => {
    e.trigger(a, s), b("closeChoseVideoSource");
  }, i = e?.streamInUse === "main", o = e?.streamInUse === "sub";
  return t(Gp, { children: d(qp, { children: [t(jt, { onClick: () => b("closeChoseVideoSource") }), t(B, { label: i ? "stop-webcam" : "share-webcam", onClick: () => {
    n("webcam", i);
  } }), t(B, { label: o ? "stop-sharescreen" : "sharescreen", onClick: () => {
    n("screenshare", o);
  } })] }) });
}, jn = () => {
  const [e, n] = /* @__PURE__ */ m(null), i = /* @__PURE__ */ yn();
  return j("choseVideoSource", ({ streamInUse: o, onSelectSource: a }) => {
    i && n({ streamInUse: o, trigger: a });
  }), j("closeChoseVideoSource", () => {
    n(null);
  }), e ? t(Zp, { selectSource: e }) : null;
}, Gp = l.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
`, qp = l.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  background: #101010;
  max-width: 600px;
  border-radius: 20px;
  pointer-events: all;
  padding: 40px 40px;

  .clsmbtn {
    position: absolute;
  }
`, Fn = () => (w(() => {
  function e() {
    const n = navigator.onLine;
    C({ isOnline: n }), b(n ? "notification:server:close" : "notification:server", { type: "internet" });
  }
  return window.addEventListener("online", e), window.addEventListener("offline", e), () => {
    window.removeEventListener("online", e), window.removeEventListener("offline", e);
  };
}, []), null);
l.input`
  position: absolute;
  opacity: 0;
`;
const Yp = l.div`
  position: relative;

  .dangerBg {
    transition: fill 0.2s ease, fill-opacity 0.2s ease;
  }
`, Kp = l.div`
  position: absolute;
  bottom: 2px;
  left: 2px;
  transition: transform 0.3s ease;
  &.active {
    transform: translate3d(26px, 0, 0);
  }
`, Yo = ({ alertIconBgColor: e, alertIconBgOpacity: n, alertIconColor: i, alertIconBgInside: o = true }) => d("svg", { width: "25", height: "23", viewBox: "0 0 25 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [o ? t("path", { d: "M14.2339 3.88528C13.5528 2.74843 11.9472 2.74843 11.2661 3.88528C8.99874 7.66973 5.08784 14.2965 2.92534 17.966C2.23009 19.1458 3.05538 20.6198 4.42475 20.6247C8.9381 20.6409 16.6932 20.622 21.0043 20.609C22.3882 20.6048 23.2453 19.104 22.5426 17.9117C20.3737 14.2314 16.4901 7.65111 14.2339 3.88528Z", fill: e, fillOpacity: n }) : null, t("path", { d: "M10.3874 3.35882C8.11777 7.14703 4.20494 13.7771 2.04284 17.446C0.95289 19.2955 2.24719 21.6412 4.42107 21.6491C8.93841 21.6653 16.697 21.6464 21.0074 21.6333C23.1801 21.6268 24.5307 19.2677 23.4251 17.3916C21.2566 13.712 17.3711 7.12841 15.1126 3.35882C14.0338 1.55812 11.4663 1.55812 10.3874 3.35882Z", stroke: e, strokeOpacity: n, strokeWidth: "2.0487" }), o ? t("path", { d: "M14.2339 3.88539C13.5528 2.74854 11.9472 2.74854 11.2661 3.88539C8.99874 7.66983 5.08784 14.2966 2.92534 17.9661C2.23009 19.1459 3.05538 20.6199 4.42475 20.6248C8.9381 20.6411 16.6932 20.6221 21.0043 20.6091C22.3882 20.6049 23.2453 19.1041 22.5426 17.9118C20.3737 14.2315 16.4901 7.65122 14.2339 3.88539Z", stroke: i, strokeWidth: "0.8125" }) : null, t("path", { d: "M12.3438 8.75C10.1038 8.75 8.28125 10.5726 8.28125 12.8125C8.28125 13.8999 8.72321 14.9449 9.5 15.7078V17.2812C9.5 17.9533 10.0467 18.5 10.7188 18.5V17.2812C10.7188 17.0567 10.9005 16.875 11.125 16.875C11.3495 16.875 11.5312 17.0567 11.5312 17.2812V18.5H13.1563V17.2812C13.1563 17.0567 13.338 16.875 13.5625 16.875C13.787 16.875 13.9688 17.0567 13.9688 17.2812V18.5C14.6408 18.5 15.1875 17.9533 15.1875 17.2812V15.7078C15.9643 14.9449 16.4063 13.8999 16.4063 12.8125C16.4063 10.5726 14.5837 8.75 12.3438 8.75ZM10.7188 14.4375C10.0457 14.4375 9.5 13.8918 9.5 13.2188C9.5 12.5457 10.0457 12 10.7188 12C11.3918 12 11.9375 12.5457 11.9375 13.2188C11.9375 13.8918 11.3918 14.4375 10.7188 14.4375ZM12.3438 15.6562C12.1194 15.6562 11.9375 15.4744 11.9375 15.25C11.9375 15.0256 12.1194 14.8438 12.3438 14.8438C12.5681 14.8438 12.75 15.0256 12.75 15.25C12.75 15.4744 12.5681 15.6562 12.3438 15.6562ZM13.9688 14.4375C13.2957 14.4375 12.75 13.8918 12.75 13.2188C12.75 12.5457 13.2957 12 13.9688 12C14.6419 12 15.1875 12.5457 15.1875 13.2188C15.1875 13.8918 14.6419 14.4375 13.9688 14.4375ZM7.875 19.3125C7.42627 19.3125 7.0625 18.9487 7.0625 18.5C7.0625 18.0513 7.42627 17.6875 7.875 17.6875C8.32373 17.6875 8.6875 18.0513 8.6875 18.5C8.6875 18.9487 8.32373 19.3125 7.875 19.3125ZM17.2188 17.2812C16.77 17.2812 16.4063 16.9175 16.4063 16.4688C16.4063 16.02 16.77 15.6562 17.2188 15.6562C17.6675 15.6562 18.0313 16.02 18.0313 16.4688C18.0313 16.9175 17.6675 17.2812 17.2188 17.2812ZM5.84375 16.875C5.61939 16.875 5.4375 16.6931 5.4375 16.4688C5.4375 16.2444 5.61939 16.0625 5.84375 16.0625C6.06811 16.0625 6.25 16.2444 6.25 16.4688C6.25 16.6931 6.06811 16.875 5.84375 16.875ZM7.0625 14.8438C6.83814 14.8438 6.65625 14.6619 6.65625 14.4375C6.65625 14.2131 6.83814 14.0312 7.0625 14.0312C7.28686 14.0312 7.46875 14.2131 7.46875 14.4375C7.46875 14.6619 7.28686 14.8438 7.0625 14.8438ZM16.4063 19.3125C16.1819 19.3125 16 19.1306 16 18.9062C16 18.6819 16.1819 18.5 16.4063 18.5C16.6306 18.5 16.8125 18.6819 16.8125 18.9062C16.8125 19.1306 16.6306 19.3125 16.4063 19.3125ZM19.25 16.0625C19.0256 16.0625 18.8438 15.8806 18.8438 15.6562C18.8438 15.4319 19.0256 15.25 19.25 15.25C19.4744 15.25 19.6562 15.4319 19.6562 15.6562C19.6562 15.8806 19.4744 16.0625 19.25 16.0625Z", fill: i })] }), Jp = ({ defaultChecked: e, click: n, disabled: i, children: o, ...a }) => {
  const s = /* @__PURE__ */ k(null);
  let r = i ? { disabled: true } : {};
  const c = e ? "#000" : "#fff", p = e ? "#FFE600" : "#fff", u = e ? 1 : 0.5;
  return d(Do, { ...a, className: `${i ? "disabled" : ""} ${o ? "" : "nolabel"}`, children: [o, t(zo, { type: "checkbox", ref: s, defaultChecked: e, ...r, onClick: () => {
    n(), s.current && s.current.blur();
  } }), d(Yp, { children: [d("svg", { width: "57", height: "26", viewBox: "0 0 57 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M9.81793 2.40327C10.6938 0.914261 12.2923 0 14.0199 0H42.8551C44.5827 0 46.1812 0.914263 47.0571 2.40328L55.5355 16.8166C57.9251 20.8789 54.9961 26 50.2831 26H6.59191C1.87891 26 -1.05008 20.8789 1.3395 16.8166L9.81793 2.40327Z", fill: "#fff", fillOpacity: "0.1" }), t("path", { d: "M14.0199 0.4875H42.8551C44.4099 0.4875 45.8486 1.31034 46.6369 2.65045L55.1153 17.0638C57.3137 20.8011 54.619 25.5125 50.2831 25.5125H6.59191C2.25595 25.5125 -0.438725 20.8011 1.7597 17.0638L10.2381 2.65045C11.0264 1.31033 12.4651 0.4875 14.0199 0.4875Z", stroke: e ? "#FFE600" : "#FAFAFA", strokeOpacity: e ? 1 : 0.7, strokeWidth: "0.975" }), d("mask", { id: "mask0_12891_2319", maskUnits: "userSpaceOnUse", x: "-24", y: "-5", width: "99", height: "39", children: [t("path", { d: "M-0.8125 -4.875H3.25L-19.5 33.3125H-23.5625L-0.8125 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M5.6875 -4.875H9.75L-13 33.3125H-17.0625L5.6875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M12.1875 -4.875H16.25L-6.5 33.3125H-10.5625L12.1875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M31.6875 -4.875H35.75L13 33.3125H8.9375L31.6875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M18.6875 -4.875H22.75L0 33.3125H-4.0625L18.6875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M38.1875 -4.875H42.25L19.5 33.3125H15.4375L38.1875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M25.1875 -4.875H29.25L6.5 33.3125H2.4375L25.1875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M44.6875 -4.875H48.75L26 33.3125H21.9375L44.6875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M57.6875 -4.875H61.75L39 33.3125H34.9375L57.6875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M64.1875 -4.875H68.25L45.5 33.3125H41.4375L64.1875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M51.1875 -4.875H55.25L32.5 33.3125H28.4375L51.1875 -4.875Z", fill: "white", fillOpacity: "0.12" }), t("path", { d: "M70.6875 -4.875H74.75L52 33.3125H47.9375L70.6875 -4.875Z", fill: "white", fillOpacity: "0.12" })] }), t("g", { mask: "url(#mask0_12891_2319)", children: t("path", { d: "M12.4253 3.94828C13.0212 3.0076 14.0572 2.4375 15.1708 2.4375H41.7042C42.8178 2.4375 43.8538 3.0076 44.4497 3.94829L52.5292 16.7023C54.414 19.6777 52.2763 23.5625 48.7542 23.5625H8.12084C4.59872 23.5625 2.46097 19.6777 4.34581 16.7023L12.4253 3.94828Z", fill: e ? "#FFE500" : "#D9D9D9" }) })] }), t(Kp, { className: `${e ? "active" : ""}`, children: t(Yo, { alertIconBgColor: p, alertIconBgOpacity: u, alertIconColor: c }) })] })] });
}, Xp = l.div`
  width: 100%;
  max-width: 148px;
  font-size: 14px;
  line-height: 21px;
  ${(e) => e.theme.highlightFont}

  letter-spacing: 0.12em;
`, Qp = l.div`
  position: relative;
  width: 100%;
  max-width: 340px;
  height: 10px;
  cursor: pointer;

  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0.4) -2.04%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    border-radius: 20px;
    ${(e) => e.children.props.defaultValue && e.children.props.min && e.children.props.max && xi`
        width: ${((e.children.props.defaultValue - e.children.props.min) * (0.95 - 0.05) / (e.children.props.max - e.children.props.min) + 0.05) * 100}%;
      `}
    height: 100%;
    pointer-events: none;
    background: rgba(255, 255, 255, 0.2);
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    appearance: none;
    width: 100%;
    height: 100%;
    background: none;
    outline: none;
    pointer-events: all;
    z-index: 1;
    touch-action: pan-x;
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 16px;
      height: 16px;
      background: #fff;
      background-size: 100%;
      border-radius: 50%;
      cursor: pointer;
    }
    &::-moz-range-thumb {
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 50%;
      cursor: pointer;
    }
  }
`, Ko = /* @__PURE__ */ wt(({ defaultValue: e, min: n, max: i, step: o, change: a, children: s, onRelease: r, ...c }, p) => {
  const u = /* @__PURE__ */ k(null), h = (f) => {
    f.stopPropagation(), u?.current && u.current.children[0].blur(), r && r();
  };
  return t(Xp, { ...c, children: d("label", { children: [s, t(Qp, { ref: u, children: t("input", { ref: p, type: "range", defaultValue: e, min: n, max: i, step: o, onChange: a, onMouseUp: h, onTouchEnd: h, onMouseLeave: h }) })] }) });
});
Ko.displayName = "Range";
const On = ({ title: e, description: n, defaultValue: i, min: o, max: a, step: s, onRelease: r, onChange: c }) => {
  const { t: p } = /* @__PURE__ */ x("common");
  return d(e0, { children: [d("div", { children: [t("h5", { children: p(e) }), n ? t("p", { children: p("sensitivity-camera-desc") }) : null] }), t(Ko, { min: o, max: a, step: s, defaultValue: i, change: c, onRelease: r })] });
}, e0 = l.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  ${(e) => e.theme.bodyText3}
  p {
    padding: 5px 0 0;
  }
`, t0 = ({ data: e, index: n, activeTab: i, setActiveTab: o }) => {
  const { t: a } = /* @__PURE__ */ x("common");
  return t("li", { children: d(n0, { className: i === n ? "active" : "", onClick: () => {
    o(n), b("tracking", { event: "click", category: "tab-bar", label: e.label });
  }, children: [e.icon, t("span", { children: a(e.label) })] }) });
}, n0 = l.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 10px;
  line-height: 12px;
  height: 58px;
  padding: 11px 20px;
  overflow: hidden;
  opacity: 0.5;
  transition: opacity 0.3s ease;
  color: #fff;
  text-transform: uppercase;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transform: translate3d(-50%, 100%, 0);
    background: #fff;
    transition: transform 0.3s ease;
  }

  &.active {
    opacity: 1;
    &::before {
      transform: translate3d(-50%, 50%, 0);
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      opacity: 1;
    }
  }
`, i0 = ({ list: e, activeTab: n, setActiveTab: i }) => t(o0, { className: "tabbar secfont", children: t("ul", { children: e.map((o, a) => t(t0, { data: o, index: a, activeTab: n, setActiveTab: i }, a)) }) }), o0 = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d2d2d;
  width: 100%;

  ul {
    display: flex;
    gap: 20px;
  }
`, a0 = ({ data: e }) => {
  const [n, i] = /* @__PURE__ */ m(0);
  return j("open-tab", (o) => {
    const a = /* @__PURE__ */ e.findIndex((s) => s.label === o);
    a > -1 && i(a);
  }), d(T, { children: [t(r0, { className: "tabbarcnt", children: e[n].content }), t(i0, { list: e, activeTab: n, setActiveTab: i })] });
}, ht = ({ data: e, show: n, children: i, cls: o = "", office: a }) => {
  const s = /* @__PURE__ */ k(null), [r, c] = /* @__PURE__ */ m(true), p = /* @__PURE__ */ K("isMobile"), u = /* @__PURE__ */ K("isWindows");
  return w(() => {
    const h = (f) => {
      if (s.current && !s.current.contains(f.target)) {
        if (o === "emoji-chat" && f.target.classList.contains("emjbtn"))
          return;
        n && C({ openModal: "" });
      }
    };
    return document.addEventListener("mousedown", h), () => {
      document.removeEventListener("mousedown", h);
    };
  }), w(() => {
    let h, f;
    return n ? (c(false), b("playAudio", { id: an.openModal })) : (f = setTimeout(() => {
      N().openModal === "" && b("playAudio", { id: an.closeModal });
    }, 10), h = setTimeout(() => {
      c(true);
    }, 400)), () => {
      clearTimeout(h), clearTimeout(f);
    };
  }, [n]), d(s0, { ref: s, className: `${n ? "show" : ""} ${o} ${p ? "sp" : ""} ${r ? "" : "enable"} ${u ? "windows" : ""} ${a ? "office" : ""}`, children: [p ? t(jt, { show: true, onClick: () => {
    C({ openModal: "", hideUI: false });
  } }) : null, e?.length > 1 ? t(a0, { data: e }) : { ...i }] });
}, s0 = l.div`
  position: fixed;
  flex-direction: column;
  right: 47px;
  bottom: 118px;
  width: 373px;
  height: 660px;
  overflow: auto;
  z-index: 2;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 20px;

  transition: transform 0.4s ease;
  transform: translate3d(0, calc(100% + 120px), 0);

  pointer-events: none;

  visibility: hidden;

  &.hauto {
    height: auto;
  }

  &.office {
    bottom: 10px;
    right: 60px;
    background: #232323;
  }

  &.windows {
    width: 390px;
  }

  // if window height < 840
  @media all and (max-height: 840px) {
    height: 600px;
  }

  @media all and (max-height: 780px) {
    height: 500px;
  }

  &.enable {
    visibility: visible;
  }

  &.emoji-chat {
    left: 480px;
    right: auto;
    bottom: 40px;
    transform: translate3d(0, calc(100% + 40px), 0);
  }

  .search-ctn,
  .cntscroll,
  .tabbar,
  .tabbarcnt {
    transform: translate3d(0, 100%, 0);
    transition: transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.3s;
  }

  .cntscroll,
  .tabbarcnt {
    transform: translate3d(0, 60%, 0);
  }

  &.sp {
    bottom: auto;
    top: 80px;
    transform: translate3d(0, calc(-100% - 80px), 0);
    z-index: 81;
    .clsmbtn {
      display: none;
    }

    @media all and (max-width: 600px), all and (max-height: 800px) {
      top: 0;
      right: 0;
      bottom: 0;
      width: 100% !important;
      height: 100%;
      border-radius: 0;
      z-index: 1000;
      .clsmbtn {
        display: block;
      }
    }
  }

  &.show {
    pointer-events: all;
    transform: translate3d(0, 0, 0);
    transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    .cntscroll,
    .tabbarcnt {
      transition-delay: 0.05s;
    }
    .search-ctn,
    .cntscroll,
    .tabbar,
    .tabbarcnt {
      transform: translate3d(0, 0, 0);
    }
  }

  @media all and (max-width: 1024px) {
    right: 31px;
    &.emoji-chat {
      left: 410px;
    }
  }

  @media all and (max-width: 920px) {
    &.emoji-chat {
      bottom: 60px;
      transform: translate3d(0, calc(100% + 60px), 0);
      z-index: 1000;
    }
  }
`, r0 = l.div`
  height: calc(100% - 58px);
  overflow: auto;
`, l0 = () => {
  const e = /* @__PURE__ */ S((i) => i.colorPaint || "#ff00dd"), n = /* @__PURE__ */ S((i) => i.paintSize || 0.4);
  return t(h0, { children: t("div", { className: "size", style: { transform: `translate3d(-50%, -50%, 0) scale(${n * 2.5})`, backgroundColor: e } }) });
}, c0 = ({ data: e }) => t(On, { title: "size", defaultValue: e.value, value: e.value, onChange: (n) => e.onChange(Number(n.target.value)), min: e.min, max: e.max, step: e.step }), d0 = () => {
  const [e, n, i] = /* @__PURE__ */ S((a) => [a.colorPaint || "#ff00dd", a.paintSize || 0.4, a.paintLazer || false]), { t: o } = /* @__PURE__ */ x();
  return t(Z, { title: "tooltip-paint", children: d(p0, { children: [t(l0, {}), d(u0, { children: [t("label", { children: o("color") }), t("input", { type: "color", value: e, onChange: (a) => {
    const s = a.target.value;
    C({ colorPaint: s });
  } })] }), t(c0, { data: { min: 0.05, max: 0.4, step: 0.01, value: n, onChange: (a) => {
    Rs(a), b("brush_size", { playerId: $().id, size: a }), C({ paintSize: a });
  } } }), t(Jp, { defaultChecked: i, click: () => {
    C({ paintLazer: !i });
  }, children: t("strong", { children: o("paint-warning") }) })] }) });
}, Bn = /* @__PURE__ */ ce(({ forceActive: e = false }) => {
  const [n] = /* @__PURE__ */ S((a) => [a.openModal]), i = n === J.PAINT;
  return t(ht, { show: e || i, cls: "hauto", children: t(d0, {}) });
});
Bn.displayName = "paint_modal";
const p0 = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 0 0 20px;

  h5,
  label {
    font-family: Mundial;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 12px; /* 100% */
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }

  input[type='color']::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  input[type='color']::-webkit-color-swatch {
    border: none;
    border-radius: 5px;
  }

  input[type='color'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 148px;
    height: 25px;
    border-radius: 3px;
    border: none;
    outline: none;
    background-color: transparent;
    cursor: pointer;
  }
`, u0 = l.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
`, h0 = l.div`
  position: relative;
  width: 100%;
  height: 172px;
  border-radius: 3px;
  background: #2d2d2d;
  overflow: hidden;

  /* .color {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  } */

  .size {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    width: 100px;
    height: 100px;
    border-radius: 100%;
    background: #2d2d2d;
  }

  @media all and (max-height: 450px) {
    height: 100px;
    .size {
      width: 60px;
      height: 60px;
    }
  }
`, f0 = ({ videoElement: e }) => {
  const n = /* @__PURE__ */ k(), [i, o] = /* @__PURE__ */ m(false);
  w(() => {
    setTimeout(() => {
      o(true);
    });
  }, []);
  const a = () => {
    b("[@utsubo/ui]closeFullScreenStreamLive");
  };
  return w(() => (e && (n.current.srcObject = e.srcObject, n.current.play(), e.pause()), () => {
    e && e.play();
  }), [e]), d(g0, { className: i ? "show" : "", children: [t(x0, { className: "cv", children: t("video", { ref: n, autoPlay: true, playsInline: true }) }), t(jt, { onClick: a })] });
}, m0 = () => {
  const e = /* @__PURE__ */ k(null), [n, i] = /* @__PURE__ */ m(null);
  return j("[@utsubo/ui]openFullScreenStreamLive", ({ graphId: o, videoElement: a }) => {
    e.current = o, i(a);
  }), j("[@utsubo/ui]closeFullScreenStreamLive", ({ graphId: o }) => {
    o === e.current && (i(null), e.current = null);
  }), n ? t(f0, { videoElement: n }) : null;
}, g0 = l.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    opacity: 0;
    z-index: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }
  &.show {
    pointer-events: all;
    &::before {
      opacity: 1;
      pointer-events: all;
    }
    .cv {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`, x0 = l.div`
  position: relative;
  padding: 0 15px 20px;
  width: 100%;
  z-index: 1;

  opacity: 0;
  transform: translate3d(0, 60px, 0);
  transition: opacity 0.3s ease 0.1s, transform 0.5s ease 0.1s;
`, Un = () => {
  const [e, n] = /* @__PURE__ */ m({ width: 0, height: 0 });
  return w(() => {
    function i() {
      n({ width: window.innerWidth, height: window.innerHeight });
    }
    return i(), window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, []), e;
}, Rn = ({ onClick: e, ariaLabel: n, cls: i = "" }) => t(v0, { "aria-label": n, className: i, onClick: e, children: t("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 19", children: t("path", { d: "M.937988 18.0308 18.0001.968682M.937988.968262 18.0001 18.0303", stroke: "#fff", strokeWidth: "1.2", strokeLinecap: "round" }) }) }), v0 = l.button`
  position: absolute;
  z-index: 2;
  top: -29px;
  right: -29px;
  width: 58px;
  height: 58px;
  background: #2d2d2d;
  border-radius: 99px;
  display: flex;
  justify-content: center;
  align-items: center;

  transform: scale(0) translateZ(0);
  transition: transform 0.4s ease;

  svg {
    position: relative;
    z-index: 1;
    width: 19px;
    height: 19px;
  }

  @media all and (pointer: fine) {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      border-radius: 99px;
      transition: transform 0.2s ease;
      transform: scale(0) translateZ(0);
    }
    &:hover {
      &:before {
        transform: scale(1) translateZ(0);
      }
    }
  }
`, Jo = ({ text: e = "" }) => {
  const { t: n } = /* @__PURE__ */ x();
  return t(b0, { children: d(w0, { children: [t("div", {}), t("div", {}), t("div", {}), t("div", {}), t("p", { children: n(e) })] }) });
}, b0 = l.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 10;
`, w0 = l.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }

  div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }

  div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }

  div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
`, y0 = ({ data: e, gridMode: n = true }) => {
  const [i, o] = /* @__PURE__ */ m(false), a = /* @__PURE__ */ ie((I) => I.gridFullscreen), [s, r] = /* @__PURE__ */ m(null), c = e?.playerId, p = e?.playerId === $().id;
  x();
  const [u, h] = /* @__PURE__ */ m(true), [f, v, g] = /* @__PURE__ */ Ce((I) => [I.client, I.peers.get(e.playerId), I.peersNeedsUpdt[e.playerId]]), [y, L] = /* @__PURE__ */ Ce((I) => [I.peers.get(e.playerId)?.enabled.screenShare, I.signalPeerUpdate]);
  return w(() => {
    f && s && (async () => {
      let A = null;
      p ? A = await f.getVideoTrack({ streamType: "sub" }) : y ? (A = await f.getVideoTrack({ userId: c, streamType: "sub" }), A || (await f.startRemoteVideo({ userId: c, streamType: "sub" }).catch((E) => {
        console.error(`start video ${c} failed`, E);
      }), A = await f.getVideoTrack({ userId: c, streamType: "sub" }))) : (await f.stopRemoteVideo({ userId: c, streamType: "sub" }).catch((E) => {
        console.error(`stop video ${c} failed`, E);
      }), s.srcObject = null), A && (s.srcObject = new MediaStream([A]), s.play(), h(false));
    })();
  }, [f, y, s]), w(() => {
    a || o(false);
  }, [a]), t("div", { children: d(C0, { className: `${n ? "" : "small"}   ${i ? "fullscreen" : a ? "hide" : ""}`, onClick: () => {
    n ? (o(true), oe({ gridFullscreen: true })) : oe({ showCallGrid: true }), Ve({ paused: true });
  }, children: [u ? t(Jo, { text: "" }) : null, t(k0, { className: `vc ${u ? "hide" : ""}`, ref: r, autoPlay: true, playsInline: true, muted: true })] }) });
}, C0 = l.button`
  font-size: 0;
  pointer-events: all;
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 65.8%;
  background-color: #383838;
  border-radius: 10px;
  object-fit: scale-down;

  &.small {
    max-width: calc(100% - 15px);
    margin: 0 auto;
  }

  &.unavailable {
    pointer-events: none;
    .vc {
      opacity: 0.5;
    }
  }

  &.disable {
    pointer-events: none;
  }

  &.fullscreen {
    position: fixed;
    inset: 0;
    z-index: 100;
    pointer-events: none;
    border-radius: 0;
    padding-top: 0;
  }

  &.hide {
    display: none;
  }
`, k0 = l.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
  overflow: hidden;
  &.hide {
    display: none;
  }
`, S0 = ({ page: e, currentPage: n, setCurrentPage: i }) => t($0, { onClick: () => i(e), className: e === n ? "active" : "", children: t("span", { children: e + 1 }) }), M0 = ({ currentPage: e, setCurrentPage: n, totalPage: i, screenShareOn: o }) => i > 1 ? t(L0, { className: o ? "ss" : "", children: t(I0, { children: Array.from(Array(i).keys()).map((a) => t(S0, { page: a, currentPage: e, setCurrentPage: n }, a)) }) }) : null, L0 = l.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #292929;
  z-index: 1;

  &.ss {
    max-width: calc(100% * 0.2);
    background: rgba(45, 45, 45, 0.7);
  }

  @media all and (max-width: 767px) {
    position: relative;
    left: auto;
    top: auto;
    &.ss {
      max-width: none;
      background: transparent;
    }
  }
`, I0 = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`, $0 = l.button`
  position: relative;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #2d2d2d;
  overflow: hidden;
  isolation: isolate;

  span {
    position: relative;
    z-index: 1;
    text-align: center;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: ${(e) => e.theme.colors.highlight};
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &.active {
    pointer-events: none;
    &::before {
      opacity: 1;
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
`, T0 = ({ children: e, participants: n, gridFullscreen: i, screenShareOn: o }) => {
  const a = /* @__PURE__ */ Un(), s = { customWidth: null, customHeight: null, customCols: null, cls: "" }, [r, c] = /* @__PURE__ */ m(s), [p, u] = /* @__PURE__ */ m(0), [h, f] = /* @__PURE__ */ m(false), v = /* @__PURE__ */ k(null);
  return ue(() => {
    const g = (y, L, I) => {
      let A = { area: 0, cols: 0, rows: 0, width: 0, height: 0 };
      const E = 5, D = 16 / 9;
      for (let F = 0; F <= I; F++) {
        const H = /* @__PURE__ */ Math.ceil(I / F), _ = y / (F * D), P = L / H;
        let U, X;
        _ <= P ? (U = Math.floor(y / F) - E, X = Math.floor(U / D)) : (X = Math.floor(L / H) - E, U = Math.floor(X * D));
        const ne = U * X;
        ne > A.area && (A = { area: ne, width: U, height: X, rows: H, cols: F });
      }
      return A;
    };
    if (v.current) {
      c(s);
      const y = v.current.children.length > 0 ? v.current.children[0].children : null;
      if (h)
        return;
      if (y.length === 2) {
        const L = /* @__PURE__ */ [...y].find((I) => I.className.includes("others"));
        L && (L.style.width = "", L.offsetHeight > v.current.offsetHeight && (L.style.width = `${v.current.offsetHeight / 0.658}px`));
      } else if (y.length > 2) {
        if (a.width < 768)
          return;
        if (o) {
          v.current.children[0].offsetHeight - (y.length - 1) * 10 < y.length * ((v.current.offsetWidth * 0.2 - 10) / (16 / 9)) && c({ customWidth: null, customHeight: null, customCols: null, cls: "grid-4-ss" });
          return;
        }
        const { width: L, height: I, cols: A } = /* @__PURE__ */ g(v.current.offsetWidth, v.current.offsetHeight, y.length);
        c({ customWidth: L, customHeight: I, customCols: A, cls: "grid-4" });
      }
    }
  }, [n, v, a, h, o, p]), w(() => {
    i ? f(true) : setTimeout(() => {
      f(false);
    });
  }, [i]), ue(() => {
    const g = new MutationObserver((y, L) => {
      for (let I of y)
        if (I.type === "childList") {
          const A = v.current.children.length > 0 ? v.current.children[0].children : null;
          A && u(A.length);
        }
    });
    return v?.current?.children?.[0] && g.observe(v.current.children[0], { childList: true }), () => g.disconnect();
  }, [v]), t(N0, { customwidth: r.customWidth, customheight: r.customHeight, customcols: r.customCols, className: r.cls, ref: v, children: e });
}, N0 = l.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 100%;
  max-height: 100%;
  pointer-events: all;

  .others {
    width: 100%;
  }

  .self {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 300px;
    z-index: 2;
  }

  &.grid-4 {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    & > div {
      gap: 5px;
      align-content: center;
    }

    /* max-width: calc(
      ${({ customwidth: e }) => e}px * ${({ customcols: e }) => e}
    ); */

    .others,
    .self,
    .atl {
      /* width: calc(50% - 5px); */
      width: ${({ customwidth: e }) => e}px;
      height: ${({ customheight: e }) => e}px;
      & > div,
      & > button {
        width: ${({ customwidth: e }) => e}px;
        height: ${({ customheight: e }) => e}px;
        padding-top: 0;
      }
    }

    .self {
      position: relative;
      top: auto;
      right: auto;
    }
    /* .atl {
      order: 1;
      position: relative;
      left: auto;
      bottom: auto;
      div {
        width: 100%;
    
      }
    } 
    */
  }

  &.grid-4-ss {
    overflow: auto;
    pointer-events: all;
    & > div {
      gap: 5px;
      align-content: center;

      max-height: 100%;
      overflow: auto;
    }
    .others,
    .self,
    .atl {
      width: calc(50% - 5px) !important;
      height: auto;
      & > div,
      & > button {
        width: 100%;
        padding-top: 100%;
      }
    }
  }

  @media all and (max-width: 767px) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    height: auto;
    max-height: none;
    padding: 0 0 105px;

    & > div {
      gap: 5px;
      align-content: center;
      &:first-child {
        order: 1;
      }
    }

    .others,
    .self,
    .atl {
      width: calc(50% - 3px);
    }

    .self {
      position: relative;
      top: auto;
      right: auto;
    }
  }
`, Xo = ({ user: e, isOn: n, volumeDetected: i }) => {
  const o = /* @__PURE__ */ z((s) => s.playersFirebase?.[e?.id]?.callStatus), { t: a } = /* @__PURE__ */ x("office");
  return t(A0, { title: a(o), className: `${n ? "" : "off"} ${o}`, children: t(T, { children: o === "connecting" ? t(E0, {}) : t(T, { children: n ? t(D0, { className: i ? "on" : "off", children: d("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("rect", { className: "rl", x: "0.542969", y: "0.294189", width: "1.14029", height: "7.41188", rx: "0.570144", fill: "white" }), t("rect", { className: "rm", x: "3.39453", y: "0.294189", width: "1.14029", height: "7.41188", rx: "0.570144", fill: "white" }), t("rect", { className: "rr", x: "6.24609", y: "0.294189", width: "1.14029", height: "7.41188", rx: "0.570144", fill: "white" })] }) }) : t("img", { src: M["/icons/mic-off-white.svg"], alt: "mic-off" }) }) }) });
}, A0 = l.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  width: 14px;
  height: 14px;
  background: #49e162;
  border-radius: 50%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #f33182;
    transform: scale(0) translateZ(0);
    transition: transform 0.2s ease;
  }

  &.off {
    &::before {
      transform: scale(1) translateZ(0);
    }
  }

  &.connecting {
    background: none;
    &::before {
      background: #083cbd;
    }
  }

  img,
  div {
    position: relative;
    z-index: 2;
  }
`, E0 = l.div`
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff65;
  animation: spin 1.2s linear infinite;

  &::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    animation: spin 0.6s linear infinite;
  }
`, D0 = l.div`
  min-width: 8px;
  width: 8px;
  height: 8px;
  font-size: 0;
  rect {
    transform-origin: center;
  }

  &.on {
    .rr {
      animation: scaleYR 0.5s ease-in-out infinite;
    }

    .rm {
      animation: scaleYM 0.7s ease-in-out infinite;
    }

    .rl {
      animation: scaleYL 0.9s ease-in-out infinite;
    }
  }

  &.off {
    .rr,
    .rm,
    .rl {
      transition: transform 0.2s ease;
      transform: scaleY(0.2) translateZ(0);
    }
  }
`, z0 = ({ data: e, gridMode: n = true }) => {
  const [i, o] = /* @__PURE__ */ m(false), a = /* @__PURE__ */ ie((P) => P.gridFullscreen), [s, r] = /* @__PURE__ */ m(null), c = e?.playerId, p = c === $().id, { t: u } = /* @__PURE__ */ x("office"), h = z((P) => P.usersById[c]?.status?.id) || "default", f = /* @__PURE__ */ z((P) => P.usersById?.[c]?.name), v = /* @__PURE__ */ z((P) => P.playersFirebase?.[c]?.callStatus), [g, y, L] = /* @__PURE__ */ Ce((P) => [P.client, P.peers.get(c), P.peersNeedsUpdt[c]]), [I, A, E] = /* @__PURE__ */ Ce((P) => [P.peers.get(c)?.enabled.audio, P.peers.get(c)?.enabled.video, P.peers.get(c)?.currentVolume]), D = /* @__PURE__ */ z((P) => P.hasUserInteracted);
  w(() => {
    g && y && s && D && (async () => {
      let U = null;
      p ? U = await g.getVideoTrack() : A ? (U = await g.getVideoTrack({ userId: c, streamType: "main" }), U || (await g.startRemoteVideo({ userId: c, streamType: "main" }).catch((X) => {
        console.error(`start video ${c} failed`, X);
      }), U = await g.getVideoTrack({ userId: c, streamType: "main" }))) : await g.stopRemoteVideo({ userId: c, streamType: "main" }).catch((X) => {
        console.error(`stop video ${c} failed`, X);
      }), U && (s.srcObject = new MediaStream([U]), s.play());
    })();
  }, [g, y, s, A, D]), w(() => {
    a || o(false);
  }, [a]);
  const F = !p && (h !== "default" || !f || v === "busy"), H = p ? u("you") : f || u("anonymous"), _ = R().usersById[c];
  return t(P0, { className: `${p ? "self" : "others"}`, children: d(_0, { className: `${n ? "" : "small"}  ${F ? "unavailable" : ""} ${i ? "fullscreen" : a ? "hide" : ""}`, onClick: () => {
    n ? (o(true), oe({ gridFullscreen: true })) : oe({ showCallGrid: true }), Ve({ paused: true });
  }, children: [t(U0, { currentvolume: E }), y ? null : t(Jo, { text: "" }), t(j0, { className: `vc ${A ? "" : "hide"}`, ref: r, autoPlay: true, playsInline: true, muted: true }), t(B0, { className: `${A ? "hide" : ""}`, children: _ ? t(Ye, { alt: _.name, hasProfilePic: _.hasProfilePic, userId: _.id, profilePicUid: _.profilePicUid }) : null }), n ? d(F0, { children: [t(O0, { children: t("span", { children: H }) }), t(Xo, { isOn: I, volumeDetected: E > 0, user: _ })] }) : null] }) });
}, P0 = l.div`
  font-size: 0;
`, _0 = l.button`
  font-size: 0;
  pointer-events: all;
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 56.25%;
  background-color: #383838;
  border-radius: 10px;
  overflow: hidden;
  isolation: isolate;
  object-fit: scale-down;

  &.small {
    max-width: calc(100% - 5px);
    margin: 0 auto;
    transform: translate3d(0, calc(-100% - 16px), 0);
  }

  &.unavailable {
    pointer-events: none;
    .vc {
      opacity: 0.5;
    }
  }

  &.disable {
    pointer-events: none;
  }

  &.fullscreen {
    position: fixed;
    inset: 0;
    z-index: 100;
    pointer-events: none;
    border-radius: 0;
    padding-top: 0;

    video {
      object-fit: contain;
    }
  }

  &.hide {
    display: none;
  }
`, j0 = l.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  &.hide {
    display: none;
  }
`, F0 = l.div`
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 5px;
  background: rgba(45, 45, 45, 0.6);
  border-radius: 17px 0px 10px;

  font-family: 'Mundial';
  font-weight: 700;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #fff;
`, O0 = l.div`
  flex-grow: 1;
  overflow: hidden;

  span {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, B0 = l.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 33.5%;
    height: auto;
    max-width: 80px;
    border-radius: 50%;
    clip-path: none;
  }

  &.hide {
    display: none;
  }
`, U0 = l.div`
  position: absolute;
  top: 0;
  left: 0;
  border: 4px solid #49e162;
  border-radius: 10px;
  z-index: 20;
  pointer-events: none;
  transition: opacity 0.3s ease;
  opacity: ${(e) => e.currentvolume > 0 ? 1 : 0};
  width: 100%;
  height: 100%;
`, R0 = () => t(G0, { className: "show", children: t(Rn, { onClick: () => {
  oe({ gridFullscreen: false });
}, ariaLabel: "close" }) }), H0 = ({ screens: e }) => {
  const n = /* @__PURE__ */ k(null), i = /* @__PURE__ */ Un();
  return ue(() => {
    if (n.current) {
      const o = n.current.children, a = n.current.offsetHeight - 40;
      if (o.length > 0)
        for (let s = 0; s < o.length; s++)
          o[s].style.width = "", o[s].offsetHeight > a && (o[s].style.width = `${a / 0.658}px`);
    }
  }, [n, i]), t(q0, { ref: n, className: [...e].length > 1 ? "half" : "", children: [...e].map((o) => t(y0, { data: o[1] }, o[1].playerId)) });
}, W0 = (e, n, i) => Array.from(e.values()).slice(n * i, (n + 1) * i), V0 = () => {
  const [e, n, i, o] = /* @__PURE__ */ Te((h) => [h.participants, h.screens, h.participants.size, h.screens.size]), [a] = /* @__PURE__ */ ie((h) => [h.gridFullscreen]), s = [...n].length > 0, r = 20, [c, p] = /* @__PURE__ */ m(0), u = /* @__PURE__ */ Math.ceil(i / r);
  return w(() => {
    c > u - 1 && p(Math.max(u - 1, 0));
  }, [c, u]), d(Z0, { className: `${a ? "fs" : ""} ${s ? "ss" : ""}`, children: [t(M0, { currentPage: c, setCurrentPage: p, totalPage: u, screenShareOn: s }), d(T0, { participants: e, gridFullscreen: a, screenShareOn: s, children: [t(Y0, { className: s ? "ss" : "", children: W0(e, c, r).map((h) => t(z0, { data: h }, h.playerId)) }), s ? t(H0, { screens: n }) : null, a ? t(R0, {}) : null] })] });
}, Hn = () => ie((n) => n.showCallGrid) ? t(V0, {}) : null, Z0 = l.div`
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 50px);
  height: 100%;
  background: #222222;
  padding: 20px 20px 105px;
  pointer-events: all;
  z-index: -1;

  &.fs {
    z-index: 2000;
    width: 100%;
    padding: 0;
  }

  @media all and (min-width: 768px) {
    &.ss {
      .self {
        width: 100%;
        position: relative;
        right: auto;
        top: auto;
      }
    }
  }

  @media all and (max-width: 767px) {
    width: 100%;
    top: 50px;
    height: calc(100% - 105px);
    overflow: auto;
    pointer-events: all;
    padding: 20px 20px 0;

    &.fs {
      top: 0;
      height: 100%;
    }
  }
`, G0 = l.div`
  position: absolute;
  top: 49px;
  right: 49px;
  z-index: 999999;
  button {
    width: 35px;
    height: 35px;
    svg {
      width: 13px;
      height: 13px;
    }
  }
  &.show {
    button {
      transform: scale(1) translateZ(0);
    }
  }
`, q0 = l.div`
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  height: 100%;

  background: #2d2d2d;
  border-radius: 10px;
  width: 100%;
  max-width: 80%;
  min-width: 80%;
  padding: 20px 25px;
  & > div {
    width: 100%;
  }

  &.half {
    & > div {
      width: calc(50% - 15px);
    }
  }

  @media all and (max-width: 767px) {
    max-width: 100%;
    padding: 0;
    background: none;
    & > div {
      width: 100% !important;
    }
  }
`, Y0 = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;

  @media all and (min-width: 768px) {
    &.ss {
      width: calc(20% - 10px);
      justify-content: flex-start;
      align-content: flex-start !important;
      gap: 10px;
      /* flex-direction: column; */
    }
  }
`, K0 = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = e?.id, o = i === $().id, a = o ? n("you") : e?.name || n("anonymous"), [s, r, c] = /* @__PURE__ */ Ce((u) => [u.peers.get(i)?.enabled.audio, u.peers.get(i)?.currentVolume, u.peersNeedsUpdt[i]]), p = /* @__PURE__ */ z((u) => u.usersById[i]?.status);
  return d(J0, { className: e ? "" : "nouser", children: [e ? t(ut, { user: e, showOnline: false, self: o }) : null, t("span", { children: a }), t(Xo, { isOn: s, volumeDetected: r > 0, user: e }), p?.id !== "default" && p?.icon ? t(X0, { children: t("img", { src: M[p.icon], alt: "status" }) }) : null] });
}, J0 = l.div`
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  pointer-events: all;

  display: flex;
  align-items: center;
  max-width: 100%;
  padding: 0px 7px 0px 0px;
  gap: 5px;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 999px;

  min-height: 24px;

  span {
    white-space: nowrap;
    font-family: 'Mundial';
    font-weight: 700;
    font-size: 9px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .avatar {
    width: 24px;
    height: 24px;
    min-width: 24px;
  }

  &.nouser {
    padding: 0px 7px;
  }

  @media all and (max-width: 767px) {
    top: -10px;
  }
`, X0 = l.div`
  position: relative;
  font-size: 0;
  min-width: 14px;
  height: 14px;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    clip-path: none;
  }
`, Q0 = () => {
  const { t: e } = /* @__PURE__ */ x("office");
  return ie((i) => i.showCallGrid) ? null : d(eu, { onClick: () => {
    oe({ showCallGrid: true }), Ve({ paused: true });
  }, children: [t("div", { children: t("svg", { width: "21", height: "22", viewBox: "0 0 21 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: d("g", { children: [t("path", { className: "v", d: "M1.48239 21.1302C2.30109 21.1302 2.96477 20.4665 2.96477 19.6478C2.96477 18.8291 2.30109 18.1654 1.48239 18.1654C0.663687 18.1654 0 18.8291 0 19.6478C0 20.4665 0.663687 21.1302 1.48239 21.1302Z", fill: "#49E162" }), t("path", { className: "v2", d: "M1.48239 12.2358C0.663368 12.2358 0 12.8992 0 13.7182C0 14.5372 0.663368 15.2006 1.48239 15.2006C3.93481 15.2006 5.92955 17.1954 5.92955 19.6478C5.92955 20.4668 6.59292 21.1302 7.41194 21.1302C8.23095 21.1302 8.89432 20.4668 8.89432 19.6478C8.89432 15.561 5.56914 12.2358 1.48239 12.2358Z", fill: "#49E162" }), t("path", { className: "v3", d: "M1.48239 6.30627C0.663368 6.30627 0 6.96964 0 7.78866C0 8.60768 0.663368 9.27105 1.48239 9.27105C7.2044 9.27105 11.8591 13.9257 11.8591 19.6478C11.8591 20.4668 12.5225 21.1301 13.3415 21.1301C14.1605 21.1301 14.8239 20.4668 14.8239 19.6478C14.8239 12.2914 8.83873 6.30627 1.48239 6.30627Z", fill: "#49E162" }), t("path", { className: "v4", d: "M1.48239 0.376709C0.663368 0.376709 0 1.04008 0 1.8591C0 2.67812 0.663368 3.34148 1.48239 3.34148C10.474 3.34148 17.7886 10.6561 17.7886 19.6477C17.7886 20.4668 18.452 21.1301 19.271 21.1301C20.0901 21.1301 20.7534 20.4668 20.7534 19.6477C20.7534 9.02181 12.1083 0.376709 1.48239 0.376709Z", fill: "#49E162" })] }) }) }), t("p", { children: e("sharingscreen") })] });
}, eu = l.button`
  position: absolute;
  top: -96px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  pointer-events: all;

  background-color: #2c2c2c;
  border-radius: 3px;
  padding: 4px 6px 4px 3px;

  display: flex;
  align-items: center;
  gap: 6px;

  font-size: 0;

  div {
    min-width: 21px;
    width: 21px;
    min-height: 22px;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.35px;
    line-height: 19px;
    white-space: nowrap;
  }

  // animate the svg opacity one by one in sequence
  svg {
    .v {
      animation: screensharing 1s ease 0s infinite;
    }
    .v2 {
      animation: screensharing 1s ease 0.1s infinite;
    }
    .v3 {
      animation: screensharing 1s ease 0.2s infinite;
    }
    .v4 {
      animation: screensharing 1s ease 0.3s infinite;
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      background-color: #000;
    }
  }

  @media all and (max-width: 767px) {
    top: -50px;
  }
`, tu = ({ userId: e, userName: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return t(nu, { children: d(iu, { onClick: () => {
    b("openModal", t(Wo, { userId: e, userName: n }));
  }, children: [t(Pn, { children: t("img", { src: M["/icons/wave.svg"], alt: i("wave") }) }), t("span", { children: i("wave") })] }) });
}, nu = l.div`
  position: absolute;
  bottom: 170px;
  left: 50%;
  transform: translate3d(-50%, 0%, 0);
  z-index: 10;

  @media all and (max-width: 767px) {
    bottom: 100px;
  }
`, iu = l.button`
  pointer-events: all;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  gap: 5px;
  background: #ffffff;
  border-radius: 53px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);

  img {
    min-width: 16px;
    height: auto;
    clip-path: none;
  }

  span {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 12px;
    line-height: 9px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #2d2d2d;
    white-space: nowrap;
  }

  @media all and (pointer: fine) {
    img,
    span {
      position: relative;
      z-index: 1;
    }
    &::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      background: #111;
      border-radius: 53px;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    &:hover::before {
      opacity: 0.1;
    }
  }
`, ou = ({ user: e }) => {
  const [n, i] = /* @__PURE__ */ Te((o) => [o.screens, o.screens.size]);
  return n.has(e.id) ? t(Q0, {}) : null;
}, Wn = ({ data: e, showChip: n, showWave: i }) => {
  const [o, a] = /* @__PURE__ */ m(false), s = e?.playerId, r = s === $().id, { t: c } = /* @__PURE__ */ x("office"), p = /* @__PURE__ */ z((y) => y.usersById?.[s]), u = /* @__PURE__ */ z((y) => y.usersById?.[s]?.name), h = /* @__PURE__ */ z((y) => y.playersFirebase?.[s]?.callStatus), f = r ? c("you") : p?.name || c("anonymous"), v = z((y) => y.usersById[s]?.status?.id) || "default", g = !r && (v !== "default" || !u || h === "busy");
  return ue(() => {
    setTimeout(() => {
      a(true);
    });
  }, []), d(au, { children: [t(su, { className: o ? "show" : "", children: p && n ? d(T, { children: [t(ou, { user: p }), t(K0, { user: p, unavailable: g })] }) : null }), i && g ? t(tu, { userId: s, userName: f }) : null] });
}, Vn = (e) => e < 620 ? 3 : e < 820 ? 4 : 5, Qo = ({ isElectron: e }) => {
  const n = /* @__PURE__ */ k(null), i = /* @__PURE__ */ k(null), { width: o, height: a } = /* @__PURE__ */ Un(), [s, r] = /* @__PURE__ */ Te((v) => [v.participants, v.participants.size]);
  w(() => {
    oe({ avatarsContainerRef: n });
  }, [n]), w(() => {
    oe({ avatarsContainerRefBack: i });
  }, [i]);
  const c = /* @__PURE__ */ Array.from(s.values()), p = /* @__PURE__ */ c.slice(0, Vn(o)), u = /* @__PURE__ */ c.slice(Vn(o)), h = /* @__PURE__ */ Math.min(p.length, Vn(o)), f = /* @__PURE__ */ ie((v) => v.showCallGrid);
  return w(() => {
    if (!e || !n?.current)
      return;
    const v = /* @__PURE__ */ n.current.getBoundingClientRect();
    return window.electronBridge.ignoreEventRect({ id: "avatar", rect: { x: v.x, y: v.y, width: v.width, height: v.height } }), () => {
      window.electronBridge.ignoreEventRect({ id: "avatar", rect: null });
    };
  }, [n, e]), w(() => {
    if (e)
      return () => {
        window.electronBridge.ignoreEventRect({ id: "avatar", rect: null });
      };
  }, [e]), d(T, { children: [t(Zn, { ref: n, $num: h, children: p.map((v) => t(Wn, { data: v, showChip: !(f && p > 5) }, v.playerId)) }), t(Zn, { className: "above", $num: h, children: p.map((v) => t(Wn, { data: v, showWave: true }, v.playerId)) }), u.length > 0 ? t(Zn, { ref: i, $num: u.length, className: "chibi", children: u.map((v) => t(Wn, { data: v }, v.playerId)) }) : null] });
}, Zn = l.div`
  position: fixed;
  z-index: 0;
  left: 10px;
  bottom: -60px;
  display: flex;

  &.above {
    z-index: 1;
  }

  width: calc(140px * ${(e) => e.$num});
  height: calc(140px * 2);
  max-width: 767px;
  & > div {
    width: 140px;
    max-width: min(140px, calc(140px * ${(e) => e.$num}));
  }
  &.chibi {
    width: 100%;
    bottom: 0;
    height: 140px;
    flex-wrap: wrap-reverse;
    & > div {
      width: 70px;
      max-width: min(70px, calc(70px * ${(e) => e.$num}));
    }
  }

  @media all and (max-width: 767px) {
    max-width: 100%;

    & > div {
      max-width: 140px;
    }

    gap: 20px;

    // width: calc(100% - 20px);
    justify-content: center;
    bottom: 55px;

    &.chibi {
      bottom: 75px;
    }
  }

  @media all and (max-width: 540px) {
    gap: 10px;
  }

  @media all and (max-width: 480px) {
    left: 0;
    // width: 100%;
    gap: 0;
  }

  @media all and (max-width: 420px) {
    & > div {
      max-width: calc(33.33vw);
    }
    height: calc(33.33vw * 2);
  }
`, au = l.div`
  position: relative;
  /* background: #00006066; */
  padding: 0 3px;
`, su = l.div`
  opacity: 0;
  transform: translate3d(0, 100%, 0);
  transition: opacity 0.2s ease, transform 0.4s ease;
  &.show {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`, ea = ({ visual: e, label: n, cls: i, action: o, reactions: a, disabled: s, tr: r = "office" }) => {
  const { t: c } = /* @__PURE__ */ x(r), p = /* @__PURE__ */ k(null);
  return d(ru, { children: [t(du, { className: "tt", children: t("span", { children: c(n) }) }), a ? t(pu, { children: a }) : null, t(lu, { className: `${i} ${s ? "disabled" : ""}`, onClick: () => {
    o && o(), p.current && p.current.blur();
  }, children: t(cu, { children: t("img", { src: e, alt: c(n) }) }) })] });
}, ru = l.div`
  position: relative;
  @media all and (pointer: fine) {
    &:hover {
      .tt {
        transition-delay: 0s;
        transition-duration: 0.3s;
        transform: translate3d(-50%, 0, 0) scaleX(1);
        span {
          transform: translate3d(0, 0, 0);
          transition-delay: 0.2s;
          transition-duration: 0.2s;
        }
      }
    }
  }
`, lu = l.button`
  position: relative;
  z-index: 1;
  padding: 5px;

  img {
    position: relative;
    z-index: 1;
    width: 30px;
    clip-path: none;
  }

  &.emote {
    img {
      width: 14px;
    }
  }

  &.emoji {
    img {
      width: 20px;
    }
  }

  &.active {
    & > div {
      background: #5f5a5a;
    }
  }

  &.disabled {
    pointer-events: none !important;
    opacity: 0.5;
  }

  @media all and (pointer: fine) {
    & > div {
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        background: #000;
        transform: translate3d(-50%, -50%, 0) scale(0);
        transition: transform 0.2s ease;
      }
    }

    &:hover {
      & > div {
        &::before {
          transform: translate3d(-50%, -50%, 0) scale(1);
        }
      }
    }
  }
`, cu = l.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: #2d2d2d;
  border-radius: 100%;

  .svg {
    width: 32px;
    height: auto;
  }
`, du = l.div`
  position: absolute;
  top: -23px;
  left: 50%;
  white-space: nowrap;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 32px;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  color: #fff;
  transform: translate3d(-50%, 0, 0) scaleX(0);
  transition: transform 0s ease 0s;
  transform-origin: center center;
  overflow: hidden;
  pointer-events: none;
  z-index: 3;
  span {
    display: block;
    padding: 7px 15px;
    transform: translate3d(0, 100%, 0);
    transition: transform 0s ease;
    text-transform: uppercase;
  }
`, pu = l.div`
  position: absolute;
  z-index: 2;
  top: -6px;
  right: 0px;
  padding: 5px;

  background: #ffffff;
  border: 1px solid #595353;
  border-radius: 999px;

  font-family: 'Mundial';
  font-weight: 400;
  font-size: 8px;
  line-height: 8px;
  color: #2d2d2d;

  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`, Gn = [{ label: "clap", emoji: 1561, cls: "emoji", tr: "office" }, { label: "raised_hand", emoji: 1532, cls: "emoji", tr: "office" }, { label: "hello", emote: "hello", cls: "emote" }, { label: "dance", emote: "dance", cls: "emote" }, { label: "laugh", emote: "laugh", cls: "emote" }], ta = ({ actions: e = Gn, actionCallback: n }) => {
  const i = /* @__PURE__ */ dn(async () => await Ge(), ["emojis"]), o = (r) => {
    $n(r);
  }, a = (r) => {
    Tn(i, r);
  }, s = /* @__PURE__ */ Y(() => {
    const r = [];
    return e.forEach(async (c) => {
      c.emoji ? r.push({ label: c.label, visual: Sn(i, c.emoji), action: () => {
        a(c.emoji), n && n(c);
      }, reactions: c.reactions, cls: "emoji", tr: c.tr || "common" }) : c.emote && r.push({ label: c.label, visual: M[`${so}${c.emote}.webp`], reactions: c.reactions, action: () => {
        o(c.emote), n && n(c);
      }, cls: "emote", tr: c.tr || "common" });
    }), r;
  }, [e, i]);
  return s ? t(T, { children: s.map((r, c) => t(ea, { label: r.label, cls: r.cls, visual: r.visual, action: r.action, reactions: r.reactions, tr: r.tr }, c)) }) : null;
}, uu = /* @__PURE__ */ bt(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]), hu = l.span`
  border: 2px solid rgba(0, 0, 0, 0.1);
  width: 24px;
  height: 24px;
  padding: 6px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: ${uu} 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -12px;
  margin-top: -12px;
`, fu = ({ isOffice: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ z((c) => c.currentMeeting), o = /* @__PURE__ */ z((c) => c.currentMeeting?.isPrivate || false), a = /* @__PURE__ */ O((c) => c.id), s = /* @__PURE__ */ Te((c) => Array.from(c.participants.values()).every((p) => p.firebase?.status?.id && p.firebase.status.id !== "default" || p.playerId === a || !p.firebase?.name));
  return d(na, { isOffice: e, action: () => {
    const { updateMeeting: c } = /* @__PURE__ */ N(), { workspace: p, microverseId: u, currentMeeting: h } = /* @__PURE__ */ R();
    !h || s || c(p, u, h.meetingId, { isPrivate: !o });
  }, loading: !i, active: o, disabled: s, children: [t("div", { className: "lock", children: d("div", { children: [t("img", { src: M["/office/lock.svg"], alt: n("private") }), e ? t("span", { className: "secfont", children: n("private") }) : null] }) }), t("div", { className: "unlock", children: d("div", { children: [t("img", { src: M["/office/unlock.svg"], alt: n("unlock") }), e ? t("span", { className: "secfont", children: n("unlock") }) : null] }) })] });
}, na = ({ isOffice: e, loading: n, active: i, disabled: o, action: a, children: s }) => {
  const { t: r } = /* @__PURE__ */ x("office");
  return t(mu, { className: `${o ? "disabled" : ""} ${i ? "active" : ""} ${e ? "" : "onlyIcon"} ${n ? "loading" : ""}`, onClick: a, children: n ? d("div", { children: [t("span", { className: "secfont sfx", children: r("connecting-s") }), t("div", { className: "ldr", children: t(hu, {}) })] }) : t(T, { children: s }) });
}, mu = l.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 30px;

  min-width: 150px;
  height: 50px;
  background: #ffffff;
  border-radius: 53px;
  color: #2d2d2d;
  text-transform: uppercase;

  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  margin: 0 5px 0 0;
  overflow: hidden;

  &.onlyIcon {
    min-width: 50px;
    padding: 20px 10px;
    .sfx {
      display: none;
    }
  }

  img {
    clip-path: none;
  }

  div {
    position: relative;
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }

  & > div {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease;
    transform: translate3d(0, 0, 0);
  }

  .unlock {
    color: #fff;
    transform: translate3d(0, 100%, 0);
  }

  span {
    position: relative;
    z-index: 2;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
  }

  &::before {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 53px;
    background: #f33182;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &.disable {
    pointer-events: none;
    opacity: 0.3;
  }

  &.active {
    &::before {
      opacity: 1;
    }
    .unlock {
      transform: translate3d(0, 0, 0);
    }

    .lock {
      color: #fff;
      transform: translate3d(0, -100%, 0);
    }
  }

  .sfx {
    font-size: 12px;
    line-height: 12px;
  }

  .ldr {
    position: relative;
    width: 24px;
    height: 24px;
    span {
      position: relative;
      padding: 0;
      margin: 0;
      top: auto;
      left: auto;
    }
  }

  @media all and (max-width: 767px) {
    min-width: 50px;
    padding: 20px 10px;
    span {
    }
    .secfont {
      display: none;
    }
  }

  @media all and (pointer: fine) {
    &::after {
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      border-radius: 53px;
      background: #939393;
      z-index: 1;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    &:hover {
      &::after {
        opacity: 0.15;
      }
    }
  }

  &.loading {
    pointer-events: none;
  }

  &.disabled {
    pointer-events: none;
    background: #999;
    cursor: not-allowed;
    &:hover {
      &::after {
        opacity: 0;
      }
    }
  }
`, gu = ({ isElectron: e }) => {
  const n = /* @__PURE__ */ ie((s) => s.showCallGrid), i = /* @__PURE__ */ S((s) => s.workspaceDoc?.plan?.videoCall), o = /* @__PURE__ */ O((s) => s.id), a = /* @__PURE__ */ Te((s) => Array.from(s.participants.values()).every((r) => r.firebase?.status?.id && r.firebase.status.id !== "default" || r.playerId === o || !r.firebase?.name));
  return t(ea, { label: "grid", cls: n ? "svg active" : "svg", visual: M["/icons/grid.svg"], action: () => {
    oe({ showCallGrid: !n }), Ve({ paused: !n });
  }, disabled: !i || a });
}, xu = () => d(T, { children: [t(Dt, { show: true, huddleBar: true }), t(Pt, { show: true, huddleBar: true }), t(zt, { show: true, huddleBar: true })] }), vu = ({ isOffice: e, isElectron: n }) => d(T, { children: [t(fu, { isOffice: e }), t(gu, { isElectron: n }), n ? t(xu, {}) : null, e ? t(T, {}) : null, t(Cu, {}), t(q, { fallback: null, children: t(ta, { actions: n ? Gn.slice(0, 3) : Gn }) })] }), bu = ({ label: e = "join-call" }) => {
  const [n, i] = /* @__PURE__ */ m(false), { t: o } = /* @__PURE__ */ x("office");
  return w(() => {
    Ls().showCallGrid && (oe({ showCallGrid: false, gridFullscreen: false }), Ve({ paused: false }));
  }, []), d(T, { children: [t(na, { isOffice: true, loading: n, action: async () => {
    if (i(true), e === "activate-mic") {
      await he().userMediaUpdate(true), i(false);
      return;
    }
    const { workspace: s, microverseId: r, currentMeeting: c } = /* @__PURE__ */ R(), { editUser: p, joinMeeting: u } = /* @__PURE__ */ N();
    await p({ status: { id: "default", icon: null } }), c ? u(s, r, c.meetingId) : i(false);
  }, children: t("div", { className: "lock", children: t("div", { children: t("span", { className: "secfont", children: o(e) }) }) }) }), e === "activate-mic" ? t(yu, { children: t("p", { children: o("authorize-audio-call") }) }) : null] });
}, wu = ({ isOffice: e, isElectron: n }) => {
  const [i, o] = /* @__PURE__ */ O((p) => [p.id, p.spawning]), [a, s] = /* @__PURE__ */ z((p) => [p.usersById[i]?.status?.id || "default", p.usersById[i]?.name]), r = /* @__PURE__ */ yt((p) => p.audioAccessEnabled);
  return a !== "default" || !s || o || !r ? t(bu, { label: r ? "join-call" : "activate-mic" }) : t(vu, { isOffice: e, isElectron: n });
}, yu = l.div`
  padding: 0 0 0 5px;
  max-width: 220px;
  p {
    line-height: 14px;
  }
`, Cu = l.div`
  position: relative;
  width: 10px;
  height: 52px;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    height: 100%;
    opacity: 0.2;
    background: #fff;
  }
`, ia = ({ show: e, isOffice: n, isElectron: i, onLeavingCall: o, shbRef: a }) => {
  const [s] = /* @__PURE__ */ ie((c) => [c.leavingCall]), r = /* @__PURE__ */ yt((c) => c.audioAccessEnabled);
  return w(() => (e && he().userMediaUpdate(true), C({ socialBarOpened: e }), () => {
    C({ socialBarOpened: false });
  }), [r, e]), w(() => {
    o && s && o();
  }, [s, o]), s ? null : t(ku, { ref: a, className: `${e ? "show" : ""} ${n ? "" : "event"}`, children: t(wu, { isOffice: n, isElectron: i }) });
}, ku = l.div`
  position: fixed;
  z-index: 1;
  left: 20px;
  bottom: 20px;
  transform: translate3d(0, calc(100% + 25px), 0);
  transition: transform 0.5s ease;
  min-height: 72px;

  display: flex;
  align-items: center;
  padding: 10px 15px;
  background: rgba(45, 45, 45, 0.7);
  border-radius: 99px;
  gap: 5px;

  &.event {
    bottom: 35px;
    transform: translate3d(0, calc(100% + 35px), 0);
  }

  button {
    pointer-events: none;
  }

  &.show {
    button {
      pointer-events: all;
    }
    transform: translate3d(0, 0, 0);
  }

  @media all and (max-width: 767px) {
    left: 50%;
    bottom: 65px;
    transform: translate3d(-50%, calc(100% + 70px), 0);

    &.event {
      bottom: 90px;
      transform: translate3d(-50%, calc(100% + 100px), 0);
    }

    &.show {
      transform: translate3d(-50%, 0, 0);
    }
  }

  @media all and (max-width: 660px) {
    & > div {
      &:last-child {
        display: none;
      }
    }
  }

  @media all and (max-width: 600px) {
    & > div {
      &:nth-child(9) {
        display: none;
      }
    }
  }

  @media all and (max-width: 540px) {
    & > div {
      &:nth-child(8) {
        display: none;
      }
    }
  }

  @media all and (max-width: 490px) {
    & > div {
      &:nth-child(7) {
        display: none;
      }
    }
  }

  @media all and (max-width: 440px) {
    & > div {
      &:nth-child(6),
      &:nth-child(5) {
        display: none;
      }
    }
  }

  @media all and (max-width: 374px) {
    & > div {
      &:nth-child(4) {
        display: none;
      }
    }
  }
`, Su = ({ children: e, options: n, onClosed: i }) => {
  const [o, a] = /* @__PURE__ */ m(null), [s, r] = /* @__PURE__ */ m(false), c = /* @__PURE__ */ Y(() => it.MathUtils.generateUUID(), []);
  return w(() => {
    let p = null;
    return (async () => {
      if (!o) {
        if (typeof window.electronBridge < "u") {
          const h = /* @__PURE__ */ JSON.stringify({ options: n, id: c });
          p = window.open("about:blank", "_blank", h);
        } else {
          const h = `width=${n.width},height=${n.height},left=${n.left},top=${n.top}`;
          p = window.open("about:blank", n.title, h);
        }
        await new Promise((h) => {
          p.onload = h();
        }), a(p), r(true);
      }
    })(), () => {
      p && (p.onload = null);
    };
  }, [o, c, n]), w(() => () => {
    o?.close();
  }, []), w(() => {
    s && typeof window < "u" && typeof window.electronBridge < "u" && window.electronBridge.updateWindowOptions(c, n);
  }, [n, c, s]), w(() => {
    if (s) {
      const p = () => i();
      return typeof window < "u" && typeof window.electronBridge < "u" && window.electronBridge?.onWindowClosed(p), () => {
        typeof window < "u" && typeof window.electronBridge < "u" && window.electronBridge?.offWindowClosed(p);
      };
    }
  }, [i, s]), s ? Qs(t(zs, { target: o.document.body, children: e }), o.document.body) : null;
}, Mu = ({ show: e, isOffice: n }) => {
  const i = /* @__PURE__ */ useRef(null), o = () => {
    window.electronBridge.ignoreEventRect({ id: "bar", rect: null });
  }, a = () => {
    const r = /* @__PURE__ */ ref.current.getBoundingClientRect();
    window.electronBridge.ignoreEventRect({ id: "bar", rect: { x: r.x, y: r.y, width: r.width, height: r.height } });
  };
  useEffect(() => {
    ref?.current && (e ? setTimeout(() => {
      a();
    }, 550) : o());
  }, [ref, e]), useEffect(() => {
    ref.current && (e ? (i.current = new ResizeObserver((r) => {
      for (const c of r) {
        if (!isElectron || !ref?.current)
          return;
        a();
      }
    }), i.current.observe(ref.current)) : i?.current?.disconnect());
  }, [ref, e]);
  const s = () => {
    o();
  };
  return t(ia, { shbRef: ref, show: e, isOffice: n, isElectron: true, onLeavingCall: s });
}, Lu = ({ callMode: e, isOffice: n }) => {
  const i = e === "huddle";
  return d(Su, { options: { modal: true, fullScreen: true, bottom: 0, left: 0, transparent: true, frame: false, alwaysOnTop: true, hasShadow: false, resizable: false, visualEffectState: "active", title: "Social Bar", movable: true, show: false, webPreferences: { webgl: true, webgl2: true, contextIsolation: true, enableRemoteModule: true, nodeIntegration: false, sandbox: false, webviewTag: false } }, children: [d(Zi, { disableGlobalEffects: true, children: [t(Mu, { show: i, isOffice: n }), i ? t(Qo, { isElectron: true }) : null] }), t(hi.Out, {})] });
}, Iu = (e) => {
  const n = /* @__PURE__ */ k(null), i = async () => {
    try {
      n.current = await navigator.wakeLock.request("screen");
    } catch (a) {
      console.error(`${a.name}, ${a.message}`);
    }
  }, o = async () => {
    try {
      n.current && (await n.current.release(), n.current = null);
    } catch (a) {
      console.error(`${a.name}, ${a.message}`);
    }
  };
  return w(() => (e ? i() : o(), () => {
    o();
  }), [e]), { wakeLock: n };
}, $u = ({ callMode: e, isOffice: n }) => {
  const i = typeof window < "u" && window.electronBridge, o = e === "huddle";
  return i ? t(Lu, { callMode: e, isOffice: n }) : d(T, { children: [t(ia, { show: o, isOffice: n }), o ? t(Qo, {}) : null, t(hi.Out, {})] });
}, qn = ({ isOffice: e = true }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i] = /* @__PURE__ */ ie((a) => [a.callMode]), o = i === "huddle";
  return Iu(o), w(() => {
    document && (document.title = n(o ? "in-call" : "konpi-office"));
  }, [i]), t($u, { callMode: i, isOffice: e });
}, Tu = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = ["guest-features-not-accessible-1", "guest-features-not-accessible-2", "guest-features-not-accessible-3", "guest-features-not-accessible-4"];
  return d(ju, { className: "imc", children: [t("h5", { className: "secFontTxtSml", children: e("guest-info-ttl") }), t("p", { className: "normalTxt", children: e("guest-info-desc") }), t("ul", { children: n.map((i) => d("li", { children: [t("img", { src: M["/icons/red-cross.svg"], alt: "none" }), t("p", { className: "normalTxt", children: e(i) })] }, i)) })] });
}, Nu = ({ infoModal: e }) => {
  const [n, i] = /* @__PURE__ */ m(false), o = /* @__PURE__ */ nt("isMobile");
  return d(Pu, { className: n ? "showModal" : "", children: [e, t(_u, { onClick: o ? () => i(!n) : null, onMouseEnter: o ? null : () => i(true), onMouseLeave: o ? null : () => i(false), children: t("img", { src: M["/icons/warning.svg"], alt: "info" }) })] });
}, Au = ({ title: e, label: n, info: i }) => {
  const { t: o } = /* @__PURE__ */ x("office");
  return d(zu, { children: [t("td", { className: "ttl secFontTxtSml", children: o(e) }), t("td", { className: "cnt secFontTxtSml", children: o(n) }), i ? t("td", { children: t(Nu, { infoModal: i }) }) : null] });
}, Eu = ({ user: e, accountType: n }) => t(Du, { children: t("tbody", { children: t(Au, { title: "role-tab", label: { 999: "owner", 900: "admin", 100: "member", 10: "guest" }[n], info: n === 10 ? t(Tu, {}) : null }) }) }), Du = l.table`
  position: relative;
  z-index: 10;
  display: table;
  width: 100%;
  padding: 0 0 10px;
  margin-top: -10px;
`, zu = l.tr`
  position: relative;
  display: table-row;

  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  td {
    padding: 10px 0;
  }

  .ttl {
    font-weight: 200;
    padding: 0 14px 0 0;
    white-space: nowrap;
  }

  .cnt {
    letter-spacing: 0;
    width: 100%;
  }
`, Pu = l.div`
  position: absolute;
  top: 50%;
  right: -2px;
  transform: translateY(-50%);

  &.showModal {
    .imc {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`, _u = l.button`
  padding: 10px 4px;
  img {
    width: 16px;
    clip-path: none;
  }
`, ju = l.div`
  position: absolute;
  bottom: -11px;
  right: 33px;
  z-index: 10;

  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 5px;
  isolation: isolate;

  background: #2d2d2d;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.4);
  border-radius: 10px;

  min-width: 280px;

  & > p {
    padding: 0 0 5px;
  }

  ul {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    li {
      padding: 10px 0 0 0;
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }

  img {
    width: 16px;
    height: auto;
    clip-path: none;
  }

  pointer-events: none;
  opacity: 0;
  transform: translate3d(-20px, 0, 0);
  transition: opacity 0.2s ease, transform 0.4s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 17px;
    right: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px 0 12px 12px;
    border-color: transparent transparent transparent #2d2d2d;
  }
`, Yn = /* @__PURE__ */ ln(er(() => ({ openMenuSp: false, openAdminOverlay: false, addOfficeStep: 0, officeSelected: null, officeInfo: null, currentSectionAdmin: "", analyticsDetails: null, currentTimeSelected: "2023-4", workspaceCreationDate: "2023-1-10", analyticsMonths: [{ value: "2023-1" }, { value: "2023-2" }, { value: "2023-3" }, { value: "2023-4" }] }))), se = (e, n) => Yn(e, n || rn);
Object.assign(se, Yn);
const { getState: Kn, setState: G } = Yn, Fu = ({ open: e }) => d(Uu, { onClick: () => {
  G({ openMenuSp: !e });
}, children: [d("div", { className: e ? "hide" : "", children: [t("div", { className: "bar" }), t("div", { className: "bar" }), t("div", { className: "bar" })] }), t("div", { className: e ? "" : "hide", children: t(Me, {}) })] }), Ou = ({ open: e }) => {
  const n = /* @__PURE__ */ se((i) => i.openAdminOverlay);
  return d(Bu, { className: `${e ? "open" : ""} ${n ? "hide" : ""}`, children: [t(Rt, {}), t(Fu, { open: e })] });
}, Bu = l.div`
  position: fixed;
  width: 100%;
  height: 55px;
  left: 0;
  top: 0;
  background: #292929;
  box-shadow: 0px 4px 90px rgba(0, 0, 0, 0.55);
  display: none;
  z-index: 10;

  &.hide {
    display: none;
  }
  .whc {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    div {
      width: 55px;
      height: 55px;
      border-radius: 0;
    }
    h2 {
      font-family: 'Mundial';
      font-size: 19px;
      line-height: 26px;
      letter-spacing: 0.1em;
      br {
        display: none;
      }
    }
  }
  @media screen and (max-width: 890px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.open {
      box-shadow: none;
      background: #2d2d2d;
      justify-content: flex-end;
      .whc {
        display: none;
        box-shadow: none;
      }
    }
  }
`, Uu = l.button`
  padding: 20px;
  & > div {
    position: relative;
    width: 20px;
    height: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.hide {
      display: none;
    }
  }

  .bar {
    width: 100%;
    height: 1px;
    background: #fff;
  }
`, Rt = () => {
  const e = /* @__PURE__ */ S((i) => i.workspaceDoc), n = /* @__PURE__ */ Ne(e && e.logoUuid ? `${Ae.workspaceStorage}workspacelogo.webp?v=${e.logoUuid}` : null, null);
  return d(Zu, { className: "whc", children: [t(Gu, { children: t(qu, { src: n || M["/placeholder/workspace-icon-placeholder.webp"], alt: "workspace logo" }) }), t("h2", { className: "secfont", children: e?.name })] });
}, Ru = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ se((o) => o.currentSectionAdmin);
  return d(Ku, { className: i === e.title ? "active" : "", onClick: () => {
    const { router: o } = /* @__PURE__ */ N();
    o.push(e.url), G({ openMenuSp: false });
  }, children: [t("img", { src: M[e.icon], alt: e.title }), t("p", { className: "secFontTxtSml", children: n(e.title) })] });
}, Hu = ({ workspace: e }) => {
  const n = /* @__PURE__ */ S((c) => c.WORKSPACE_ADMIN_ROOT), [i, o] = /* @__PURE__ */ z((c) => [c.isWorkspaceOwner, c.isAdmin]), a = "/icons/admin/", s = e === "sougen", r = /* @__PURE__ */ [{ title: s ? "microverses" : "offices", url: `/${n}`, icon: `${a}office.svg` }].filter((c) => c);
  if (!s) {
    const c = [{ title: "overview", url: `/${n}/overview`, icon: `${a}settings.svg` }, { title: "privacy", url: `/${n}/privacy`, icon: `${a}privacy.svg` }, { title: "members", url: `/${n}/members`, icon: `${a}people.svg` }, process.env.NODE_ENV === "development" ? { title: "activities", url: `/${n}/activities`, icon: `${a}stats.svg` } : null];
    r.push(...c.filter((p) => p)), (i || o) && e !== "metacare" && r.push({ title: "billing", url: `/${n}/billing`, icon: `${a}billing.svg` });
  }
  return t(Yu, { children: r.map((c) => t("li", { children: t(Ru, { data: c }) }, c.title)) });
}, Wu = ({ workspace: e }) => {
  const [n, i] = /* @__PURE__ */ se((o) => [o.openMenuSp, o.openAdminOverlay]);
  return d(T, { children: [t(Vu, { className: `${n ? "open" : ""} ${i ? "hide" : ""}`, children: d("div", { className: "menutop", children: [t(q, { fallback: null, children: t(Rt, {}) }), t(Hu, { workspace: e })] }) }), t(Ou, { open: n })] });
}, Vu = l.div`
  width: 100%;
  max-width: 600px;
  padding: 30px 15px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  & > div {
    min-width: 260px;
    margin-bottom: -20px;
  }

  .menutop {
    transition: opacity 0.3s ease, transform 0.6s ease;
    transform: translate3d(0, 0, 0);
  }

  &.hide {
    .menutop {
      opacity: 0.1;
      transform: translate3d(-120px, 0, 0);
      pointer-events: none;
    }
  }

  @media screen and (max-width: 1600px) {
    max-width: 400px;
  }

  @media screen and (max-width: 1380px) {
    max-width: 360px;
  }

  @media screen and (max-width: 1340px) {
    max-width: 340px;
  }

  @media screen and (max-width: 890px) {
    position: fixed;
    top: 0;
    left: 0;
    inset: 0;
    max-width: none;
    display: none;
    background: #2d2d2d;

    &.open {
      display: flex;
      z-index: 10;
    }
  }
`, Zu = l.div`
  h2 {
    padding: 15px 0;
    font-weight: 600;
    font-size: 30px;
    line-height: 115%;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #eeeeee;
  }
`, Gu = l.div`
  width: 66px;
  height: 66px;
  border: 1px solid #444444;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
  }
`, qu = l.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #444444;
  border-radius: 6px;
`, Yu = l.ul`
  padding: 0 0 20px;
`, Ku = l.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 0;
  gap: 12px;

  &.active {
    position: relative;
    pointer-events: none;
    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      left: -34px;
      top: 50%;
      background: ${(e) => e.theme.colors.highlight};
      border-radius: 50%;
      transform: translate3d(0, -50%, 0);
    }
  }

  p {
    text-transform: capitalize;
  }

  img {
    width: 21px;
    height: auto;
    clip-path: none;
  }

  @media all and (pointer: fine) {
    transition: opacity 0.3s ease;
    &:hover {
      opacity: 0.7;
    }
  }
`, Ju = () => d(Xu, { children: [t("img", { className: "bg", src: M["/placeholder/office-preview.webp"], alt: "office" }), t(Qu, { children: t(q, { fallback: null, children: t(Rt, {}) }) })] }), Xu = l.div`
  position: relative;
  width: 412px;
  height: 544px;
  background: #2d2d2d;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  overflow: hidden;
  isolation: isolate;

  font-size: 0;

  .bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    clip-path: none;
  }

  @media (max-width: 800px) {
    width: 380px;
  }

  @media all and (max-width: 760px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`, Qu = l.div`
  position: absolute;
  z-index: 1;
  left: 40px;
  top: 40px;

  & > div {
    display: flex;
    align-items: center;
    gap: 15px;
    & > div {
      min-width: 66px;
    }
    h2 {
      padding: 0 40px 0 0;
      br {
        display: none;
      }
    }
  }
`, oa = ({ label: e, tr: n = "common" }) => {
  const { t: i } = /* @__PURE__ */ x(n);
  return d(eh, { children: [t(aa, {}), t("span", { children: i(e) }), t(aa, {})] });
}, eh = l.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  span {
    white-space: nowrap;
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    opacity: 0.2;
  }
`, aa = l.div`
  width: 100%;
  height: 1px;
  background: #ffffff;
  opacity: 0.2;
`, th = ({ email: e, ...n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = /* @__PURE__ */ k(null), [a, s] = /* @__PURE__ */ m(false), [r, c] = /* @__PURE__ */ m(60), [p, u] = /* @__PURE__ */ m(r);
  return w(() => (a || (o.current = setInterval(() => {
    u((h) => h > 1 ? h - 1 : (clearInterval(o.current), s(true), r));
  }, 1e3)), () => {
    clearInterval(o.current);
  }), [a, r]), d(nh, { children: [t(et, { label: "resend-email", tr: "office", action: () => {
    n.authFunctions.email(e, ae().lang || "en"), s(false);
    const h = p + 60;
    u(h), c(h);
  }, disable: !a }), t("p", { className: a ? "hide" : "", dangerouslySetInnerHTML: { __html: i("resend-email-desc", { seconds: `${p}` }) } })] });
}, nh = l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  p {
    text-align: center;
    transition: opacity 0.2s ease;
    &.hide {
      opacity: 0;
      transition: opacity 0s ease;
    }
  }
`, ih = ({ icon: e, type: n, placeholder: i, action: o, fieldRef: a }) => {
  const { t: s } = /* @__PURE__ */ x("office");
  return d(oh, { children: [t("img", { src: M[e], alt: n }), t("input", { ref: a, type: n, placeholder: s(i), required: true }), t(ah, { onClick: o, children: t("img", { src: M["/icons/back.svg"], alt: "back" }) })] });
}, oh = l.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  & > img {
    position: absolute;
    left: 23px;
    width: 18px;
    height: auto;
    clip-path: none;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  input {
    padding: 0 15px 0 54px;
    width: 100%;
    height: 48px;
    background: rgba(0, 0, 0, 0.4);
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    color: #fff;

    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.03em;
  }
`, ah = l.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;

  background: #060606;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 1px solid rgba(217, 217, 217, 0.2);

  img {
    position: relative;
    z-index: 1;
    width: 6px;
    transform: rotate(180deg);
    height: auto;
    clip-path: none;
  }

  @media all and (pointer: fine) {
    &:hover {
      background-color: #111;
    }
  }
`, sh = ({ setEmailSuccess: e, ...n }) => {
  const i = /* @__PURE__ */ k(null), [o, a] = /* @__PURE__ */ m(false), [s, r] = /* @__PURE__ */ m(null), c = async () => {
    if (r(null), !o && i.current) {
      const u = i.current.value;
      if (u.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
        a(true);
        const h = /* @__PURE__ */ u.replace(/\s/g, "");
        n.authFunctions.email(h, ae().lang || "en"), e({ email: h });
      } else
        i.current.focus(), r("email-incorrect");
    }
  }, p = (u) => {
    document.activeElement === i.current && u.key === "Enter" && c();
  };
  return w(() => (document.addEventListener("keydown", p, false), () => {
    document.removeEventListener("keydown", p, false);
  })), d(T, { children: [t(ih, { icon: "/icons/email.svg", type: "email", action: c, placeholder: "login-with-email", fieldRef: i }), s ? t(we, { label: s }) : null] });
}, rh = () => {
  const { t: e } = /* @__PURE__ */ x("office"), [n, i] = /* @__PURE__ */ m(false);
  return w(() => {
    if (window) {
      const a = new URL(window.location.href).hostname;
      i(a.split(".")[0] === "sougen");
    }
  }, []), n ? null : t(lh, { className: "secFontTxtSmlLight", dangerouslySetInnerHTML: { __html: e("tos") } });
}, lh = l.p`
  text-align: center;
  letter-spacing: 0.04em;

  a {
    font-weight: 700;
  }
`, ch = ({ emailSuccess: e, ...n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(T, { children: [t(sa, { children: t(rt, { isAccept: true }) }), t(te, { title: "sending-login-email", desc: i("sending-login-email-desc", { email: e.email }), tr: "office" }), t(th, { email: e.email, ...n })] });
}, dh = ({ setEmailSuccess: e, ...n }) => d(T, { children: [t(te, { title: "office-login-title", desc: "office-login-desc", tr: "office" }), d(vh, { children: [t(Ui, { data: [{ name: "google", icon: "/icons/google.svg" }, { name: "microsoft", icon: "/icons/microsoft.svg" }, { name: "apple", icon: "/icons/apple.svg" }], ...n }), t("div", { className: "or", children: t(oa, { label: "or", tr: "office" }) }), t(sh, { setEmailSuccess: e, ...n })] }), t(rh, {})] }), ph = (e) => {
  const [n, i] = /* @__PURE__ */ m(false);
  return n ? t(ch, { emailSuccess: n, ...e }) : t(dh, { setEmailSuccess: i, ...e });
}, uh = () => {
  const e = /* @__PURE__ */ k(null), [n, i] = /* @__PURE__ */ m(null), [o, a] = /* @__PURE__ */ m(false);
  return d(T, { children: [t(te, { title: "enter-name-title", desc: "enter-name-desc", tr: "office" }), t(xn, { ref: e, placeholder: "enter-name-placeholder", tr: "office" }), n ? t(we, { label: n, tr: "office" }) : null, t("div", { children: t(B, { label: "save", tr: "office", disable: o, cls: "white", arrow: false, onClick: async () => {
    if (i(null), e.current.value.length < 1) {
      i("name-error");
      return;
    }
    const { setPublic: s } = /* @__PURE__ */ ot(), { id: r } = /* @__PURE__ */ $();
    await s({ property: "name", value: e.current.value, userId: r }), a(true);
  } }) })] });
}, hh = () => d("div", { children: [t(sa, { children: t(rt, { isAccept: true }) }), t(te, { title: "login-success", desc: "login-success-desc", tr: "office" })] }), fh = ({ user: e, ...n }) => {
  const i = /* @__PURE__ */ O((o) => o.name);
  return n.requireName && !e?.isAnonymous && !i ? t(uh, {}) : t(ph, { ...n });
}, mh = (e) => {
  const n = /* @__PURE__ */ O((i) => i.user);
  return t(gh, { children: t(xh, { children: n?.emailVerified ? t(hh, {}) : t(fh, { user: n, ...e }) }) });
}, gh = l.div`
  display: flex;
  align-items: center;
  background: #2d2d2d;
  height: 100%;
  padding: 30px 50px;

  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
  isolation: isolate;

  @media (max-width: 860px) {
    padding: 30px 20px;
  }
`, xh = l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  max-width: 332px;

  background: #2d2d2d;

  .tdc {
    text-align: center;
  }
`, vh = l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;

  .or {
    width: 100%;
    max-width: 170px;
    & > div {
      padding: 0;
    }
  }
`, sa = l.div`
  max-width: 332px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`, ra = ({ authFunctions: e, guestLogin: n, office: i, requireName: o, showBg: a }) => d(bh, { children: [a ? t("img", { src: M["/placeholder/office-preview.webp"], alt: "bg" }) : null, d(wh, { className: "office", children: [t(la, { className: "olv", children: t(Ju, {}) }), t(la, { children: t(mh, { requireName: o, authFunctions: e }) })] })] }), bh = l.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;

  & > img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    filter: blur(20px);
    pointer-events: none;
  }
`, wh = l.div`
  display: flex;
  gap: 10px;
  pointer-events: auto;

  &.office {
    gap: 0;
    & > div {
      padding: 0;
    }

    @media all and (max-width: 760px) {
      height: 100%;
      width: 100%;
      flex-direction: column;
      background: #2d2d2d;
      & > div {
        height: 100%;
        &:first-child {
          order: 2;
        }
        &.olv {
          display: none;
        }
      }
    }
  }
`, la = l.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 40px;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacity});
  border-radius: 10px;
  min-height: 376px;
`, yh = ({ children: e, cls: n }) => {
  const [i, o] = /* @__PURE__ */ m(false), a = () => {
    o(false), setTimeout(() => {
      b("closeModal");
    }, 500);
  };
  return ue(() => {
    const s = (r) => {
      r.keyCode === 27 && a();
    };
    return setTimeout(() => {
      o(true);
    }, 0), window.addEventListener("keydown", s), () => {
      window.removeEventListener("keydown", s);
    };
  }, []), t(vn, { className: i ? "show" : "", children: t(kh, { children: d(Sh, { children: [t(Mh, { className: `${i ? "show" : ""} ${n}`, children: e }), n === "noclose" ? null : d(Wi, { className: "blm", children: [t(sn, { label: "close", action: a, tr: "office" }), t(Lh, { className: "close-sp", onClick: a, children: t(Me, {}) })] })] }) }) });
}, Ch = ({ children: e, cls: n = "" }) => e ? t(yh, { cls: n, children: e }) : null, kh = l.div`
  position: relative;
  z-index: 1;
  overflow: auto;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (max-height: 650px), all and (max-width: 720px) {
    align-items: flex-start;
  }

  @media all and (max-width: 720px) {
    width: 100%;

    .lblbtn {
      display: none;
    }

    .close-sp {
      display: block;
    }

    .blm {
      position: fixed;
      right: 7px;
      top: 7px;
      z-index: 10;
      left: auto;
      bottom: auto;
      transform: translate3d(100%, 0, 0);
      width: auto;
    }
  }
`, Sh = l.div`
  position: relative;
  z-index: 1;
  padding: 10px 5px;

  @media all and (max-width: 720px) {
    padding: 0;
    width: 100%;
    min-height: 100%;
  }
`, Mh = l.div`
  display: flex;
  position: relative;
  pointer-events: all;
  padding: 50px;
  z-index: 1;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #292929;
    border-radius: 10px;
    transition: transform 0.4s ease 0.3s, opacity 0.2s ease 0.3s;
    opacity: 0;
    transform: scaleX(0) translateZ(0);
  }

  & > div {
    position: relative;
    z-index: 1;
    transition: transform 0.4s ease;
    transform: translate3d(0, calc(100% + 70px), 0);
  }

  @media all and (max-width: 720px) {
    & > div {
      transform: translate3d(0, 100vh, 0);
    }
  }

  &.show {
    &::before {
      transform: scaleX(1) translateZ(0);
      opacity: 1;
      transition-duration: 0.4s, 0s;
      transition-delay: 0s, 0s;
    }
    & > div {
      transform: translate3d(0, 0, 0);
      transition-delay: 0.25s;
      transition-duration: 0.5s;
    }

    &.gong {
      & > div {
        opacity: 1;
        transition: opacity 0s ease;
      }

      .gvt {
        opacity: 1;
        transition-delay: 0.4s, 0.4s;
        transform: translate3d(0, 0, 0);
      }

      .btm {
        img {
          opacity: 1;
          transition-delay: 0.3s;
        }
        &::before {
          transform: translate3d(0, 0, 0);
          transition-delay: 0s;
        }
        &::after {
          transform: rotate(10deg) translate3d(0, 0, 0);
          transition-delay: 0.2s;
        }
      }

      .anim,
      .cyber_cheering,
      .main_dance,
      .soul_cheering {
        transform: translate3d(0, 0, 0);
        transition-delay: 0.2s;
      }

      .main_dance {
        transition-delay: 0.35s;
      }

      .soul_cheering {
        transition-delay: 0.4s;
      }

      .cyber_cheering {
        transition-delay: 0.45s;
      }

      .confetti {
        transform: translate3d(-50%, 0, 0) scale(1);
        transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
        transition-delay: 0.1s;
      }
      .balloon-blue,
      .balloon-red,
      .balloon-yellow {
        transform: scale(1) translate3d(0, 0, 0);
        transition-duration: 0.9s;
      }

      .balloon-blue {
        transition-delay: 0.7s;
      }
      .balloon-red {
        transition-delay: 0.5s;
      }
      .balloon-yellow {
        transition-delay: 0.4s;
        transition-duration: 1.2s;
      }
    }
  }

  &.gong {
    padding: 0;
    overflow: visible;
    & > div {
      transform: translate3d(0, 0, 0);
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }

  @media all and (max-width: 720px) {
    flex-direction: column;
    min-height: 100vh;
    padding: 70px 20px 30px;
    height: 100%;
    & > div {
      &:first-child {
        order: 2;
        width: 100%;
        margin: 0 auto;
      }
    }
  }

  @media all and (max-width: 720px) {
    &::before {
      border-radius: 0;
    }
  }

  &.validation {
    padding: 0;
  }
`, xe = l.div`
  min-width: 480px;
  max-width: 480px;

  &.split-mdl {
    min-width: 845px;
  }

  @media all and (max-width: 860px) {
    &.split-mdl {
      min-width: 100%;
      max-width: 100%;
      width: 100%;
    }
  }

  @media screen and (max-width: 600px) {
    min-width: 100%;
    max-width: 100%;
    width: 100%;
  }
`, ye = l.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 0 0;
  button {
    min-width: auto;
  }

  &.center {
    justify-content: center;
  }

  &.sptw {
    justify-content: space-between;
  }

  &.nopt {
    padding: 0;
  }
`, Lh = l.button`
  font-size: 0;
  padding: 15px;
  display: none;
  pointer-events: all;
  z-index: 10;

  svg {
    width: 20px;
    height: auto;
  }
`, ca = ({ status: e }) => {
  const { t: n } = /* @__PURE__ */ x("office");
  return d(zh, { children: [t("img", { src: M[e.icon], alt: e.id }), t(Ph, { children: t("p", { className: "status secFontTxtSml", children: n(e.id) }) })] });
}, Ih = ({ status: e, setUpdating: n }) => t(Dh, { onClick: async (i) => {
  i.preventDefault(), i.stopPropagation(), n(true);
  const { editUser: o } = /* @__PURE__ */ N();
  await o({ status: e }) ? (b("closeModal"), e.id !== "default" && await Hs().leaveCall()) : n(false);
}, children: t(ca, { status: e }) }), $h = () => {
  const [e, n] = /* @__PURE__ */ m(false);
  return e ? t(_h, { children: t(It, {}) }) : t(Eh, { children: Ro.map((i) => i.id !== "default" ? t(Ih, { status: i, setUpdating: n }, i.id) : null) });
}, Th = () => {
  const { t: e } = /* @__PURE__ */ x("office");
  return t(xe, { children: d(Nh, { children: [t(Ah, { children: t("h3", { children: e("set-status") }) }), t($h, {})] }) });
}, Nh = l.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`, Ah = l.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  h3 {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
  }
`, Eh = l.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`, Dh = l.button`
  position: relative;
  display: flex;
  padding: 15px 23px;
  width: 100%;
  border: 1px solid #ffffff;
  border-radius: 5px;

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0;
      transition: opacity 0.2s ease;
      border-radius: 5px;
    }
    &:hover {
      &::before {
        opacity: 0.1;
      }
    }
  }
`, zh = l.div`
  position: relative;
  z-index: 1;
  display: flex;
  gap: 20px;
  align-items: center;
  img {
    width: 17px;
    height: 17px;
    clip-path: none;
  }
`, Ph = l.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .status {
    text-transform: capitalize;
  }

  .time {
    opacity: 0.5;
  }
`, _h = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 285px;
`, jh = () => {
  const [e, n] = /* @__PURE__ */ m(false);
  return t(Rh, { onClick: e ? null : async () => {
    n(true);
    const { editUser: i } = /* @__PURE__ */ N();
    await i({ status: pt("default") }), n(false);
  }, children: e ? t(Et, {}) : t(Me, {}) });
}, Fh = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = /* @__PURE__ */ O((a) => a.id), i = /* @__PURE__ */ z((a) => a.usersById[n]?.status?.id), o = i && i !== "default" ? pt(i) : null;
  return d(Oh, { children: [t(Bh, { className: o ? "active" : "", onClick: () => {
    C({ openModal: "" }), b("openModal", t(Th, {}));
  }, children: o ? t(ca, { status: o }) : t(Uh, { children: t("p", { className: "secFontTxtSml", children: e("set-status") }) }) }), o && o.id !== "default" ? t(jh, {}) : null] });
}, Oh = l.div`
  position: relative;
  width: 100%;
`, Bh = l.button`
  display: flex;
  flex-direction: row;
  min-height: 48px;

  align-items: center;
  padding: 12px 20px;
  border: 2px solid #ffffff;
  border-radius: 5px;
  width: 100%;

  justify-content: center;

  &.active {
    justify-content: flex-start;
    padding-right: 50px;
  }

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0;
      transition: opacity 0.2s ease;
      border-radius: 5px;
    }
    &:hover {
      &::before {
        opacity: 0.1;
      }
    }
  }
`, Uh = l.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  p {
    line-height: 14px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
`, Rh = l.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 7px;
  height: 100%;
  width: 48px;

  svg {
    width: 14px;
    height: auto;
    opacity: 0.6;
  }

  @media all and (pointer: fine) {
    svg {
      transition: opacity 0.2s ease;
    }
    &:hover {
      svg {
        opacity: 1;
      }
    }
  }
`, da = ({ setPreviewUrl: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i, o] = /* @__PURE__ */ m(false), a = (p) => {
    p.preventDefault(), o(true);
  }, s = (p) => {
    p.preventDefault(), o(false);
  }, r = (p) => {
    b("notification:error", { message: n(p) });
  }, c = async (p) => {
    if (o(false), p.dataTransfer.files && p.dataTransfer.files.length > 0) {
      if (p.dataTransfer.files.length > 1) {
        r("only-one-image");
        return;
      }
      const u = p.dataTransfer.files[0];
      if (!u.type.startsWith("image/")) {
        r("sorry-file-not-supported");
        return;
      }
      if (!await new Promise((v) => {
        const g = new Image();
        g.src = URL.createObjectURL(u), g.onload = () => {
          g.width < 256 || g.height < 256 ? v(false) : v(true);
        }, g.onerror = () => v(false);
      })) {
        r("image-too-small");
        return;
      }
      const f = new FileReader();
      f.onload = (v) => {
        e(v.target.result);
      }, f.readAsDataURL(u);
    }
  };
  return d(Vh, { className: `${i ? " drag-over" : ""}`, onDragOver: a, onDragLeave: s, onDrop: c, children: [t(Hh, {}), t("input", { type: "file", accept: "image/*", onChange: (p) => c({ ...p, dataTransfer: { files: p.target.files } }) })] });
}, Hh = () => {
  const { t: e } = /* @__PURE__ */ x();
  return d(Zh, { children: [t("img", { src: M["/icons/image.svg"], alt: "upload" }), t("p", { dangerouslySetInnerHTML: { __html: e("upload-photo-spec") } })] });
}, pa = ({ hasProfilePic: e, id: n, profilePicUid: i, className: o, previewUrl: a }) => {
  const s = /* @__PURE__ */ Ne(e ? `${Ae.profilePicturePath + n}/profile.webp${i ? `?v=${i}` : ""}` : null, M["/placeholder/profilepic.jpg"]);
  return t("img", { className: o, src: a || s, alt: "selected" });
}, Wh = ({ setEditPhoto: e }) => {
  const [n, i] = /* @__PURE__ */ m(false), [o, a] = /* @__PURE__ */ m(null), [s, r, c] = /* @__PURE__ */ O((p) => [p.id, p.hasProfilePic, p.profilePicUid]);
  return d(T, { children: [d(Z, { title: "update-photo", children: [t("div", { className: "flx-center pb-30", children: d(qh, { children: [t(q, { fallback: t("img", { className: "img-bg", src: M["/placeholder/profilepic.jpg"], alt: "Selected" }), children: t(pa, { className: "img-bg", hasProfilePic: r, id: s, profilePicUid: c, previewUrl: o }) }), t(q, { fallback: t("img", { className: "img-preview", src: M["/placeholder/profilepic.jpg"], alt: "Selected" }), children: t(pa, { className: "img-preview", hasProfilePic: r, id: s, profilePicUid: c, previewUrl: o }) })] }) }), t(da, { setPreviewUrl: a })] }), d(Gh, { children: [t(B, { label: "save", tr: "office", arrow: false, onClick: () => {
    if (!o) {
      b("notification:error", { message: "error-no-image" });
      return;
    }
    i(true), N().compressAndUpload(o, [512, 512], "profile", "global", () => {
      i(false), e(false);
    });
  }, cls: "white", disable: !o || n }), t(B, { label: "cancel", tr: "office", arrow: false, onClick: () => {
    e(false);
  } })] })] });
}, Vh = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 180px;
  border: 2px dashed rgba(255, 255, 255, 0.4);
  background: #1d1d1d;

  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &.drag-over {
    border-color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }

  input[type='file'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  @media all and (pointer: fine) {
    &:hover {
      border-color: #fff;
    }
  }
`, Zh = l.div`
  font-weight: 600;
  font-size: 9px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.1em;
  padding: 0 30px;

  img {
    width: 36px;
    height: auto;
    clip-path: none;
    margin: 0 auto;
  }

  p {
    padding: 5px 0 0;
    max-width: 300px;
  }
`, Gh = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px 30px;
  width: 100%;
  button {
    width: 100%;
  }
`, qh = l.div`
  position: relative;
  width: 108px;
  height: 108px;
  border-radius: 5px;
  overflow: hidden;
  isolation: isolate;
  background: #000;
  font-size: 0;

  .img-bg {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.4;
  }

  .img-preview {
    position: relative;
    z-index: 1;
    border-radius: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
  }
`, Yh = () => d(T, { children: [t(Ot, {}), t("div", { className: "edit flx-center", children: t("img", { src: M["/icons/edit.svg"], alt: "edit" }) })] }), Kh = ({ connected: e }) => {
  const { workspace: n } = /* @__PURE__ */ z(), i = /* @__PURE__ */ Y(() => ({ facebook: async () => {
    await N().signInCustomPopUp("facebook.com", n);
  }, twitter: async () => {
    await N().signInCustomPopUp("twitter.com", n);
  }, google: async () => {
    await N().signInCustomPopUp("google.com", n);
  }, email: async (s, r) => {
    await N().signInEmail(s, n, r, "/initAuth");
  } }), [n]), o = () => {
    C({ openModal: "" }), b("openModalValidation", t(ra, { authFunctions: i, office: true }));
  };
  return j("showLoginModal", o), t("div", { className: "flx-center", children: t(sn, { label: e ? "logout" : "login", action: e ? async () => {
    b("showSpinnerLoader", { opaque: true }), await N().cleanAndSignout(true), window.location.href = "/";
  } : o }) });
}, Jh = ({ setEditPhoto: e, office: n }) => {
  const i = /* @__PURE__ */ k(null), [o, a] = /* @__PURE__ */ m(false), [s, r] = /* @__PURE__ */ O((y) => [y.user, y.name]), [c, p] = /* @__PURE__ */ m("Anonymous"), u = /* @__PURE__ */ z((y) => y.isAdmin), h = z((y) => y.usersById[s?.uid]?.accountType) || 10, f = (s?.isAnonymous || h === 10) && !u;
  w(() => {
    p(r);
  }, [r]);
  const v = () => {
    b("open-tab", "avatar"), C({ openModal: J.MENU });
  }, g = () => {
    if (i.current.value !== c && i.current.value !== "") {
      p(i.current.value);
      const { setPublic: y } = /* @__PURE__ */ N();
      y({ property: "name", value: i.current.value, userId: s.uid });
    }
    a(false);
  };
  return d(T, { children: [t(Z, { title: "your-profile", children: d(e1, { children: [d(t1, { children: [t(n1, { onClick: () => {
    e(true);
  }, children: s ? t(Yh, {}) : null }), t("div", { className: "flx-center name w-100", children: o ? t("input", { type: "text", defaultValue: c, ref: i }) : d(T, { children: [t("h5", { children: c }), t(i1, { onClick: () => a(true), children: t("img", { src: M["/icons/edit.svg"], alt: "edit" }) })] }) }), n && !o && s?.email ? t("p", { children: s.email }) : null] }), o ? null : d(T, { children: [t(o1, { children: n && s && !f ? t(Fh, {}) : null }), n ? t(Eu, { user: s, accountType: h }) : null, t(Kh, { connected: s && !s.isAnonymous })] })] }) }), t("div", { className: "flx-center btm", children: t(B, { label: o ? "save" : "customize-avatar", arrow: false, onClick: o ? g : v, cls: o ? "white" : "", tr: o ? "office" : "common" }) })] });
}, Xh = ({ office: e }) => {
  const [n, i] = /* @__PURE__ */ m(false);
  return t(Qh, { children: n ? t(Wh, { setEditPhoto: i }) : t(Jh, { setEditPhoto: i, office: e }) });
}, Qh = l.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .btm {
    padding: 0 25px 30px;
    button {
      width: 100%;
    }
  }
`, e1 = l.div``, t1 = l.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Mundial';
  & > img {
    width: 108px;
    height: 108px;
    border-radius: 50%;
    clip-path: none;
  }

  .name {
    h5,
    input {
      border: none;
      background: none;
      text-align: center;
      color: #fff;
      font-weight: 600;
      font-size: 19px;
      line-height: 20px;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
  }

  h5 {
    margin: 15px 0 0 0;
  }

  input {
    width: 100%;
    padding: 15px 0 0 0;
  }

  p {
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.04em;
    opacity: 0.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`, n1 = l.button`
  position: relative;
  width: 108px;
  height: 108px;
  img {
    clip-path: none;
  }
  .pp {
    width: 108px;
    border-radius: 100%;
    height: 108px;
    object-fit: cover;
  }
  .edit {
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
    height: 30px;
    background: #2d2d2d;
    border-radius: 50%;

    img {
      width: 13px;
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      .edit {
        background: #f33182;
      }
    }
  }
`, i1 = l.button`
  padding: 15px 8px 0;
  img {
    width: 12px;
    height: auto;
    opacity: 0.3;
  }
  @media all and (pointer: fine) {
    &:hover {
      img {
        opacity: 1;
      }
    }
  }
`, o1 = l.div`
  padding: 25px 0;
`, Jn = ({ forceActive: e = false, office: n }) => {
  const i = /* @__PURE__ */ S((o) => o.openModal === J.PROFIL);
  return t(ht, { office: n, show: e || i, cls: "user-modal", children: t(Xh, { office: n }) });
}, a1 = l.div`
  position: fixed;
  bottom: 40px;
  left: 40px;
  padding: 50px;
`, s1 = l.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  background: rgba(45, 45, 45, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  &.anim {
    transition: opacity 0.3s ease;
  }
`, r1 = l.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120px;
  height: 120px;
  &.anim {
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
`, l1 = l.div`
  position: absolute;
  top: 50%;
  left: 50%;
  border: 5px solid #fff;
  border-radius: 100px;
  background: #ffffff40;
  width: 100%;
  height: 100%;
  &.anim {
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
`, c1 = l.div`
  position: absolute;
  top: -6px;
  right: 50%;
  bottom: 50%;
  left: -6px;
  transform-origin: 100% 100%;
  overflow: hidden;
  :before {
    content: '';
    display: block;
    width: 200%;
    height: 200%;
    box-sizing: border-box;
    border: 9px solid #16ebeb80;
    border-radius: 50%;
    transform: skewX(-30deg);
  }
`, Ht = 20, d1 = l.div`
  position: absolute;
  width: 28px;
  height: 28px;
  top: 50%;
  left: 50%;
  transform: translate3D(-50%, -50%, 0);
  & > div {
    &:nth-child(1) {
      left: 50%;
      top: 0;
      transform: translate3D(-50%, 0, 0);
    }
    &:nth-child(2) {
      right: -2px;
      top: 50%;
      transform: translate3D(0, -50%, 0) rotate(90deg);
    }
    &:nth-child(3) {
      left: 50%;
      bottom: 0;
      transform: translate3D(-50%, 0, 0) rotate(180deg);
    }
    &:nth-child(4) {
      left: -2px;
      top: 50%;
      transform: translate3D(0, -50%, 0) rotate(-90deg);
    }
  }

  &.active {
    & > div {
      transition-duration: 0.2s;
      &:nth-child(1) {
        transform: translate3D(-50%, -${Ht}px, 0);
      }
      &:nth-child(2) {
        transform: translate3D(${Ht}px, -50%, 0) rotate(90deg);
      }
      &:nth-child(3) {
        transform: translate3D(-50%, ${Ht}px, 0) rotate(180deg);
      }
      &:nth-child(4) {
        transform: translate3D(-${Ht}px, -50%, 0) rotate(-90deg);
      }
    }
  }
`, Wt = l.div`
  position: absolute;
  width: 7px;
  height: 3px;
  background: url(${M["/icons/arrow-small.svg"]}) no-repeat;
  background-size: contain;
  transition: transform 0.4s ease;
`, Vt = 20, ua = 45, ha = 50, p1 = ({ dragging: e, pos: n, visible: i }) => {
  const o = /* @__PURE__ */ Math.atan2(n.x, n.y), a = { x: Math.sin(o) * (ua - ha / 2 + Vt), y: Math.cos(o) * (ua - ha / 2 + Vt) };
  n.x = Math.abs(n.x) < Math.abs(a.x) ? n.x : a.x, n.y = Math.abs(n.y) < Math.abs(a.y) ? n.y : a.y;
  const s = i && e ? 0 : 1, r = { x: `calc(-50% + ${e ? n.x : 0}px)`, y: `calc(-50% + ${e ? n.y : 0}px)`, z: 0 };
  return t(s1, { className: `jsc ${e ? "" : "anim"}`, style: { opacity: s, transform: `translate3d(${r.x}, ${r.y}, ${r.z}px)` } });
}, u1 = ({ show: e, dragging: n, pos: i }) => {
  const o = /* @__PURE__ */ Math.atan2(i.x, i.y), a = { x: Math.sin(o) * Vt, y: Math.cos(o) * Vt };
  i.x = Math.abs(i.x) < Math.abs(a.x) ? i.x : a.x, i.y = Math.abs(i.y) < Math.abs(a.y) ? i.y : a.y;
  const s = e && n ? 1 : 0, r = { x: `calc(-50% + ${n ? i.x : 0}px)`, y: `calc(-50% + ${n ? i.y : 0}px)`, z: 0 };
  return d(r1, { className: `jdc ${n ? "" : "anim"}`, style: { transform: `translate3d(${r.x}, ${r.y}, ${r.z}px)` }, children: [d(d1, { className: `${n ? "active" : ""}`, style: { transform: `translate3d(${r.x}, ${r.y}, ${r.z}px) ` }, children: [t(Wt, {}), t(Wt, {}), t(Wt, {}), t(Wt, {})] }), t(h1, { dragging: n, pos: i }), t(l1, { className: `${n ? "" : "anim"}`, style: { opacity: s, transform: `translate3d(${r.x}, ${r.y}, ${r.z}px) scale(${n ? 1 : 0}) ` } })] });
}, h1 = ({ dragging: e, pos: n }) => {
  const i = Math.atan2(n.x, n.y) + Math.PI / 1.5;
  return t(c1, { className: "jda", style: { opacity: e ? 1 : 0, transform: `rotate(${-(e ? i : 0)}rad) skewX(30deg) translateZ(0)` } });
}, f1 = ({ show: e, dragging: n, pos: i, visible: o = true, ...a }) => {
  const s = /* @__PURE__ */ S((r) => r.showJumpTutorial);
  return d(a1, { className: "", ...a, children: [t(p1, { dragging: n, visible: o, pos: i }), o ? t(u1, { show: e, dragging: n, pos: i }) : null] });
}, m1 = l.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  padding: 50px;
  z-index: 100;
  pointer-events: none;
  transform: scale(0) translateZ(0);
  transition: transform 0.4s ease;

  svg {
    transform-origin: center;
    transition: transform 0.3s ease, opacity 0.2s ease;
    path {
      transform-origin: top center;
    }
  }

  &:active {
    pointer-events: all;
    svg {
      opacity: 1;
      transition-duration: 0.1s;
      transform: scale(1.2);
    }
  }

  &.show {
    pointer-events: all;
    transform: scale(1) translateZ(0);
  }
`, g1 = l.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 100px;
  transform: translate3D(-50%, -50%, 0);
  background: rgba(45, 45, 45, 0.1);
`, x1 = l.div`
  position: absolute;
  top: 12px;
  left: 50%;
  width: 18px;
  height: 11px;
  transform: translate3D(-50%, 0, 0);

  svg {
    opacity: 0.4;
    display: block;
  }
`, v1 = () => t("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 13", children: d("g", { stroke: "#fff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [t("path", { d: "m1.89648 8 8.80002-7 8.8 7", strokeOpacity: ".8" }), t("path", { d: "m5.66797 12 5.02853-4 5.0286 4", strokeOpacity: ".4" })] }) }), b1 = ({ show: e, ...n }) => {
  const i = /* @__PURE__ */ S((o) => o.showMoveTutorial);
  return t(m1, { className: e ? "show" : "", ...n, children: t(g1, { className: "", children: t(x1, { className: "", children: t(v1, {}) }) }) });
}, w1 = ({ paintColor: e }) => d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "29", height: "34", viewBox: "0 0 29 34", fill: "none", children: [t("path", { d: "M14.5 10C15.8169 10.0001 16.6881 8.23557 16.2407 6.99704L13.5014 0L1.65744 4.63793L1.82238 5.0988L1.33623 5.92549C0.395374 7.52538 1.14396 9.99992 2.99999 10H14.5Z", fill: e, transform: "translate(11 18)" }), t("path", { d: "M13.8145 20.3009C14.0225 20.2265 14.1307 19.9975 14.0563 19.7895C13.9819 19.5815 13.7529 19.4733 13.5449 19.5477L13.8145 20.3009ZM13.5449 19.5477L11.6619 20.2216L11.9314 20.9749L13.8145 20.3009L13.5449 19.5477Z", fill: "white" }), t("path", { d: "M19.3058 14.4209L21.4716 14.8937C22.8149 15.1869 23.9134 16.1495 24.3806 17.4426L27.3833 25.7547C27.7366 26.7325 27.0122 27.7644 25.9725 27.7643L13.9238 27.7638C12.3771 27.7638 11.4159 26.0832 12.1999 24.75L12.7809 23.762L12.0958 21.8476C11.6311 20.5491 11.868 19.1027 12.7229 18.0205L14.0921 16.2869C14.353 15.9565 14.3791 15.4982 14.1573 15.1403L12.3703 12.2568C11.1254 10.2479 10.7206 7.82998 11.2434 5.52519L11.6475 3.7435C11.8094 3.0297 12.6581 2.72595 13.2361 3.17493L14.679 4.2956C16.5455 5.7453 17.7668 7.87098 18.0793 10.2136L18.5278 13.5762C18.5834 13.9934 18.8945 14.3312 19.3058 14.4209Z", stroke: "white", strokeWidth: "0.8" }), t("path", { d: "M24.9766 18.145L12.6953 22.5404", stroke: "white", strokeWidth: "0.8" }), t("path", { d: "M17.6851 18.2046C17.4771 18.2791 17.3689 18.508 17.4433 18.716C17.5178 18.924 17.7467 19.0323 17.9547 18.9578L17.6851 18.2046ZM23.6933 16.0543L17.6851 18.2046L17.9547 18.9578L23.9629 16.8075L23.6933 16.0543Z", fill: "white" }), t("path", { d: "M13.6313 6.78999L13.668 6.89233", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" }), t("path", { d: "M23.0111 21.7306L24.0586 24.6575", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" }), t("path", { d: "M21.8022 24.2874L22.1758 25.3313", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" }), t("path", { d: "M25.5039 27.7744H1", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" })] }), y1 = () => d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "32", viewBox: "0 0 26 32", fill: "none", children: [t("path", { d: "M20.573 16.2065L24.7148 23.3803C25.2671 24.3368 24.9394 25.56 23.9828 26.1123L16.1504 30.6343C15.1938 31.1866 13.9706 30.8589 13.4183 29.9023L9.27654 22.7285C8.58696 21.5341 8.56131 20.0687 9.20867 18.8509L10.2456 16.9004C10.4432 16.5287 10.3868 16.073 10.1046 15.7606L7.83051 13.2434C6.24623 11.4897 5.41531 9.18321 5.51721 6.82208L5.59598 4.99683C5.62754 4.26559 6.40819 3.81488 7.05725 4.15317L8.67735 4.99757C10.7731 6.08989 12.3551 7.96272 13.0817 10.2116L14.1247 13.4397C14.2541 13.8402 14.6205 14.1169 15.0412 14.1316L17.2489 14.2089C18.6272 14.2572 19.8835 15.0121 20.573 16.2065Z", stroke: "white", strokeWidth: "0.8" }), t("path", { d: "M21.2852 16.7808L9.98865 23.3028", stroke: "white", strokeWidth: "0.8" }), t("path", { d: "M14.1251 18.1439C13.9338 18.2543 13.8682 18.4989 13.9787 18.6903C14.0891 18.8816 14.3338 18.9471 14.5251 18.8367L14.1251 18.1439ZM19.6516 14.9532L14.1251 18.1439L14.5251 18.8367L20.0516 15.646L19.6516 14.9532Z", fill: "white" }), t("path", { d: "M11.0594 20.8366C11.2507 20.7262 11.3162 20.4816 11.2058 20.2902C11.0953 20.0989 10.8507 20.0334 10.6594 20.1438L11.0594 20.8366ZM10.6594 20.1438L8.92732 21.1438L9.32732 21.8366L11.0594 20.8366L10.6594 20.1438Z", fill: "white" }), t("path", { d: "M8.09409 7.63902L8.14844 7.73315", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" }), t("path", { d: "M15.5003 27.8739L15.5547 27.968", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" }), t("path", { d: "M20.4925 21.5258L22.0469 24.218", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" }), t("path", { d: "M19.7621 24.2579L20.3164 25.218", stroke: "white", strokeWidth: "0.8", strokeLinecap: "round" })] }), C1 = ({ show: e }) => {
  const n = /* @__PURE__ */ ie((s) => s.disableDrag), [i, o, a] = /* @__PURE__ */ S((s) => [s.uiSettings?.isPaintGame, s.colorPaint || "#ff00dd", s.showTutorialPaint]);
  return i ? t(S1, { className: `${e || a ? "show" : ""} ${n ? "active" : ""}`, onClick: () => {
    oe({ disableDrag: !n }), wi({ drawMode: !n }), a && !n ? (C({ hidePaintTutoHighlight: true }), b("message-toast-close"), setTimeout(() => {
      b("message-toast", { message: "tutorial-paint-sp-2" });
    }, 300)) : a && (b("message-toast-close"), C({ hidePaintTutoHighlight: false, tutorialPaint: true, showTutorialPaint: false }));
  }, $paintColor: o, children: n ? t(w1, { paintColor: o }) : t(y1, {}) }) : null;
}, k1 = /* @__PURE__ */ bt(["from{transform:rotate(0deg) translateZ(0);}to{transform:rotate(360deg) translateZ(0);}"]), S1 = l.button`
  position: fixed;
  right: 100px;
  bottom: 100px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 58px;
  height: 58px;
  border-radius: 50%;

  opacity: 0.8;
  background: rgba(1, 1, 1, 0.2);

  z-index: 101;
  pointer-events: all;
  transition: transform 0.2s ease 0.3s;
  transform: scale(0) translateZ(0);

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.7);
  }

  &.active {
    background: rgba(1, 1, 1, 0.25);
    &::before {
      border: 1px dashed ${(e) => e.$paintColor};
      // anim rotation
      animation: ${k1} 5s linear infinite;
    }
  }

  &.show {
    transform: scale(1) translateZ(0);
  }
`, fa = l.div`
  position: fixed;
  bottom: -10px;
  left: -10px;
`, M1 = l(fa)`
  width: 180px;
  height: 180px;
  z-index: 90;

  pointer-events: none;
  transform: scale(0) translateZ(0);

  transition: transform 0.4s ease;
  &.show {
    pointer-events: all;
    transform: scale(1) translateZ(0);
  }
`, L1 = l(fa)`
  inset: 0;
  z-index: 0;
  pointer-events: all;
  &.disabled {
    pointer-events: none;
  }
`, Pe = 60, ma = { drag: { filterTaps: true, pointer: { touch: false } }, pinch: { scaleBounds: { min: 0.1, max: 10 }, pointer: { touch: false } } }, I1 = ({ show: e = false }) => {
  const [n, i] = /* @__PURE__ */ m(false), [o, a] = /* @__PURE__ */ m(false), [s, r] = /* @__PURE__ */ m({ x: 0, y: 0 }), c = /* @__PURE__ */ k(null), p = /* @__PURE__ */ yi((u) => u.sharedCamera);
  return w(() => {
    o && b("dragCtrl");
  }, [o]), Ci({ onPointerDown: ({ down: u }) => {
    i(u);
  }, onPointerUp: ({ down: u }) => {
    i(u), N().showJoystickTutorial && (b("message-toast-close"), C({ showJoystickTutorial: false }), setTimeout(() => {
      C({ tutorialMove: true });
    }, 600));
  }, onPinch: ({ delta: u }) => {
    p && (p.offsetAdjuster += (u[1] + u[0]) / 100, p.offsetAdjuster = Math.min(Math.max(p.offsetAdjuster, Ks), Js));
  }, onDrag: ({ movement: u, dragging: h }) => {
    const { playerApi: f, autoWalkOn: v, preventControls: g } = /* @__PURE__ */ Mt();
    if (!p || (p.aimMode = false, p.lockRotation = true, a(h), r({ x: u[0], y: u[1] }), fi(), v || g))
      return;
    const y = u[0] > 0 ? Math.min(u[0], Pe) / Pe : Math.max(u[0], -Pe) / Pe, L = u[1] > 0 ? Math.min(u[1], Pe) / Pe : Math.max(u[1], -Pe) / Pe;
    u[0] = Math.abs(u[0]), u[1] = Math.abs(u[1]);
    const I = (u[0] !== 0 || u[1] !== 0) && h;
    tt({ controls: { left: u[0] !== 0 && h, right: u[0] !== 0 && h, forward: u[1] !== 0 && h, backward: u[1] !== 0 && h } }), f.move = I, f.xAxisCtrl = y, f.yAxisCtrl = -L, tt({ moveAlongZ: u[1] !== 0 && h });
  } }, { target: c, ...ma }), t(M1, { className: e ? "show" : "", style: { touchAction: "none" }, ref: c, children: t(f1, { show: n, dragging: o, pos: s }) });
}, $1 = ({ show: e }) => {
  const n = /* @__PURE__ */ k(), i = /* @__PURE__ */ ie((s) => s.disableDrag), o = /* @__PURE__ */ yi((s) => s.sharedCamera);
  w(() => {
    o && (o.aimMode = false, o.lockRotation = true);
  }, [o]), Ci({ onDrag: ({ delta: s }) => {
    const { dragSensitivity: r } = /* @__PURE__ */ St();
    o && (o.dragDeltax = -s[0] * 2.5 * r, o.dragDeltay = s[1] * r, wi({ isDragging: true }), b("userAction"));
  }, onDragStart: () => {
    St();
  }, onDragEnd: () => {
    Is();
  } }, { target: n, ...ma });
  const a = (s) => {
    const { autoWalkOn: r, preventControls: c } = /* @__PURE__ */ Mt();
    r || c || (fi(), b(s));
  };
  return d(L1, { ref: n, className: `${e && !i ? "" : "disabled"}`, style: { touchAction: "none" }, children: [t(b1, { show: e, onTouchStart: () => {
    a("ctrl_jump");
  }, onTouchEnd: () => {
    a("ctrl_stopJump");
  } }), t(C1, { show: e })] });
}, T1 = () => {
  const [e, n] = /* @__PURE__ */ S((o) => [o.hideUI, o.showJoystickTutorial]), i = /* @__PURE__ */ ie((o) => o.showCallGrid);
  return d(T, { children: [t(I1, { show: !i && (!e || n) }), t($1, { show: !i && !e })] });
}, ga = () => K("isMobile") ? t(T1, {}) : null, Xn = ({ forceActive: e = false }) => {
  const n = /* @__PURE__ */ S((o) => o.openModal === J.EMOJI), i = /* @__PURE__ */ S((o) => o.renderEmoji);
  return w(() => {
    (e || n) && C({ renderEmoji: true });
  }, [e, n]), t(ht, { show: e || n, cls: "emoji-chat", children: t(q, { fallback: null, children: t(ho, { show: e || n || i, chat: true }) }) });
}, Zt = "/portals/", N1 = [{ label: "virtual-office", data: [] }, { label: "virtual-events", data: [{ visual: `${Zt}demo-05.webp`, to: "/auditorium", alt: "auditorium-world", desc: "auditorium-world-desc" }, { visual: `${Zt}demo-02.webp`, to: "/stadium", alt: "stadium-world", desc: "stadium-world-desc" }, { visual: `${Zt}demo-03.webp`, to: "/moon", alt: "moon-world", desc: "moon-world-desc" }, { visual: `${Zt}demo-04.webp`, to: "/village", alt: "village-world", desc: "village-world-desc" }] }, { label: "virtual-promotions", data: [] }], A1 = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("common"), [i, o] = /* @__PURE__ */ m("");
  return w(() => {
    window.location.pathname === e.to && o("current");
  }, []), t(F1, { href: e.to, className: i, "aria-label": n(e.desc), onClick: () => {
    C({ forceShowLoader: true });
  }, children: t("img", { src: M[e.visual], alt: e.alt, loading: "lazy", width: "235px", height: "381px" }) });
}, E1 = () => {
  const { t: e } = /* @__PURE__ */ x("common");
  return t(U1, { className: "nwc", children: t("h4", { className: "secfont", children: e("portal-no-worlds") }) });
}, D1 = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("common"), [i, o] = /* @__PURE__ */ m(1);
  return d(P1, { className: "cnt", children: [t(Rn, { ariaLabel: "close modal", cls: "cmb", onClick: () => {
    C({ openModal: "", hideUI: false }), b("tracking", { event: "click", category: "portal-modal", label: "close-modal" });
  } }), t("div", { className: "scrlsp", children: d("div", { children: [d(_1, { children: [t("h4", { className: "secfont", dangerouslySetInnerHTML: { __html: n("portal-title") } }), t("div", { children: t(oo, { data: e, setCurrent: o, current: i }) })] }), t(O1, { children: e[i].data.length > 0 ? t(B1, { className: "scrl", children: d(j1, { className: "wrlds", children: [t(va, {}), e[i].data.map((a, s) => t(A1, { data: a }, s)), t(va, {})] }) }) : t(E1, {}) })] }) })] });
}, xa = ({ forceOpen: e = false, data: n = N1 }) => {
  const i = /* @__PURE__ */ S((s) => s.openModal === J.PORTAL), [o, a] = /* @__PURE__ */ m(false);
  return w(() => {
    let s = null;
    return e || i ? a(true) : s = setTimeout(() => {
      a(false);
    }, 700), () => {
      clearTimeout(s);
    };
  }, [e, i]), t(z1, { className: `${e || i ? "show" : ""} ${o ? "active" : ""} `, children: t(D1, { data: n }) });
}, z1 = l.div`
  position: fixed;
  inset: 0;

  justify-content: center;
  align-items: center;
  pointer-events: none;
  padding: 30px 45px;
  display: flex;
  visibility: hidden;

  &.active {
    visibility: visible;
  }

  &.show {
    .scrl {
      overflow-x: auto;
      overflow-y: hidden;
    }

    pointer-events: all;
    .cnt {
      pointer-events: all;
      &::before {
        transform: scaleY(1) translateZ(0);
        transition-delay: 0s;
      }
    }
    h4,
    .wrlds a,
    ul {
      transform: translate3d(0, 0, 0);
    }
    h4 {
      transition-delay: 0.2s;
    }
    ul {
      transition-delay: 0.3s;
    }
    .wrlds {
      a {
        transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1) 0.35s;

        &:nth-child(2) {
          transition-delay: 0.4s;
        }
        &:nth-child(3) {
          transition-delay: 0.45s;
        }
        &:nth-child(4) {
          transition-delay: 0.45s;
        }
        &:nth-child(5) {
          transition-delay: 0.5s;
        }
      }
    }
    .nwc {
      opacity: 1;
      transition-delay: 0.3s;
    }
    .cmb {
      transform: scale(1) translateZ(0);
      transition-delay: 0.5s;
    }
  }

  @media all and (max-width: 768px), all and (max-height: 600px) {
    z-index: 99999;
    visibility: hidden;
    padding: 0;
    align-items: flex-start;

    .wrlds {
      transform: translate3d(0, 100%, 0);
      transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1) 0.3s;
    }

    &.show {
      visibility: visible;
      .wrlds {
        transform: translate3d(0, 0, 0);
      }
    }

    .scrlsp {
      height: 100%;
      overflow: auto;
    }

    .cnt {
      height: 100%;
      &::before {
        background: rgba(45, 45, 45, 1);
        border-radius: 0;
      }
    }

    .cmb {
      top: 20px;
      right: 20px;
    }
  }
`, P1 = l.div`
  position: relative;
  pointer-events: none;

  width: 100%;
  max-width: 1036px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(45, 45, 45, 0.6);
    border-radius: 10px;
    z-index: 0;
    transform: scaleY(0) translateZ(0);
    transform-origin: top center;
    transition: transform 0.4s ease 0.32s;
  }

  & > div {
    position: relative;
    z-index: 1;
    overflow: hidden;
  }
`, _1 = l.div`
  padding: 60px 60px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 15px 30px;

  h4 {
    display: block;
    font-weight: 600;
    font-size: 25px;
    line-height: 30px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #ffffff;
    transition: transform 0.6s ease;
    transform: translate3d(0, calc(-100% - 85px), 0);
  }

  div {
    display: flex;
  }

  ul {
    position: relative;
    top: auto;
    left: auto;
    right: auto;

    transition: transform 0.6s ease;
    transform: translate3d(0, calc(-100% - 85px), 0);

    h5 {
      white-space: nowrap;
    }

    button {
      padding-left: 30px;
      padding-right: 30px;
    }

    li {
      &:first-child {
        .bg {
          background: ${(e) => e.theme.colors.highlight};
        }
      }
      &:nth-child(2) {
        .bg {
          background: #f33182;
        }
      }
      &:nth-child(3) {
        .bg {
          background: #7e1ef9;
        }
      }
    }
  }

  @media all and (max-width: 1120px) {
    padding: 60px 30px 0;
  }

  @media all and (max-width: 930px) {
    ul {
      transform: translate3d(0, calc(-100% - 145px), 0);
    }
  }

  @media all and (max-width: 767px) {
    padding: 60px 20px 0;
    ul {
      /* todo remove */
      display: none;
    }
  }
`, j1 = l.div`
  display: flex;
  gap: 20px;
  padding: 20px 0 60px;

  @media all and (max-width: 768px), all and (max-height: 600px) {
    flex-wrap: wrap;
    padding: 20px 20px 60px;
    justify-content: space-between;
  }

  @media all and (max-width: 730px) {
    max-width: 490px;
    margin: 0 auto;
  }

  @media all and (max-width: 450px) {
    max-width: 220px;
  }

  @media all and (max-width: 420px) {
    max-width: 100%;
    gap: 10px;
  }
`, va = l.div`
  min-width: 40px;

  @media all and (max-width: 1120px) {
    min-width: 10px;
  }

  @media all and (max-width: 768px), all and (max-height: 600px) {
    display: none;
  }
`, F1 = l.a`
  flex-shrink: 0;
  display: block;
  position: relative;
  width: 214px;
  height: 348px;
  border-radius: 10px;
  overflow: hidden;

  transform: translate3d(0, calc(100% + 61px), 0);
  transition: transform 0.35s ease;

  img {
    clip-path: none;
    transition: transform 0.8s ease;
  }

  &.current {
    pointer-events: none;
    background: #f33182;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 4px solid #f33182;
      z-index: 1;
      border-radius: 10px;
    }
    img {
      transform: scale(1) translateZ(0);
      border-radius: 0px 0px 100px 0px;
      overflow: hidden;
    }
  }

  @media all and (pointer: fine) {
    img {
      transform: scale(1.1) translateZ(0);
    }
    &:hover {
      img {
        transform: scale(1) translateZ(0);
      }
    }
  }

  @media all and (max-width: 420px) {
    width: calc(50% - 5px);
    height: auto;
  }
`, O1 = l.div``, B1 = l.div`
  overflow: hidden;
`, U1 = l.div`
  min-height: 428px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
`, R1 = ({ label: e }) => {
  const { t: n } = /* @__PURE__ */ x("common");
  return d("span", { className: "link", children: [t("span", { className: "out", children: n(e) }), t("span", { className: "hvr", "aria-hidden": "true", children: n(e) })] });
}, H1 = ({ label: e, link: n, full: i = false, cls: o = "", disable: a = false }) => t(W1, { children: t("a", { className: `${i ? "full" : ""} ${o} ${a ? "disable" : ""}`, href: n, target: "_blank", rel: "noopener noreferrer", children: t(R1, { label: e }) }) }), W1 = l.div`
  font-weight: 600;
  line-height: 14px;
  a,
  button {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    color: #fff;
    padding: 17px 42px;
    border-radius: 53px;
    text-transform: uppercase;
    isolation: isolate;

    &::after {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      border-radius: 53px;
      border: 2px solid #f33182;
      z-index: 2;
    }

    &.full {
      background: #f33182;
      color: #fff;
      .hvr {
        color: #f33182;
      }
      &::before {
        background: #fff;
      }
    }

    &.disable {
      &::after {
        border-color: #ccc;
      }
      color: #ccc;
      pointer-events: none;
    }

    @media all and (pointer: fine) {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #f33182;
        border-radius: 53px;
        transform: translate3d(0, 100%, 0);
        transition: transform 0.7s cubic-bezier(0.68, 0.005, 0.235, 1);
      }
      &:hover {
        .out,
        .arrout {
          transform: translate3d(0, -30px, 0);
        }
        .arrhvr,
        &::before,
        .hvr {
          transform: translate3d(0, 0, 0);
        }
      }
    }
  }

  .link {
    position: relative;
    span {
      display: block;
      perspective: 1000px;
      perspective-origin: 50% 50%;
      transition: transform 0.65s cubic-bezier(0.68, 0.005, 0.235, 1);
      transform-style: preserve-3d;
      backface-visibility: hidden;
    }
  }

  .hvr {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translate3d(0, 30px, 0);
    color: #eee;
  }
`, ba = () => {
  const e = /* @__PURE__ */ K("isMobile"), [n] = /* @__PURE__ */ S((o) => [o.hideUI]), i = /* @__PURE__ */ ve((o) => o.lang);
  return e ? null : t(V1, { className: n ? "" : "show", children: t(H1, { label: "get-in-touch", link: `https://konpi.${i === "en" ? "com" : i === "ja" ? "jp" : "fr"}/contact-us`, full: true }) });
}, V1 = l.div`
  position: fixed;
  top: 40px;
  right: 40px;
  z-index: 0;
  pointer-events: all;

  transition: transform 0.5s ease;
  transform: translate3d(0, calc(-100% - 40px), 0);

  &.show {
    transform: translate3d(0, 0, 0);
    transition-delay: 0.4s;
  }
`, wa = () => {
  const [e, n] = /* @__PURE__ */ S((i) => [i.isDemo, i.uiSettings]);
  return e && !n?.hidePortalButton ? d(T, { children: [t(ba, {}), t(xa, {})] }) : null;
}, Z1 = (e, n) => {
  !e && !n ? document.fullscreenElement ? document.exitFullscreen && document.exitFullscreen() : document.documentElement.requestFullscreen() : document.webkitFullscreenElement ? document.webkitCancelFullScreen() : document.documentElement.webkitRequestFullScreen();
}, G1 = ({ size: e }) => {
  const [n] = /* @__PURE__ */ S((o) => [o.colorPaint || "#ffffff"]), i = /* @__PURE__ */ z((o) => o.mouseDown);
  return t(Q1, { className: i ? "show" : "", style: { width: `${e - 4}px`, height: `${e - 4}px`, backgroundColor: n } });
}, q1 = () => {
  const [e, n, i] = /* @__PURE__ */ S((s) => [s.hideUI, s.paintSize || 0.4, s.paintLazer]), o = 10 + Math.round(n * 30), a = 0.5 + (o - 12) / 20;
  return i ? t(X1, { className: e ? "hide" : "", children: t("div", { style: { transform: `scale(${a}) translateZ(0)` }, children: t(Yo, { alertIconBgColor: "#fff", alertIconBgInside: false, alertIconBgOpacity: 1, alertIconColor: "#fff" }) }) }) : t(J1, { className: e ? "hide" : "", style: { width: `${o}px`, height: `${o}px` }, children: t(G1, { size: o }) });
}, Y1 = ({ forceFullscreen: e }) => {
  const n = /* @__PURE__ */ k(null), [i, o] = /* @__PURE__ */ m(false), a = /* @__PURE__ */ nt("isSafari"), s = /* @__PURE__ */ nt("isAndroid"), r = /* @__PURE__ */ nt("isIOS"), c = s || r, p = !a && !s, u = () => {
    e && document.body.classList.add("hideCursor"), b("fsAimMode", true);
  }, h = () => {
    e && document.body.classList.remove("hideCursor"), b("fsAimMode", false);
  }, f = () => {
    const y = p ? document.fullscreenElement : document.webkitFullscreenElement;
    o(y), y ? u() : h();
  }, v = () => {
    document.pointerLockElement || (o(false), b("exitPointerLock"));
  }, g = () => {
    o(false), b("stopAudio", { id: an.paint });
  };
  return w(() => (e ? document.addEventListener(`${p ? "" : "webkit"}fullscreenchange`, f) : (document.addEventListener("pointerlockchange", v, false), document.addEventListener("pointerlockerror", g, false)), () => {
    h(), document.removeEventListener(`${p ? "" : "webkit"}fullscreenchange`, f), document.removeEventListener("pointerlockchange", v), document.removeEventListener("pointerlockerror", g);
  }), []), w(() => {
    if (c) {
      const { sharedCamera: y } = /* @__PURE__ */ Mt();
      y.preventDrag = 0;
    }
  }, [c]), t(K1, { ref: n, className: i || c ? "active" : "", onClick: i ? null : () => {
    e ? Z1(a, s) : (o(true), u()), n.current.blur();
  }, children: c ? null : t(q1, {}) });
}, ya = () => pn((n) => n.aimMode) ? t(Y1, { forceFullscreen: false }) : null, K1 = l.button`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  pointer-events: all;

  &.active {
    cursor: none;
    pointer-events: none;
  }
`, J1 = l.div`
  position: relative;
  border: 1px solid #fff;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  pointer-events: none;
  transform: scale(1) translateZ(0);
  transition: transform 0.2s ease;
  &.hide {
    transform: scale(0) translateZ(0);
  }
`, X1 = l.div`
  position: relative;
  pointer-events: none;
  transform: scale(1) translateZ(0);
  transition: transform 0.2s ease;
  svg {
    width: 30px;
    height: auto;
  }
  &.hide {
    transform: scale(0) translateZ(0);
  }
`, Q1 = l.div`
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  pointer-events: none;
  transform: translate3d(-50%, -50%, 0) scale(0);
  transition: transform 0.3s ease 0.1s;
  &.show {
    transform: translate3d(-50%, -50%, 0) scale(1);
    transition-delay: 0s;
  }
`, Ca = () => (j("screenshot", ({ imageUrl: e }) => {
  N().compressAndUpload(e, [512, 512], "profile", "global", () => {
    console.log("uploaded picture profile");
  });
}), null), ef = ({ name: e, visual: n, emote: i }) => {
  const { t: o } = /* @__PURE__ */ x("common"), a = /* @__PURE__ */ k(null), s = /* @__PURE__ */ k(null), [r, c] = /* @__PURE__ */ m(false);
  return w(() => {
    const p = a.current, u = (v) => {
      v.code === "Space" && v.preventDefault();
    }, h = () => {
      window.removeEventListener("keydown", u), p.removeEventListener("blur", h);
    }, f = () => {
      window.addEventListener("keydown", u), p.addEventListener("blur", h);
    };
    return p.addEventListener("focus", f), () => {
      p.removeEventListener("focus", f), window.removeEventListener("keydown", u), p.removeEventListener("blur", h);
    };
  }, []), d(tf, { ref: a, onClick: () => {
    r || ($n(i || e), c(true), setTimeout(() => {
      c(false);
    }, 500));
  }, children: [t("div", { children: t(q, { fallback: t("div", { style: { width: "72px", height: "51px" } }), children: t("img", { width: "72px", height: "51px", src: i ? `${In}${n || e}.webp` : M[`${so + (n || e)}.webp`], alt: e, loading: "lazy" }) }) }), t("span", { ref: s, children: o(e) })] });
}, tf = l.button`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  height: 94px;
  text-align: center;
  color: #fff;
  padding: 12px 15px;

  div {
    min-height: 0;
    width: 100%;
  }
  span {
    display: flex;
    ${(e) => e.theme.bodyText4}
  }
  span,
  img {
    position: relative;
    z-index: 1;
  }
  img {
    transition: transform 0.7s ease;
    width: 100%;
    height: 100%;
    object-fit: contain;
    flex-shrink: 1;
    transform: scale(1) translateZ(0);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: #2d2d2d;
    border-radius: 6px;
    opacity: 0.3;
    transition: opacity 0.3s ease;
  }

  @media all and (pointer: fine) {
    &:hover {
      img {
        transform: scale(0.9) translateZ(0);
      }
      &::before {
        opacity: 0.8;
      }
    }
  }
`, ka = /* @__PURE__ */ ce(({ title: e, list: n }) => {
  const { t: i } = /* @__PURE__ */ x("common"), { text: o } = /* @__PURE__ */ Q(Nt), a = /* @__PURE__ */ n.filter((s) => i(s.name).toLowerCase().includes(o.toLowerCase()));
  return t(Z, { title: e, cls: a.length === 0 ? "hide" : "", children: t(nf, { children: a.map((s, r) => t("li", { children: t(ef, { ...s }) }, r)) }) });
});
ka.displayName = "Emote list container";
const Sa = /* @__PURE__ */ ce(({ checkRef: e }) => {
  const { text: n } = /* @__PURE__ */ Q(Nt), [i, o] = /* @__PURE__ */ m(false);
  return w(() => {
    if (e?.current) {
      const a = /* @__PURE__ */ Array.from(e.current.children).every((s) => s.classList.contains("hide"));
      o(a && e.current.children.length > 1);
    }
  }, [e, n]), t(lo, { show: i, cls: "hide" });
});
Sa.displayName = "No result";
const Ma = /* @__PURE__ */ ce(({ show: e }) => {
  const n = /* @__PURE__ */ k(null), [i, o] = /* @__PURE__ */ m(false), a = /* @__PURE__ */ S((r) => r.hideUI);
  return w(() => {
    a || o(true);
  }, [a]), d("div", { ref: n, style: { display: e ? "block" : "none" }, children: [i ? ((r) => N().uiSettings?.filterEmojis ? r.filter((u) => u.category !== "exercice-cat") : r)(ro).map((r, c) => t(ka, { title: r.category, list: r.items }, c)) : null, t(Sa, { checkRef: n })] });
});
Ma.displayName = "Emote content";
const La = /* @__PURE__ */ ce(({ show: e }) => t(ao, { searchPlaceholder: "search-emote", children: t(Ma, { show: e }) }));
La.displayName = "Emote container";
const Gt = /* @__PURE__ */ ce(({ forceActive: e = false, office: n }) => {
  const [i, o] = /* @__PURE__ */ S((c) => [c.openModal, c.renderEmoji]), a = i === J.EMOTE;
  w(() => {
    (e || a) && C({ renderEmoji: true });
  }, [e, a]);
  const s = e || a;
  return t(ht, { office: n, show: s, children: t(uc, { data: [{ label: "emote", content: t(La, { show: s || !n }) }, { label: "emoji", content: t(q, { fallback: null, children: t(ho, { show: s || o }) }) }] }) });
});
Gt.displayName = "Emote container";
const nf = l.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 13px;

  &.hide {
    display: none;
  }

  li {
    flex: 0 0 calc(33.333333% - 9px);
  }
`, of = l.div`
  position: fixed;
  left: 0;
  top: 60px;
  width: 100%;
  z-index: 101;
  overflow: auto;
  max-height: calc(var(--app-height) - 150px);
  padding: 15px 15px 0 30px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

  transition: transform 0.5s ease;
  transform: translate3d(calc(-100% - 5px), 0, 0);

  &.show {
    transform: translate3d(0, 0, 0);
  }

  &.pc {
    z-index: 10;
    top: auto;
    left: 62px;
    bottom: 115px;
    max-height: calc(100% - 275px);
    width: 100%;
    max-width: 420px;
    overflow-x: hidden;
    padding: 0 20px;

    opacity: 0.3;
    transition: opacity 0.3s ease;

    @media all and (max-width: 1024px) {
      max-width: 360px;
      left: 52px;
    }

    &:hover {
      opacity: 1;
    }
  }
  &.active {
    opacity: 1;
  }

  pointer-events: all;

  @media all and (max-width: 920px) {
    top: 0 !important;
    left: 0 !important;
    max-height: calc(100vh - 58px) !important;
    max-width: none !important;
    bottom: 58px !important;
  }

  &.sp {
    top: 0 !important;
    left: 0 !important;
    max-height: calc(100vh - 58px) !important;
    max-width: none !important;
    bottom: 58px !important;
  }
`, af = l.div`
  flex: 100% 0 0;
  display: flex;
  flex-direction: column-reverse;
  overflow-wrap: anywhere;
  gap: 15px;
  &.noanim {
    .msg {
      animation: unset;
    }
  }

  @media all and (max-width: 920px) {
    padding: 30px 0;
  }

  &.sp {
    padding: 30px 0;
  }
`;
l.div`
  display: block;
  position: absolute;
  top: 5px;
  left: -18px;
  border-radius: 100%;
  width: 38px;
  height: 38px;
  background-color: #e9e9e9;
  background-image: url('/placeholder/profilepic.jpg');
  background-size: 100%;

  &.self {
    left: auto;
    right: -17px;
  }
`;
const sf = l.p`
  ${(e) => e.theme.bodyText1}
  padding: 7px 0 0;
  user-select: all;
`, rf = l.img`
  ${(e) => e.theme.bodyText1}
  padding: 7px 0 0;
  user-select: all;
`, lf = l.div`
  height: auto;
  position: relative;

  animation: msrRow 0.3s ease-out 0s forwards;

  .iconnpc {
    position: absolute;
    top: 10px;
    right: -8px;
  }
`, cf = l.div`
  flex: 100% 0 0;
  display: flex;
  width: 100%;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 10px;
  padding: 20px 25px 20px 30px;
  &.mymsg {
    .admin {
      color: #fff;
    }
    /* max-width: 88%; */
    margin: 0 0 0 auto;
    color: #fff;
    & > div {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      padding: 0;
      h6 {
        order: 1;
        color: #f33182;
      }
      p {
        display: inline-block;
      }
    }
  }

  &.sp {
    border: solid 1px #e5e5e5;
    &.mymsg {
      border: 0;
      max-width: 94%;
    }
  }

  @media all and (max-width: 920px) {
    padding: 5px 0;
    background: none;
  }

  &.sp {
    padding: 5px 0;
    background: none;
  }
`, df = l.div`
  width: 100%;
`, pf = l.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0.03em;
`, uf = l.h6`
  font-weight: 600;
  opacity: 0.7;

  text-align: left;
  &.npc {
    color: #ffd700;
  }
  &.admin {
    color: #3498db;
  }
`, hf = l.p`
  opacity: 0.5;
  text-align: right;
`, ff = ({ isNpc: e, name: n }) => {
  const { t: i } = /* @__PURE__ */ x("common");
  return t(uf, { className: [e ? "npc" : ""], children: n ? n.charAt(0).toUpperCase() + n.slice(1) : i("anonymous") });
}, mf = () => null, gf = ({ item: e, self: n, playerData: i, refMap: o, cls: a }) => {
  const s = i && i.isNpc, r = /* @__PURE__ */ /^!\[(.*?)\]\((.*?)\)$/.exec(e.message);
  let c = "", p = "";
  if (r) {
    r[1];
    const u = r[2], h = /* @__PURE__ */ u.match(/title="(.*?)"/), f = /* @__PURE__ */ u.match(/alt="(.*?)"/);
    h && (c = h[1]), f && (p = f[1]);
  }
  return d(lf, { className: "msg", children: [s ? t(mf, { className: "iconnpc" }) : null, t(cf, { ref: (u) => u && o.set(e, u), className: [n ? "mymsg" : "", a], children: d(df, { children: [d(pf, { children: [t(ff, { isNpc: s, name: i?.name }), t(hf, { children: e.sentTime })] }), r ? t(rf, { src: p, title: c }) : null, !r && t(sf, { children: e.message })] }) })] });
}, xf = () => {
  const e = /* @__PURE__ */ k(null), n = /* @__PURE__ */ k(null), i = R().playersFirebase, [o, a] = /* @__PURE__ */ z((g) => [g.allMessages, g.totalMessages]), s = /* @__PURE__ */ O((g) => g.id), r = /* @__PURE__ */ vi((g) => g.videoQuality === 0), [c, p, u] = /* @__PURE__ */ S((g) => [g.openChat, g.hideUI, g.socialBarOpened]), h = /* @__PURE__ */ Y(() => /* @__PURE__ */ new WeakMap(), []);
  w(() => {
    e.current.scrollTo({ top: n.current.offsetHeight, left: 0, behavior: r ? "auto" : "smooth" });
  }, [a, r]);
  const v = K("isMobile") ? "sp" : "pc";
  return t(of, { ref: e, className: `${v} ${c ? "active" : ""} ${(!p || c) && !u ? "show" : ""}`, children: t(af, { ref: n, className: `${v} ${r ? "noanim" : ""} `, children: o.map((g) => t(gf, { item: g, self: s === g.playerId, playerData: i[g.playerId], refMap: h, cls: v }, g.key)) }) });
}, vf = () => d("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("circle", { cx: "10.5408", cy: "10.259", r: "9.25903", stroke: "white", strokeWidth: "1.2" }), t("path", { d: "M6.08252 12.9189C7.25215 14.0327 8.83505 14.7164 10.5776 14.7164C12.3202 14.7164 13.9031 14.0327 15.0728 12.9189", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("circle", { cx: "7.38893", cy: "8.47878", r: "0.62038", fill: "white", stroke: "white", strokeWidth: "1.2" }), t("circle", { cx: "13.7307", cy: "8.47878", r: "0.62038", fill: "white", stroke: "white", strokeWidth: "1.2" })] }), bf = ["アホ", "アホ毛", "死ね", "セックス", "ちんこ", "レイプ", "乱交", "マンコ", "ファック", "ファッキュー", "パイパン", "パイズリ", "売春", "ちんぽ", "大麻", "性交", "自殺", "ザコ", "殺す", "ゴミカス", "ゴミクズ", "キチガイ", "害児", "キンタマ", "オナニー", "きえろ", "クズ"], wf = ["fuck", "bitch", "dick", "niggas", "niggaz", "nigger", "niggers", "nobhead", "nobjocky", "cunt", "cuntlick", "cuntlicker", "cock"], yf = (e) => {
  let n = e;
  return (/[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+/.test(n) ? bf : wf).forEach((a) => {
    n = n.replaceAll(a, "***");
  }), n;
}, Cf = () => d("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M5.6499 8.35059L0.649901 5.85059L17.1499 0.850589L12.1499 17.3506L9.6499 11.8506", stroke: "#FCFCFC", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t("path", { d: "M12.1499 5.85059L4.1499 13.3506", stroke: "#FCFCFC", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" })] }), kf = ({ inputRef: e, send: n, setShowSendButton: i }) => {
  const { t: a } = /* @__PURE__ */ x("common"), s = /* @__PURE__ */ k(false), r = (f) => {
    if (f.key === "Enter") {
      if (s.current)
        return;
      n();
    }
  }, c = /* @__PURE__ */ K("isMobile");
  j("chat:emoji", (f) => {
    const v = /* @__PURE__ */ f.u.split("-").map((g) => parseInt(g.substring(0), 16));
    e.current.value += String.fromCodePoint(...v), e.current.focus(), e.current.value.length > 0 && i(true);
  });
  const p = /* @__PURE__ */ K("isIOS"), u = () => {
    s.current = true;
  }, h = () => {
    s.current = false;
  };
  return w(() => {
    if (e)
      return e.current.addEventListener("compositionstart", u), e.current.addEventListener("compositionend", h), () => {
        e.current?.removeEventListener("compositionstart", u), e.current?.removeEventListener("compositionend", h);
      };
  }, [e]), t(Tf, { onSubmit: (f) => {
    f && (f.preventDefault(), f.stopPropagation()), n();
  }, children: t(If, { ref: e, type: "text", className: p ? "ios" : "", placeholder: a("placeholder-message"), maxLength: "180", enterKeyHint: "send", onKeyDown: c ? null : (f) => r(f), onChange: (f) => {
    const v = f.target.value;
    i(v.length > 0);
  } }) });
}, Sf = () => {
  const e = /* @__PURE__ */ S((n) => n.openModal === J.EMOJI);
  return t($f, { "aria-label": "open emoji picker", className: `emjbtn ${e ? "active" : ""}`, onClick: () => {
    C({ openModal: e ? "" : J.EMOJI }), b("tracking", { event: "click", category: "chat", label: "open_emoji_picker" });
  }, children: t(vf, {}) });
}, Ia = ({ send: e, show: n }) => t(Nf, { className: `sendbtn ${n ? "show" : ""}`, onClick: e, "aria-label": "send message", children: t(Cf, {}) }), Mf = ({ isMobile: e }) => {
  const [n, i, o] = /* @__PURE__ */ S((p) => [p.hideUI, p.openChat, p.socialBarOpened]), a = /* @__PURE__ */ k(null), [s, r] = /* @__PURE__ */ m(false), c = () => {
    if (!a.current || a.current.value.length === 0)
      return;
    const p = a.current.value;
    a.current.value = "", r(false);
    const u = $().id;
    if (!N().blockSendMessage && p.replace(/\s/g, "").length > 0) {
      const h = /* @__PURE__ */ yf(p);
      $s(u, h), Ws(h), b("messageSent"), b("tracking", { event: "click", category: "chat", label: "send_message" });
    }
  };
  return d(Lf, { className: `${s ? "showSendButton" : ""} ${(!n || i) && !o ? "show" : ""} ${e ? "sp" : ""}`, children: [t(kf, { send: c, inputRef: a, setShowSendButton: r }), e ? null : t(Sf, {}), t(Ia, { show: s, send: c })] });
}, Lf = l.div`
  position: fixed;
  left: 40px;
  bottom: 40px;
  width: 100%;
  max-width: 420px;
  overflow: hidden;
  pointer-events: all;

  transition: transform 0.5s ease;
  transform: translate3d(0, 100%, 0);

  &.show {
    transform: translate3d(0, 0, 0);
  }

  @media all and (max-width: 1024px) {
    max-width: 360px;
    left: 30px;
  }

  @media all and (max-width: 920px) {
    max-width: none;
    left: 0;
    bottom: 0;
    right: 0;
    input {
      background: #2d2d2d;
      border-radius: 0;
    }
  }

  &.showSendButton {
    input {
      width: calc(100% - 60px);
    }
    .emjbtn {
      transform: translate3d(-60px, 0, 0);
    }
    .sendbtn {
      pointer-events: all;
      transform: translate3d(0, 0, 0);
    }
  }

  &.sp {
    input {
      padding: 0 20px;
      transition: background-color 0.2s ease;
    }
    .sendbtn {
      width: 60px;
      height: 58px;
      border-radius: 0;
      transition: none;
      &::before {
        border-radius: 0;
        opacity: 1;
      }
    }
  }
`, If = l.input`
  display: block;
  padding: 0px;

  width: 100%;
  height: 58px;

  padding: 0 60px 0 20px;

  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 0px 40px 10px 10px;

  font-weight: 600;
  font-size: 13px;
  line-height: 18px;

  letter-spacing: 0.03em;
  color: #ffffff;

  transition: background-color 0.2s ease, width 0.4s ease;

  &:focus {
    background: #2d2d2d;
  }
  &::placeholder {
    font-size: 13px;
  }

  &.ios {
    font-size: 16px;
  }
`, $f = l.button`
  position: absolute;
  top: 0;
  right: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 58px;

  svg {
    pointer-events: none;
  }

  opacity: 0.5;
  transition: opacity 0.3s ease, transform 0.4s ease;

  &.active {
    opacity: 1;
  }

  @media all and (pointer: fine) {
    &:hover {
      opacity: 1;
    }
  }
`, Tf = l.form``, Nf = l.button`
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate3d(60px, 0, 0);
  transition: transform 0.4s ease;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 58px;
  height: 58px;
  pointer-events: none;
  border-radius: 10px 10px 0px 40px;

  svg {
    display: block;
    position: relative;
    z-index: 1;
    transform: translate3d(-40px, 40px, 0);
    transition: transform 0s ease 0.4s;
  }

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #2d2d2d;
    border-radius: 10px 10px 0px 40px;
    opacity: 0.8;
    transition: opacity 0.35s ease;
  }

  &.show {
    svg {
      transition: transform 0.3s ease 0.1s;
      transform: translate3d(0, 0, 0);
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
`, Af = () => {
  const e = /* @__PURE__ */ k(0), n = /* @__PURE__ */ k(null), i = () => {
    e.current = 0, C({ blockSendMessage: false });
  }, o = () => {
    e.current === 0 && (n.current = setTimeout(i, 8e3)), e.current++, e.current >= 7 && (clearTimeout(n.current), n.current = setTimeout(i, 1e4), C({ blockSendMessage: true }));
  };
  return w(() => () => {
    C({ blockSendMessage: false }), n.current && clearTimeout(n.current);
  }, []), j("messageSent", o), null;
}, Ef = ({ show: e }) => t(jt, { show: e, onClick: () => {
  C({ openChat: false, hideUI: false });
} }), $a = () => {
  const e = /* @__PURE__ */ S((i) => i.openChat), n = /* @__PURE__ */ wn();
  return d(Df, { className: `${n ? "sp" : "pc"} ${e ? "openChat" : ""}`, children: [t(Af, {}), t(xf, {}), t(Mf, { isMobile: n }), n ? t(Ef, { show: e }) : null] });
}, Df = l.div`
  position: fixed;
  left: 40px;
  bottom: 40px;
  top: 160px;
  max-width: 420px;
  width: 100%;
  pointer-events: none;
  z-index: 1;

  @media all and (max-width: 1024px) {
    max-width: 360px;
    left: 30px;
  }

  &.pc {
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 25%
    );
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 20%
    );
  }

  &.sp {
    display: none;
    inset: 0;
    max-width: none;
    background: rgba(45, 45, 45, 0.8);
    z-index: 999;

    &.openChat {
      display: block;
      pointer-events: all;
    }
  }
`, zf = "/perks/webp/", ft = [{ color: "#830000" }, { color: "#8D5B00" }, { color: "#888800" }, { color: "#003D00" }, { color: "#000089" }, { color: "#330058" }, { color: "#965096" }, { color: "#2D2D2D" }, { color: "#FF0000" }, { color: "#FFA500" }, { color: "#FFFF00" }, { color: "#008000" }, { color: "#0000FF" }, { color: "#4B0082" }, { color: "#EE82EE" }, { color: "#838383" }, { color: "#FF8080" }, { color: "#FFCF78" }, { color: "#FFFF81" }, { color: "#78FF78" }, { color: "#7C7CFF" }, { color: "#C980FF" }, { color: "#FFB7FF" }, { color: "#FFFFFF" }], Pf = [{ color: "#FFEAD7" }, { color: "#FFDDAD" }, { color: "#F2C37F" }, { color: "#E3AC6B" }, { color: "#CE8E71" }, { color: "#DFA98F" }, { color: "#B37344" }, { color: "#88583B" }, { color: "#66412A" }, { color: "#553724" }, { color: "#A97C9B" }, { color: "#7A8CA4" }, { color: "#4F6886" }, { color: "#B5C5AA" }, { color: "#DB7F70" }, { color: "#CC7061" }], _f = ft, jf = [{ visual: "hair_default", label: "Hair", value: "hair_default" }, { visual: "hair_soul", label: "Hair" }, { visual: "hair_cyber", label: "Hair" }, { visual: "hair_horn", label: "Hair" }, { visual: "hair_traditional", label: "Hair" }, { visual: "hair_sidebraid", label: "Hair" }, { visual: "hair_short", label: "Hair" }, { visual: "hair_ponytail", label: "Hair" }, { visual: "hair_longstraight", label: "Hair", value: "hair_longstraight" }, { visual: "hair_longstraight2", label: "Hair", value: "hair_longstraight2" }, { visual: "hair_slickedback", label: "Hair", value: "hair_slickedback" }, { visual: "hair_frontwave", label: "Hair" }, { visual: "hair_cornrows", label: "Hair", value: "hair_cornrows" }, { visual: "hair_tousledcrop", label: "Hair", value: "hair_tousledcrop" }, { visual: "hair_doubleponytail", label: "Hair", value: "hair_doubleponytail" }], Ff = [{ visual: "cloth_default", label: "Top cloths", value: "cloth_default" }, { visual: "cloth_soul", label: "Top cloths" }, { visual: "cloth_cyber", label: "Top cloths" }, { visual: "cloth_horn", label: "Top cloths" }, { visual: "cloth_traditional", label: "Top cloths" }, { visual: "cloth_staff", label: "Top cloths" }, { visual: "cloth_suit", label: "Top cloths", value: "cloth_suit" }], Of = ft, Bf = [{ visual: "legs_accessory_default", label: "Legs acessory" }, { visual: "legs_accessory_suit", label: "Legs acessory" }, { visual: "legs_accessory_staff", label: "Legs acessory" }, { visual: "legs_accessory_cyber", label: "Legs acessory" }, { visual: "legs_accessory_soul", label: "Legs acessory" }], Uf = ft, Rf = [{ visual: "none", label: "None", value: "" }, { visual: "hair_accessory_default", label: "Head accessory", value: "hair_accessory_default" }, { visual: "hair_accessory_cyber", label: "Head accessory" }, { visual: "hair_accessory_hat1", label: "Head accessory" }, { visual: "hair_accessory_hat2", label: "Head accessory" }, { visual: "hair_accessory_hat3", label: "Head accessory" }, { visual: "hair_accessory_hat4", label: "Head accessory" }], Hf = ft, Wf = [{ visual: "head_standard", label: "Hair accessories", value: "head_default" }, { visual: "head_soul", label: "Hair accessories" }, { visual: "head_cyber", label: "Hair accessories" }, { visual: "head_horn", label: "Hair accessories" }, { visual: "head_traditional", label: "Hair accessories" }], Vf = [{ visual: "shoes_default", label: "Shoes", value: "shoes_default" }, { visual: "shoes_soul", label: "Shoes" }, { visual: "shoes_cyber", label: "Shoes" }, { visual: "shoes_horn", label: "Shoes" }, { visual: "shoes_traditional", label: "Shoes" }, { visual: "shoes_suit", label: "Shoes", value: "shoes_suit" }, { visual: "shoes_boots1", label: "Shoes", value: "shoes_boots1" }, { visual: "shoes_boots2", label: "Shoes", value: "shoes_boots2" }, { visual: "shoes_boots3", label: "Shoes", value: "shoes_boots3" }, { visual: "shoes_boots4", label: "Shoes", value: "shoes_boots4" }, { visual: "shoes_boots5", label: "Shoes", value: "shoes_boots5" }, { visual: "shoes_withsocks", label: "Shoes", value: "shoes_withsocks" }, { visual: "shoes_withsocks2", label: "Shoes", value: "shoes_withsocks2" }], Zf = [{ visual: "none", label: "None", value: "" }, { visual: "mask", label: "Mask" }], Gf = ft, qf = ({ category: e, colorPick: n }) => {
  const i = /* @__PURE__ */ O((s) => s.skin?.colors?.[e === "skin" ? "head" : e]), o = /* @__PURE__ */ S((s) => s.isOffice);
  return t(Kf, { children: t(Jf, { className: i === n ? "current" : "", onClick: () => {
    const { skin: s } = /* @__PURE__ */ $();
    if (s.notCustomisable)
      return;
    s.colors || (s.colors = {});
    const { colors: r } = s;
    e === "skin" ? (r.hands = n, r.head = n, r.legs = n) : r[e] = n, s.colors = r, le({ skin: { ...s, colors: { ...s.colors } }, colors: { ...s.colors } }), b("tracking", { event: "avatar-customization", category: "colors", label: e, value: r[e] }), o && setTimeout(() => {
      $().hasProfilePic || (le({ profilePicture: null }), tt({ askedScreenshot: true }));
    }, 500);
  }, children: t("div", { style: { backgroundColor: n } }) }) });
}, Ke = ({ category: e, data: n, office: i }) => t(Yf, { children: n.map((o, a) => t(qf, { colorPick: o.color, category: e }, a)) }), Yf = l.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px;
  font-size: 0;
`, Kf = l.li``, Jf = l.button`
  padding: 4px;
  div {
    position: relative;
    border-radius: 100%;
    width: 34px;
    height: 34px;
    overflow: hidden;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 2px solid #fff;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }
  &.current {
    pointer-events: none;
    div {
      &:before {
        opacity: 1;
      }
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      div {
        &:before {
          opacity: 1;
        }
      }
    }
  }
`, Xf = () => t("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "39px", height: "39px", viewBox: "0 0 39 39", children: d("g", { opacity: ".4", fill: "#fff", children: [t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.2736 1.18023c.2318.23676.2278.61664-.0089.84848L1.01978 37.5185c-.236773.2318-.616651.2278-.848486-.0089-.231835-.2368-.227837-.6167.008931-.8485L36.4251 1.17129c.2368-.231831.6167-.227833.8485.00894Z" }), t("path", { d: "M1.2 19.1c0-9.8859 8.0141-17.9 17.9-17.9 4.8238 0 9.2009 1.90733 12.4204 5.01026.2167.20888.4281.42317.6341.64265l.8576-.83972c-.2142-.22765-.4339-.45004-.659-.66695C28.9191 2.03645 24.2467 0 19.1 0 8.55136 0 0 8.55136 0 19.1c0 5.3396 2.19111 10.1675 5.72326 13.6335l.8576-.8397C3.26055 28.6443 1.2 24.1128 1.2 19.1Zm6.26734 13.6053-.86055.8426C9.95587 36.4464 14.3232 38.2 19.1 38.2c10.5486 0 19.1-8.5514 19.1-19.1 0-4.6321-1.6495-8.8798-4.3922-12.18643l-.8605.84258C35.4804 10.8445 37 14.7944 37 19.1 37 28.9859 28.9859 37 19.1 37c-4.4409 0-8.504-1.6172-11.63266-4.2947Z" })] }) }), Qf = ({ data: e, category: n }) => {
  const i = /* @__PURE__ */ O((c) => c.skin?.perks?.[n]), o = e.value ? e.value : e.visual, a = /* @__PURE__ */ S((c) => c.isOffice), s = /* @__PURE__ */ ee(() => {
    const { skin: c } = /* @__PURE__ */ $();
    if (c.notCustomisable)
      return;
    c.perks || (c.perks = {});
    const { perks: p } = c;
    p[n] = o, c.perks = p, le({ skin: { ...c, perks: { ...c.perks } } }), b("tracking", { event: "avatar-customization", category: "perks", label: n, value: p[n] }), a && setTimeout(() => {
      $().hasProfilePic || (le({ profilePicture: null }), tt({ askedScreenshot: true }));
    }, 500);
  }, [a]), { t: r } = /* @__PURE__ */ x("common");
  return t("li", { children: t(tm, { onClick: s, className: i === o ? "active" : "", children: e.visual !== "none" ? t("img", { src: M[`${zf + e.visual}.webp`], alt: r(e.label) }) : t(Xf, {}) }) });
}, He = ({ data: e, category: n = "" }) => t(em, { children: e.map((i, o) => t(Qf, { data: i, category: n }, o)) }), em = l.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 13px;
`, tm = l.button`
  position: relative;
  width: 102px;
  height: 102px;
  background: rgba(45, 45, 45, ${(e) => e.theme.opacityUI});
  border-radius: 6px;
  overflow: hidden;
  isolation: isolate;
  font-size: 0;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    z-index: 1;
    opacity: 0;
    border-radius: 6px;
    transition: opacity 0.3s ease;
  }

  &.active {
    pointer-events: none;
    &::before {
      opacity: 1;
    }
  }

  @media all and (pointer: fine) {
    img,
    svg {
      transform: scale(1) translateZ(0);
      transition: transform 0.6s ease;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
      img,
      svg {
        transform: scale(0.9) translateZ(0);
      }
    }
  }
`, Ta = ({ show: e, office: n, active: i }) => {
  const [o, a] = /* @__PURE__ */ m(false);
  return Y(() => {
    C({ isOffice: n });
  }, [n]), w(() => {
    i && a(true);
  }, [i]), d("div", { children: [t(Z, { title: "skin-color", children: t(Ke, { office: n, data: Pf, category: "skin" }) }), e ? d(T, { children: [t(Z, { title: "head", children: t(He, { office: n, data: Wf, category: "head" }) }), t(Z, { title: "hair-style", children: t(He, { office: n, data: jf, category: "hair" }) }), t(Z, { title: "hair-color", children: t(Ke, { office: n, data: _f, category: "hair" }) }), t(Z, { title: "hair-accessories", children: t(He, { office: n, data: Rf, category: "hair_accessory" }) }), t(Z, { title: "hair-accessories-color", children: t(Ke, { office: n, data: Hf, category: "hair_accessory" }) }), o ? t(Z, { title: "face-accessories", children: t(He, { office: n, data: Zf, category: "face_accessory" }) }) : null, t(Z, { title: "face-accessories-color", children: t(Ke, { office: n, data: Gf, category: "face_accessory" }) }), o ? t(Z, { title: "top-clothes", children: t(He, { office: n, data: Ff, category: "cloth" }) }) : null, t(Z, { title: "top-clothes-color", children: t(Ke, { office: n, data: Of, category: "cloth" }) }), o ? t(Z, { title: "bottom-clothes", children: t(He, { office: n, data: Bf, category: "legs_accessory" }) }) : null, t(Z, { title: "bottom-clothes-color", children: t(Ke, { office: n, data: Uf, category: "legs_accessory" }) }), o ? t(Z, { title: "shoes", children: t(He, { office: n, data: Vf, category: "shoes" }) }) : null] }) : null] });
};
l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const nm = () => d("svg", { width: "20", height: "17", viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M1 2.5H19", stroke: "#FCFCFC", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t("circle", { cx: "14", cy: "2.5", r: "2", fill: "white" }), t("path", { d: "M1 14.5H19", stroke: "#FCFCFC", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t("circle", { cx: "11", cy: "14.5", r: "2", fill: "white" }), t("path", { d: "M19 8.5L1 8.5", stroke: "#FCFCFC", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }), t("circle", { cx: "5.5", cy: "8.5", r: "2", transform: "rotate(-180 5.5 8.5)", fill: "white" })] }), Na = 20, im = l.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  gap: 15px;
  cursor: pointer;
  ${(e) => e.theme.bodyText3}
  h5 {
    display: block;
    padding: 0 0 5px;
  }

  &.disable {
    pointer-events: none;
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
    input {
      pointer-events: none !important;
    }
  }

  @media (pointer: fine) {
    &:hover {
      .checkmark {
        transform: translate3d(-50%, -50%, 0) scale(0.7);
      }
    }
  }
`, om = l.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  pointer-events: auto;
  width: 100%;
  height: 34px;
  &:checked {
    pointer-events: none;
  }
  &:checked ~ .radiomark {
    opacity: 1;
  }
  &:checked ~ .radiomark .checkmark {
    transform: translate3d(-50%, -50%, 0) scale(1);
  }
`, am = l.span`
  display: block;
  position: relative;
  height: ${Na}px;
  min-width: ${Na}px;
  background: rgba(255, 255, 255, 0.15);
  border: 1.5px solid #ffffff;
  border-radius: 100%;
  opacity: 0.5;
  transition: opacity 0.3s ease;
`, sm = l.span`
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  height: 10px;
  width: 10px;
  background: #fff;
  border-radius: 100%;
  transform: translate3d(-50%, -50%, 0) scale(0);
  transition: transform 0.3s ease;
`, rm = ({ value: e, name: n, checked: i, click: o, disabled: a, children: s, ...r }) => {
  const c = /* @__PURE__ */ k(null);
  return d(im, { ...r, className: `${i ? "disable" : ""} ${a ? "disabled" : ""}`, children: [s, t(om, { type: "radio", value: e, name: n, defaultChecked: i, ref: c, onClick: () => {
    o(), c.current && c.current.blur();
  } }), t(am, { className: "radiomark", children: t(sm, { className: "checkmark" }) })] });
}, Je = ({ name: e, label: n, description: i, value: o, checked: a, click: s, disabled: r }) => {
  const { t: c } = /* @__PURE__ */ x("common");
  return t(rm, { value: o, name: e, checked: a, click: s, disabled: r, children: d("div", { children: [t("h5", { children: c(n) }), c(i)] }) });
}, lm = () => {
  const e = /* @__PURE__ */ vi((a) => a.videoQuality), n = /* @__PURE__ */ z((a) => a.isAdmin), i = /* @__PURE__ */ Gs((a) => a.dpr), o = /* @__PURE__ */ ee((a) => {
    qs({ videoQuality: a, isVideoUserChoice: true }), b("update_graphism_quality", a), b("tracking", { event: "click", category: "settings", label: "graphics-quality", value: a });
  }, []);
  return t(Z, { title: "settings-graphics", children: d(Le, { children: [t(Je, { name: "quality", label: "sg-low", description: "sg-low-desc", value: 0, checked: e === 0, click: e !== 0 ? () => o(0) : null }), t(Je, { name: "quality", label: "sg-optimal", description: "sg-optimal-desc", value: 1, checked: e === 1, click: e !== 1 ? () => o(1) : null }), n ? d(T, { children: [t(Je, { name: "quality", label: "sg-ultra", description: "sg-ultra-desc", value: 2, checked: e === 2, click: e !== 2 ? () => o(2) : null }), t(On, { title: `DPR: ${i}`, defaultValue: i, value: i, onChange: (a) => {
    let s = 0.5;
    a.target ? (a.stopPropagation(), s = a.target.value) : s = a, Ve({ dpr: parseFloat(s) });
  }, min: "0.05", max: "2", step: ".05" })] }) : null] }) });
}, cm = ({ office: e }) => {
  const { t: n } = /* @__PURE__ */ x(), [i, o, a, s, r] = /* @__PURE__ */ O((g) => [g.settings.privacy.anonymousSession, g.settings.privacy.showChatChecked, g.settings.privacy.showNames, g.settings.privacy.alwaysShowChat, g.settings.privacy.enableNotifications]), c = typeof Notification < "u";
  S((g) => g.lang), w(() => {
    c && r && (async () => {
      try {
        await Notification.requestPermission() !== "granted" && console.warn("Permission not granted for Notifications");
      } catch (y) {
        console.error("Error while requesting notification permission: ", y);
      }
    })();
  }, [c, r]);
  const p = (g, y) => {
    b("setSettings", { privacy: y }), le({ settings: g });
  }, u = () => {
    const { settings: g } = /* @__PURE__ */ $();
    g.privacy.showChat = !g.privacy.showChat, p(g, { showChat: g.privacy.showChat });
  }, h = () => {
    const { settings: g } = /* @__PURE__ */ $();
    g.privacy.alwaysShowChat = !g.privacy.alwaysShowChat, p(g, { alwaysShowChat: g.privacy.alwaysShowChat });
  }, f = () => {
    const { settings: g } = /* @__PURE__ */ $();
    g.privacy.showNames = !g.privacy.showNames, p(g, { showNames: g.privacy.showNames });
  }, v = async () => {
    if (!c)
      return;
    const g = await Notification.requestPermission(), { settings: y } = /* @__PURE__ */ $();
    let L = false;
    g && (L = !y.privacy.enableNotifications, y.privacy.enableNotifications = L), p(y, { enableNotifications: L }), L && b("notification", { message: n("notifications-enabled") });
  };
  return $().settings.privacy || le({ settings: { privacy: { offline: false, showChat: true, showCharacter: true, alwaysShowChat: false, showNames: true, enableNotifications: false } } }), t(Z, { title: "settings-privacy", children: d(Le, { children: [t(de, { show: r, click: v, label: "enable-notifications", description: "enable-notifications-desc", disabled: i || !c }), e ? null : d(T, { children: [t(de, { show: o, click: u, label: "show-chat", description: "show-chat-desc", disabled: i }), t(de, { show: s, click: h, label: "show-global-chat", description: "show-global-chat-desc", disabled: i })] }), t(de, { show: a, click: f, label: "toggle-name", description: "toggle-name-desc", disabled: i })] }) });
}, dm = () => {
  const [e, n, i] = /* @__PURE__ */ O((o) => [o.media.mic, o.media.speaker, o.media.video]);
  return t(Z, { title: "audio_video_setup", children: t(Le, { children: t(um, { children: t(Oi, { camera: i, mic: e, speaker: n }) }) }) });
}, pm = () => {
  const [e, n] = /* @__PURE__ */ m(false), i = async (a, s) => {
    const r = /* @__PURE__ */ localStorage.getItem(`preferred${a}`), c = await Po(r, s);
    return le({ media: { ...$().media, [a]: c } }), true;
  }, o = async () => {
    await i("mic", "audioinput"), await i("video", "videoinput"), n(true);
  };
  return w(() => {
    o();
  }, []), e ? t(dm, {}) : null;
}, um = l.div`
  & > div {
    gap: 10px;
  }
  select {
    border: none;
    background: rgba(0, 0, 0, 0.2);

    font-family: 'Mundial';
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;
    text-transform: capitalize;
  }
`, hm = l.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  text-align: left;
  .scmresp {
    width: 100%;
    flex: 1;
    flex-basis: 100%;
  }

  p {
    font-weight: 600;
    font-size: 11px;
    line-height: 15px;
    letter-spacing: 0.03em;
    opacity: 0.7;
    padding: 2px 0 0;
  }

  @media (pointer: fine) {
    img {
      transition: transform 0.2s ease;
    }
    &:hover {
      img {
        transform: scale(1.05) translateZ(0);
      }
    }
  }
`, fm = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  width: 36px;
  height: 30px;
  position: relative;
  img {
    clip-path: none;
    width: 36px;
    height: auto;
  }

  svg {
    position: absolute;
    left: 0;
    top: 0;
    transform: none;
  }
`, mm = () => {
  const { t: e } = /* @__PURE__ */ x("common"), n = /* @__PURE__ */ k(null), [i, o] = /* @__PURE__ */ pn((s) => [s.firstPerson, s.lockRotation]), a = i ? "fps" : o ? "tps" : "bird";
  return d(hm, { ref: n, onClick: () => {
    St().setNextCameraMode(), n.current && n.current.blur();
  }, children: [d("div", { className: "scmresp", children: [t("h5", { className: "secfont", children: e("switch-camera") }), t("p", { children: e(`switch-camera-${a}`) })] }), t(fm, { children: t("img", { src: M[`/icons/${a}.svg`], alt: a }) })] });
}, gm = () => t(Z, { title: "settings-camera", children: t(Le, { children: t(mm, {}) }) }), xm = () => {
  const [e] = /* @__PURE__ */ z((n) => [n.sceneAudioMute]);
  return t(Z, { title: "settings-audio", children: t(Le, { children: t(de, { show: e, click: () => {
    tt({ sceneAudioMute: !e });
  }, label: "scene-audio-mute", description: "scene-audio-mute-desc" }) }) });
}, Qn = ({ lang: e, update: n }) => {
  const i = /* @__PURE__ */ ve((o) => o.lang);
  return t(Je, { name: "lang", label: `lang-${e}`, value: e, checked: i === e, click: i !== e ? () => n(e) : null });
}, vm = () => {
  const e = /* @__PURE__ */ ve((i) => i.lang), n = (i) => {
    Fs({ lang: i }), document?.documentElement?.setAttribute("lang", i), b("tracking", { event: "custom_event", category: "language", label: `switch to ${i}` }), localStorage.setItem("lang", i);
  };
  return t(Z, { title: "settings-lang", children: d(Le, { children: [t(Qn, { lang: "en", update: n }), t(Qn, { lang: "fr", update: n }), t(Qn, { lang: "ja", update: n })] }, `lang_${e}`) });
}, Aa = ({ office: e }) => {
  const n = R().workspace, [i, o] = /* @__PURE__ */ S((a) => [a.uiSettings, a.hasSceneAudio]);
  return d("div", { children: [t(vm, {}), t(lm, {}), o ? t(xm, {}) : null, e || n === "metacare" ? t(pm, {}) : null, i?.disableCameraChange ? null : t(gm, {}), i?.isPaintGame ? null : t(cm, { office: e }), t(bm, {})] });
}, Le = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, bm = l.div`
  height: 50px;
`, ei = ({ forceActive: e = false, office: n }) => {
  const [i, o] = /* @__PURE__ */ m(false), a = /* @__PURE__ */ S((c) => c.openModal === J.MENU), s = /* @__PURE__ */ [{ label: "avatar", icon: t(qi, {}), content: t(Ta, { office: true, show: true, active: a }) }, n ? null : { label: "settings", icon: t(nm, {}), content: t(Aa, {}) }].filter(Boolean), r = e || a;
  return w(() => {
    a && o(true);
  }, [a]), t(ht, { office: n, show: r, data: s, children: n ? t(Ta, { office: n, show: i, active: a }) : null });
}, ti = () => (j("escapeCtrl", () => {
  N().simpleModalOpened || (N().openModal.length > 0 ? C({ openModal: "", hideUI: false }) : N().subMenuOffice && b("closeSubMenu"));
}), null), wm = () => {
  const e = /* @__PURE__ */ K("isMobile"), n = /* @__PURE__ */ S((i) => i.uiSettings);
  return d(T, { children: [!e && d(T, { children: [t(Xn, {}), t(ti, {})] }), t(Jn, {}), t(Gt, {}), t(ei, {}), n?.isPaintGame ? t(Bn, {}) : null] });
}, ym = () => {
  const e = /* @__PURE__ */ S((i) => i.showTutorial), n = /* @__PURE__ */ K("isMobile");
  return e ? n ? d(T, { children: [t($o, {}), t(qo, {})] }) : t(Xi, {}) : null;
}, ni = () => S((n) => n.hiderLoading) ? t("div", { style: { position: "fixed", inset: 0, zIndex: "99998", background: "#2d2d2d" } }) : null, Ea = () => {
  const e = /* @__PURE__ */ O((a) => a.user), i = (z((a) => a.usersById[e?.uid]?.accountType) || 10) >= 900;
  return z((a) => a.isAdmin) || i ? t(jo, {}) : null;
}, Cm = ({ callEnabled: e = false, children: n }) => {
  const [i, o] = /* @__PURE__ */ z((a) => [a.disableUI, a.editorMode]);
  return d(km, { className: i || o ? "hide" : "", children: [t(ni, {}), t($a, {}), t(wm, {}), t(ko, { callEnabled: e }), t(Eo, {}), t(ga, {}), t(No, {}), t(Ut, {}), t(Fn, {}), t(Ea, {}), t(Ao, {}), t(ym, {}), t(Ca, {}), t(wa, {}), t(ya, {}), t(jn, {}), t(m0, {}), n, e ? d(T, { children: [t(qn, { isOffice: false }), t(En, {}), t(Hn, {})] }) : null] });
}, km = l.div`
  position: fixed;
  inset: 0;
  z-index: 1;
  &.hide {
    display: none;
  }
`, Sm = () => {
  const [e, n] = /* @__PURE__ */ m(0);
  return w(() => {
    let i, o, a, s;
    const r = function(c) {
      i = new window.AudioContext(), o = i.createAnalyser(), a = i.createMediaStreamSource(c), s = i.createScriptProcessor(2048, 1, 1), o.smoothingTimeConstant = 0.8, o.fftSize = 1024, a.connect(o), o.connect(s), s.connect(i.destination), s.onaudioprocess = () => {
        const p = new Uint8Array(o.frequencyBinCount);
        o.getByteFrequencyData(p);
        let u = 0;
        const h = p.length;
        for (let v = 0; v < h; v++)
          u += p[v];
        const f = u / h;
        n(f);
      };
    };
    return typeof navigator == "object" && navigator.mediaDevices.getUserMedia({ audio: true }).then(r).finally(() => {
      he().userMediaUpdate(true);
    }), () => {
      s && (s.disconnect(), s.onaudioprocess = null), o && o.disconnect(), a && a.disconnect(), i && i.close().then(() => {
        console.log("Audio context closed.");
      });
    };
  }, []), e;
}, Mm = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = /* @__PURE__ */ Ce((s) => s.peers.get($().id)?.enabled.audio), i = () => {
    a(false), setTimeout(() => {
      oe({ micOffWarning: false, micOffWarningDisplayed: true });
    }, 300);
  }, [o, a] = /* @__PURE__ */ m(false);
  return ue(() => {
    setTimeout(() => {
      a(true);
    });
  }, []), w(() => {
    n && i();
  }, [n]), d($m, { className: o ? "show" : "", onClick: i, children: [t("p", { dangerouslySetInnerHTML: { __html: e("mic-off-warning") } }), t("img", { src: M["/icons/close.svg"], alt: "close" })] });
}, Lm = () => {
  const e = $().id, [n] = /* @__PURE__ */ Ce((a) => [a.peers.get(e)?.enabled.audio]), i = /* @__PURE__ */ Sm(), o = /* @__PURE__ */ k(false);
  return w(() => {
    n ? o.current = false : o.current || (o.current = (/* @__PURE__ */ new Date()).getTime()), i > 15 && !n && ((/* @__PURE__ */ new Date()).getTime() - o.current) / 1e3 > 60 && oe({ micOffWarning: true });
  }, [i, n]), null;
}, Im = () => {
  const e = /* @__PURE__ */ Ce((a) => a.peers.get($().id)?.enabled.audio), [n, i, o] = /* @__PURE__ */ ie((a) => [a.inCall, a.micOffWarningDisplayed, a.micOffWarning]);
  return !n || e ? null : o ? t(Mm, {}) : i ? null : t(Lm, {});
}, $m = l.div`
  position: fixed;
  z-index: 10;
  right: 62px;
  bottom: 22px;
  transform: translateY(-50%);
  background: #f33182;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;

  &.show {
    opacity: 1;
    pointer-events: all;
    cursor: pointer;
  }

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 0 6px 8px;
    border-color: transparent transparent transparent #f33182;
    right: -7px;
    top: 50%;
    transform: translateY(-50%);
  }

  p {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    padding: 0 15px 0 0;
  }

  img {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 16px;
    height: 16px;
    clip-path: none;
  }

  @media all and (max-width: 767px) {
    right: 90px;
    bottom: 34px;
    &::before {
      top: auto;
      bottom: -11px;
      right: 15px;
      border-width: 8px 6px 0 6px;
      border-color: #f33182 transparent transparent transparent;
    }
  }

  @media all and (max-width: 415px) {
    right: 84px;
  }

  @media all and (max-width: 390px) {
    right: 80px;
  }

  @media all and (max-width: 375px) {
    right: 78px;
  }
`, Tm = ({ data: e }) => {
  const n = /* @__PURE__ */ k(null), { x: i, y: o, actions: a } = e, s = () => {
    C({ showContextMenu: null });
  };
  return w(() => {
    const r = (c) => {
      n.current && !n.current.contains(c.target) && s();
    };
    return document.addEventListener("mousedown", r), () => {
      document.removeEventListener("mousedown", r);
    };
  }, []), t(Am, { ref: n, posx: i, posy: o, children: a ? t(Oo, { actions: a, close: s }) : null });
}, Nm = () => {
  const e = /* @__PURE__ */ S((n) => n.showContextMenu);
  return e ? t(Tm, { data: e }) : null;
}, Am = l.div`
  position: fixed;
  pointer-events: all;
  top: ${(e) => e.posy}px;
  left: ${(e) => e.posx}px;
  z-index: 2;
`, Em = ({ data: e }) => {
  let n = "";
  switch (e?.type) {
    case "gong":
      n = "admin/gong";
      break;
    case "meeting":
      n = "admin/meeting";
    default:
      n = "admin/notifications";
      break;
  }
  return t(jm, { className: e?.type, children: t("img", { src: e?.type !== "social" ? M[`/icons/${n}.svg`] : "", alt: "notification" }) });
}, Dm = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("office");
  return d(_m, { children: [t(Em, { data: e }), d("div", { className: "txt", children: [t("h3", { className: "secFontTxtSmlLight", children: n(e?.title) }), t("span", { className: "secFontTxtSmlLight", children: e?.date })] })] });
}, zm = ({ data: e }) => d(T, { children: [e?.visual ? t(Fm, { children: e?.visual }) : null, e?.content ? e.content : null] }), Da = ({ data: e }) => d(Pm, { className: "nc", children: [t(Dm, { data: e }), t(zm, { data: e })] }), Pm = l.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 5px;
  isolation: isolate;
  width: 100%;
  background: #222222;
  border-radius: 10px;
`, _m = l.div`
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;

  .txt {
    display: flex;
    align-items: flex-end;
    gap: 5px;
    white-space: nowrap;
    min-width: 0;
  }

  h3 {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.04em;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    font-size: 12px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    opacity: 0.5;
    white-space: nowrap;
  }
`, jm = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f33182;

  img {
    width: 8px;
    height: auto;
    clip-path: none;
  }

  &.meeting {
    background: #f37731;
  }

  &.gong {
    background: #ff9f0e;
    img {
      width: 16px;
    }
  }

  &.social {
    background: #2d2d2d;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`, Fm = l.div`
  position: relative;
  width: 100%;
  height: auto;
  img {
    clip-path: none;
  }
  border-radius: 5px;
  overflow: hidden;
  isolation: isolate;
`, Om = ({ data: e, jsConfetti: n }) => {
  const [i, o] = /* @__PURE__ */ m(null), a = /* @__PURE__ */ S((p) => p.gongsData[e.gongId].reactions), s = [1561, 705, 1560, 65, 704], r = async (p, u = true) => {
    if (u) {
      const { microverseId: f } = /* @__PURE__ */ R(), { gongUpdate: v } = /* @__PURE__ */ N(), { id: g } = /* @__PURE__ */ $();
      Di(e.gongId, g, p.emoji, 1), v(f, e.gongId, p.emoji, 1);
      return;
    }
    const h = await sc(p.emoji);
    n.addConfetti({ emojis: [String.fromCodePoint(parseInt(h, 16))], emojiSize: 80, confettiNumber: 20 }), n.addConfetti();
  };
  w(() => {
    s.forEach((p) => {
      const u = a?.[p], h = i?.[p];
      u?.total !== h?.total && r({ emoji: p }, false);
    }), o(a);
  }, [a]);
  const c = [{ label: "raised_hand", emoji: 1561, cls: "emoji", reactions: i?.[1561]?.total || 0, tr: "office" }, { label: "tada", emoji: 705, cls: "emoji", reactions: i?.[705]?.total || 0, tr: "office" }, { label: "clap", emoji: 1560, cls: "emoji", reactions: i?.[1560]?.total || 0, tr: "office" }, { label: "wow", emoji: 65, cls: "emoji", reactions: i?.[65]?.total || 0, tr: "office" }, { label: "balloon", emoji: 704, cls: "emoji", reactions: i?.[704]?.total || 0, tr: "office" }];
  return t(Wm, { children: t(q, { fallback: null, children: t(ta, { actions: c, actionCallback: r }) }) });
}, Bm = ({ data: e }) => t("img", { src: M["/office/gong/gong-notification-bg-default.webp"], alt: "visual" }), Um = ({ data: e }) => t(Vm, { onClick: () => {
  b("closeGong", { gongId: e.gongId });
  const { gongUpdate: n } = /* @__PURE__ */ N(), { microverseId: i } = /* @__PURE__ */ R();
  n(i, e.gongId);
}, children: t(Me, {}) }), Rm = ({ data: e, offset: n, jsConfetti: i, visible: o }) => {
  const [a, s] = /* @__PURE__ */ m(false);
  return w(() => {
    setTimeout(() => {
      s(true), i.addConfetti({ confettiNumber: 60 }), i.addConfetti();
    }, 10);
  }, []), d(Hm, { className: a && o ? "show" : "", offset: n, children: [t(Um, { data: e }), t(Da, { data: e }), t(Om, { data: e, jsConfetti: i })] });
}, Hm = l.div`
  position: fixed;
  right: 70px;
  bottom: 20px;
  max-width: 300px;
  pointer-events: all;
  z-index: ${(e) => 1e3 - e.offset};
  width: 100%;

  transform: translate3d(0, calc(100% + 75px), 0);

  padding: 10px;
  background: #222222;
  border-radius: 10px;

  .nc {
    padding-bottom: 10px;
  }

  &.show {
    transition: transform 0.5s ease;
    transform: translate3d(0, ${(e) => `${e.offset * -40}px`}, 0);
  }

  @media all and (max-width: 767px) {
    bottom: 65px;
    right: 10px;
  }
`, Wm = l.div`
  display: flex;
  align-items: center;
  padding: 10px 20px 0;
  margin: 0 -5px;
`, Vm = l.button`
  position: absolute;
  padding: 10px;
  top: 2px;
  right: 2px;
  z-index: 3;
  opacity: 0.6;
  svg {
    width: 12px;
  }

  @media all and (pointer: fine) {
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 1;
    }
  }
`, Zm = l.canvas`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  user-select: none;
  width: 100%;
  height: 100%;
`, Gm = () => {
  const [e, n] = /* @__PURE__ */ m([]), [i, o] = /* @__PURE__ */ m(null), a = /* @__PURE__ */ Y(() => new ir({ canvas: i }), [i]);
  return j("gong", (s) => {
    const r = N().gongsData[s], c = { type: "gong", title: "gong-celebration", gongId: s, date: me(r.createdAt), visual: t(Bm, { data: r }), content: t("p", { dangerouslySetInnerHTML: { __html: r.message } }) };
    n([c, ...e]);
  }), j("closeGong", ({ gongId: s, all: r }) => {
    e.length > 0 && n(r ? [] : e.filter((c) => c.gongId !== s));
  }), e.length > 0 ? d("div", { children: [e.map((s, r) => t(Rm, { data: s, offset: r, jsConfetti: a, visible: r === 0 }, s.gongId)), t(Zm, { ref: o })] }) : null;
}, qm = () => {
  const [e, n] = /* @__PURE__ */ m(false), i = /* @__PURE__ */ S((o) => o.hideUI);
  return w(() => {
    i || setTimeout(() => {
      n(true);
    }, 3e3);
  }, [i]), e ? t(Gm, {}) : null;
}, za = () => {
  const [e, n] = /* @__PURE__ */ m(""), [i, o] = /* @__PURE__ */ m(null);
  return w(() => {
    C({ simpleModalOpened: i !== null });
  }, [i]), j("openModal", (a) => {
    n(""), o(a);
  }), j("openModalUnclose", (a) => {
    n("noclose"), o(a);
  }), j("openModalValidation", (a) => {
    n("validation"), o(a);
  }), j("openModalGong", (a) => {
    n("gong"), o(a);
  }), j("closeModal", () => {
    o(null);
  }), t(Ch, { cls: e, children: i });
}, Ym = () => d(Km, { children: [t(oa, { label: "old-notif-above", tr: "office" }), t(Da, { data: { type: "meeting", title: "Meeting with John", date: "1:26pm" } })] }), Km = l.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;
`, Jm = ({ member: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = () => {
    window.open("/admin/billing", "_blank");
  };
  return t(Xm, { children: d(Qm, { children: [t("img", { src: M["/icons/warning.svg"], alt: "warning" }), d(eg, { children: [t("h4", { className: "secFontTxtSml", children: n(`${e ? "member" : "guest"}-limit-reach-title`) }), t("p", { className: "normalTxt", dangerouslySetInnerHTML: { __html: n(`${e ? "member" : "guest"}-limit-reach-desc`) } }), t("div", { children: t(tg, { className: "secFontTxtSml", onClick: i, children: n("upgrade-plan") }) })] })] }) });
}, Xm = l.div`
  display: flex;
  padding: 20px;
  width: 100%;
  border: 2px solid #f33182;
  border-radius: 5px;
`, Qm = l.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 100%;
  & > img {
    min-width: 19px;
    width: 19px;
    height: 19px;
    clip-path: none;
  }
`, eg = l.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  div {
    font-size: 0;
  }

  h4 {
    text-transform: capitalize;
    color: #f33182;
    text-align: left;
  }

  p {
    text-align: left;
  }
`, tg = l.button`
  display: inline-block;
  position: relative;
  text-transform: capitalize;
  text-align: left;
  padding: 0 0 4px;

  &::before {
    pointer-events: none;
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #fff;
    transform: scaleX(1) translateZ(0);
    transition: transform 0.3s ease;
  }

  @media all and (pointer: fine) {
    &:hover::before {
      transform: scaleX(0) translateZ(0);
    }
  }
`, ng = ({ user: e, listUsers: n, setListUsers: i }) => t(sg, { onClick: () => {
  i([...n, e]);
}, children: t(Bt, { user: e }) }), ig = ({ listUsers: e, setListUsers: n, idsToExclude: i = [] }) => {
  const { usersList: o } = /* @__PURE__ */ R(), a = /* @__PURE__ */ e.map((r) => r.id), s = /* @__PURE__ */ o.filter((r, c) => !i.includes(r.id) && !a.includes(r.id) && r.active);
  return t(og, { className: s.length === 0 ? "hide" : "", children: t(ag, { children: s.map((r) => t(ng, { user: r, listUsers: e, setListUsers: n }, r.id)) }) });
}, og = l.div`
  width: 100%;
  max-height: 230px;
  background: #000;
  border-radius: 5px;
  overflow: auto;
  isolation: isolate;

  &.hide {
    display: none;
  }

  @media (max-height: 720px) {
    max-height: 150px;
  }
`, ag = l.div`
  display: flex;
  flex-direction: column;
`, sg = l.button`
  width: 100%;
  padding: 0 10px;
  height: 54px;
  @media all and (pointer: fine) {
    position: relative;
    overflow: hidden;
    & > div {
      position: relative;
      z-index: 1;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #3d3d3d;
      z-index: 0;
      transform: translate3d(-100%, 0, 0);
      transition: transform 0.2s ease;
    }
    &:hover::before {
      transform: translate3d(0, 0, 0);
    }
  }
`, Pa = (e) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(e), rg = ({ data: e, onRemove: n, cannotRemove: i }) => d(lg, { className: `${e?.hasProfilePic ? "userchip" : ""} ${e?.error ? "error" : ""}`, children: [e?.hasProfilePic ? t(ut, { user: e, showOnline: false }) : null, t("span", { children: e.name || "Anonymous" }), i ? null : t(cg, { onClick: () => {
  n(e.id);
}, children: t(Me, {}) })] }), lg = l.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 9px 4px 7px 14px;
  background: #000;
  border: 1px solid #000;
  border-radius: 999px;
  max-width: 100%;

  font-weight: 200;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.1em;
  color: #fff;

  &.error {
    color: #f33182;
    border-color: #f33182;
  }

  span {
    display: block;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.userchip {
    padding: 5px 5px 4px 39px;
    .avatar {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      min-width: 31px;
      width: 31px;
      height: 31px;
    }
  }
`, cg = l.button`
  padding: 5px 10px;
  svg {
    width: 10px;
    height: auto;
  }

  @media all and (pointer: fine) {
    &:hover {
      opacity: 0.7;
    }
  }
`, dg = ({ list: e, listUsers: n, setListUsers: i }) => {
  const o = /* @__PURE__ */ e.filter((a) => !n.find((r) => r.id === a.id) && a.active);
  return t(xg, { children: t(vg, { children: o.map((a, s) => t(bg, { onClick: () => {
    i((r) => [...r, a]);
  }, children: t(Bt, { user: a }) }, s)) }) });
}, pg = ({ data: e, listUsers: n, setListUsers: i, cannotRemove: o }) => t(rg, { data: e, onRemove: (a) => {
  i(n.filter((s) => s.id !== a));
}, cannotRemove: o }), ug = ({ mandatoryListUsers: e, listUsers: n, setListUsers: i }) => d(gg, { className: e.length > 0 || n.length > 0 ? "pb" : "", children: [e.map((o, a) => null), n.map((o, a) => t(pg, { data: o, listUsers: n, setListUsers: i }, a))] }), ii = ({ listUsers: e, setListUsers: n, setCanSend: i, onlyOnlineUsers: o, acceptEmails: a, onlyEmails: s, idsToExclude: r = [], mandatoryListUsers: c = [] }) => {
  const { t: p } = /* @__PURE__ */ x("office"), u = /* @__PURE__ */ k(null), [h, f] = /* @__PURE__ */ m([]), [v, g] = /* @__PURE__ */ m(false), y = /* @__PURE__ */ k(false), [L, I] = /* @__PURE__ */ m(false), A = /* @__PURE__ */ k(e), E = () => {
    const _ = /* @__PURE__ */ e.find((P) => P.error);
    g(_), i(!_ && e.length > 0);
  };
  w(() => {
    A.current = e, f([]), E(), u.current && (u.current.value = "", y.current && u.current.focus()), setTimeout(() => {
      y.current = true;
    }, 500);
  }, [e]);
  const D = (_, P) => {
    const U = _.target.value, { usersList: X } = /* @__PURE__ */ R();
    if (f(U === "" && !P ? [] : X.filter((ne) => (ne.name?.toLowerCase().includes(U) || ne.email?.toLowerCase().includes(U)) && !r.includes(ne.id))), U.includes(",") || P || s && U.includes(" ")) {
      if (!a || U === "")
        return;
      const ne = /* @__PURE__ */ U.split(/[,|\n]+/);
      for (const Fe of ne) {
        let pe = Fe.trim();
        pe = pe.replace(/\n/g, "").replace(/ /g, "").trim();
        const $e = A.current.filter((re) => re.email === pe).length, Oe = $e > 0;
        if (pe.length > 0) {
          const re = { id: pe + $e, name: pe, email: pe, error: !Pa(pe) || Oe };
          n((Qe) => {
            const pi = [...Qe, re];
            return A.current = pi, pi;
          });
        }
      }
    }
  }, F = () => {
    const _ = /* @__PURE__ */ e.filter((P) => !P.error);
    n(_);
  }, H = (_) => {
    _.key === "Enter" && (_.preventDefault(), _.stopPropagation(), D({ target: { value: u.current.value } }, true));
  };
  return w(() => (document.addEventListener("keydown", H), () => {
    document.removeEventListener("keydown", H);
  }), []), d(hg, { children: [d(fg, { children: [t("img", { src: M["/icons/search.svg"], alt: "search", className: focus ? "focus" : "" }), t(ug, { mandatoryListUsers: c, listUsers: e, setListUsers: n }), t(mg, { ref: u, placeholder: p(a ? "invite-placeholder" : "invite-team-placeholder"), onChange: D }), s ? null : t(dg, { list: h, listUsers: e, setListUsers: n })] }), s ? null : t(ig, { listUsers: e, setListUsers: n, idsToExclude: r }), v ? d(wg, { children: [t("img", { src: M["/icons/warning.svg"], alt: "error" }), t("span", { className: "normalTxt", children: p("invite-error") }), t(yg, { className: "secFontTxtSml", onClick: F, children: p("remove-email-error") })] }) : null, L ? t(Jm, { member: true }) : null] });
};
l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 100%;
`;
const hg = l.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`, fg = l.div`
  position: relative;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 20px;
  padding: 16px 20px 16px 55px;

  & > img {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 22px;
    height: auto;
    clip-path: none;
  }
`, mg = l.textarea`
  background: none;
  border: none;
  outline: none;
  color: #fff;
  resize: none;
  width: 100%;
`;
l.div``;
const gg = l.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  &.pb {
    padding-bottom: 9px;
  }
`, xg = l.div`
  position: absolute;
  bottom: 0;
  left: 50px;
  z-index: 10;
  min-width: 450px;
  background: #000000;
  border-radius: 5px;
  overflow: hidden;
  transform: translate3d(0, calc(100% - 30px), 0);
`, vg = l.div`
  max-height: 216px;
  overflow: auto;
`, bg = l.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  overflow: hidden;
  position: relative;
  & > div {
    position: relative;
    z-index: 1;
    width: 100%;
  }
  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #3d3d3d;
      z-index: 0;
      transform: translate3d(-100%, 0, 0);
      transition: transform 0.2s ease;
    }
    &:hover::before {
      transform: translate3d(0, 0, 0);
    }
  }
`, wg = l.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 19px;
    height: auto;
    clip-path: none;
  }
`, yg = l.button`
  position: relative;
  text-transform: capitalize;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 1px;
    background: #fff;
  }

  @media all and (pointer: fine) {
    &::before {
      transform: scale(1) translateZ(0);
      transition: transform 0.2s ease;
    }
    &:hover::before {
      transform: scale(0) translateZ(0);
    }
  }
`, Cg = ({ convId: e, convName: n, currentList: i }) => {
  const [o, a] = /* @__PURE__ */ m([]), [s, r] = /* @__PURE__ */ m(false), c = /* @__PURE__ */ S((h) => h.convsData[e]?.users), p = async () => {
    const { currentConvId: h } = /* @__PURE__ */ N(), f = /* @__PURE__ */ o.map((g) => g.id), { success: v } = await N().updateParticipants(h, f);
    if (!v) {
      b("notification:error", { message: "could not add participant" });
      return;
    }
    C((g) => (g.convsData[h].participants.push(...f), { convsData: { ...g.convsData } })), b("closeModal");
  }, { t: u } = /* @__PURE__ */ x("office");
  return t(xe, { children: d(kg, { children: [t(te, { title: u("add-users-to-conv", { name: n }), tr: "office" }), t(ii, { listUsers: o, setListUsers: a, setCanSend: r, acceptEmails: false, idsToExclude: c ? Object.keys(c) : i || [] }), t(ye, { className: "center nopt", children: t(B, { cls: "white", label: "invite-users", arrow: false, tr: "office", onClick: p, disable: !s }) })] }) });
}, kg = l.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  h1,
  p {
    text-align: center;
  }
`, _a = () => d("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M6.3457 12.1533H17.7303", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("path", { d: "M11.8848 6.61523L11.8848 17.9998", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }), t("rect", { x: "0.791406", y: "1.06191", width: "22.1846", height: "22.1846", rx: "11.0923", stroke: "white", strokeWidth: "1.2" })] }), Sg = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x();
  return d(Tg, { children: [t(Ag, { className: "pl", children: e?.name || n("anonymous") }), t(Ng, { children: t(Ye, { alt: e.name, hasProfilePic: e.hasProfilePic, userId: e.id, profilePicUid: e.profilePicUid }) })] });
}, Mg = ({ convId: e, convName: n }) => {
  const [i, o] = /* @__PURE__ */ S((s) => [s.convsData[e] ? s.convsData[e].participants : [], s.convsData[e] && s.convsData[e].participants?.length]), { usersById: a } = /* @__PURE__ */ R();
  return d(Lg, { children: [t($g, { children: i?.map((s) => a[s] ? t(Sg, { user: a[s] }, s) : null) }), t(Ig, { onClick: () => {
    b("openModal", t(Cg, { convId: e, convName: n, currentList: i }));
  }, children: t(_a, {}) })] });
}, Lg = l.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px 5px 20px;
  background: #222222;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
`, Ig = l.button`
  padding: 10px;
  opacity: 0.7;
  @media all and (pointer: fine) {
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 1;
    }
  }
`, $g = l.div`
  display: flex;

  button:first-child {
    margin-left: 0;
  }
`, Tg = l.button`
  position: relative;
  margin-left: -4px;
  padding: 10px 0;

  @media all and (pointer: fine) {
    &:hover {
      .pl {
        opacity: 1;
      }
    }
  }
`, Ng = l.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
  }
`, Ag = l.div`
  pointer-events: none;
  position: absolute;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s ease;
  left: 50%;
  transform: translateX(-50%);
  top: -10px;
  font-size: 12px;
  padding: 2px 5px;
  border-radius: 5px;
  background: #222222;
`, Eg = ({ linkText: e = "", editorInstance: n }) => {
  const i = /* @__PURE__ */ k(null), o = /* @__PURE__ */ k(null), [a, s] = /* @__PURE__ */ m(false), r = (p) => /^(https?:\/\/)?([\w.-]+)\.([a-zA-Z]{2,})(\/[\w.-]*)*\/?$/.test(p), c = () => {
    let p = o.current.value;
    /^https?:\/\//i.test(p) || (p = `https://${p}`), n.exec("addLink", { linkUrl: p, linkText: i.current.value }), b("closeModal");
  };
  return w(() => {
    r(e) && (o.current.value = e, s(true)), setTimeout(() => {
      o?.current?.focus();
    }, 600);
  }, []), d(Dg, { children: [t(W, { label: "url-text", children: t("input", { id: "url-text", type: "text", ref: i, defaultValue: e }) }), t(W, { label: "url-link", children: t("input", { id: "url-link", type: "url", ref: o, onChange: (p) => {
    s(p.target.value.length > 0);
  } }) }), t(zg, { children: t(B, { label: "save", arrow: false, onClick: c, cls: "white", disable: !a, tr: "office" }) })] });
}, Dg = l.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  isolation: isolate;
  background: #2d2d2d;
  border-radius: 10px;
  min-width: 400px;
  & > div {
    width: 100%;
  }

  @media all and (max-width: 600px) {
    min-width: auto;
  }
`, zg = l.div`
  display: flex;
  justify-content: flex-end;
  button {
    min-width: auto;
  }
`;
let oi;
try {
  oi = _s(() => import("@toast-ui/react-editor").then((e) => ({ default: e.Editor })));
} catch {
  console.warn("@toast-ui/react-editor is not installed, falling back to a default component."), oi = () => t("div", { children: "Editor not available." });
}
const Pg = ({ data: e, editorRef: n }) => t(Ug, { onClick: () => {
  const o = /* @__PURE__ */ n.getInstance();
  if (e.id !== "link")
    o.exec(e.value ? e.value : e.id, e.language);
  else {
    const a = o?.getSelectedText();
    if (!a || a === " ")
      return;
    b("openModal", t(Eg, { linkText: a, editorInstance: o }));
  }
}, className: e.active ? "active" : "", children: t("img", { src: M[`/icons/chat/${e.id}.svg`], alt: e.id }) }), _g = ({ editorRef: e, toolbarState: n }) => {
  const i = [{ id: "bold", active: n?.strong?.active }, { id: "italic", active: n?.emph?.active }, { id: "strikethrough", value: "strike", active: n?.strike?.active }, { id: "num-list", value: "orderedList", active: n?.orderedList?.active }, { id: "dot-list", value: "bulletList", active: n?.bulletList?.active }, { id: "code", active: n?.code?.active }, { id: "split-01", value: "split" }, { id: "link" }];
  return t(Bg, { children: i.map((o) => o?.value !== "split" ? t(Pg, { data: o, editorRef: e }, o.id) : t(Hg, {}, o.id)) });
}, jg = ({ editorRef: e, sendMessage: n, canSend: i, creatingConv: o }) => {
  const { t: a } = /* @__PURE__ */ x();
  return t(Rg, { className: i && !o ? "canSend" : "", onSubmit: (s) => {
    s && (s.preventDefault(), s.stopPropagation());
  }, children: d(q, { fallback: null, children: [t(oi, { previewStyle: "vertical", height: "100px", width: "100%", initialEditType: "wysiwyg", placeholder: a("placeholder-message"), ref: e, toolbarItems: [], hideModeSwitch: true, autofocus: false, useCommandShortcut: true }), t(Ia, { send: () => {
    n(true);
  }, show: true })] }) });
}, Fg = () => {
  const [e, n] = /* @__PURE__ */ m({}), [i, o] = /* @__PURE__ */ m(false), [a, s] = /* @__PURE__ */ m(false), [r, c] = /* @__PURE__ */ m(false), p = /* @__PURE__ */ k(false), u = /* @__PURE__ */ k(false), h = /* @__PURE__ */ k(false), f = () => {
    const D = /* @__PURE__ */ i.getInstance().getHTML();
    return new DOMParser().parseFromString(D, "text/html").body.textContent || "";
  }, v = async (E) => {
    if (r || p.current || (u.current || h.current) && !E)
      return;
    const D = /* @__PURE__ */ i.getInstance(), H = /* @__PURE__ */ D.getHTML().replace(/(<p><br><\/p>)*$/, "").replace(/<li><p><br><\/p><\/li>/g, ""), { convsData: _, currentConvId: P } = /* @__PURE__ */ N();
    let U;
    _[P].isDM && !_[P].messages.length && (p.current = true, c(true), U = N().createConv({ participants: _[P].participants.join(","), isDM: true }));
    const ne = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTime(), Fe = /* @__PURE__ */ Math.floor(ne / 1e3), pe = ne % 1e3 * 1e6, $e = { id: `temp${_[P].messages.length}`, avatar: "/", message: H, date: { _seconds: Fe, _nanoseconds: pe }, saved: false, userId: $().id };
    C((Oe) => (Oe.convsData[P].messages = [...Oe.convsData[P].messages, $e], { convsData: Oe.convsData })), D.setHTML(""), await U, N().sendMessage(P, $e), s(false), c(false), p.current = false;
  }, g = (E) => {
    E.key === "Enter" && !E.shiftKey || s(f().length > 0);
  }, y = (E) => {
    E.key === "Enter" && !E.shiftKey && (E.preventDefault(), f().length > 0 ? v() : i.getInstance().setHTML("")), E.stopPropagation();
  }, L = () => {
    h.current = true;
  }, I = () => {
    h.current = false;
  }, A = (E) => {
    const D = E?.toolbarState;
    D && (D.orderedList?.active || D.bulletList?.active ? u.current = true : setTimeout(() => {
      u.current = false;
    }), n(D));
  };
  return w(() => {
    if (!i)
      return;
    const E = /* @__PURE__ */ i.getInstance(), D = E?.getEditorElements()?.wwEditor;
    return E?.on("changeToolbarState", A), D && (D.addEventListener("keydown", y), D.addEventListener("keyup", g), D.addEventListener("compositionstart", L), D.addEventListener("compositionend", I)), () => {
      E?.off("changeToolbarState", A), D?.removeEventListener("keydown", y), D?.removeEventListener("keyup", g), D?.removeEventListener("compositionstart", L), D?.removeEventListener("compositionend", I);
    };
  }, [i]), d(Og, { children: [t(jg, { editorRef: o, sendMessage: v, canSend: a, creatingConv: r }), t(_g, { editorRef: i, toolbarState: e })] });
}, Og = l.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 30px 15px;
  gap: 15px;
  width: 100%;

  background: #222222;
  border-radius: 0px 20px 0px 0px;
`, Bg = l.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 -5px;
`, Ug = l.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;

  &::before {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    background: #000;
    border-radius: 5px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 0;
  }

  img {
    clip-path: none;
    transition: opacity 0.2s ease;
    position: relative;
    z-index: 1;
  }

  &.active {
    &::before {
      opacity: 1;
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      img {
        opacity: 0.6;
      }
    }
  }
`, Rg = l.form`
  position: relative;

  display: flex;
  align-items: flex-start;
  width: 100%;

  .toastui-editor-defaultUI .ProseMirror {
    padding: 0;
  }

  .toastui-editor-contents {
    p {
      font-weight: 400;
      color: #fff;
    }
  }

  & > div {
    width: 100%;
    pointer-events: all;
  }

  .toastui-editor-defaultUI {
    border: none;
  }
  .toastui-editor-toolbar {
    display: none;
  }

  .toastui-editor-defaultUI .toastui-editor-md-tab-container,
  .toastui-editor-ww-container {
    border: none;
    background: none;
  }

  .toastui-editor-contents a {
    color: #f33182;
  }
  .toastui-editor-main-container {
    color: #fff;
  }
  textarea {
    width: 100%;
    min-height: 50px;
    background: none;
    resize: none;
    color: #fff;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.05em;
  }

  code {
    color: #ffc400 !important;
    font-size: 12px !important;
    line-height: 20px !important;
    letter-spacing: 0.05em !important;
    background: #1e1e1e !important;
    border-radius: 5px !important;
    padding: 2px 5px !important;
    border: 1px solid #444 !important;
  }

  button {
    opacity: 0.6;
    pointer-events: none;
    position: relative;
    top: auto;
    right: auto;
    width: 40px;
    min-width: 40px;
    height: 40px;
    transform: none;
    border-radius: 50%;
    &::before {
      border-radius: 50%;
    }
    svg {
      width: 16px;
      height: 16px;
    }
  }

  &.canSend {
    button {
      pointer-events: all;
      opacity: 1;
    }
  }

  @media (pointer: coarse) {
    textarea {
      font-size: 16px;
      line-height: 24px;
    }

    /* code {
      font-size: 16px !important;
      line-height: 24px !important;
    } */
  }
`, Hg = l.div`
  width: 1px;
  height: 18px;
  background: #fff;
  opacity: 0.3;
  margin: 0 5px;
`, Wg = (e) => {
  const { usersById: n } = /* @__PURE__ */ R(), i = $().id, o = e?.participants?.filter((s) => s !== i), a = [];
  return o?.forEach((s) => {
    const r = n[s];
    r && a.push(r?.name?.length > 0 ? r.name : "anonymous");
  }), a.join(", ");
}, Vg = ({ show: e }) => {
  const n = /* @__PURE__ */ k(), i = /* @__PURE__ */ k(false), [o, a, s] = /* @__PURE__ */ S((r) => [r.convsData[r.currentConvId]?.messages, r.convsData[r.currentConvId]?.messages?.length, r.currentConvId]);
  return w(() => {
    if (!n.current || !e)
      return;
    const r = n.current.children || [];
    r?.length > 0 && (setTimeout(() => {
      r[r.length - 1]?.scrollIntoView({ behaviour: "smooth" });
    }, i.current ? 0 : 300), i.current = true);
  }, [a, e]), t(qg, { children: t(Yg, { ref: n, children: o ? o.map((r) => t(xp, { data: r, convId: s }, r.id)) : null }) });
}, Zg = ({ show: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = $().id, [o, a, s, r] = /* @__PURE__ */ S((p) => [p.convsData[p.currentConvId], p.currentConvId, p.markAsRead, p.chatOfficeFullscreen]), c = o?.participants?.filter((p) => p !== i);
  return w(() => {
    o && a && o.messages.length && s(a, o.messages[o.messages.length - 1].id);
  }, [a, o, s]), d(Gg, { children: [t(Ra, { highlight: true, data: { title: o ? o.isDM ? Wg(o) : o.name : "", actions: [{ icon: `/icons/resize-${r ? "off" : "on"}.svg`, alt: "fullscreen", cls: "nosp", onClick: () => {
    C({ chatOfficeFullscreen: !N().chatOfficeFullscreen });
  } }, o?.isDM && c.length > 0 ? { icon: "/icons/phone.svg", alt: "call", onClick: () => {
    if (c?.length > 0) {
      const p = R().usersById[c[0]];
      ct("you_to_them", p, n);
    }
  } } : null, { icon: "/icons/close.svg", alt: "close", onClick: () => {
    b("closeDetailMenu");
  } }].filter(Boolean) } }), o?.isDM ? null : t(Mg, { convId: a, convName: o?.name }), t(Vg, { show: e }), t(q, { fallback: t("div", {}), children: t(Fg, {}) })] });
}, Gg = l.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: stretch;
`, qg = l.div`
  position: relative;
  height: 100%;
  overflow: auto;
`, Yg = l.div`
  display: flex;
  flex: 1 1 auto;
  min-height: 100%;
  justify-content: flex-end;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`, Kg = ({ subMenuOffice: e, close: n }) => {
  const i = /* @__PURE__ */ k(null), [o, a] = /* @__PURE__ */ m(false), s = /* @__PURE__ */ S((p) => p.chatOfficeFullscreen), c = /* @__PURE__ */ [{ id: "users", content: t(Zg, { show: o }) }].find((p) => p.id === e);
  return j("openDetailMenu", () => {
    clearTimeout(i.current), a(true);
  }), j("closeDetailMenu", () => {
    a(false);
  }), t(Jg, { className: `${o && !n ? "show" : ""} ${c?.id} ${s ? "fs" : ""}`, children: t(Xg, { children: t(Ha, { children: t(Qg, { children: c?.content ? c.content : null }) }) }) });
}, Jg = l.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 366px;
  transform: translate3d(-100%, 0, 0);
  z-index: -1;
  overflow: hidden;

  &.show {
    & > div {
      transform: translate3d(0, 0, 0);
    }
  }

  @media all and (min-width: 768px) {
    &.users {
      &.fs {
        max-width: none;
        width: calc(100vw - 366px);
      }
    }
  }

  @media all and (max-width: 767px) {
    max-width: 100%;
    z-index: 2;
    transform: translate3d(0, 0, 0);
  }
`, Xg = l.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #313030;
  transform: translate3d(100%, 0, 0);
  transition: transform 0.3s ease;

  @media all and (max-width: 767px) {
    transition-duration: 0.6s;
  }
`, Qg = l.div`
  height: 100%;
`, qt = () => {
  const [e, n] = /* @__PURE__ */ m([]), [i, o] = /* @__PURE__ */ m(false);
  return t(xe, { children: d(e2, { children: [t(te, { title: "add-new-member", desc: "add-new-member-desc", tr: "office" }), t(ii, { listUsers: e, setListUsers: n, setCanSend: o, acceptEmails: true, onlyEmails: true }), t(ye, { className: "center nopt", children: t(B, { label: "invite", onClick: async () => {
    o(false), C({ showSpinnerLoader: true });
    const { microverseId: s } = /* @__PURE__ */ R(), r = await $().user.getIdToken();
    await fetch(`${window.location.origin}/api/${s || "office"}/invite-to-workspace`, { method: "POST", body: JSON.stringify({ listUsers: e.map(({ email: c }) => ({ email: c })) }), headers: { authorization: `Bearer ${r}` } }), C({ showSpinnerLoader: false }), b("closeModal"), b("membersInvited");
  }, cls: "white", disable: !i, tr: "office" }) })] }) });
}, e2 = l.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  h1,
  p {
    text-align: center;
  }
`, t2 = () => {
  const { t: e } = /* @__PURE__ */ x("office");
  return t(n2, { onClick: () => {
    const { workspaceDoc: n } = /* @__PURE__ */ N(), i = /* @__PURE__ */ be(n.productId);
    if (n.quantity >= (i?.maxMembers || 50))
      return b("notification", { message: e("upgrade-plan-member") }), false;
    b("openModal", t(qt, {}));
  }, children: d(i2, { children: [t("img", { src: M["/icons/admin/people.svg"], alt: "invite" }), d("div", { children: [t("div", { className: "hover" }), t("div", { className: "square" }), t("div", { className: "square2" }), t("h5", { className: "secfont", children: e("add-member") }), t("p", { children: e("add-member-baseline") })] })] }) });
}, n2 = l.button`
  padding: 20px;

  @media all and (pointer: fine) {
    .hover {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: #111;
      opacity: 0;
      transition: opacity 0.2s ease;
      z-index: 0;
    }

    &:hover {
      .hover {
        opacity: 1;
      }
    }
  }
`, i2 = l.div`
  position: relative;
  width: 100%;
  padding: 21px 20px;
  background: ${(e) => e.theme.colors.highlight};
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 20px;
  overflow: hidden;
  text-align: left;

  img,
  h5,
  p {
    position: relative;
    z-index: 2;
  }

  img {
    width: 27px;
    height: auto;
    clip-path: none;
  }

  h5 {
    font-weight: 600;
    font-size: 17px;
    line-height: 19px;
    letter-spacing: 0.04em;
  }

  p {
    font-size: 9px;
    line-height: 15px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .square {
    position: absolute;
    width: 173px;
    height: 173px;
    left: -105px;
    top: -82px;
    z-index: 1;

    background: linear-gradient(
      201deg,
      #ffffff -30%,
      rgba(255, 255, 255, 0) 86%
    );
    opacity: 0.2;
    transform: rotate(22.8deg);
  }

  .square2 {
    position: absolute;
    width: 120px;
    height: 120px;
    left: -54px;
    top: 0;
    z-index: 1;

    background: linear-gradient(201deg, #fff -30%, rgba(255, 255, 255, 0) 86%);
    opacity: 0.1;
    transform: rotate(23deg);
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    z-index: 1;
  }
  &::before {
    width: 100px;
    height: 60px;
    right: -35px;
    top: -10px;
    border-radius: 40px;
    background: linear-gradient(
      262.62deg,
      rgb(255, 231, 162) 2%,
      rgb(191, 65, 237) 96%
    );
    transform: rotate(15deg);
  }

  &::after {
    width: 125px;
    height: 50px;
    right: -50px;
    bottom: -50px;
    border-radius: 40px;
    background: linear-gradient(
      12deg,
      rgb(255, 61, 157) 22%,
      rgb(255, 226, 153) 96%
    );
    transform: rotate(32deg);
  }
`, o2 = ({ data: e }) => {
  const n = /* @__PURE__ */ Ne(e.coverUuid ? `${Ae.workspaceStorage}${e.docId}/microversecover.webp?v=${e.coverUuid}` : null, M["/placeholder/office-preview.webp"]);
  return t(s2, { children: d("a", { href: `/${e.docId || e.slug}`, className: `/${e.docId || e.slug}` === window?.location?.pathname ? "current" : "", children: [t("div", { className: "visual", children: t("img", { src: n, alt: e.name }) }), t("p", { children: e.name })] }) });
}, a2 = ({ departments: e }) => t(T, { children: e.map((n, i) => t(q, { fallback: null, children: t(o2, { data: n }) }, `${n.docId}-${i}`)) }), s2 = l.li`
  a {
    position: relative;
    overflow: hidden;
    display: flex;
    width: 100%;
    align-items: center;
    padding: 5px 20px;
    gap: 10px;

    &.current {
      pointer-events: none;
      opacity: 0.7;
    }

    .visual,
    p {
      position: relative;
      z-index: 1;
    }

    .visual {
      min-width: 34px;
      max-width: 34px;
      height: 34px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        clip-path: none;
      }
    }

    p {
      font-family: 'Mundial';
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.04em;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media all and (pointer: fine) {
      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: #3d3d3d;
        z-index: 0;
        top: 0;
        left: 0;
        transform: translate3d(-100%, 0, 0);
        transition: transform 0.2s ease;
      }
      &:hover {
        &::before {
          transform: translate3d(0, 0, 0);
        }
      }
    }
  }
`, r2 = () => {
  const e = /* @__PURE__ */ Ee((n) => n.allMicroverses);
  return e ? t(a2, { departments: e }) : null;
}, l2 = () => d(c2, { children: [t(d2, { children: t(r2, {}) }), t(t2, {})] }), c2 = l.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  justify-content: space-between;
  flex-grow: 1;
`, d2 = l.ul``, p2 = () => {
  const { t: e } = /* @__PURE__ */ x("office"), [n, i] = /* @__PURE__ */ m(""), [o, a] = /* @__PURE__ */ m(false), [s, r] = /* @__PURE__ */ m(null), c = R().usersById[$().id], [p, u] = /* @__PURE__ */ m([]), [h, f] = /* @__PURE__ */ m(false), v = [c], g = async () => {
    if (n.length === 0) {
      r("group-name-required");
      return;
    }
    C({ showSpinnerLoader: true }), r(null), a(true);
    const { convId: y, success: L, participants: I } = await N().createConv({ name: n, participants: v[0].id + (p.length ? `,${p.map((A) => A.id).join(",")}` : "") });
    if (!L) {
      a(false), C({ showSpinnerLoader: false }), b("notification:error", { message: e("create-group-dm-error") });
      return;
    }
    zn(y, [v[0].id, ...p.map((A) => A.id)], false, n), C((A) => ({ currentConvId: y, convsList: [y, ...A.convsList] })), C({ showSpinnerLoader: false }), b("openDetailMenu", { data: null }), b("closeModal");
  };
  return d(xe, { children: [t(W, { label: "group-name", children: t("input", { id: "group-name", type: "text", onChange: (y) => {
    i(y.target.value);
  }, value: n }) }), s ? t(we, { label: e(s) }) : null, t(u2, {}), t(ii, { listUsers: p, setListUsers: u, setCanSend: f, acceptEmails: false, idsToExclude: v.map((y) => y.id), mandatoryListUsers: v }), t(ye, { children: t(B, { label: "create-group", onClick: g, cls: "white", arrow: false, disable: o || !h, tr: "office" }) })] });
}, u2 = l.div`
  height: 10px;
`, ja = () => t("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t("path", { d: "M5.56699 0.994141C5.75944 0.660808 6.24056 0.660807 6.43301 0.994141L10.7631 8.49414C10.9556 8.82747 10.715 9.24414 10.3301 9.24414H1.66987C1.28497 9.24414 1.04441 8.82747 1.23686 8.49414L5.56699 0.994141Z", stroke: "white" }) }), Fa = () => {
  const { t: e } = /* @__PURE__ */ x("office"), [n, i] = /* @__PURE__ */ m(false);
  return t(xe, { children: d(h2, { children: [t(te, { title: "invite-guests", desc: "invite-guests-desc", tr: "office" }), d("div", { children: [t("p", { className: "url secFontTxtMed", children: window.location.href }), t(ye, { className: "center nopt", children: t(B, { label: "copy-link", onClick: () => {
    const o = window.location.href;
    navigator.clipboard.writeText(o), i(true);
  }, cls: "white", tr: "office", arrow: false }) }), n ? t("p", { className: "success", children: e("link-copied") }) : null] })] }) });
}, h2 = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  h1,
  p {
    text-align: center;
  }

  .success {
    padding: 15px 0 0;
  }

  .url {
    user-select: text;
    padding: 0 0 20px;
  }
`, Oa = ({ addGuests: e }) => {
  const { t: n } = /* @__PURE__ */ x("office");
  return t(f2, { onClick: () => {
    if (!e) {
      const { workspaceDoc: i } = /* @__PURE__ */ N(), o = /* @__PURE__ */ be(i.productId);
      if (i.quantity >= (o?.maxMembers || 50))
        return b("notification", { message: n("upgrade-plan-member") }), false;
    }
    b("openModal", e ? t(Fa, {}) : t(qt, {}));
  }, children: d(m2, { className: "secFontTxtSml", children: [t(g2, { className: "circle", children: t(_a, {}) }), n(e ? "invite-guests" : "add-member")] }) });
}, f2 = l.button`
  width: 100%;
  padding: 4px 20px;

  @media all and (pointer: fine) {
    .circle {
      transition: opacity 0.2s ease;
      &::before {
        content: '';
        position: absolute;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        left: 1px;
        top: 1px;
        background: #2d2d2d;
        opacity: 0;
        transition: opacity 0.2s ease;
        z-index: 0;
        border-radius: 100%;
      }
    }

    &:hover {
      svg {
        path {
          stroke: #fff;
        }
      }
      .circle {
        opacity: 1;
        &::before {
          opacity: 1;
        }
      }
    }
  }
`, m2 = l.div`
  display: flex;
  align-items: center;
  gap: 14px;
  text-transform: capitalize;
`, g2 = l.div`
  position: relative;
  width: 34px;
  height: 34px;
  background: #fff;
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  svg {
    position: relative;
    z-index: 1;
    rect {
      opacity: 0;
    }
    path {
      stroke: #2d2d2d;
    }
  }
`, x2 = ({ user: e, listId: n }) => {
  const i = /* @__PURE__ */ S((s) => s.acceptUser), [o, a] = /* @__PURE__ */ m(false);
  return d(T, { children: [t("li", { children: t(qe, { isAccept: true, loading: o, action: () => {
    a(true), i(n, true, e);
  } }) }), t("li", { children: t(qe, { loading: o, action: () => {
    a(true), i(n, false, e);
  } }) })] });
}, v2 = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x();
  return d(b2, { children: [t(w2, { children: d(y2, { children: [t(ut, { user: e }), t(C2, { children: t("h5", { children: e.name || n("anonymous") }) })] }) }), t(x2, { user: e, listId: "waitlist" })] });
}, b2 = l.div`
  position: relative;
  display: flex;
  justify-content: space-between;
`, w2 = l.div`
  position: relative;
  width: 100%;
  padding: 4px 20px 4px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    opacity: 0.7;
  }
`, y2 = l.div`
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;
`, C2 = l.div`
  display: flex;
  align-items: center;
  width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    padding: 0 0 0 5px;
    display: inline-block;
    font-weight: 200;
    letter-spacing: 0.04em;
    opacity: 0.5;
  }
`, k2 = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = () => {
    const { hideConversation: a } = /* @__PURE__ */ N();
    a(e.id, true);
  }, o = [{ label: n("hide-group"), action: i, cls: "warning" }];
  return t(S2, { onContextMenu: (a) => {
    a.preventDefault(), C({ showContextMenu: { x: a.clientX, y: a.clientY, actions: o } });
  }, children: d(M2, { className: e.hasUnread ? "unread" : "", onClick: () => {
    b("openDetailMenu", null), C({ currentConvId: e.id });
  }, children: [t("span", { className: "sharp", children: "#" }), t("span", { className: "label", children: e.label })] }) });
}, S2 = l.div`
  position: relative;
  display: flex;
`, M2 = l.button`
  position: relative;
  font-family: 'Mundial';
  display: flex;
  justify-content: flex-start;
  text-align: left;
  align-items: center;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  gap: 10px;
  padding: 12px 20px;
  width: 100%;
  max-width: 100%;

  span {
    position: relative;
    z-index: 1;
    opacity: 0.7;
  }

  &.unread {
    span {
      opacity: 1;
    }
  }

  .label {
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sharp {
    font-weight: 300;
    font-size: 18px;
    line-height: 17px;
  }

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #3d3d3d;
      transform: translate3d(-100%, 0, 0);
      transition: transform 0.3s ease;
    }
    &:hover {
      &::before {
        transform: translate3d(0, 0, 0);
      }
    }
  }
`;
l.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  svg {
    width: 12px;
  }

  @media all and (pointer: fine) {
    &:hover {
      svg {
        opacity: 0.6;
      }
    }
  }
`;
const L2 = ({ title: e, tr: n = "common" }) => {
  const { t: i } = /* @__PURE__ */ x(n);
  return t("h4", { className: "secFontTxtMed", children: i(e) });
}, I2 = ({ title: e, minimize: n, setMinimize: i, isGroup: o, isWaitlist: a, isGuest: s, noContent: r }) => {
  const { t: c } = /* @__PURE__ */ x("office");
  return d(D2, { children: [t(L2, { title: e, tr: "office" }), t(P2, {}), d(z2, { children: [a ? null : t(lt, { tooltip: o ? "create-group" : s ? "invite-guests" : "add-member", tr: "office", action: () => {
    if (!o && !s) {
      const { workspaceDoc: p } = /* @__PURE__ */ N(), u = /* @__PURE__ */ be(p.productId);
      if (p.quantity >= (u?.maxMembers || 50))
        return b("notification", { message: c("upgrade-plan-member") }), false;
    }
    b("openModal", o ? t(p2, {}) : s ? t(Fa, {}) : t(qt, {}));
  }, icon: t("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", children: t("path", { d: "M11 7L11 11.0002M11 11.0002V15.0003M11 11.0002H15.0002M11 11.0002L6.99986 11.0001", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }) }) }), t(lt, { cls: `minbtn ${n ? "" : "rotate"}`, label: "minimize", action: () => {
    i(!n);
  }, icon: t(ja, {}), disabled: r })] })] });
}, $2 = ({ list: e }) => {
  const i = /* @__PURE__ */ e.filter((o) => !(!o.online && o.isAnonymous)).filter((o) => (o.isAnonymous || !o.accountType || o.accountType === 10) && o.online);
  return d(Yt, { title: "guests", noContent: !i?.length, isGuest: true, children: [i.map((o) => t(Zo, { user: o }, o.id)), t(Oa, { addGuests: true })] });
}, T2 = ({ list: e }) => {
  const n = $().id, i = R().usersById, o = /* @__PURE__ */ e.filter((a) => {
    const s = i[a.id]?.accountType || 10;
    return !(!a.online && a.isAnonymous) && s > 10;
  }).sort((a, s) => a.online && !s.online ? -1 : !a.online && s.online ? 1 : 0);
  return d(Yt, { title: "people", noContent: !o?.length, children: [o.map((a) => t(Zo, { user: a, mainUser: n === a.id }, a.id)), t(Oa, {})] });
}, N2 = ({ list: e }) => t(Yt, { title: "group", noContent: !e?.length, isGroup: true, children: e.map((n) => t(k2, { data: n }, n.id)) }), A2 = () => {
  const n = z((i) => i.microverseWaitlistLive)?.filter((i) => !(!i.online && i.isAnonymous)).sort((i, o) => i.online && !o.online ? -1 : !i.online && o.online ? 1 : 0);
  return n && n.length > 0 ? t(Yt, { title: "waitlist", noContent: !n?.length, isWaitlist: true, children: n.map((i) => t(v2, { user: i }, i.id)) }) : null;
}, Yt = ({ title: e, children: n, noContent: i, isGroup: o, isGuest: a, isWaitlist: s }) => {
  const [r, c] = /* @__PURE__ */ m(false);
  return d(_2, { children: [t(I2, { title: e, minimize: r, setMinimize: c, isGroup: o, noContent: i, isGuest: a, isWaitlist: s }), t(j2, { className: r ? "min" : "", children: n })] });
}, E2 = () => {
  const e = /* @__PURE__ */ z((s) => s.usersList || [], (s, r) => s === r && s.v === r.v), n = /* @__PURE__ */ S((s) => s.convsList || [], (s, r) => s === r && s.v === r.v), i = /* @__PURE__ */ S((s) => s.convsData), o = /* @__PURE__ */ z((s) => s.userPrivateWorkspaceData?.hiddenConvs || {}), a = /* @__PURE__ */ Y(() => n.map((s) => ({ id: s, label: i[s] && i[s].name, hasUnread: i[s] && i[s].hasUnread, hidden: !!o[s] })), [n, i, o]);
  return d(T, { children: [t(A2, {}), t(N2, { list: a }), t(T2, { list: e }), t($2, { list: e }), t(F2, {})] });
}, D2 = l.div`
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 13px;

  h4 {
    text-transform: uppercase;
    padding: 0 7px 0 0;
    white-space: nowrap;
  }
`, z2 = l.div`
  display: flex;
  margin: 0 -7px 0 0;
`, P2 = l.div`
  width: 100%;
  height: 1px;
  background: #fff;
  opacity: 0.2;
`, _2 = l.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h5 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, j2 = l.div`
  &.min {
    display: none;
    .minbtn {
      transform: rotate(180deg);
    }
  }
`, F2 = l.div`
  height: 17px;
`, Ba = ({ defaultLinkUrl: e, defaultLinkTitle: n, update: i, onSubmit: o, onDelete: a }) => {
  const { t: s } = /* @__PURE__ */ x("office"), r = /* @__PURE__ */ k({ linkUrl: e, linkTitle: n }), c = /* @__PURE__ */ k(Ts(r.current)), [p, u] = /* @__PURE__ */ m(e), [h, f] = /* @__PURE__ */ m(false), v = i && a, g = (y) => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(y);
  return d(xe, { children: [d(O2, { children: [t("div", { style: { textAlign: "center" }, children: t("h4", { className: "secFontTxtBig", children: s(i ? "update-link-url" : "add-link-url-office") }) }), t(W, { label: "link-url-title", children: t("input", { defaultValue: n, type: "text", onChange: (y) => {
    c.current.linkTitle = y.target.value;
  } }) }), t(W, { label: "link-url-url", children: t("input", { defaultValue: e, type: "text", onChange: (y) => {
    c.current.linkUrl = y.target.value, u(y.target.value);
  } }) }), h ? t(we, { label: "enter-valid-url" }) : null] }), d(ye, { className: v ? "sptw" : "center", children: [v ? t(et, { label: "delete", action: a, tr: "office" }) : null, t(B, { label: "save", tr: "office", disable: !p, onClick: async () => {
    const y = c.current.linkUrl;
    if (!(!o || !y)) {
      if (!g(y)) {
        f(true);
        return;
      }
      await o(c.current);
    }
  }, cls: "white" })] })] });
}, O2 = l.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  h4 {
    text-transform: uppercase;
    padding: 0 0 5px;
  }
`, B2 = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = ["confetti", "balloon-blue", "balloon-red", "balloon-yellow", "cyber_cheering", "main_dance", "soul_cheering"];
  return d(Z2, { children: [t("p", { className: "gvt", dangerouslySetInnerHTML: { __html: e("gong-visual") } }), t(q2, { children: t(G2, { children: n.map((i) => t("img", { className: i, src: M[`/office/gong/${i}.webp`], alt: i }, i)) }) }), t("div", { className: "btm", children: t("img", { src: M["/office/gong/bg.webp"], alt: "light" }) })] });
}, U2 = () => {
  const [e, n] = /* @__PURE__ */ m(false), [i, o] = /* @__PURE__ */ m(""), { t: a } = /* @__PURE__ */ x("office"), s = async () => {
    n(true);
    const { sendGong: r } = /* @__PURE__ */ N(), { microverseId: c } = /* @__PURE__ */ R(), { success: p, gongId: u } = await r(i, c);
    p ? (C((h) => ({ gongsData: { ...h.gongsData, [u]: { message: i, reactions: {}, seen: [], createdAt: { _seconds: Date.now() / 1e3, _milliseconds: Date.now() } } } })), b("gong", u), b("closeModal")) : n(false);
  };
  return t(W2, { children: d(V2, { className: "anim", children: [t(te, { title: "gong-name", desc: "gong-desc", tr: "office" }), d("div", { className: "cnt", children: [t(W, { children: t("textarea", { type: "text", placeholder: a("gong-placeholder"), className: "normalTxt", onChange: (r) => {
    o(r.target.value);
  }, value: i }) }), t("p", { className: "tips", children: a("gong-tips") })] }), t(B, { label: e ? "loading" : "celebrate", onClick: s, cls: "white", arrow: !e, disable: e || i.length === 0, tr: "office" })] }) });
}, R2 = () => d(H2, { children: [t(B2, {}), t(U2, {})] }), H2 = l.div`
  display: flex;

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
  }
`, W2 = l.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .tdc {
    text-align: center;
  }

  .cnt {
    width: 100%;
  }

  textarea {
    width: 100%;
    min-height: 120px;
    max-height: 180px;
    max-width: 326px;
    min-width: 326px;
    letter-spacing: 0;
    color: #fff;
  }

  .tips {
    padding: 4px 0 0;
    font-family: 'Mundial';
    font-weight: 200;
    font-size: 9px;
    line-height: 15px;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    max-width: 326px;
  }

  @media (max-width: 720px) {
    height: auto;
    min-width: 100%;

    textarea {
      min-width: 100%;
      max-width: 100%;
    }
  }
`, V2 = l.div`
  transition: transform 0.6s ease;
  transform: translate3d(0, 100%, 0);
  width: 100%;
  min-width: 426px;
  height: 100%;
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;

  @media (max-width: 900px) {
    padding: 30px 20px;
    min-width: 366px;
  }

  @media (max-width: 720px) {
    height: auto;
    min-width: 100%;
  }
`, Z2 = l.div`
  position: relative;
  min-width: 413px;
  height: 513px;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;

  /* background: linear-gradient(164.75deg, #91adf3 0.5%, #0f40bc 63.46%); */

  p {
    position: absolute;
    z-index: 4;
    left: 0;
    width: 100%;
    top: 72px;
    font-family: 'Mundial';
    font-style: italic;
    font-weight: 700;
    font-size: 35px;
    line-height: 42px;
    text-align: center;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    text-shadow: 0px 0px 25.4141px rgba(13, 56, 176, 0.5);

    opacity: 0;
    transform: translate3d(0, 60px, 0);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .btm {
    position: absolute;
    z-index: 0;
    left: 0;
    width: 100%;
    top: 0;
    height: 100%;
    overflow: hidden;

    &::before,
    &::after {
      content: '';
      position: absolute;
    }

    img {
      position: absolute;
      left: 0;
      width: 100%;
      top: 0;
      height: 100%;
      object-fit: cover;
      object-position: top center;
      clip-path: none;
      z-index: 1;
      opacity: 0;
      transition: opacity 0.5s ease;
    }

    &::before {
      left: 0;
      width: 100%;
      top: 0;
      height: 100%;
      background: linear-gradient(164.75deg, #91adf3 0.5%, #0f40bc 63.46%);
      transform: translate3d(100%, 0, 0);
      transition: transform 0.3s ease 0.2s;
    }

    &::after {
      bottom: -120px;
      left: -25px;
      width: calc(100% + 50px);
      height: 200px;
      background: linear-gradient(202deg, #ffe7a2 42%, #bf41ed 95%);
      transform: rotate(0deg) translate3d(0, 120px, 0);
      mix-blend-mode: screen;
      z-index: 2;
      transition: transform 0.5s ease;
    }
  }

  @media (max-width: 800px) {
    min-width: 370px;
  }

  @media (max-width: 760px) {
    min-width: 320px;
  }

  @media (max-width: 720px) {
    width: 100%;
    height: 120vw;
    overflow: hidden;
    border-radius: 0;

    p {
      font-size: 6.5vw;
      line-height: 7.5vw;
      top: 12vw;
    }
  }
`, G2 = l.div`
  position: absolute;
  z-index: 2;
  left: 0;
  width: 100%;
  top: 0;
  height: 100%;
  overflow: hidden;
`, q2 = l.div`
  position: absolute;
  z-index: 2;
  left: -20px;
  width: calc(100% + 40px);
  top: 0;
  height: 100%;
  img {
    position: absolute;
    clip-path: none;
    height: auto;
    z-index: 0;
  }

  .balloon-blue {
    /* width: 83px;
    height: 134px; */
    // get percentage value from width 453px
    width: 18.3036%;
    right: -1.55%;
    bottom: 8.2%;
  }
  .balloon-red {
    /* width: 114px;
    height: 164px; */
    // get percentage value from width 453px
    width: 25.1656%;
    bottom: 0;
    left: 1.2%;
  }
  .balloon-yellow {
    /* width: 72px;
    height: 131px; */
    // get percentage value from width 453px
    width: 15.8893%;
    left: 23.7%;
    top: 27.35%;
  }

  .balloon-blue,
  .balloon-red,
  .balloon-yellow {
    transition: transform 0.5s ease;
    transform: translate3d(0, 200px, 0);
  }

  .balloon-yellow {
    transform: translate3d(0, 400px, 0);
  }

  .confetti {
    top: 2.7%;
    left: 50%;
    /* width: 484px; */
    /* height: 383px; */
    // get percentage value from width 453px
    min-width: 102%;

    transform: translate3d(-50%, 0, 0) scale(0);
    transition: transform 0.4s ease;
    transform-origin: top center;
  }

  .cyber_cheering,
  .main_dance,
  .soul_cheering {
    bottom: 0;
    transition: transform 0.5s ease;
    transform: translate3d(0, 100%, 0);
  }

  .cyber_cheering {
    /* width: 166px; */
    /* height: 333px; */
    // get percentage value from width 453px
    width: 36.5934%;
    left: 29%;
    z-index: 3;
  }

  .main_dance {
    /* width: 184px;
    height: 301px; */

    // get percentage value from width 453px
    width: 40.6176%;
    left: 1%;
  }

  .soul_cheering {
    /* width: 233px;
    height: 298px; */
    // get percentage value from width 453px
    width: 51.4383%;
    right: -1.1%;
  }
`, Y2 = ({ data: e }) => {
  const n = /* @__PURE__ */ k(null), i = /* @__PURE__ */ k(null), { t: o } = /* @__PURE__ */ x("office");
  return d("li", { children: [t("input", { style: { display: "none" }, type: "file", accept: ".jpg, .png, .jpeg, .pdf", onChange: (s) => {
    b("dropFile", s.target.files[0]);
  }, ref: n }), d(Ua, { ref: i, onClick: () => {
    n?.current?.click(), i.current && i.current.blur();
  }, children: [d("div", { children: [t("img", { src: M[e.icons], alt: o(e.label) }), t("p", { className: "secFontTxtSml", children: o(e.label) })] }), t(mi, {})] })] });
}, K2 = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("office");
  return t("li", { children: d(Ua, { onClick: e.action, children: [d("div", { children: [t("img", { src: M[e.icons], alt: n(e.label) }), t("p", { className: "secFontTxtSml", children: n(e.label) })] }), t(mi, {})] }) });
}, J2 = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = /* @__PURE__ */ z((o) => o.isAdmin);
  return t(X2, { children: [{ id: "gong", icons: "/icons/admin/gong.svg", label: "gong-celeb", action: () => {
    b("openModalGong", t(R2, {}));
  } }, { id: "url", icons: "/icons/tools/3d-url.svg", label: "share-3d-url", action: () => {
    b("openModal", t(Ba, { onSubmit: async ({ linkUrl: o, linkTitle: a }) => {
      b("showSpinnerLoader", true);
      const { id: s, user: r } = /* @__PURE__ */ $(), p = on().playersMeshes[s], u = new Lt(), h = new Lt();
      p.getWorldPosition(u), p.getWorldDirection(h);
      const f = [u.x + h.x, u.y + h.y + 1, u.z + h.z], v = await r.getIdToken(), { workspace: g, microverseId: y } = /* @__PURE__ */ R(), L = await fetch(`${gi(g)}/api/${y}/shared/link-url/create`, { method: "POST", body: JSON.stringify({ position: f, metadata: { linkUrl: o, linkTitle: a } }), headers: { authorization: `Bearer ${v}` } }), { success: I } = await L.json();
      I || b("notification:error", { message: e("unexpected-error") }), b("showSpinnerLoader", false), b("closeModal");
    }, onCancel: () => {
      b("closeModal");
    }, update: false }));
  } }, { id: "postit", icons: "/icons/tools/3d-postit.svg", label: "share-3d-postit", action: () => {
    b("openModalUnclose", t(Q2, { children: t(Ns, { onSubmit: async ({ boardName: o }) => {
      b("showSpinnerLoader", true);
      const { id: a, user: s } = /* @__PURE__ */ $(), c = on().playersMeshes[a], p = new Lt(), u = new Lt();
      c.getWorldPosition(p), c.getWorldDirection(u);
      const h = [p.x + u.x, p.y + u.y + 1, p.z + u.z], f = await s.getIdToken(), { workspace: v, microverseId: g } = /* @__PURE__ */ R();
      await (await fetch(`${gi(v)}/api/${g}/shared/post-it/create`, { method: "POST", body: JSON.stringify({ position: h, metadata: { postItBoard: [{ id: 0, title: o || "New Post-It", position: [0, 0], content: "", order: 0, colorVariant: 0 }] } }), headers: { authorization: `Bearer ${f}` } })).json(), b("showSpinnerLoader", false), b("closeModal");
    }, onCancel: () => {
      b("closeModal");
    }, update: false }) }));
  } }, { id: "file", icons: "/icons/tools/import-file.svg", label: "share-3d-file", action: () => {
  } }, n && { id: "whiteboard-test", icons: "/icons/tools/import-file.svg", label: "Whiteboard Test", action: () => {
    b("openModal", t(As, { whiteboardId: "AArA5PtcKM8VnKPsAOKU" }));
  } }].filter(Boolean).map((o) => o.id !== "file" ? t(K2, { data: o }, o.id) : t(Y2, { data: o }, o.id)) });
}, X2 = l.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;

  li {
    position: relative;
  }
`, Ua = l.button`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  gap: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;

  text-transform: capitalize;

  img {
    width: 20px;
    height: auto;
    clip-path: none;
  }

  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  svg {
    width: 10px;
    height: auto;
  }

  div,
  svg {
    position: relative;
    z-index: 1;
  }

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0;
      transition: opacity 0.2s ease;
      border-radius: 10px;
    }

    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }
`, Q2 = l.div`
  min-width: 600px;

  @media all and (max-width: 600px) {
    min-width: auto;
    max-width: 100%;
  }
`, ex = ({ emailTo: e }) => {
  const { t: n } = /* @__PURE__ */ x("office");
  return d(ox, { children: [t("img", { src: M["/icons/admin/eye.svg"], alt: "success" }), d("div", { children: [t("h4", { className: "secFontTxtBig", children: n("thank-you") }), t("p", { dangerouslySetInnerHTML: { __html: n("need-help-success", { email: e }) } })] })] });
}, tx = ({ setFormSent: e, setEmailTo: n }) => {
  const [i] = /* @__PURE__ */ O((g) => [g.user]), o = /* @__PURE__ */ k(null), a = /* @__PURE__ */ k(null), s = /* @__PURE__ */ k(null), [r, c] = /* @__PURE__ */ m(""), [p, u] = /* @__PURE__ */ m(""), [h, f] = /* @__PURE__ */ m(""), v = async () => {
    const g = o.current.value, y = a.current.value, L = s?.current?.value || i?.email;
    g.length === 0 || y.length === 0 || L.length === 0 || (C({ showSpinnerLoader: true }), await $().user.getIdToken(), window.location.href, i?.uid, C({ showSpinnerLoader: false }), n(L), e(true));
  };
  return d(T, { children: [t(W, { label: "need-help-form-title", tr: "office", children: t("input", { id: "need-help-form-title", type: "text", ref: o, defaultValue: "", onChange: (g) => c(g.target.value) }) }), t(W, { label: "need-help-form-content", tr: "office", children: t("textarea", { id: "need-help-form-content", type: "text", ref: a, defaultValue: "", onChange: (g) => u(g.target.value) }) }), i?.email ? null : t(W, { label: "your-email", tr: "office", children: t("input", { id: "your-email", type: "email", defaultValue: "", ref: s, onChange: (g) => f(g.target.value) }) }), t(ax, { children: t(B, { label: "send", onClick: v, cls: "white", arrow: false, disable: !r || !p || !h && !i?.email, tr: "office" }) })] });
}, nx = () => {
  const [e, n] = /* @__PURE__ */ m(false), [i, o] = /* @__PURE__ */ m("");
  return t(ix, { children: e ? t(ex, { emailTo: i }) : t(tx, { setFormSent: n, setEmailTo: o }) });
}, ix = l.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;

  input,
  textarea {
    color: #fff;
  }

  textarea {
    min-height: 182px;
    min-width: 100%;
    max-width: 100%;
    max-height: 400px;
  }
`, ox = l.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  text-align: center;

  h4 {
    text-transform: uppercase;
    padding: 0 0 5px;
  }

  img {
    width: 50px;
    height: auto;
    clip-path: none;
  }
`, ax = l.div`
  padding: 10px 0 30px;
  button {
    width: 100%;
  }
`, sx = ({ actions: e }) => {
  const n = /* @__PURE__ */ k(null);
  return t(ux, { children: e.map((i, o) => t("li", { children: t(hx, { ref: n, className: i.cls, onClick: () => {
    i.onClick && i.onClick(), n.current && n.current.blur();
  }, children: t("img", { src: M[i.icon], alt: i.alt }) }) }, o)) });
}, Ra = ({ data: e, highlight: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(px, { className: n ? "highlight" : "", children: [t("h3", { className: "secFontTxtBig", children: e?.title ? e.title : i(e?.id) }), e?.actions ? t(sx, { actions: e?.actions }) : null] });
}, rx = ({ subMenuOffice: e }) => {
  const n = /* @__PURE__ */ $(), i = z((c) => c.usersById[n?.id]?.accountType) || 10, o = n?.isAnonymous || i === 10, a = /* @__PURE__ */ z((c) => c.isAdmin), r = /* @__PURE__ */ [!o || a ? { id: "workspace", content: t(l2, {}), actions: n?.isAdmin || i >= 900 || a ? [{ icon: "/icons/admin/workspace-settings.svg", alt: "workspace-settings", onClick: () => {
    window.open("/admin", "_blank");
  } }] : null } : null, !o || a ? { id: "users", content: t(E2, {}) } : null, !o || a ? { id: "notifications", content: t(Ym, {}) } : null, !o || a ? { id: "tools", content: t(J2, {}) } : null, { id: "settings", content: t(Aa, { office: true }) }, { id: "help", content: t(nx, {}) }].filter((c) => c !== null).find((c) => c.id === e);
  return t(Ha, { children: d(dx, { children: [t(Ra, { data: r }), r?.content] }) });
}, lx = () => {
  const e = /* @__PURE__ */ k(null), [n, i] = /* @__PURE__ */ m(false), o = /* @__PURE__ */ S((s) => s.subMenuOffice), a = () => {
    N().subMenuOffice !== "" && (i(false), e.current = setTimeout(() => {
      C({ subMenuOffice: "" });
    }, 300));
  };
  return j("closeSubMenu", () => {
    a();
  }), j("openSubMenu", (s) => {
    clearTimeout(e.current), s !== N().subMenuOffice ? (C({ subMenuOffice: s }), i(true)) : a();
  }), t(cx, { className: n ? "show" : "", children: o !== "" ? d(T, { children: [t(rx, { subMenuOffice: o }), t(Kg, { subMenuOffice: o, close: !n })] }) : null });
}, cx = l.div`
  position: fixed;
  right: 50px;
  top: 0;
  height: 100%;
  width: 318px;
  background: #2d2d2d;
  z-index: 0;
  transform: translate3d(100%, 0, 0);
  transition: transform 0.3s ease;
  &.show {
    transform: translate3d(0, 0, 0);
    transition-duration: 0.5s;
  }

  @media all and (max-width: 767px) {
    top: 50px;
    height: calc(100% - 50px);
    right: 0;
    z-index: 2;
    width: 100%;
  }
`, Ha = l.div`
  height: 100%;
  max-height: 100%;
  overflow: auto;
  pointer-events: all;
`, dx = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 100%;
`, px = l.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 0 20px;
  min-height: 75px;
  border-bottom: solid 1px #222222;

  h3 {
    text-transform: uppercase;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.highlight {
    position: relative;
    z-index: 2;
    background: #313030;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  }
`, ux = l.ul`
  display: flex;
  align-items: center;
  gap: 5px;
`, hx = l.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0.6;
  border-radius: 50%;

  img {
    position: relative;
    z-index: 1;
    width: 17px;
    height: auto;
    clip-path: none;
  }

  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      transform: scale(0) translateZ(0);
      transition: transform 0.3s ease;
      background: #000;
    }
    &:hover {
      &::before {
        transform: scale(1) translateZ(0);
      }
    }
  }

  @media all and (max-width: 767px) {
    &.nosp {
      display: none;
    }
  }
`, fx = () => {
  const e = /* @__PURE__ */ O((o) => o.id), n = z((o) => o.usersById[e]?.status?.id) || "default", i = n !== "default" ? pt(n) : null;
  return d(gx, { children: [t("div", { style: { width: "35px", height: "35px" }, children: t(Ot, {}) }), i && i.id !== "default" ? t(xx, { children: t("img", { src: M[i.icon], alt: i.id }) }) : null] });
}, mx = ({ show: e }) => {
  const n = /* @__PURE__ */ S((i) => i.openModal === J.PROFIL);
  return t(ge, { visual: t(fx, {}), label: "your-profile", show: e, disabled: n, action: () => {
    C({ openModal: n ? "" : J.PROFIL });
  } });
}, gx = l.div`
  position: relative;
`, xx = l.div`
  position: absolute;
  right: -3px;
  top: -3px;
  z-index: 2;

  img {
    width: 14px;
    height: 14px;
    clip-path: none;
  }
`, vx = ({ title: e, desc: n, tr: i = "office" }) => {
  const { t: o } = /* @__PURE__ */ x(i), [a, s] = /* @__PURE__ */ m(false);
  return ue(() => {
    setTimeout(() => {
      s(true);
    }, 1);
  }, []), d(bx, { className: `${a ? "show" : ""}`, children: [t("h5", { className: "secFontTxtSml", children: o(e) }), t("p", { children: o(n) })] });
}, bx = l.div`
  position: absolute;
  top: 50%;
  right: 65px;
  z-index: 10;

  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 5px;
  isolation: isolate;

  background: #2d2d2d;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.4);
  border-radius: 10px;

  min-width: 300px;

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.03em;
  }

  pointer-events: none;
  opacity: 0;
  transform: translate3d(-20px, -50%, 0);
  transition: opacity 0.2s ease, transform 0.4s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    right: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px 0 12px 12px;
    border-color: transparent transparent transparent #2d2d2d;
  }

  &.show {
    opacity: 1;
    transform: translate3d(0, -50%, 0);
  }

  @media all and (max-width: 767px) {
    position: fixed;
    top: 60px;
    right: auto;
    left: 50%;
    transform: translate3d(-50%, 20px, 0);
    &::after {
      display: none;
    }
    &.show {
      transform: translate3d(-50%, 0, 0);
    }
  }
`, wx = () => t($x, { children: t("span", { children: "3" }) }), Wa = ({ data: e, disable: n, userNotLoggedIn: i }) => {
  const o = /* @__PURE__ */ k(null), a = /* @__PURE__ */ K("isMobile"), s = /* @__PURE__ */ S((h) => h.subMenuOffice), [r, c] = /* @__PURE__ */ m(false), p = /* @__PURE__ */ k(null), u = (h) => {
    n ? a && (r || b("openGuestLimitationTooltip"), c(!r), clearTimeout(p.current), p.current = setTimeout(() => {
      c(false);
    }, 3e3)) : (b("openSubMenu", h), b("closeDetailMenu")), i && !a && n && b("showLoginModal");
  };
  return j("openGuestLimitationTooltip", () => {
    c(false);
  }), d(Lx, { children: [d(Ix, { ref: o, className: `${e.id || ""} ${s === e.id ? "active" : ""} ${n ? "" : "not-disabled"}`, onClick: () => {
    u(e.id), o.current && o.current.blur();
  }, onMouseEnter: n && !a ? () => {
    c(true);
  } : null, onMouseLeave: n && !a ? () => {
    c(false);
  } : null, children: [e.id === "notifications" ? t(wx, {}) : null, t("img", { src: e.external ? e.icon : M[e.icon], alt: e.label })] }), n && r && e.id !== "workspace" ? t(vx, { title: e.disableTitle ? e.disableTitle : "exclusive-member-feature-ttl", desc: e.disableDesc ? e.disableDesc : "exclusive-member-feature-desc" }) : null] });
}, yx = ({ disable: e }) => {
  const n = /* @__PURE__ */ S((o) => o.workspaceDoc), i = /* @__PURE__ */ Ne(n && n.logoUuid ? `${Ae.workspaceStorage}workspacelogo.webp?v=${n.logoUuid}` : null, null);
  return t(Wa, { data: { id: "workspace", icon: i || "/placeholder/workspace-icon-placeholder.webp", external: !!i, label: "workspace" }, disable: e });
}, Cx = () => {
  const e = /* @__PURE__ */ O((r) => r.user), n = z((r) => r.usersById[e?.uid]?.accountType) || 10, i = e?.isAnonymous || n === 10, o = /* @__PURE__ */ z((r) => r.isAdmin), a = e?.isAnonymous;
  return d(Va, { className: "omai", children: [t(q, { fallback: null, children: t(yx, { disable: i && !o }) }), [{ id: "users", icon: "/icons/admin/people.svg", label: "users" }, { id: "tools", icon: "/icons/admin/tools.svg", label: "tools" }, { id: "settings", icon: "/icons/admin/settings.svg", label: "settings" }, { id: "help", icon: "/icons/admin/help.svg", label: "need-help-menu" }].map((r) => t(Wa, { data: r, userNotLoggedIn: a, disable: i && !o && r.id !== "settings" && r.id !== "help" }, r.id))] });
}, kx = () => {
  const e = /* @__PURE__ */ K("isMobile");
  return d(Va, { className: "uma", children: [t(q, { fallback: null, children: t(fo, { show: true }) }), t(wo, { show: true }), e ? null : t(Dt, { show: true }), t(Pt, { show: true }), t(zt, { show: true }), t(mx, { show: true })] });
}, Sx = () => d(Mx, { children: [t(Cx, {}), t(kx, {})] }), Mx = l.div`
  pointer-events: all;
  position: relative;
  z-index: 1;
  width: 50px;
  height: 100%;

  background: #222222;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media all and (max-width: 767px) {
    width: auto;
    height: auto;
    background: none;
  }
`, Va = l.div`
  display: flex;
  flex-direction: column;

  .tt {
    top: 50%;
    left: auto;
    right: 55px;
    transform: translate3d(0, -50%, 0) scaleX(0);
  }

  @media all and (pointer: fine) {
    button {
      &:hover {
        .tt {
          transform: translate3d(0, -50%, 0) scaleX(1);
        }
      }
    }
  }

  &.uma {
    padding: 0 0 5px;
    button {
      padding: 5px 7px;
    }
    .cbn {
      width: 36px;
      height: 36px;
    }

    .icn-emote {
      width: 16px;
    }

    .quickemoji {
      img {
        width: 17px;
      }
    }

    .sv {
      bottom: auto;
      top: -11px;
      left: 50%;
      transform: translateX(-50%);
    }

    img {
      clip-path: none;
    }
  }

  @media all and (max-width: 767px) {
    position: fixed;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    left: 0;
    right: 0;
    background: #222222;
    &.uma {
      bottom: 0;
      padding: 5px 13px;
    }
    &.omai {
      top: 0;
    }
  }
`, Lx = l.div`
  position: relative;
  @media all and (max-width: 767px) {
    width: 100%;
  }
`, Ix = l.button`
  position: relative;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.workspace {
    &::before {
      display: none;
    }
    img {
      opacity: 1;
      width: 100%;
      height: 100%;
      object-fit: cover;
      clip-path: none;
      max-width: 50px;
    }
  }

  &.users {
    img {
      width: 21px;
    }
  }

  &.meeting {
    img {
      width: 19px;
    }
  }

  &.notifications {
    img {
      width: 17px;
    }
  }

  &.settings {
    img {
      width: 24px;
    }
  }

  &.help {
    img {
      width: 20px;
    }
  }

  &.tools {
    img {
      width: 18px;
    }
  }

  img {
    position: relative;
    z-index: 1;
    opacity: 0.7;
    transition: opacity 0.2s ease;
    clip-path: none;
    transform: translateZ(0.01px);
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
  }

  &.not-disabled {
    &::before {
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      background: #333333;
      transform: translate3d(100%, 0, 0);
      transition: transform 0.2s ease;
    }
  }

  &::after {
    z-index: 1;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    top: 50%;
    right: 0;
    transform: translate3d(100%, -50%, 0);
    transition: transform 0.2s ease;
  }

  &.active {
    img {
      opacity: 1;
    }
    &::before {
      transform: translate3d(0, 0, 0);
    }
    &::after {
      transform: translate3d(50%, -50%, 0);
    }
  }

  &.disable {
    pointer-events: none;
    img {
      opacity: 0.3;
    }

    &.workspace {
      img {
        opacity: 1;
      }
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      &::before {
        transform: translate3d(0, 0, 0);
      }
      img {
        opacity: 1;
      }
    }
  }

  @media all and (max-width: 767px) {
    overflow: hidden;
    width: 100%;

    &::before {
      transform: translate3d(0, -100%, 0);
    }

    &::after {
      top: auto;
      left: 50%;
      right: auto;
      bottom: 0;
      transform: translate3d(-50%, 100%, 0);
    }

    &.active {
      &::after {
        transform: translate3d(-50%, 50%, 0);
      }
    }
  }
`, $x = l.div`
  position: absolute;
  top: 10px;
  left: calc(50% + 3px);

  width: 13px;
  height: 13px;
  padding: 3px;
  background: #f33182;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Mundial';
  color: #fff;
  font-size: 11px;
  line-height: 17px;
  letter-spacing: 0.04em;
`, Tx = () => d(Nx, { children: [t(Sx, {}), t(lx, {})] }), Nx = l.div`
  position: fixed;
  width: 50px;
  height: 100%;
  right: 0;
  top: 0;
  z-index: 1;
`, Ax = () => {
  const e = /* @__PURE__ */ O((a) => a.user), n = z((a) => a.usersById[e?.uid]?.accountType) || 10, i = e?.isAnonymous || n === 10, o = /* @__PURE__ */ z((a) => a.isAdmin);
  return i && !o ? null : d(T, { children: [t(qm, {}), t(jo, {})] });
}, Ex = () => {
  const e = /* @__PURE__ */ nt("isMobile");
  return d(T, { children: [!e && d(T, { children: [t(Xn, {}), t(ti, {})] }), t(Jn, { office: true }), t(Gt, { office: true }), t(ei, { office: true }), t(En, {})] });
}, Dx = ({ children: e }) => {
  const [n, i] = /* @__PURE__ */ z((o) => [o.disableUI, o.editorMode]);
  return w(() => {
    window && he().checkAuthStatus();
  }, []), d(zx, { className: n || i ? "hide" : "", children: [t(ni, {}), t(qn, {}), t(za, {}), t(Tx, {}), t(Hn, {}), t(Ex, {}), t(jn, {}), t(Ut, {}), t(Fn, {}), t(Ax, {}), e, t(Im, {}), t(Nm, {})] });
}, zx = l.div`
  position: fixed;
  inset: 0;
  z-index: 1;
  &.hide {
    display: none;
  }
`, Za = () => {
  localStorage.setItem("tutorial-office", true), C({ hideUI: false });
}, Px = () => (ve((e) => e.lang), w(() => () => {
  Za();
}, []), t(_x, { children: t(jx, { children: t(te, { title: "office-tutorial", desc: "office-tutorial-desc", tr: "office" }) }) })), _x = l.div`
  width: 620px;
  max-width: 100%;

  @media all and (max-width: 767px) {
    width: 100%;
  }
`, jx = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  h1,
  p {
    text-align: center;
  }

  video {
    min-width: 620px;
    max-width: 100%;
    height: auto;
  }

  @media all and (max-width: 767px) {
    video {
      min-width: 100%;
    }
  }
`, Kt = () => t("img", { src: M["/icons/logo.svg"], alt: "KONPI", width: "130px", height: "43px" }), Fx = ({ color: e = "#fff" }) => d("svg", { width: "220", height: "45", viewBox: "0 0 780 159", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.535 14.576c-14.704 0-21.959 8.388-21.959 15.44 0 3.159 1.61 6.21 5.871 9.102 4.383 2.974 10.944 5.259 18.82 6.417 8.588 1.263 17.635 3.165 24.61 7.46 3.619 2.227 6.842 5.19 9.127 9.154 2.294 3.98 3.407 8.562 3.407 13.66 0 9.147-5.059 16.82-12.026 21.943-6.971 5.125-16.25 8.073-26.18 8.073-9.928 0-19.207-2.948-26.178-8.073C5.059 92.63 0 84.956 0 75.808a7.288 7.288 0 1 1 14.576 0c0 3.405 1.862 7.096 6.084 10.2 4.22 3.101 10.399 5.24 17.546 5.24s13.326-2.139 17.545-5.24c4.223-3.104 6.084-6.795 6.084-10.2 0-2.924-.62-4.923-1.46-6.38-.848-1.471-2.158-2.802-4.139-4.021-4.221-2.6-10.633-4.207-19.09-5.451-9.172-1.349-18.07-4.153-24.884-8.777C5.326 46.472 0 39.41 0 30.017 0 11.964 17.087 0 36.535 0c13.376 0 28.307 6.424 34.85 23.575a7.288 7.288 0 1 1-13.618 5.196c-3.913-10.257-12.45-14.195-21.233-14.195Z", fill: e }), t("path", { d: "M140.675 11.673c-2.179-3.09-6.417-4.004-9.374-1.647-12.121 9.66-19.89 24.55-19.89 41.254 0 29.117 23.605 52.721 52.722 52.721 29.118 0 52.722-23.604 52.722-52.722 0-16.857-7.911-31.866-20.224-41.517-2.952-2.314-7.149-1.398-9.316 1.664-2.466 3.483-1.31 8.308 1.904 11.116 8.004 6.993 13.06 17.275 13.06 28.737 0 21.068-17.079 38.146-38.146 38.146s-38.146-17.078-38.146-38.145c0-11.354 4.961-21.55 12.833-28.538 3.172-2.815 4.3-7.603 1.855-11.069Z", fill: e }), t("path", { d: "M166.045 14.685a2 2 0 0 1-3.268 0l-8.14-11.532C153.702 1.83 154.649 0 156.271 0h16.28c1.622 0 2.569 1.829 1.634 3.153l-8.14 11.532ZM304.577 90.868c21.068 0 38.146-17.079 38.146-38.146V7.289a7.289 7.289 0 0 1 14.576-.001v45.434c0 29.117-23.604 52.722-52.722 52.722-29.117 0-52.722-23.605-52.722-52.722V7.288a7.288 7.288 0 0 1 14.577 0v45.434c0 21.067 17.078 38.146 38.145 38.146Z", fill: e }), t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M445.15 14.832c-21.068 0-38.146 17.078-38.146 38.146 0 21.067 17.078 38.146 38.146 38.146 21.067 0 38.146-17.079 38.146-38.146 0-21.068-17.079-38.146-38.146-38.146Zm-52.722 38.146c0-29.118 23.604-52.722 52.722-52.722 29.117 0 52.722 23.604 52.722 52.722 0 29.117-23.605 52.722-52.722 52.722-29.118 0-52.722-23.605-52.722-52.722Z", fill: e }), t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M490.584 45.188a7.288 7.288 0 0 1 7.288 7.288v53.791c0 29.117-23.604 52.722-52.722 52.722-23.932 0-44.122-15.94-50.568-37.766a7.288 7.288 0 0 1 13.979-4.129c4.667 15.8 19.292 27.318 36.589 27.318 21.068 0 38.146-17.078 38.146-38.145v-53.79a7.288 7.288 0 0 1 7.288-7.288Z", fill: e }), t("path", { d: "M484.983 3.851C483.807 2.57 484.717.5 486.458.5h15.453a2 2 0 0 1 2 2v16.858c0 1.824-2.242 2.696-3.474 1.352L484.983 3.85Z", fill: e }), t("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M586.021 14.576c-21.068 0-38.146 17.079-38.146 38.146s17.078 38.146 38.146 38.146a37.939 37.939 0 0 0 21.483-6.62 7.288 7.288 0 0 1 8.22 12.037 52.51 52.51 0 0 1-29.703 9.159c-29.118 0-52.722-23.605-52.722-52.722C533.299 23.604 556.903 0 586.021 0c29.117 0 52.722 23.604 52.722 52.722v7.288h-52.722a7.288 7.288 0 0 1 0-14.576h37.45c-3.401-17.581-18.875-30.858-37.45-30.858ZM726.465 14.576c-21.067 0-38.146 17.079-38.146 38.146v45.433h-7.285 7.285a7.288 7.288 0 1 1-14.576.001h7.288-7.288v-85.53a7.288 7.288 0 0 1 14.576 0v3.702C697.92 6.268 711.461 0 726.465 0c29.118 0 52.722 23.604 52.722 52.722v45.434h-14.576V52.722c0-21.067-17.078-38.146-38.146-38.146Zm45.434 90.868a7.288 7.288 0 0 1-7.288-7.288h14.576a7.288 7.288 0 0 1-7.288 7.288Z", fill: e })] }), Ox = () => {
  const e = ae().lang;
  [].includes(e) ? b("openModal", t(Px, {})) : Za();
}, Bx = ({ children: e, isActive: n = false, progress: i = 0, isOffice: o, isSougen: a }) => {
  const s = /* @__PURE__ */ S((u) => u.forceShowLoader), [r, c] = /* @__PURE__ */ m(true), p = () => {
    const u = /* @__PURE__ */ localStorage.getItem(`tutorial${o ? "-office" : ""}`);
    if (b("tracking", { event: "custom_event", category: "loading", label: "load-complete" }), u)
      C({ hideUI: false });
    else if (o)
      Ox();
    else {
      const { sharedCamera: h } = /* @__PURE__ */ Mt();
      if (h.birdView) {
        C({ hideUI: false });
        return;
      }
      C({ showTutorial: true }), b("tracking", { event: "custom_event", category: "tutorial", label: "start-tutorial" });
    }
  };
  return w(() => {
    n ? (c(true), C({ hideUI: true }), b("tracking", { event: "custom_event", category: "loading", label: "load-start" })) : (C({ renderEmoji: false, hiderLoading: false }), setTimeout(() => {
      c(false);
    }, 100), setTimeout(() => {
      p();
    }, 800));
  }, [n]), d(Ux, { className: r || s ? "show" : "", children: [d(Rx, { children: [a ? t(Fx, {}) : t(Kt, {}), d("p", { children: [Math.floor(Math.min(100, i)), "%"] })] }), e] });
}, Ux = l.div`
  position: fixed;
  inset: 0;
  z-index: 12;
  display: flex;
  justify-content: center;
  align-items: center;

  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: #2d2d2d;
    z-index: 0;
    opacity: 0;
    transition: opacity 0.3s ease 0.1s;
  }

  &.show {
    pointer-events: all;
    &::before {
      opacity: 1;
      transition-delay: 0s;
    }
    img,
    svg,
    p {
      transform: translate3d(0, 0, 0);
    }

    img,
    svg {
      transition-delay: 0.1s;
    }

    p {
      transition-delay: 0.2s;
    }
  }
`, Rx = l.div`
  position: relative;
  overflow: hidden;
  z-index: 1;
  img,
  svg {
    width: 130px;
    height: auto;
    transition: transform 0.3s ease 0s;
    transform: translate3d(0, -100%, 0);
  }

  svg {
    width: 160px;
    margin: 0 0 10px;
  }

  p {
    text-align: center;
    display: block;
    color: #f33182;
    transition: transform 0.3s ease 0s;
    transform: translate3d(0, 100%, 0);
  }
`, Hx = () => {
  const e = /* @__PURE__ */ K("isMobile"), n = /* @__PURE__ */ S((r) => r.adminPanelOpen), { t: i } = /* @__PURE__ */ x(), o = /* @__PURE__ */ k(null), a = /* @__PURE__ */ ie((r) => r.showCallGrid), [s] = /* @__PURE__ */ z((r) => [r.editorMode]);
  return s ? null : d(Wx, { ref: o, className: `${n ? "open" : ""} ${e ? "sp" : ""} ${a ? "top" : ""}`, onClick: () => {
    C({ adminPanelOpen: !n }), o.current && o.current.blur();
  }, children: [t("img", { src: M["/icons/admin.svg"], alt: "admin" }), t("span", { className: "secfont", children: i("admin") })] });
}, Wx = l.button`
  position: fixed;
  top: 35px;
  right: 40px;
  transform: translate3d(0, 0, 0);
  transition: transform 0.6s ease;
  z-index: 1;
  pointer-events: all;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 25px;
  gap: 10px;

  background: rgba(45, 45, 45, 0.8);
  border-radius: 53px;

  img {
    width: 12px;
    height: auto;
  }

  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.1em;

  &.top {
    z-index: 100;
  }

  &.sp {
    top: 80px;
    right: 20px;
    z-index: 100;
  }

  &.open {
    transform: translate3d(-600px, 0, 0);

    @media all and (max-width: 768px) {
      transform: translate3d(-400px, 0, 0);
    }

    @media all and (max-width: 600px) {
      transform: none;
    }
  }
`, Vx = ({ user: e, listId: n }) => {
  const i = /* @__PURE__ */ S((r) => r.onMoreAction), o = R().live?.find((r) => r.userId === r.id)?.role === "anchor", { t: a } = /* @__PURE__ */ x("office"), s = /* @__PURE__ */ [{ action: () => {
    N().updateUserRoleLive(R().microverseId, e.id, o ? "audience" : "anchor");
  }, label: a(o ? "demote-speaker" : "promote-speaker") }, { action: () => {
    i(n, "kick_user", e);
  }, label: "kick_user", cls: "warning" }].filter(Boolean);
  return t(Ft, { actions: s, tooltip: "more_options", icon: t("img", { src: M["/icons/admin/more.svg"], alt: "more_actions" }), rightAlign: true });
}, Zx = ({ user: e, listId: n }) => {
  const i = /* @__PURE__ */ S((o) => o.acceptUser);
  return d(T, { children: [n !== "whitelist" ? t("li", { children: t(qe, { isAccept: true, action: () => {
    i(n, true, e);
  } }) }) : null, t("li", { children: t(qe, { action: () => {
    i(n, false, e);
  } }) })] });
}, Gx = ({ user: e, listId: n }) => (S((i) => i.openInfo), S((i) => i.directChat), d(T, { children: [t("li", { children: t(hp, { user: e }) }), t("li", { children: t(Vx, { listId: n, user: e }) })] })), qx = ({ user: e, listId: n }) => t(Yx, { children: ["guestlist", "live"].includes(n) ? t(Gx, { listId: n, user: e }) : t(Zx, { listId: n, user: e }) }), Yx = l.ul`
  display: flex;
  align-items: center;
`, Kx = ({ user: e, listId: n }) => d(Jx, { children: [t(Bt, { user: e, listId: n }), t(qx, { user: e, listId: n })] }), Jx = l.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`, Xx = ({ users: e, minimize: n, setMinimize: i, waiting: o }) => t(i5, { className: n ? "min" : "", children: t("li", { children: t(lt, { cls: "minbtn", label: "minimize", icon: t(ja, {}), action: () => {
  i(!n);
} }) }) }), Qx = ({ category: e, total: n, minimize: i, setMinimize: o, users: a, waiting: s }) => {
  const { t: r } = /* @__PURE__ */ x();
  return d(t5, { children: [d("h3", { children: [r(e), d("span", { children: ["(", n, ")"] })] }), t(n5, {}), t(Xx, { waiting: s, users: a, minimize: i, setMinimize: o })] });
}, Jt = ({ category: e, users: n, listId: i }) => {
  const [o, a] = /* @__PURE__ */ m(false), [s] = /* @__PURE__ */ O((r) => [r.id]);
  return d(e5, { children: [t(Qx, { users: n, category: e, total: n.length, minimize: o, setMinimize: a }), t(o5, { className: o ? "minimize" : "", children: n.map((r, c) => r.id !== s ? t(Kx, { user: r, listId: i }, c) : null) })] });
}, e5 = l.div``, t5 = l.div`
  display: flex;
  align-items: center;
  gap: 20px;

  h3 {
    display: flex;
    gap: 10px;
    line-height: 20px;
    white-space: nowrap;
    span {
      font-weight: 200;
      letter-spacing: 0.04em;
      opacity: 0.5;
    }
  }
`, n5 = l.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
`, i5 = l.ul`
  display: flex;
  align-items: center;

  .minbtn {
    transition: transform 0.3s ease;
    transform: rotate(0deg) translateZ(0);
  }

  &.min {
    .minbtn {
      transform: rotate(180deg) translateZ(0);
      path {
        fill: #fff;
      }
    }
  }
`, o5 = l.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 25px 0 15px;

  &.minimize {
    display: none;
  }
`, a5 = () => {
  const [e, n, i] = /* @__PURE__ */ z((o) => [o.microverseWaitlistLive, o.microverseWhitelistLive, o.microverseGuestsLive]);
  return d(s5, { children: [t(Jt, { listId: "waitlist", category: "waiting", users: e }), t(Jt, { listId: "guestlist", category: "guests", users: i }), t(Jt, { listId: "whitelist", category: "whitelisted", users: n })] });
}, s5 = l.div`
  padding: 50px 30px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media all and (max-width: 768px) {
    padding: 50px 20px;
  }
`, r5 = () => {
  const [e] = /* @__PURE__ */ Ce((n) => [n.peers]);
  return e ? t(Jt, { category: "participants", users: [...e].map(([n, i]) => ({ id: i.peerId, name: i.name, avatar: i.avatar, status: i.status })), listId: "live" }) : null;
}, l5 = () => {
  const e = /* @__PURE__ */ wn(), [n, i] = /* @__PURE__ */ m(false);
  return w(() => {
    const o = /* @__PURE__ */ setTimeout(() => {
      i(true);
    }, 1);
    return () => clearTimeout(o);
  }, []), d(p5, { children: [t(Pt, { show: n }), t(zt, { show: n }), e ? null : t(Dt, { show: n })] });
}, c5 = () => {
  const { t: e } = /* @__PURE__ */ x("office"), [n, i] = /* @__PURE__ */ We((s) => [s.isJoiningCall, s.meetingId]), o = () => {
  }, a = () => {
    b("stop_stream");
  };
  return d(d5, { children: [t("h2", { children: e("stream") }), t(B, { label: i ? "stop-live" : "start-live", arrow: false, onClick: i ? a : o, cls: "white", tr: "office", disable: n }), i ? d(T, { children: [t(l5, {}), t(r5, {})] }) : null] });
}, d5 = l.div`
  padding: 50px 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media all and (max-width: 768px) {
    padding: 50px 20px;
  }
`, p5 = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: #262626;
  border-radius: 10px;
`, u5 = ({ children: e }) => d(h5, { children: [t(m5, { children: t(Rn, { onClick: () => {
  ke({ adminPanelOpen: false });
} }) }), t(f5, { children: e })] }), h5 = l.div`
  width: 100%;
  min-width: 520px;
  background: #2d2d2d;
  height: 100%;
  overflow: auto;

  @media all and (max-width: 768px) {
    min-width: 420px;
    width: 100%;
  }

  @media all and (max-width: 420px) {
    min-width: 100vw;
  }
`, f5 = l.div``, m5 = l.div`
  display: none;
  @media all and (max-width: 600px) {
    width: 44px;
    height: 44px;
    display: block;
    position: absolute;
    right: 20px;
    top: 0;
    pointer-events: all;
    button {
      position: relative;
      top: auto;
      right: auto;
      width: 100%;
      height: 100%;
      transform: none;
    }
  }
`, g5 = ({ data: e, currentItem: n, setCurrentItem: i }) => {
  const { t: o } = /* @__PURE__ */ x("common"), a = n === e.id;
  return t(b5, { onClick: () => {
    a ? C({ adminPanelOpen: false }) : i(e.id);
  }, className: a ? "active" : "", children: d("div", { children: [t("img", { src: M[e.icon], alt: e.name }), t("span", { children: o(e.name) })] }) });
}, x5 = ({ data: e, currentItem: n, setCurrentItem: i }) => t(v5, { children: e.map((o, a) => t("li", { children: t(g5, { data: o, currentItem: n, setCurrentItem: i }) }, a)) }), v5 = l.ul`
  background: #222222;
`, b5 = l.button`
  position: relative;
  pointer-events: all;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  span,
  img {
    position: relative;
    z-index: 1;
  }

  img {
    clip-path: none;
    width: 24px;
    height: auto;
    margin: 0 auto;
  }

  span {
    display: block;
    text-transform: uppercase;
    font-size: 9px;
    padding: 5px 0 0;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
  }

  &::before {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #2d2d2d;
    transform-origin: left center;
    transform: scaleX(0) translateZ(0);
    transition: transform 0.3s ease;
  }

  &::after {
    top: 50%;
    width: 12px;
    height: 12px;
    right: 0;
    background: #fff;
    border-radius: 100%;
    transform: translate3d(100%, -50%, 0);
    transition: transform 0.3s ease;
  }

  &.active {
    &::before {
      transform: scaleX(1) translateZ(0);
    }
    &::after {
      transform: translate3d(50%, -50%, 0);
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      &::after {
        transform: translate3d(50%, -50%, 0);
      }
    }
  }
`, w5 = ({ data: e }) => {
  const n = /* @__PURE__ */ S((a) => a.adminPanelOpen), [i, o] = /* @__PURE__ */ m(0);
  return d(y5, { className: n ? "open" : "", children: [t(u5, { children: e[i].content }), e.length > 1 ? t(x5, { data: e, currentItem: i, setCurrentItem: o }) : null] });
}, y5 = l.div`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  transform: translate3d(100%, 0, 0);
  transition: transform 0.6s ease;
  &.open {
    pointer-events: all;
    transform: translate3d(0, 0, 0);
  }
`, C5 = () => {
  const [e] = /* @__PURE__ */ z((i) => [i.liveStreaming?.trtcMode === "live"]), n = /* @__PURE__ */ [{ id: 0, name: "people", icon: "/icons/admin/people.svg", content: t(a5, {}) }, e ? { id: 1, name: "stream", icon: "/icons/admin/stream.svg", content: t(c5, {}) } : null].filter(Boolean);
  return t(w5, { data: n });
}, k5 = () => {
  const [e, n] = /* @__PURE__ */ z((i) => [i.disableUI, i.playCinematicId]);
  return !n && !e ? d(T, { children: [t(Hx, {}), t(C5, {})] }) : null;
}, S5 = ({ userId: e, setUserNameEntered: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = /* @__PURE__ */ k(null), [a, s] = /* @__PURE__ */ m(false), [r, c] = /* @__PURE__ */ m(false), p = /* @__PURE__ */ K("isMobile"), u = () => {
    if (o.current.value !== name && o.current.value !== "") {
      c(true), C({ showSpinnerLoader: true });
      const { setPublic: f } = /* @__PURE__ */ N();
      n(true);
      const v = $().id;
      v && b(`update_name_${v}`, o.current.value), f({ property: "name", value: o.current.value, userId: e });
    }
  }, h = (f) => {
    f.key === "Enter" && u();
  };
  return w(() => () => {
    N().showSpinnerLoader && C({ showSpinnerLoader: false });
  }), t(L5, { children: d(I5, { children: [t("h2", { className: "secFontTxtBig", children: i("enter-name-title") }), t(W, { label: "", children: t("input", { ref: o, type: "text", placeholder: i("your-name"), onChange: (f) => s(f.target.value !== ""), onKeyDown: p ? null : (f) => h(f) }) }), t("div", { className: "rb", children: t(B, { label: "continue", arrow: false, onClick: u, cls: "white", disable: !a || r }) })] }) });
}, M5 = ({ setUserNameEntered: e }) => {
  const n = /* @__PURE__ */ O((a) => a.id), [i, o] = /* @__PURE__ */ z((a) => [a.usersById[n], a.usersById[n]?.name]);
  return i && !o ? t(S5, { userId: n, setUserNameEntered: e }) : null;
}, L5 = l.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: center;
`, I5 = l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  pointer-events: all;

  h2 {
    font-size: 20px;
    line-height: 30px;
    text-transform: uppercase;
  }

  .rb {
    padding: 5px 0 0;
    button {
      min-width: auto;
      padding: 20px 30px;
    }
  }
`, $5 = ({ microverseId: e, coverUuid: n }) => {
  const i = /* @__PURE__ */ Ne(n ? `${Ae.workspaceStorage}${e}/microversecover.webp?v=${n}` : null, M["/placeholder/office-preview.webp"]);
  return t(T5, { children: t("img", { src: i, alt: "bg" }) });
}, T5 = l.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    clip-path: none;
  }
`, N5 = ({ show: e, closeModal: n, requestAccess: i }) => {
  const [o, a] = /* @__PURE__ */ m(false);
  return d(z5, { children: [d(D5, { className: e && !o ? "show" : "", children: [d(P5, { children: [t("img", { src: M["/icons/share-device.svg"], alt: "share device" }), t(te, { title: "allow-access-device-title", desc: "allow-access-device-desc" })] }), t(_5, { className: "cb", children: t(B, { cls: "white nomw", label: "continue", arrow: false, onClick: () => {
    a(true), setTimeout(() => {
      i();
    }, 600);
  } }) })] }), t(Wi, { className: "blm", children: t(sn, { label: "skip", action: n }) })] });
}, A5 = ({ closeModal: e }) => {
  const [n, i] = /* @__PURE__ */ m(false);
  return w(() => {
    setTimeout(() => {
      i(true);
    }, 1);
  }, []), t(j5, { children: t(F5, { children: t(O5, { className: n ? "show" : "", children: t(Bi, { fromGateModal: false, action: () => {
    i(false), e();
  } }) }) }) });
}, E5 = () => {
  const [e, n] = /* @__PURE__ */ m(true), [i, o] = /* @__PURE__ */ m(false);
  w(() => {
    setTimeout(() => {
      o(true);
    }, 5);
  }, []);
  const a = () => {
    o(false), setTimeout(() => {
    }, 600);
  };
  return t(vn, { className: i ? "show" : "", children: e ? t(N5, { show: i, closeModal: a, requestAccess: () => {
    n(false);
  } }) : t(A5, { closeModal: a }) });
}, D5 = l.div`
  position: relative;
  z-index: 3;
  background: #242424;
  border-radius: 10px;
  pointer-events: none;
  width: 100%;
  min-width: 500px;
  overflow: hidden;

  opacity: 0;
  transform: scaleX(0) translateZ(0);
  transition: opacity 0.2s ease 0.2s, transform 0.4s ease 0.2s;

  &.show {
    pointer-events: all;
    opacity: 1;
    transform: scaleX(1) translateZ(0);
    transition: opacity 0s ease, transform 0.4s ease;

    .cb,
    img,
    h1,
    p {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    .cb {
      transition-delay: 0.35s;
    }

    img {
      transition-delay: 0.2s, 0.2s;
    }
    h1 {
      transition-delay: 0.25s, 0.25s;
    }
    p {
      transition-delay: 0.3s, 0.3s;
    }
  }

  @media all and (max-width: 520px) {
    min-width: 100%;
  }
`, z5 = l.div`
  position: relative;
`, P5 = l.div`
  padding: 50px 50px 40px;
  text-align: center;
  img {
    width: 50px;
    height: auto;
    margin: 0 auto;
    padding: 0 0 10px;
  }

  img,
  h1,
  p {
    opacity: 0;
    transform: translate3d(0, 50px, 0);
    transition: opacity 0.2s ease, transform 0.4s ease;
  }

  @media all and (max-width: 500px) {
    padding: 50px 30px 40px;
  }
`, _5 = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 20px;
  background: #101010;
  button {
    &::before {
      background: #101010 !important;
    }
  }

  transform: translate3d(0, 100%, 0);
  transition: transform 0.4s ease;
`, j5 = l.div`
  position: relative;
  z-index: 1;
  overflow: auto;
  height: 100vh;
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (max-height: 650px), all and (max-width: 720px) {
    align-items: flex-start;
  }
`, F5 = l.div`
  position: relative;
  z-index: 1;
  padding: 10px 5px;

  @media all and (max-width: 620px) {
    padding: 0;
  }
`, O5 = l.div`
  display: flex;
  position: relative;
  min-height: 544px;
  border-radius: 10px;
  background: #2d2d2d;
  pointer-events: all;
  overflow: hidden;
  transform: scaleX(0) translateZ(0);
  opacity: 0;

  transition: transform 0.4s ease 0.1s, opacity 0.2s ease;

  @media all and (max-width: 720px) {
    flex-direction: column;
    min-height: auto;
    & > div {
      &:first-child {
        order: 2;
      }
    }
  }

  @media all and (max-width: 620px) {
    border-radius: 0;
  }

  &.show {
    transform: scaleX(1) translateZ(0);
    opacity: 1;
    transition: transform 0.4s ease, opacity 0s ease;
  }
`, B5 = ({ workspace: e, children: n }) => O((o) => o.user) ? d(U5, { children: [t(Wu, { workspace: e }), t(za, {}), n, t(Ut, {})] }) : null, U5 = l.div`
  position: fixed;
  inset: 0;
  background: #292929;
  z-index: 999;
  pointer-events: all;
  display: flex;
  overflow: hidden;
`, mt = l.div`
  width: 100%;
  opacity: 0.2;
  height: 1px;
  background: #ffffff;
`, R5 = ({ icon: e, title: n, actionButtonLabel: i, actionDisabled: o = false, backButton: a, rightActionDefault: s }) => {
  const r = /* @__PURE__ */ Q(Ie), { t: c } = /* @__PURE__ */ x("office");
  return d(W5, { className: a ? "backButton" : "", children: [a ? t(G5, { className: "bb", onClick: () => {
    G({ openAdminOverlay: false });
  }, children: t("img", { src: M["/icons/back.svg"], alt: "back" }) }) : null, d(V5, { children: [t("img", { src: M[e], alt: c(n) }), t("p", { className: "secFontTxtBig", children: c(n) })] }), i.length > 0 ? t(B, { disable: o, arrow: false, cls: "actbtn white bluehvr", label: i, onClick: o ? null : () => {
    r.save?.current && r.save.current();
  }, tr: "office" }) : s || null] });
}, Ie = /* @__PURE__ */ Be(null), _e = ({ icon: e, title: n, children: i, actionButtonLabel: o = "save", cls: a = "", backButton: s, rightActionDefault: r }) => {
  const [c, p] = /* @__PURE__ */ m(true), u = /* @__PURE__ */ k(null), h = /* @__PURE__ */ Y(() => ({ save: u, mainButtonEnable: c, setMainButtonEnable: p }), [c]);
  return t(Ie.Provider, { value: h, children: d(H5, { className: a, children: [t(R5, { icon: e, title: n, actionButtonLabel: o, actionDisabled: !c, backButton: s, rightActionDefault: r }), t(Z5, { children: i })] }) });
}, H5 = l.div`
  width: 100%;
  height: 100%;
  background: #2d2d2d;
  box-shadow: 0px 4px 97px rgba(0, 0, 0, 0.15);
  border-radius: 40px 0 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  isolation: isolate;
  min-width: 600px;
  transition: transform 0.6s ease;

  &.create {
    visibility: hidden;
    position: absolute;
    left: 50%;
    top: 0;
    height: 100%;
    transform: translate3d(-50%, 100%, 0);
    max-width: 1200px;
    width: 100%;
    border-radius: 40px 40px 0 0;

    &.show {
      visibility: visible;
      transform: translate3d(-50%, 0, 0);
    }
  }

  &.hide {
    display: none; //@jocelyn temp fix
    transform: translate3d(100%, 0, 0);
    pointer-events: none;
  }

  &.officesett {
    min-width: 920px;
    @media all and (max-width: 1230px) {
      min-width: 840px;
    }

    @media all and (max-width: 1180px) {
      min-width: 600px;
    }
  }

  @media screen and (max-width: 890px) {
    min-width: auto !important;
    padding: 60px 0;

    &.create {
      padding: 0 0 0;
      border-radius: 0;
    }
  }
`, W5 = l.div`
  position: relative;
  overflow: hidden;
  background: ${(e) => e.theme.colors.highlight};
  width: 100%;
  padding: 25px 30px 25px 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.backButton {
    padding: 25px 30px 25px 145px;
  }

  button {
    min-width: auto;
  }
  div,
  button {
    position: relative;
    z-index: 1;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
  }
  &::before {
    width: 400px;
    height: 150px;
    right: -100px;
    top: -40px;
    border-radius: 80px;
    background: linear-gradient(
      262.62deg,
      rgb(255, 231, 162) 2.11%,
      rgb(191, 65, 237) 95.96%
    );
    transform: rotate(12deg);
    animation: levitationSettings2 10.3s ease-in-out infinite alternate;
  }

  &::after {
    width: 500px;
    height: 200px;
    right: 20px;
    bottom: -260px;
    border-radius: 120px;
    background: linear-gradient(
      12deg,
      rgb(255, 61, 157) 22.11%,
      rgb(255, 226, 153) 95.96%
    );
    transform: rotate(42deg);
    animation: levitationSettings1 11s ease-in-out infinite alternate;
  }

  @media all and (max-width: 890px) {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 15px;
    height: 60px;

    button {
      padding: 13px 30px;
      height: auto;
    }

    &.backButton {
      position: relative;
      bottom: auto;
      left: auto;
      .bb {
        padding: 0;
        width: 60px;
        height: 60px;
        img {
          width: 10px;
        }
        &::after {
          height: 38px;
          top: 11px;
        }
      }

      padding: 21px 30px 21px 80px;

      .actbtn {
        display: none;
      }
    }

    &::before {
      width: 200px;
      height: 100px;
      right: -100px;
      top: -60px;
      border-radius: 80px;
    }
    &::after {
      width: 300px;
      height: 150px;
      right: -100px;
      bottom: -180px;
      border-radius: 120px;
    }
  }
`, V5 = l.div`
  display: flex;
  align-items: center;
  gap: 15px;
  text-transform: uppercase;

  p {
    text-transform: uppercase;
    color: #eeeeee;
    white-space: nowrap;
  }

  @media all and (max-width: 890px) {
    p {
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.04em;
    }
  }
`, Z5 = l.div`
  position: relative;
  height: 100%;
  overflow: auto;
  padding: 0 30px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media all and (max-width: 767px) {
    padding: 0 20px;
  }
`, G5 = l.button`
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100px;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    height: 64px;
    background: #d9d9d9;
    opacity: 0.2;
    width: 1px;
    top: 18px;
  }

  img {
    width: 12px;
    height: auto;
    clip-path: none;
  }

  @media all and (pointer: fine) {
    img {
      transition: transform 0.3s ease;
      transform: translate3d(0, 0, 0);
    }

    &:hover img {
      transform: translate3d(-5px, 0, 0);
    }
  }
`, je = (e, n) => {
  localStorage && (n ? localStorage.setItem(e, JSON.stringify({ date: /* @__PURE__ */ new Date(), data: n })) : localStorage.removeItem(e));
}, Xt = (e, n) => {
  let i = { data: null, stale: true };
  const o = /* @__PURE__ */ JSON.parse(localStorage?.getItem(e));
  return o !== null ? (i.data = o?.data, o?.date && (i.stale = (/* @__PURE__ */ new Date()).getTime() > new Date(o?.date).getTime() + 1e3 * n)) : i = null, i;
}, q5 = ({ office: e, newSettings: n }) => {
  const i = /* @__PURE__ */ k(null), [o, a] = /* @__PURE__ */ m(e?.usePassword);
  return j("closeModal", () => {
    i.current && (i.current.value = "");
  }), d(Le, { children: [t(de, { tr: "office", show: o, click: () => {
    n ? n.current.usePassword = !o : e.usePassword = !o, a(!o);
  }, label: "enable-password-access", description: "enable-password-access-desc", disabled: false }), t(X5, { className: o ? "show" : "", children: t(W, { label: "password", children: t(bn, { ref: i, defaultValue: e?.passwordValue, onChange: (s) => {
    n ? n.current.passwordValue = s : e.passwordValue = s;
  } }) }) })] });
}, Y5 = ({ office: e, newSettings: n }) => {
  const [i, o] = /* @__PURE__ */ m(e?.allowGuest), [a, s] = /* @__PURE__ */ m(e?.guestApprovalAlwaysRequired);
  return d(Le, { children: [t(de, { show: i, click: () => {
    n ? n.current.allowGuest = !i : e.allowGuest = !i, o(!i);
  }, label: "allowguest-name", description: "allowguest-desc", disabled: false, tr: "office" }), t(de, { tr: "office", show: a, click: () => {
    n ? n.current.guestApprovalAlwaysRequired = !a : e.guestApprovalAlwaysRequired = !a, s(!a);
  }, label: "required-access-guest", description: "required-access-guest-desc", disabled: !i })] });
}, Ga = ({ office: e, newSettings: n, error: i, isSougen: o }) => d(T, { children: [o ? null : d(T, { children: [t(Y5, { office: e, newSettings: n }), t(mt, {})] }), t(q5, { office: e, newSettings: n }), i ? t(we, { label: i }) : null, t(mt, {})] }), K5 = ({ office: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i, o] = /* @__PURE__ */ m(null), a = /* @__PURE__ */ k({ allowGuest: e?.allowGuest, guestApprovalAlwaysRequired: e?.guestApprovalAlwaysRequired, usePassword: e?.usePassword, passwordValue: null }), s = () => {
    ke({ showSpinnerLoader: false }), b("notification", { message: n("save-success") });
  }, r = async () => {
    const c = e?.allowGuest !== a.current.allowGuest, p = e?.guestApprovalAlwaysRequired !== a.current.guestApprovalAlwaysRequired, u = e?.usePassword !== a.current.usePassword;
    if (o(null), c || p || u || a.current.passwordValue) {
      if (a.current.usePassword && a.current.passwordValue.length === 0) {
        o("password-required");
        return;
      }
      const { editMicroverse: h } = /* @__PURE__ */ ot();
      if (ke({ showSpinnerLoader: true }), await h(e.docId, a.current)) {
        const v = R().workspace;
        v && tr(`microverses-${v}`, null), Object.assign(e, a.current), a.current.passwordValue && (delete a.current.passwordValue, a.current.hasPassword = true);
      }
      s(), b("closeModal");
    } else
      b("closeModal");
  };
  return d(xe, { children: [d(J5, { children: [t("div", { style: { textAlign: "center" }, children: t("h4", { className: "secFontTxtBig", children: n("permission-access-for", { name: e.name }) }) }), t(Ga, { office: e, newSettings: a, error: i })] }), t(ye, { className: "center", children: t(B, { label: "save", onClick: r, cls: "white", arrow: false, tr: "office" }) })] });
}, J5 = l.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  h4 {
    text-transform: uppercase;
    padding: 0 0 5px;
  }
`, X5 = l.div`
  display: none;
  &.show {
    display: block;
  }
`, Q5 = ({ isSougen: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ Q(Ie);
  w(() => {
    const r = async () => {
      a(null);
      const c = Kn().officeInfo;
      if (c.usePassword && c.passwordValue.length === 0) {
        a("password-required");
        return;
      }
      i.setMainButtonEnable(false);
      const { createMicroverseFromTemplate: p } = /* @__PURE__ */ N();
      C({ showSpinnerLoader: true });
      const u = R().workspace;
      je(`microverses-${u}`, null);
      const { success: h } = await p({ workspaceSrc: c.workspace, microverseSrcId: c.id, workspaceDest: u, microverseDestId: c.slug, name: c.name, description: c.description, usePassword: c.usePassword, passwordValue: c.passwordValue, allowGuest: c.allowGuest, guestApprovalAlwaysRequired: c.guestApprovalAlwaysRequired, membersRestricted: c.membersRestricted, type: c.type });
      if (C({ showSpinnerLoader: false }), !h) {
        b("notification", { message: n("error-creating-microverse", { name: c.name }) }), i.setMainButtonEnable(true);
        return;
      }
      b("notification", { message: n("done-creating-microverse", { name: c.name }) }), C((f) => ({ allMicroverses: [...f.allMicroverses] })), G({ openAdminOverlay: false }), setTimeout(() => {
        G({ addOfficeStep: 0, officeSelected: null, officeInfo: null });
      }, 500);
    };
    i?.save && (i.save.current = r);
  }, [i, n]);
  const [o, a] = /* @__PURE__ */ m(null), s = /* @__PURE__ */ se((r) => r.officeInfo);
  return t(e3, { children: t(Ga, { isSougen: e, office: s, newSettings: false, error: o }) });
}, e3 = l.div`
  padding: 120px 0 0;
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .error {
    color: red;
  }
`, qa = /* @__PURE__ */ wt((e, n) => d(t3, { children: [d(n3, { children: [((o) => o.replace(/^(?:https?:\/\/)?(?:www\.)?/i, ""))(e?.prefixUrl), "/"] }), t("input", { type: "text", ref: n, defaultValue: e?.defaultValue, onChange: (o) => {
  o.target.value = o.target.value.replace(/[^a-zA-Z0-9-]/g, "");
} })] }));
qa.displayName = "SubUrlInput";
const t3 = l.div`
  display: flex;
  input {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`, n3 = l.div`
  display: flex;
  align-items: center;
  background: rgba(160, 160, 160, 0.6);
  border-radius: 5px 0 0 5px;

  padding: 15px 23px;

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.03em;
  color: #2d2d2d;

  white-space: nowrap;
`, i3 = ({ isSougen: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ S((g) => g.WORKSPACE_URL_ROOT), o = /* @__PURE__ */ se((g) => g.officeInfo), a = /* @__PURE__ */ k(null), s = /* @__PURE__ */ k(null), r = /* @__PURE__ */ k(null), [c, p] = /* @__PURE__ */ m(null), [u, h] = /* @__PURE__ */ m(null), f = /* @__PURE__ */ Q(Ie), v = e ? "microverse" : "office";
  return w(() => {
    const g = () => {
      const y = a.current.value, L = s.current.value, I = r.current.value, A = ["admin", "api", "auth", "billing", "__users__", "authemail", "call", "initauth", "login", "root-index", "builder"];
      if (p(null), h(null), y.length === 0) {
        p(v + "-name-empty");
        return;
      }
      if (L.length === 0) {
        h(v + "-url-empty");
        return;
      }
      if (A.includes(L) || L.startsWith("__")) {
        h(v + "-url-invalid");
        return;
      }
      if (N().allMicroverses.map((D) => D.docId).includes(L)) {
        h(v + "-url-not-available");
        return;
      }
      G((D) => ({ officeInfo: { ...D.officeInfo, name: y, slug: L, type: "office", description: I, allowGuest: true, guestApprovalAlwaysRequired: false, usePassword: false, passwordValue: "" }, addOfficeStep: 2 }));
    };
    f?.save && (f.save.current = g);
  }, [f]), d(o3, { children: [t(W, { label: "name", tr: "common", children: t("input", { id: "name", type: "text", ref: a, defaultValue: n(o?.name) }) }), c ? t(we, { label: c }) : null, t(W, { label: v + "-url", children: t(qa, { ref: s, prefixUrl: i, defaultValue: o?.slug }) }), u ? t(we, { label: u }) : null, t(W, { label: "description", tr: "common", children: t("input", { id: "description", type: "text", ref: r, defaultValue: o?.description }) })] });
}, o3 = l.div`
  padding: 120px 0 0;
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`, Ya = ({ label: e, placeholderSearch: n, setText: i }) => {
  const { t: o } = /* @__PURE__ */ x("office");
  return d(a3, { children: [t("h2", { children: o(e) }), t(At, { placeholder: n, setText: i, tr: "office" })] });
}, a3 = l.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 30px;

  h2 {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 16px;
    line-height: 55px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #ffffff;
  }

  .search-ctn {
    position: relative;
    left: auto;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 99px;
    width: 100%;
    max-width: 255px;
  }

  @media all and (max-width: 600px) {
    flex-direction: column;
    gap: 0px;
    padding: 0 0 15px;
    h2 {
      text-align: center;
    }
  }
`, Ka = () => {
  const { t: e } = /* @__PURE__ */ x("office");
  return d(s3, { children: [t("img", { src: M["/office/banner-custom-office.webp"], alt: "custom office banner" }), d("div", { children: [t("h4", { className: "secfont", children: e("custom-office-banner-title") }), t("p", { children: e("custom-office-banner-desc") })] }), t("div", { children: t(ui, { label: "speak-to-us", onClick: () => {
    let n = "com";
    const i = ae().lang;
    i === "fr" ? n = "fr" : i === "ja" && (n = "jp"), window.open(`https://www.konpi.${n}/contact-us`, "_blank");
  }, tr: "office" }) })] });
}, s3 = l.div`
  position: relative;
  display: flex;
  margin: 60px 0 0;

  justify-content: space-between;
  align-items: center;
  padding: 42px 50px;
  gap: 15px;
  width: 100%;
  background: ${(e) => e.theme.colors.highlight};
  border-radius: 5px;
  overflow: hidden;
  isolation: isolate;

  div {
    position: relative;
    z-index: 1;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
  }

  h4 {
    font-weight: 600;
    font-size: 25px;
    line-height: 30px;
    letter-spacing: 0.04em;
    color: #eeeeee;
    padding: 0 0 2px;
  }

  p {
    font-weight: 400;
    font-size: 15px;
    line-height: 26px;
    letter-spacing: 0.03em;
    color: #eeeeee;
  }

  button {
    background: none;
    font-size: 14px;
    line-height: 14px;
    padding: 17px 25px;
    white-space: nowrap;
  }

  @media all and (max-width: 700px) {
    flex-direction: column;
    text-align: center;
    padding: 42px 20px;
  }
`, gt = ({ icon: e, title: n, desc: i }) => t(l3, { children: d(d3, { children: [e ? t("img", { src: M[e], alt: "icon" }) : null, d("div", { className: "cnt", children: [t("h2", { className: "secFontTxtBig", dangerouslySetInnerHTML: { __html: n } }), i ? t("p", { children: i }) : null] })] }) }), Qt = ({ children: e, onConfirm: n }) => {
  const { t: i } = /* @__PURE__ */ x(), o = () => {
    b("closeModal");
  }, a = () => {
    n(), b("closeModal");
  };
  return d(r3, { children: [e, d(c3, { children: [d(Ja, { onClick: o, children: [t(rt, {}), t("span", { className: "secFontTxtSml", children: i("cancel") })] }), d(Ja, { className: "accept", onClick: a, children: [t("span", { className: "secFontTxtSml", children: i("confirm") }), t(rt, { isAccept: true })] })] })] });
}, r3 = l.div``, l3 = l.div`
  padding: 50px 50px 40px;
  min-width: 500px;
  background: #1d1d1d;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media all and (max-width: 520px) {
    min-width: 100%;
  }
`, c3 = l.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 13px;
  background: #101010;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`, Ja = l.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px;

  span {
    text-transform: capitalize;
  }

  @media all and (pointer: fine) {
    div {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0) scale(0);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #f33182;
        transition: transform 0.2s ease;
      }
    }
    &.accept {
      div {
        &::before {
          background: #49e162;
        }
      }
    }

    &:hover {
      div {
        &::before {
          transform: translate3d(-50%, -50%, 0) scale(1);
        }
        svg {
          path {
            stroke: #2d2d2d;
          }
        }
      }
    }
  }
`, d3 = l.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;

  max-width: 600px;
  text-align: center;

  .cnt {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  img {
    width: 50px;
    height: auto;
    clip-path: none;
  }

  h2 {
    text-transform: uppercase;
    span {
      color: #f33182;
    }
  }
`, Xa = (e, n) => n ? e.filter((i) => {
  const o = i?.user || i;
  return o?.name?.toLowerCase().includes(n.toLowerCase()) || o?.email?.toLowerCase().includes(n.toLowerCase());
}) : e, Qa = (e, n) => {
  const i = /* @__PURE__ */ e.map((o, a) => [o, a]);
  return i.sort((o, a) => {
    const s = /* @__PURE__ */ n(o[0], a[0]);
    return s !== 0 ? s : o[1] - a[1];
  }), i.map((o) => o[0]);
}, es = (e, n) => e === "desc" ? (i, o) => ts(i, o, n) : (i, o) => -ts(i, o, n), ts = (e, n, i) => n[i] < e[i] ? -1 : n[i] > e[i] ? 1 : 0, p3 = ({ label: e, orderBy: n, order: i, handleSort: o, cls: a, orderKey: s }) => {
  const { t: r } = /* @__PURE__ */ x("office"), c = s || e;
  return d(h3, { className: `${e} secFontTxtSml ${a}`, onClick: () => o(c), children: [r(e), n === c && t("span", { children: i === "desc" ? "▼" : "▲" })] });
}, ns = ({ head: e, orderBy: n, order: i, handleSort: o }) => {
  const { t: a } = /* @__PURE__ */ x("office");
  return t(u3, { children: t("tr", { children: e.map((s) => s.sort ? t(p3, { orderKey: s.orderKey, label: s.label, orderBy: n, order: i, handleSort: o, cls: s.cls }, s.label) : t("th", { className: `secFontTxtSml ${s.cls}`, children: a(s.label) }, s.label)) }) });
}, u3 = l.thead`
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  th {
    padding: 10px 0;
    text-align: left;
    text-transform: capitalize;
    &.name {
      width: 30%;
    }
    &.center {
      text-align: center;
    }
  }
`, h3 = l.th`
  cursor: pointer;
  span {
    font-size: 10px;
    line-height: 10px;
    margin-left: 5px;
  }

  &.center {
    text-align: center;
  }
`, f3 = () => {
  const { t: e } = /* @__PURE__ */ x("billing");
  return t("p", { dangerouslySetInnerHTML: { __html: e("prorated") } });
}, m3 = ({ team: e, size: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(g3, { children: [d("h3", { children: [i(e ? "team-members" : "guests"), " (", n, ")"] }), e ? t(f3, {}) : null] });
}, g3 = l.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;

  h3 {
    font-family: 'Mundial';
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  p {
    font-weight: normal;
    font-size: 11px;
    max-width: 400px;
  }

  @media (max-width: 580px) {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
`, x3 = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i, o] = /* @__PURE__ */ S((p) => [p.ACCOUNT_TYPES, p.workspaceDoc]), [a, s] = /* @__PURE__ */ m(e.accountType || i.guest), r = [{ label: "owner", description: "owner-desc", value: i.owner }, { label: "admin", description: "admin-desc", value: i.admin }, { label: "member", description: "member-desc", value: i.member }, { label: "guest", description: "guest-desc", value: i.guest }], c = async () => {
    C({ showSpinnerLoader: true });
    try {
      const { usersById: p } = /* @__PURE__ */ R(), { editAccountType: u } = /* @__PURE__ */ N(), h = p[$().id].accountType, f = p[$().id].active;
      if (!R().isAdmin && (!h || !f || e.accountType > h || a > h)) {
        C({ showSpinnerLoader: false }), b("notification", { message: n("cannot-save-a-role-above-yours") });
        return;
      }
      if (!e.active && a >= i.member) {
        const { workspaceDoc: v } = /* @__PURE__ */ N(), g = /* @__PURE__ */ be(v.productId);
        if (g && v.quantity >= g.maxMembers) {
          b("notification", { message: n("upgrade-plan-member") });
          return;
        }
      }
      await u(e.id, a), b("notification", { message: n("save-success") }), C({ showSpinnerLoader: false }), b("closeModal");
    } catch {
      C({ showSpinnerLoader: false }), b("notification", { message: n("unexpected-error") });
    }
  };
  return d(xe, { children: [d(v3, { children: [t("h4", { className: "secFontTxtBig", children: n("change-account-type") }), t("p", { className: "normalTxt", dangerouslySetInnerHTML: { __html: n("change-account-type-desc", { name: e.name, workspace: o?.name || "WORKSPACE" }) } })] }), t(Le, { children: r.map((p, u) => t(Je, { name: "account-type", label: n(p.label), description: n(p.description), value: p.value, checked: a === p.value, disabled: e.isAnonymous && a !== p.value, click: () => {
    s(p.value);
  } }, u)) }), t(b3, {}), t(ye, { className: "center", children: t(B, { label: "save", onClick: c, cls: "white", arrow: false, tr: "office" }) })] });
}, v3 = l.div`
  padding: 0 0 30px;
  text-align: center;
  h4 {
    text-transform: uppercase;
  }
  p {
    font-family: 'Open Sans';
  }
`, b3 = l.div`
  height: 30px;
`, w3 = ({ user: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ k(null), o = /* @__PURE__ */ k(null), [a, s] = /* @__PURE__ */ m(null), r = () => {
    s(null);
    const c = i.current.value, p = o.current.value;
    if (e.name !== c || e.email !== p) {
      if (c.length === 0) {
        s("name-empty");
        return;
      }
      if (!Pa(p)) {
        s("email-incorrect");
        return;
      }
      b("closeModal");
    } else
      b("closeModal");
  };
  return d(xe, { children: [d(y3, { children: [t("div", { style: { textAlign: "center" }, children: t("h4", { className: "secFontTxtBig", children: n("edit-member-name", { name: e.name }) }) }), t(W, { label: "name", tr: "common", children: t("input", { id: "name", type: "text", ref: i, defaultValue: e.name }) }), t(W, { label: "email", tr: "common", children: t("input", { id: "email", type: "email", ref: o, defaultValue: e.email }) }), a ? t(we, { label: a }) : null] }), t(ye, { className: "center", children: t(B, { label: "save", onClick: r, cls: "white", arrow: false, tr: "office" }) })] });
}, y3 = l.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  h4 {
    text-transform: uppercase;
    padding: 0 0 5px;
  }
`, C3 = ({ user: e, guestList: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), [o, a] = /* @__PURE__ */ S((c) => [c.forceRelogin, c.activateUser]), s = async (c) => {
    C({ showSpinnerLoader: true }), await a(e.id, c), C({ showSpinnerLoader: false });
  }, r = /* @__PURE__ */ Y(() => [n ? { label: i("force-relogin"), action: async () => {
    await o() && b("notification", { message: i("forced-relogin-success", { name: e.name }) });
  } } : null, e.active ? { label: i("edit-member"), action: () => {
    b("openModal", t(w3, { user: e }));
  } } : null, e.active || n ? { label: i("change-account-type"), action: () => {
    b("openModal", t(x3, { user: e }));
  } } : null, n ? null : { label: i(`${e.active ? "deactivate" : "reactivate"}-member`), action: () => {
    if (e.active)
      n || b("openModalValidation", t(Qt, { onConfirm: async () => {
        s(false);
      }, children: t(gt, { icon: "/icons/admin/eye.svg", title: i("deactivate-user-confirm", { name: e.name }) }) }));
    else {
      const { workspaceDoc: c } = /* @__PURE__ */ N(), p = /* @__PURE__ */ be(c.productId);
      if (c.quantity >= p.maxMembers)
        return b("notification", { message: i("upgrade-plan-member") }), false;
      b("openModalValidation", t(Qt, { onConfirm: async () => {
        s(true);
      }, children: t(gt, { icon: "/icons/admin/eye.svg", title: i("activate-user-confirm", { name: e.name }) }) }));
    }
  }, cls: e.active ? "warning" : "" }].filter(Boolean), [n, i, e, e.active]);
  return t(os, { children: t(Ft, { icon: t(as, { children: d("div", { children: [t("div", { className: "circ" }), t("div", { className: "circ" }), t("div", { className: "circ" })] }) }), actions: r }) });
}, xt = ({ user: e, showEmail: n = true }) => d($3, { children: [t(ut, { user: e, showOnline: e.active }), d("div", { children: [t("p", { className: "name secFontTxtSml", children: e.name }), n ? t("p", { className: "email", children: e.email }) : null] })] }), k3 = ({ user: e, isAdmin: n, guestList: i, lang: o }) => {
  const { t: a } = /* @__PURE__ */ x("office");
  return d(I3, { className: !e.active && !i ? "disabled" : "", children: [t("td", { className: "name secFontTxtSmlLight", children: t(xt, { user: e }) }), i ? null : t("td", { className: "secFontTxtSmlLight", children: a(e.active ? "active" : "disabled") }), t("td", { className: "last-login secFontTxtSmlLight", children: me(e.lastJoinWorkspace, o, true) }), n ? t("td", { className: "secFontTxtSmlLight", children: t(C3, { user: e, guestList: i }) }) : null] });
}, is = ({ members: e, team: n, isAdmin: i, guestList: o, filter: a }) => {
  const [s, r] = /* @__PURE__ */ m(e), [c, p] = /* @__PURE__ */ m("asc"), [u, h] = /* @__PURE__ */ m("name"), f = (y) => {
    p(u === y && c === "asc" ? "desc" : "asc"), h(y);
  };
  w(() => {
    r(Xa(e, a));
  }, [a, e]);
  const v = /* @__PURE__ */ ve((y) => y.lang), g = /* @__PURE__ */ [{ label: "name", sort: true }, o ? null : { label: "status", sort: true }, { label: "last-login", sort: true }, i ? { label: "actions" } : null].filter(Boolean);
  return d(S3, { className: s.length === 0 ? "hide" : "", children: [t(m3, { team: n, size: s.length }), t(M3, { children: d(L3, { children: [t(ns, { head: g, orderBy: u, order: c, handleSort: f }), t("tbody", { children: Qa(s, es(c, u)).map((y, L) => t(k3, { user: y, isAdmin: i, guestList: o, lang: v }, y.id || L)) })] }) })] });
}, S3 = l.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  &.hide {
    display: none;
  }
`, M3 = l.div`
  width: 100%;
`, L3 = l.table`
  width: 100%;

  @media all and (max-width: 860px) {
    .last-login {
      display: none;
    }
  }

  @media all and (max-width: 768px) {
    .last-login {
      display: table-cell;
    }
    min-width: 700px;
  }
`, I3 = l.tr`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  td {
    padding: 20px 0;
    vertical-align: middle;

    white-space: nowrap;

    &.name {
      width: 30%;
      padding: 0 30px 0 0;
    }
  }

  &.disabled {
    /* opacity: 0.5; */
    td {
      color: #b0b0b0;
    }
    img {
      filter: grayscale(100%);
    }
  }
`, $3 = l.div`
  display: flex;
  align-items: center;
  gap: 14px;

  .name {
    text-transform: capitalize;
    padding: 0 0 1px;
  }

  .email {
    font-family: 'Mundial';
    font-weight: 200;
    font-size: 9px;
    line-height: 13px;
    letter-spacing: 0.1em;
    opacity: 0.5;
  }
`, os = l.div`
  & > div > button {
    padding: 0;
    & > div {
      width: 34px;
      height: 34px;
    }
  }

  ul {
    left: auto;
    right: 0;
  }
`, as = l.div`
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    display: flex;
    align-items: center;
    width: 17px;
    justify-content: space-between;
    opacity: 0.7;
  }
  .circ {
    width: 3px;
    height: 3px;
    background: #fff;
    border-radius: 100%;
  }
`, T3 = ({ defaultValue: e, domain: n, disabled: i }) => d(N3, { className: i ? "disabled" : "", children: [t("input", { type: "text", defaultValue: e, disabled: i }), t(A3, { children: t("span", { children: n }) })] }), N3 = l.div`
  position: relative;
  display: flex;

  input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &.disabled {
    input {
      pointer-events: none;
      color: #a0a0a0;
      user-select: none;
    }
  }
`, A3 = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 23px;
  background: rgba(160, 160, 160, 0.6);
  border-radius: 0px 5px 5px 0px;
  border-left: solid 1px #000;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.03em;
  color: #2d2d2d;
`, E3 = () => t("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: t("path", { d: "M4 6L8.0678 10L12 5.99997", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" }) }), vt = ({ label: e, desc: n, options: i, defaultValue: o, onChange: a, itemRef: s, tr: r = "office" }) => {
  const { t: c } = /* @__PURE__ */ x(r);
  return t(W, { label: e, desc: n, children: d(D3, { children: [t("select", { defaultValue: o, ref: s, onChange: a, children: i.map((p) => t("option", { value: p.value, children: c(p.label) }, p.value)) }), t(E3, {})] }) });
}, D3 = l.div`
  position: relative;
  width: 100%;
  select {
    width: 100%;
  }
  svg {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
`, z3 = () => {
  const { t: e } = /* @__PURE__ */ x("office"), [n, i, o] = /* @__PURE__ */ S((a) => [a.deleteWorkspace, a.cancelSubscription, a.getCustomerSubscription]);
  return d(j3, { children: [d("div", { children: [t("h4", { children: e("delete-workspace-confirm") }), t("p", { children: e("delete-office-confirm-desc") })] }), t("div", { children: t(B, { arrow: false, label: "confirm", onClick: async () => {
    C({ showSpinnerLoader: true });
    const a = N().workspaceDoc.customerId, r = (await o(a))?.result?.data?.[0].id;
    await i(r, true), await n(a), setTimeout(() => {
      window.location.reload();
    }, 300);
  }, cls: "alert", tr: "office" }) })] });
}, P3 = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = () => {
    b("openModal", t(z3, {}));
  };
  return d(_3, { children: [d("div", { children: [t("h4", { className: "secFontTxtSml", children: e("delete-workspace") }), t("p", { className: "secFontTxtSml", children: e("delete-workspace-desc") })] }), t(B, { arrow: false, label: "delete", onClick: n, cls: "alert", tr: "office" })] });
}, _3 = l.div`
  display: flex;
  align-items: center;
  padding: 20px;
  gap: 30px;
  border: 2px solid #f33182;
  border-radius: 5px;
  justify-content: space-between;

  button {
    min-width: auto;
    span {
      white-space: nowrap;
    }
  }

  h4 {
    padding: 0 0 10px;
    text-transform: capitalize;
    color: #f33182;
  }

  p {
    font-weight: 200;
    letter-spacing: 0.1em;
  }

  @media all and (max-width: 480px) {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
`, j3 = l.div`
  text-align: center;
  p {
    padding: 0 0 10px;
  }

  button {
    min-width: auto;
    margin: 0 auto;
  }
`, ss = ({ previewUrl: e, setPreviewUrl: n, label: i = "logo-upload" }) => t(W, { label: i, children: e ? d(V3, { children: [t("button", { type: "button", onClick: () => {
  n(null);
}, children: t(Me, {}) }), t("img", { className: "img-bg", src: e, alt: "Selected" })] }) : t(da, { setPreviewUrl: n }) }), F3 = ({ defaultValue: e, nameRef: n }) => t(W, { label: "workspace-name", children: t("input", { id: "workspace-name", type: "text", defaultValue: e, ref: n, autoComplete: "off" }) }), O3 = ({ defaultValue: e, domain: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return t("div", { children: d(W, { label: "workspace-url", children: [t(T3, { defaultValue: e, domain: n, disabled: true }), t(W3, { children: t("p", { className: "secFontTxtSmlLight", dangerouslySetInnerHTML: { __html: i("contact-us-domain") } }) })] }) });
}, B3 = ({ defaultValue: e, languageRef: n }) => t(vt, { label: "workspace-language", desc: "workspace-language-desc", options: [{ label: "English", value: "en" }, { label: "日本語", value: "ja" }], defaultValue: e, itemRef: n }), U3 = () => {
  const e = /* @__PURE__ */ Q(Ie), [n, i] = /* @__PURE__ */ S((g) => [g.saveWorkspaceSettings, g.compressAndUpload]), { t: o } = /* @__PURE__ */ x("office"), a = /* @__PURE__ */ S((g) => g.workspaceDoc), [s, r] = /* @__PURE__ */ m(null), c = /* @__PURE__ */ k(null), p = /* @__PURE__ */ k(null), u = /* @__PURE__ */ k(null), h = R().isWorkspaceOwner, f = R().isAdmin, v = () => {
    C({ showSpinnerLoader: false }), b("notification", { message: o("save-success") });
  };
  return w(() => {
    const g = async () => {
      C({ showSpinnerLoader: true }), await n({ name: c.current.value, timezone: p?.current?.value || 9, language: u.current?.value || "en" }), s ? i(s, [512, 512], "workspacelogo", "global", () => {
        r(null), v();
      }) : v();
    };
    e?.save && (e.save.current = g);
  }, [e, s]), d(H3, { children: [d(rs, { children: [t(q, { fallback: null, children: t(ss, { previewUrl: s, setPreviewUrl: r }) }), t(F3, { defaultValue: a?.name, nameRef: c }), t(O3, { defaultValue: a?.docId, domain: "konpi.app" })] }), t(mt, {}), t(rs, { children: t(B3, { defaultValue: a?.language, languageRef: u }) }), h || f ? d(T, { children: [t(mt, {}), t(P3, {})] }) : null] });
}, R3 = (e) => (w(() => {
  G({ currentSectionAdmin: e?.section });
}), d(T, { children: [t(De, {}), t(_e, { icon: "/icons/admin/settings.svg", title: "overview", ...e, children: t(U3, {}) })] })), H3 = l.div`
  width: 100%;
  max-width: 600px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media all and (max-width: 600px) {
    padding: 30px 0;
    gap: 20px;
  }
`, rs = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, W3 = l.div`
  p {
    a {
      text-decoration: underline;
    }
  }
`, V3 = l.div`
  position: relative;

  .img-bg {
    clip-path: none;
    width: 100%;
    max-height: 174px;
    object-fit: contain;
    background: #1d1d1d;
    border-radius: 5px;
    border: 2px dashed rgba(255, 255, 255, 1);
  }

  button {
    position: absolute;
    right: 2px;
    top: 0;
    z-index: 1;
    padding: 8px;

    svg {
      width: 14px;
      opacity: 0.8;
    }

    @media all and (pointer: fine) {
      &:hover {
        svg {
          opacity: 1;
        }
      }
    }
  }
`, Z3 = ({ office: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ k(null), o = /* @__PURE__ */ k(null), [a, s] = /* @__PURE__ */ m(null), [r, c] = /* @__PURE__ */ m(null), [p, u] = /* @__PURE__ */ m(e?.isTemplate || false), [h, f] = /* @__PURE__ */ m(e?.isSougenTemplate || false), v = () => {
    C({ showSpinnerLoader: false }), b("notification", { message: n("save-success") });
  }, g = async () => {
    s(null);
    const L = i.current.value, I = o.current.value;
    if (L.length === 0) {
      s("office-name-empty");
      return;
    }
    const A = e.name !== L || e.description !== I || e.isTemplate !== p || e.isSougenTemplate !== h;
    if (A || r) {
      C({ showSpinnerLoader: true });
      const { editMicroverse: E } = /* @__PURE__ */ N(), D = R().workspace;
      let F;
      if (A && (D && je(`microverses-${D}`, null), F = await E(e.docId, { name: L, description: I, isTemplate: p, isSougenTemplate: h }), F && (e.name = L, e.description = I)), r) {
        const { compressAndUpload: H } = /* @__PURE__ */ N();
        await H(r, [2048, 2048], "microverseCoverFull", "global", () => {
        }, e.docId), await H(r, [512, 512], "microverseCover", "global", () => {
          c(null), v();
        }, e.docId), D && je(`microverses-${D}`, null), e.coverUuid = (Math.random() + 1).toString(36).substring(7);
      } else
        v();
      b("closeModal");
    } else
      b("closeModal");
  }, y = /* @__PURE__ */ z((L) => L.isAdmin);
  return d(xe, { children: [d(G3, { children: [t("div", { style: { textAlign: "center" }, children: t("h4", { className: "secFontTxtBig", children: n("edit-office-info") }) }), t(q, { fallback: null, children: t(ss, { previewUrl: r, setPreviewUrl: c, label: "office-illu-upload" }) }), t(W, { label: "name", tr: "common", children: t("input", { id: "name", type: "text", ref: i, defaultValue: e.name }) }), t(W, { label: "url", tr: "common", children: t("input", { id: "url", type: "text", readOnly: true, defaultValue: `${window.location.origin}/${e.docId}` }) }), t(W, { label: "description", children: t("input", { id: "description", type: "text", ref: o, defaultValue: e.description }) }), y ? d(T, { children: [t(de, { click: () => {
    u(!p);
  }, show: p, label: "enable-template", description: "enable-template-desc", tr: "office" }), t(de, { click: () => {
    f(!h);
  }, show: h, label: "enable-sougen-template", description: "enable-sougen-template-desc", tr: "office" })] }) : null, a ? t(we, { label: a }) : null] }), t(ye, { className: "center", children: t(B, { label: "save", onClick: g, cls: "white", arrow: false, tr: "office" }) })] });
}, G3 = l.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  h4 {
    text-transform: uppercase;
    padding: 0 0 5px;
  }
`, q3 = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = () => {
    C({ showSpinnerLoader: true });
    const a = N().billingData?.workspace;
    a && je(`microverses-${a}`, null), N().deleteMicroverse(e.docId), setTimeout(() => {
      C({ showSpinnerLoader: false });
    }, 4e3);
  }, o = /* @__PURE__ */ Y(() => [{ label: n("edit-office-info"), action: () => {
    b("openModal", t(Z3, { office: e }));
  } }, { label: n("edit-office-permissions"), action: () => {
    b("openModal", t(K5, { office: e }));
  } }, { label: n("delete-office"), action: () => {
    b("openModalValidation", t(Qt, { onConfirm: i, children: t(gt, { icon: "/icons/admin/eye.svg", title: n("delete-office-confirm"), desc: n("delete-office-confirm-desc") }) }));
  }, cls: "warning" }], [n]);
  return t(os, { children: t(Ft, { icon: t(as, { children: d("div", { children: [t("div", { className: "circ" }), t("div", { className: "circ" }), t("div", { className: "circ" })] }) }), actions: o }) });
}, Y3 = ({ data: e, preview: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = /* @__PURE__ */ Ne(e && e.coverUuid ? `${Ae.workspaceStorage}${e.docId}/microversecover.webp?v=${e.coverUuid}` : null, M[`/placeholder/${n ? e.docId || e.slug : "office-preview"}.webp`]);
  return t("img", { src: o, alt: i(e.name) });
}, ai = ({ data: e, isAdmin: n, fromTemplate: i, isSelected: o }) => {
  const { t: a } = /* @__PURE__ */ x("office");
  return d(K3, { children: [d(J3, { onClick: () => {
    i ? G({ officeSelected: e, officeInfo: { ...e, description: "" } }) : (b("showSpinnerLoader", true), window.location.href = `/${e.docId || e.slug}`);
  }, className: o ? "active" : "", children: [t("span", { className: "secFontTxtMed", children: a(i ? o ? "selected" : "select" : "enter") }), t(q, { fallback: null, children: t(Y3, { data: e, preview: i }) })] }), d(X3, { children: [t("p", { className: "normalTxt", children: a(e.name) }), i ? t(Q3, { href: i ? e.url : `https://try.konpi.app/${e.url}`, target: "_blank", children: a("preview") }) : n ? t(q3, { data: e }) : null] })] });
}, K3 = l.div`
  min-width: 240px;
  max-width: calc(33.333% - 14px);
  width: 100%;

  @media all and (max-width: 1180px) {
    max-width: calc(50% - 14px);
  }

  @media all and (max-width: 560px) {
    max-width: 100%;
  }
`, J3 = l.button`
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  isolation: isolate;
  font-size: 0;

  width: 100%;
  height: 190px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
  }

  span {
    display: block;
    opacity: 0;
    position: absolute;
    left: 0;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    transition: opacity 0.3s ease;
    z-index: 2;
    text-transform: uppercase;
    text-shadow: 0px 4px 16px #000;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
  }

  &::before {
    background: #000;
  }

  &::after {
    border: 4px solid ${(e) => e.theme.colors.highlight};
    border-radius: 5px;
  }

  @media all and (pointer: fine) {
    &:hover {
      &::before {
        opacity: 0.6;
      }
      span {
        opacity: 1;
      }
    }
  }

  &.active {
    &::before {
      opacity: 0.7;
      background: ${(e) => e.theme.colors.highlight};
    }
    &::after,
    span {
      opacity: 1;
      text-shadow: 0px 4px 16px ${(e) => e.theme.colors.highlight};
    }
  }
`, X3 = l.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  p {
    padding: 0 5px;
  }
`, Q3 = l.a`
  display: block;
  font-family: 'Mundial';
  font-weight: 200;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 5px;
  @media all and (pointer: fine) {
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.7;
    }
  }
`, ev = ({ isSougen: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), i = /* @__PURE__ */ S((f) => f.getTemplateMicroverses), [o, a] = /* @__PURE__ */ m([]), [s, r] = /* @__PURE__ */ m([]), [c, p] = /* @__PURE__ */ m("");
  w(() => {
    (async () => {
      const v = N().billingData?.workspace;
      if (v) {
        const L = /* @__PURE__ */ Xt(`office-templates-${v}`, 7200);
        if (L?.data && (a(L.data), r(y), !L?.stale))
          return;
      }
      const { success: g, templates: y } = await i();
      a(y), r(y), je(`office-templates-${v}`, y);
    })();
  }, []);
  const u = /* @__PURE__ */ se((f) => f.officeSelected), h = /* @__PURE__ */ Q(Ie);
  return w(() => {
    const f = () => {
      u && G({ addOfficeStep: 1 });
    };
    h?.save && (h.save.current = f), h && h.setMainButtonEnable(u);
  }, [h, u]), w(() => {
    const f = o?.filter((v) => n(v?.name)?.toLowerCase().includes(c.toLowerCase()) || u?.id === v.id);
    r(f);
  }, [c, o]), d(nv, { children: [t(Ya, { label: `select-${e ? "microverse" : "office"}-design`, setText: p, placeholderSearch: `search-${e ? "microverse" : "office"}` }), s?.length > 0 ? t(tv, { children: s.map((f) => t(ai, { data: f, isAdmin: true, fromTemplate: true, isSelected: `${u?.workspace}/${u?.id}` == `${f.workspace}/${f.id}` }, `${f.workspace}/${f.id}`)) }) : t(It, {}), e ? null : t(Ka, {})] });
}, tv = l.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 500px) {
    justify-content: center;
  }
`, nv = l.div`
  padding: 120px 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 920px;

  @media (max-width: 890px) {
    padding: 90px 0 0;
  }
`, iv = ({ step: e, addOfficeStep: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = n + 1 === e.index;
  return d(T, { children: [d(lv, { onClick: () => {
    G({ addOfficeStep: e.index - 1 });
  }, className: `${o ? "active" : ""} ${n > e.index - 1 ? "done" : ""}`, children: [d(cv, { className: "sn", children: [t("img", { src: M[e.icon], alt: i(e.title) }), d("span", { className: "secFontTxtSmlLight", children: ["0", e.index] })] }), t("p", { className: "secFontTxtSml", children: i(e.title) })] }), e.index < 3 ? t(rv, {}) : null] });
}, ov = ({ isSougen: e }) => {
  const n = /* @__PURE__ */ se((r) => r.addOfficeStep), i = [{ index: 1, title: e ? "microverse-design" : "office-design", icon: "/icons/admin/office.svg" }, { index: 2, title: e ? "microverse-settings" : "office-settings", icon: "/icons/admin/settings.svg" }, { index: 3, title: e ? "microverse-privacy" : "office-privacy", icon: "/icons/admin/privacy.svg" }], o = /* @__PURE__ */ k(null), a = /* @__PURE__ */ k(null), s = () => {
    if (a.current && o.current) {
      const r = a.current.offsetWidth, c = o.current.offsetWidth;
      if (r > c) {
        if (o.current.style.justifyContent = "flex-start", n === 0)
          a.current.style.transform = "translate3d(0, 0, 0)";
        else {
          const p = n === 2, u = a.current.children[0].offsetWidth, h = p ? a.current.children[2].offsetWidth : 0;
          a.current.style.transform = `translate3d(-${u + h + 84 * (p ? 2 : 1)}px, 0, 0)`;
        }
      } else
        o.current.style.justifyContent = "center", a.current.style.transform = "";
    }
  };
  return w(() => (s(), window.addEventListener("resize", s), () => {
    window.removeEventListener("resize", s);
  })), t(av, { ref: o, children: t(sv, { ref: a, children: i.map((r) => t(iv, { step: r, addOfficeStep: n }, r.index)) }) });
}, av = l.div`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  width: 100%;
  background: #222222;
  overflow: hidden;
`, sv = l.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;

  @media all and (max-width: 767px) {
    width: auto;
    transition: transform 0.6s ease;
  }
`, rv = l.div`
  width: 24px;
  height: 1px;
  opacity: 0.2;
  background: #fff;
`, lv = l.button`
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 12px;

  opacity: 0.3;
  transition: opacity 0.3s ease;

  p {
    text-transform: capitalize;
    white-space: nowrap;
  }

  &.active,
  &.done {
    opacity: 1;

    .sn {
      &::before {
        transform: scale(1) translateZ(0);
      }
      img {
        transform: scale(1) translate3d(-50%, -50%, 0);
        opacity: 1;
      }
      span {
        transform: scale(1.2) translate3d(0, -50%, 0);
        opacity: 0;
      }
    }
  }

  &.done {
    pointer-events: all;
    .sn {
      img {
        transform: scale(0.8) translate3d(-50%, -50%, 0);
        opacity: 0;
      }
      span {
        transform: scale(1) translate3d(0, -50%, 0);
        opacity: 1;
      }
    }
  }
`, cv = l.div`
  position: relative;
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 70px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${(e) => e.theme.colors.highlight};
    border-radius: 70px;
    transform: scale(0) translateZ(0);
    transition: transform 0.3s ease;
  }

  img {
    width: 21px;
    height: auto;
    clip-path: none;
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: scale(0.8) translate3d(-50%, -50%, 0);
    transition: transform 0.3s ease, opacity 0.2s ease;
    opacity: 0;
  }

  span {
    position: absolute;
    z-index: 2;
    text-align: center;
    left: 0;
    top: 50%;
    transform: scale(1) translate3d(0, -50%, 0);
    width: 100%;
    transition: transform 0.3s ease, opacity 0.2s ease;
  }
`, dv = ({ addOfficeStep: e }) => {
  const n = /* @__PURE__ */ Q(Ie);
  return t(hv, { className: n.mainButtonEnable ? "show" : "", children: t(B, { cls: "white", arrow: false, label: e < 2 ? "next" : "create", onClick: () => {
    n?.save?.current && n?.save.current();
  } }) });
}, pv = ({ addOfficeStep: e, isSougen: n }) => d(T, { children: [e === 0 ? t(ev, { isSougen: n }) : null, e === 1 ? t(i3, { isSougen: n }) : null, e === 2 ? t(Q5, { isSougen: n }) : null] }), uv = () => {
  const [e, n] = /* @__PURE__ */ se((a) => [a.openAdminOverlay, a.addOfficeStep]), o = R().workspace === "sougen";
  return d(_e, { cls: `create ${e ? "show" : ""}`, icon: "/icons/admin/office.svg", title: o ? "add-microverse" : "add-office", actionButtonLabel: n < 2 ? "next" : "create", backButton: true, children: [t(ov, { isSougen: o }), t(pv, { addOfficeStep: n, isSougen: o }), t(dv, { addOfficeStep: n })] });
}, hv = l.div`
  display: none;

  @media all and (max-width: 890px) {
    display: flex;
    position: fixed;
    bottom: 30px;
    left: 0;
    width: 100%;
    justify-content: center;
    pointer-events: none;

    &.show {
      button {
        transform: translate3d(0, 0, 0);
        pointer-events: all;
      }
    }

    button {
      z-index: 10;
      min-width: 225px;
      height: 42px;
      box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.5);
      transition: transform 0.6s ease;
      transform: translate3d(0, calc(100% + 40px), 0);
    }
  }
`, fv = ({ currentNumber: e, isSougen: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = N().workspaceDoc, a = n ? 5 : o?.docId === "try" ? 1e3 : o?.plan?.maxOffices;
  return t(mv, { onClick: () => {
    e < a ? G({ openAdminOverlay: true }) : b("notification:error", { message: i(n ? "max-microverse" : "upgrade-plan-office") });
  }, children: d("div", { children: [t("img", { src: M["/icons/admin/plus.svg"], alt: "add office icon" }), t("span", { className: "secFontTxtSml", children: i(n ? "add-microverse" : "add-office") })] }) });
}, mv = l.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 290px;
  height: 190px;

  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;

  img {
    clip-path: none;
    width: 27px;
    height: 27px;
    margin: 0 auto;
  }

  span {
    display: block;
    padding: 15px 0 0;
    text-align: center;
    text-transform: capitalize;
  }

  @media all and (pointer: fine) {
    transition: background 0.3s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`, gv = ({ isAdmin: e, isSougen: n }) => {
  const i = (s, r) => {
    if (!r)
      return s;
    const c = $().id;
    return s.filter((p) => p.owners.includes(c));
  }, o = /* @__PURE__ */ S((s) => s.allMicroverses), a = /* @__PURE__ */ i(o, n);
  return d(xv, { children: [a ? a.map((s) => t(ai, { data: s, isAdmin: e }, s.docId)) : null, e ? t(fv, { currentNumber: a.length, isSougen: n }) : null, n ? null : t(Ka, {})] });
};
l.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  background: #292929;
  pointer-events: all;
`, l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 70px 30px;
  max-width: 920px;
  width: 100%;
  margin: 0 auto;
`;
const xv = l.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media all and (max-width: 500px) {
    justify-content: center;
  }
`, vv = () => {
  const e = /* @__PURE__ */ se((i) => i.openAdminOverlay);
  w(() => {
    G({ currentSectionAdmin: "offices" });
  });
  const n = N().billingData?.workspace === "sougen";
  return d(T, { children: [t(De, {}), t(_e, { cls: `officesett ${e ? "hide" : ""}`, icon: "/icons/admin/office.svg", title: n ? "microverses" : "offices", actionButtonLabel: "", children: t(bv, { children: t(gv, { isAdmin: true, isSougen: n }) }) }), t(uv, {})] });
}, bv = l.div`
  padding: 60px 0;
  max-width: 920px;

  @media all and (max-width: 890px) {
    padding: 30px 0;
  }
`, wv = ({ defaultValue: e, autoInviteEmailsRef: n }) => t(W, { label: "autoinvite-name", desc: "autoinvite-desc", children: t("input", { id: "autoinvite-name", type: "text", placeholder: "domain.com,*.otherdomain.app", defaultValue: e, ref: n, autoComplete: "off" }) }), yv = ({ defaultValue: e, allowGuestRef: n }) => {
  const [i, o] = /* @__PURE__ */ m(e);
  return t(de, { show: i, label: "allowguest-name", description: "allowguest-desc", tr: "office", click: () => {
    n.current = !i, o(n.current);
  } });
}, Cv = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = /* @__PURE__ */ Q(Ie), [i, o, a] = /* @__PURE__ */ S((p) => [p.workspaceDoc?.autoInviteEmails, p.workspaceDoc?.whitelistedIps, p.workspaceDoc?.allowGuest]), s = /* @__PURE__ */ k(false), r = /* @__PURE__ */ k(null);
  k(null);
  const c = async () => {
    C({ showSpinnerLoader: true });
    const { editWorkspace: p } = /* @__PURE__ */ N();
    console.log("save", s.current), console.log(r.current.value);
    const u = await p({ autoInviteEmails: r.current.value, allowGuest: s.current });
    C({ showSpinnerLoader: false }), u && b("notification", { message: e("save-success") });
  };
  return w(() => {
    n?.save && (n.save.current = c);
  }, [n]), d(Sv, { children: [t(yv, { defaultValue: a, allowGuestRef: s }), t(mt, {}), t(Mv, { children: t(wv, { defaultValue: i, autoInviteEmailsRef: r }) })] });
}, kv = (e) => (w(() => {
  G({ currentSectionAdmin: e?.section });
}), d(T, { children: [t(De, {}), t(_e, { icon: "/icons/admin/privacy.svg", title: "privacy", ...e, children: t(Cv, {}) })] })), Sv = l.div`
  width: 100%;
  max-width: 600px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
`, Mv = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, Lv = ({ filter: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i] = /* @__PURE__ */ z((r) => [r.emailsSent]), [o, a] = /* @__PURE__ */ m(i);
  w(() => {
    a(e ? i.filter((r) => r?.email.toLowerCase().includes(e.toLowerCase())) : i);
  }, [i, e]);
  const s = async (r) => {
    C({ showSpinnerLoader: true }), await N().hideMembersInvitedEmail(r), b("membersInvited"), C({ showSpinnerLoader: false });
  };
  return o?.length > 0 ? d(Iv, { children: [t($v, { children: t("h5", { className: "secFontTxtMed", children: n("members-invited") }) }), t("ul", { children: o.map((r, c) => d(Tv, { children: [t("p", { className: "normalTxt", children: r?.email }), d("div", { className: "right", children: [r.at ? d("span", { children: [t("img", { src: M["/icons/email.svg"], alt: "email" }), me(r.at, ae().lang, true, { day: "numeric", month: "long", year: "numeric", hour: "numeric", minute: "numeric" })] }) : null, t(Nv, { onClick: () => {
    s(r.email);
  }, children: t("img", { src: M["/icons/close.svg"], alt: "hide" }) })] })] }, c)) })] }) : null;
}, Iv = l.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  background: #333;
  border-radius: 8px;
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ul {
    display: flex;
    flex-direction: column;
    li {
      &:last-child {
        border-bottom: none;
      }
    }
  }
`, $v = l.div`
  display: flex;
  gap: 10px;
  align-items: center;
  text-transform: uppercase;
`, Tv = l.li`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
  span {
    font-size: 12px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    gap: 10px;
    img {
      width: 15px;
      height: auto;
      clip-path: none;
    }
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .right {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`, Nv = l.button`
  font-size: 0;

  @media all and (pointer: fine) {
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.6;
    }
  }
`, Av = () => {
  const e = /* @__PURE__ */ Q(Ie), { t: n } = /* @__PURE__ */ x("office"), i = () => {
    const { workspaceDoc: h } = /* @__PURE__ */ N(), f = /* @__PURE__ */ be(h.productId);
    if (h.quantity >= (f?.maxMembers || 50))
      return b("notification", { message: n("upgrade-plan-member") }), false;
    b("openModal", t(qt, {}));
  }, [o, a] = /* @__PURE__ */ z((h) => [h.usersList, h.usersList.v]), s = /* @__PURE__ */ S((h) => h.ACCOUNT_TYPES_LABEL);
  w(() => {
    e?.save && (e.save.current = i);
  }, [e]);
  const [r, c] = /* @__PURE__ */ Y(() => {
    const h = [], f = [];
    if (o && s)
      for (let v = 0; v < o.length; v++) {
        const g = o[v];
        g?.email?.endsWith("@utsubo.co") && !R().isAdmin || (s[g.accountType || 10] !== "guest" ? h.push(g) : f.push(g));
      }
    return [h, f];
  }, [o, a, s]), [p, u] = /* @__PURE__ */ m("");
  return d(Dv, { children: [t(Ya, { label: "", placeholderSearch: "search-name-email", setText: u }), r.length > 0 ? t(is, { team: true, members: r, isAdmin: true, filter: p }) : null, t(Lv, { filter: p }), c.length > 0 ? t(is, { members: c, isAdmin: true, guestList: true, filter: p }) : null] });
}, Ev = (e) => (w(() => {
  G({ currentSectionAdmin: e?.section });
}), d(T, { children: [t(De, {}), t(_e, { icon: "/icons/admin/people.svg", title: "members", actionButtonLabel: "add-member", ...e, children: t(Av, {}) })] })), Dv = l.div`
  width: 100%;
  max-width: 920px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media all and (max-width: 600px) {
    padding: 30px 0;
    gap: 20px;
  }
`, si = ({ title: e, subtitle: n, tr: i = "billing" }) => {
  const { t: o } = /* @__PURE__ */ x(i);
  return d(zv, { children: [t("h2", { className: "secFontTxtMed", children: o(e) }), n ? t("p", { className: "secFontTxtSmlLight", children: o(n) }) : null] });
}, ri = ({ children: e }) => t(Pv, { children: e }), ls = ({ title: e }) => {
  const { t: n } = /* @__PURE__ */ x("billing");
  return t(_v, { children: t("p", { className: "secFontTxtSmlLight", children: n(e) }) });
}, zv = l.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  h2 {
    text-transform: uppercase;
  }

  p {
    font-size: 17px;
    letter-spacing: 0.03em;
    text-transform: capitalize;
  }
`, Pv = l.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`, _v = l.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 30px;

  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;

  p {
    font-size: 17px;
    letter-spacing: 0.03em;
  }
`, jv = ({ active: e, cancelAt: n }) => {
  const { t: i } = /* @__PURE__ */ x("billing"), o = /* @__PURE__ */ ve((h) => h.lang), [a, s] = /* @__PURE__ */ S((h) => [h.cancelSubscription, h.getCustomerSubscription]), r = async (h) => {
    C({ showSpinnerLoader: true });
    const f = N().workspaceDoc.customerId, g = (await s(f))?.result?.data?.[0].id;
    await a(g, h), setTimeout(() => {
      C({ showSpinnerLoader: false });
    }, 2e3);
  }, c = () => {
    b("openModalValidation", t(Qt, { onConfirm: () => {
      r(true);
    }, children: t(gt, { icon: "/icons/admin/eye.svg", title: i("billing-pause-confirm"), desc: i("billing-pause-confirm-desc") }) }));
  }, p = () => {
    r(false);
  }, u = (h) => {
    switch (h) {
      case "en":
        return "en-US";
      case "fr":
        return "fr-FR";
      case "ja":
        return "ja-JP";
      default:
        return "en-US";
    }
  };
  return d(Fv, { children: [t(Ov, { children: t("p", { className: `secFontTxtSmlLight ${e ? "active" : "inactive"}`, dangerouslySetInnerHTML: { __html: i(e ? "renewal-active" : "renewal-inactive", { date: new Date(n * 1e3).toLocaleDateString(u(o), { year: "numeric", month: "long", day: "numeric" }) }) } }) }), t(Bv, { onClick: e ? c : p, className: `secFontTxtSmlLight ${e ? "active" : "inactive"}`, children: i(e ? "pause-renewal" : "resume-renewal") })] });
}, Fv = l.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  align-items: center;
  padding: 0 30px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0px 0px 10px 10px;

  @media all and (max-width: 620px) {
    flex-wrap: wrap;
    gap: 0px;
    padding: 10px 20px;
  }
`, Ov = l.div`
  p {
    padding: 10px 0;
    font-size: 17px;
    line-height: 19px;
    letter-spacing: 0.03em;
    max-width: 500px;
    &.active {
      span {
        color: #49e162;
      }
    }
    &.inactive {
      padding: 20px 0;
      span {
        color: #f33182;
        font-weight: 600;
      }
    }
  }
`, Bv = l.button`
  padding: 10px 0;
  white-space: nowrap;
  &.active {
    transition: opacity 0.2s ease;
  }

  &.inactive {
    position: relative;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;
    text-transform: capitalize;
    color: #49e162;

    &::after {
      content: '';
      position: absolute;
      bottom: 4px;
      left: 0;
      width: 100%;
      height: 1px;
      background: #49e162;
      transform: scaleX(1) translateZ(0);
      transition: transform 0.3s ease;
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      &.active {
        opacity: 0.7;
      }

      &::after {
        transform: scaleX(0) translateZ(0);
      }
    }
  }
`, Uv = ({ brand: e }) => t(qv, { children: e }), Rv = ({ paymentMethod: e, customerEmail: n }) => {
  const { t: i } = /* @__PURE__ */ x("billing");
  return d(Vv, { children: [d(Gv, { children: [t("div", { className: "card", children: ur(e?.card?.brand) ? t("img", { src: M[`/cards/${e?.card?.brand}.webp`], alt: e?.card?.brand }) : t(Uv, { brand: e?.card?.brand }) }), d("div", { className: "cn secFontTxtSml", children: ["**** **** **** ", e?.card?.last4] }), t("div", { className: "exp secFontTxtSmlLight", children: i("month-year-card", { month: (e?.card?.exp_month < 10 ? "0" : "") + e?.card?.exp_month, year: e?.card?.exp_year }) })] }), t("a", { className: "secFontTxtSml", href: `${$i}?prefilled_email=${encodeURIComponent(n)}`, target: "_blank", rel: "noreferrer", children: i("update-payment-method") })] }, e.id);
}, Hv = () => {
  const { t: e } = /* @__PURE__ */ x("billing");
  return d(Zv, { children: [t("img", { src: M["/icons/admin/privacy-green.svg"], alt: "security", className: "icn" }), t("p", { children: e("card-not-saved-by-us") }), t("img", { src: M["/icons/stripe.svg"], alt: "stripe", className: "stripec" })] });
}, Wv = ({ workspaceDoc: e, customerEmail: n, paymentMethods: i }) => d(ri, { children: [t(si, { title: "payment-method" }), i.length > 0 ? d("div", { children: [t(Yv, { children: i.map((o) => t(Rv, { paymentMethod: o, customerEmail: n }, o.id)) }), t(jv, { active: !e?.cancelAtPeriodEnd, cancelAt: e?.cancelAt })] }) : t(ls, { title: "no-payment-method" }), i.length === 0 ? t("div", { children: t(B, { label: "add-payment-method", cls: "white", tr: "billing", arrow: false, onClick: () => {
  window.open(`${$i}?prefilled_email=${encodeURIComponent(n)}`, "_blank");
} }) }) : null, t(Hv, {})] }), Vv = l.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;

  a {
    position: relative;
    white-space: nowrap;

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 100%;
      height: 1px;
      background: #fff;
      transform: scaleX(1) translateZ(0);
      transition: transform 0.3s ease;
    }

    @media all and (pointer: fine) {
      &:hover {
        &::after {
          transform: scaleX(0) translateZ(0);
        }
      }
    }
  }

  @media all and (max-width: 600px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`, Zv = l.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;

  img {
    height: auto;
    clip-path: none;
  }

  .icn {
    min-width: 20px;
    max-width: 20px;
  }

  .stripec {
    min-width: 34px;
    max-width: 34px;
  }

  p {
    font-weight: 600;
    font-size: 11px;
    line-height: 15px;
    letter-spacing: 0.03em;
    opacity: 0.7;
  }
`, Gv = l.div`
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;

  .card {
    font-size: 0;
    min-width: 55px;
    max-width: 55px;
    height: auto;
    img {
      width: 100%;
      height: auto;
      clip-path: none;
    }
  }

  .cn {
    font-size: 17px;
    letter-spacing: 0.07em;
  }

  .exp {
    font-size: 17px;
    letter-spacing: 0;
  }

  @media all and (max-width: 520px) {
    flex-direction: column;
    gap: 10px;
  }
`, qv = l.div`
  width: 100%;
  height: 35px;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Mundial';
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #2d2d2d;

  padding: 0 5px;
`, Yv = l.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  // last child should not have border radius bottom
  > *:last-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`, Kv = ({ setCustomerId: e, workspace: n }) => {
  const [i, o] = /* @__PURE__ */ m(false), a = /* @__PURE__ */ k(null), s = /* @__PURE__ */ k(null), r = /* @__PURE__ */ k(null), c = /* @__PURE__ */ k(null), p = /* @__PURE__ */ k(null), u = /* @__PURE__ */ k(null), [h, f, v] = /* @__PURE__ */ Ee((I) => [I.createCustomer, I.createSubscription, I.billingData]), g = [{ label: "Light plan (monthly)", value: Ti }, { label: "Standard plan (monthly)", value: Ni }], y = [{ label: "default", value: "default" }, { label: "14 days", value: "tenjikai" }], L = async () => {
    if (a.current.value === "" || s.current.value === "") {
      alert("Please fill all the fields");
      return;
    }
    ke({ showSpinnerLoader: true }), o(true);
    const I = await h(a.current.value, s.current.value, r.current.value, n, c.current.value);
    e(I.customer.id), console.log("customer", I.customer.id);
    const A = /* @__PURE__ */ be(p.current.value);
    setTimeout(async () => {
      const E = await f(I.customer.id, A.monthlyPriceId, c.current.value, true, u.current.value);
      console.log("createPlan", E), o(false), ke({ showSpinnerLoader: false });
    }, 6e3);
  };
  return d(Jv, { children: [t(W, { label: "name-billing", children: t("input", { id: "name-billing", type: "text", placeholder: "name billing", ref: a, defaultValue: v?.name, autoComplete: "off" }) }), t(W, { label: "email-billing", children: t("input", { id: "email-billing", type: "mail", placeholder: "mail billing", ref: s, defaultValue: v?.email, autoComplete: "off" }) }), t(vt, { label: "language-billing", options: dr, itemRef: r, defaultValue: v?.language && v?.language?.[0] }), t(vt, { label: "currency", options: pr, itemRef: c, defaultValue: v?.currency }), t(vt, { label: "initial-plan", options: g, itemRef: p, defaultValue: v?.productId }), t(vt, { label: "trial-period", options: y, itemRef: u, defaultValue: y[0]?.value }), t("div", { children: t(B, { onClick: L, label: "create-client", cls: "white", disable: i }) })] });
}, Jv = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, Xv = ({ currentPlan: e }) => {
  const { t: n } = /* @__PURE__ */ x("billing"), i = e?.trial_end, o = /* @__PURE__ */ Math.floor(Date.now() / 1e3), a = i - o, s = /* @__PURE__ */ Math.floor(a / (60 * 60 * 24));
  return d(Qv, { children: [t("div", { className: "square" }), t("div", { className: "square2" }), d(eb, { className: "infos", children: [t("h3", { children: n("free-trial", { days: s + 1 }) }), t("p", { children: n("free-trial-desc") })] })] });
}, Qv = l.div`
  position: relative;
  overflow: hidden;
  min-height: 145px;
  background: ${(e) => e.theme.colors.highlight};
  border-radius: 5px;

  display: flex;
  align-items: center;

  .square {
    position: absolute;
    width: 173px;
    height: 173px;
    left: -105px;
    top: -42px;
    z-index: 1;

    background: linear-gradient(
      201deg,
      #ffffff -30%,
      rgba(255, 255, 255, 0) 86%
    );
    opacity: 0.2;
    transform: rotate(22.8deg);
  }

  .square2 {
    position: absolute;
    width: 120px;
    height: 120px;
    left: -20px;
    top: 200;
    z-index: 1;

    background: linear-gradient(201deg, #fff -30%, rgba(255, 255, 255, 0) 86%);
    opacity: 0.1;
    transform: rotate(23deg);
  }

  @media all and (max-width: 600px) {
    .infos {
      padding: 20px 30px;

      h3 {
        letter-spacing: 0.02em;
      }
    }
  }
`, eb = l.div`
  position: relative;
  z-index: 2;
  padding: 0 50px;
  h3 {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 25px;
    line-height: 30px;
    letter-spacing: 0.04em;
    color: #eeeeee;
    padding: 0 0 5px;
  }

  p {
    font-weight: 400;
    font-size: 15px;
    line-height: 26px;
    letter-spacing: 0.03em;
  }
`, cs = ({ title: e, yearlyPrice: n }) => {
  const { t: i } = /* @__PURE__ */ x("billing");
  return t(ab, { className: `month ${e}`, children: i(`per-${e === "office" ? `user-${n ? "year" : "month"}` : "hour"}`) });
}, tb = ({ title: e, service: n, plan: i, custom: o }) => {
  const { t: a } = /* @__PURE__ */ x("billing"), [s] = /* @__PURE__ */ Ee((f) => [f.billingData]), r = false, c = s?.currency || "USD", p = (f) => f.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), u = /* @__PURE__ */ Nr(c), h = /* @__PURE__ */ Ar(c);
  return d(T, { children: [t(sb, { className: o ? "" : e, children: d("p", { className: "price", children: [u ? t("span", { children: o ? a("custom") : a("price", { symbol: h, price: p(u[`${n}-${i}-monthly`]) }) }) : null, !o && e === "office" && u ? d(lb, { children: [t("span", { children: a("price", { symbol: h, price: p(u[`${n}-${i}-monthly-full`]) }) }), " ", c === "USD" ? "USD" : ""] }) : null, !o && e !== "office" ? t(cs, { title: e, yearlyPrice: r }) : null] }) }), e === "office" && !o ? t(cs, { title: e, yearlyPrice: r }) : null] });
}, nb = ({ title: e, name: n, desc: i, custom: o, price: a, data: s, customerId: r, currentPlan: c, currentSubscriptionId: p, currentPlanItem: u, currentPlanTrialing: h, hasPaymentMethods: f }) => {
  const { t: v } = /* @__PURE__ */ x("billing"), g = u?.id === s.id, y = g && h, L = g && (c?.status === "active" || y), [I, A] = /* @__PURE__ */ m(g ? c?.plan?.id === s.monthlyPriceId : true), E = c?.plan?.id === (I ? s.monthlyPriceId : s.yearlyPriceId), [D, F, H] = /* @__PURE__ */ Ee((re) => [re.createCheckoutSession, re.updateSubscription, re.WORKSPACE_URL_ROOT]), _ = "/admin/billing", P = ot().workspaceDoc?.quantity, U = `${H}${_}?success=true`, X = `${H}${_}?success=false`, ne = () => {
    const re = ot().workspaceDoc, Qe = ot().allMicroverses;
    return re?.quantity > s.maxMembers ? (b("notification:error", { message: v("limit-plan-members-error", { members: s.maxMembers }) }), false) : Qe.length > s.maxOffices ? (b("notification:error", { message: v("limit-plan-office-error", { office: s.maxOffices }) }), false) : true;
  }, Fe = async () => {
    if (!ne())
      return;
    ke({ showSpinnerLoader: true });
    const re = I ? s.monthlyPriceId : s.yearlyPriceId;
    console.log("updateSubscriptionPlan", p, re, P, h);
    const Qe = await F(p, re, P, h, true);
    console.log("updateSubscription", Qe), ke({ showSpinnerLoader: false });
  }, pe = async () => {
    if (!ne())
      return;
    ke({ showSpinnerLoader: true });
    const re = await D(r, I ? s.monthlyPriceId : s.yearlyPriceId, P, U, X, h, true);
    ke({ showSpinnerLoader: false }), window.location.href = re.result?.url;
  }, $e = E && L && f ? "current-plan" : c === null || !f ? "buy" : u.tier < s.tier ? "upgrade" : u.tier > s.tier ? "downgrade" : "update", Oe = P > s.maxMembers;
  return d(ib, { children: [t(ob, { children: t("div", { className: n }) }), t("p", { className: `big ${i ? "smlpd" : ""}`, children: v(n) }), i ? t("p", { className: "desc", children: v(i) }) : null, a ? t(tb, { title: e, service: e, plan: n, custom: o }) : null, e === "office" && a ? t(rb, { children: n !== "enterprise" ? t("span", { children: v("early-bird-discount") }) : null }) : null, t("div", { className: "flx", children: t(B, { label: $e, tr: "billing", cls: "white", arrow: false, disable: E && L && f || Oe, onClick: () => {
    $e === "buy" ? pe() : Fe();
  } }) })] });
}, ib = l.div`
  p {
    text-align: center;
  }
  .big {
    text-transform: uppercase;
    padding: 10px 0;

    &.smlpd {
      padding: 14px 0 0;
      line-height: 18px;
    }
  }
  .desc {
    padding: 0 0 14px;
  }
  div {
    margin: 0 auto;
    button {
      margin: 0 auto;
    }
  }

  .desc {
    color: #8a8a8a;
  }
`, ob = l.div`
  width: 62.27px;
  height: 43.59px;
  display: flex;
  align-items: center;
  justify-content: center;

  .light-plan {
    width: 20px;
    height: 27px;
    background: linear-gradient(195.36deg, #ffe299 22.74%, #ff3d9d 124.96%);
    border-radius: 6.5px 6.5px 65px 6.5px;
  }

  .standard-plan {
    position: relative;
    width: 34px;
    height: 39px;
    &::before,
    &::after {
      content: '';
      position: absolute;
    }

    &::before {
      width: 17px;
      height: 24px;
      right: 5px;
      top: 2px;

      background: linear-gradient(195.36deg, #ffe299 22.74%, #ff3d9d 125%);
      border-radius: 25.6px 5.6px 56.4px 5.6px;
      transform: rotate(45deg);
    }

    &::after {
      width: 17px;
      height: 24px;
      left: 3px;
      bottom: 2px;

      background: linear-gradient(207.92deg, #ffe7a2 -7.72%, #a18aff 102.9%);
      border-radius: 25.6px 5.6px 56.4px 5.6px;
      transform: rotate(-135deg);
    }
  }

  .enterprise-plan {
    position: relative;
    width: 63px;
    height: 44px;
    background: url('/pricing/enterprise-icon.png') no-repeat center;
    background-size: 100%;
  }
`, ab = l.span`
  font-weight: 600;
  font-size: 11px;
  line-height: 26px;
  letter-spacing: 0.05em;
  color: #8a8a8a;

  &.office {
    display: block;
    text-align: center;
    width: 100%;
  }
`, sb = l.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 13px;
  p {
    font-weight: 400;
    font-size: 33px;
    line-height: 34px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #2c2c2c;
  }
  .wave {
    font-size: 22px;
  }

  &.office {
    padding: 0;
    p {
      color: #49e162;
    }
  }
`, rb = l.div`
  display: flex;
  align-items: center;
  padding: 0 0 10px;
  span {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #49e162;
    display: inline-block;
    margin: 0 auto;
    padding: 0;
    border-radius: 20px;
  }
`, lb = l.span`
  display: inline-block;
  padding: 0 0 0 5px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
  span {
    text-decoration-line: line-through;
  }
  color: #8a8a8a;
`, cb = () => d("svg", { width: "18", height: "16", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 16", children: [t("path", { d: "m2.00029 9.23726 3.85982 3.86044 9.23769-9.23769", stroke: "url(#chckicn)", strokeWidth: "4", strokeLinecap: "round", strokeLinejoin: "round" }), t("defs", { children: d("linearGradient", { id: "chckicn", x1: "12.9783", y1: "-4.51793", x2: "-8.83142", y2: "2.81377", gradientUnits: "userSpaceOnUse", children: [t("stop", { stopColor: "#FFE299" }), t("stop", { offset: "1", stopColor: "#FF3D9D" })] }) })] }), db = ({ title: e }) => {
  const { t: n } = /* @__PURE__ */ x("billing");
  return t("p", { className: "ttl", dangerouslySetInnerHTML: { __html: n(e) } });
}, pb = ({ title: e, list: n }) => {
  const { t: i } = /* @__PURE__ */ x("billing");
  return d(xb, { children: [t(db, { title: e }), t("ul", { children: n.map((o, a) => d(vb, { children: [t(cb, {}), t("p", { dangerouslySetInnerHTML: { __html: i(...Array.isArray(o) ? o : [o]) } })] }, a)) })] });
}, ub = ({ title: e, data: n, customerId: i, currentPlan: o, currentSubscriptionId: a, currentPlanItem: s, currentPlanTrialing: r, hasPaymentMethods: c }) => {
  const { t: p } = /* @__PURE__ */ x("billing"), u = s?.id === n.id;
  return d(mb, { children: [u ? t(bb, { className: "secFontTxtSml", children: p("current-plan") }) : null, t(nb, { title: e, name: n.name, desc: n.desc, price: true, custom: n.custom, data: n, customerId: i, currentPlan: o, currentPlanItem: s, currentSubscriptionId: a, currentPlanTrialing: r, hasPaymentMethods: c }), t(gb, {}), t(pb, { title: `${n.name}-perks`, list: n.featuresList })] });
}, hb = ({ title: e, data: n, customerId: i, currentPlan: o, currentSubscriptionId: a, currentPlanItem: s, currentPlanTrialing: r, hasPaymentMethods: c }) => t(fb, { children: n.map((p, u) => t(ub, { title: e, data: p, customerId: i, currentPlan: o, currentPlanItem: s, currentSubscriptionId: a, currentPlanTrialing: r, hasPaymentMethods: c }, u)) }), fb = l.ul`
  display: flex;
  gap: 20px;

  @media (max-width: 1120px) {
    gap: 10px;
  }

  @media all and (max-width: 767px) {
    flex-direction: column;
    flex-wrap: wrap;
  }
`, mb = l.li`
  position: relative;
  flex: 1;
  background: #272727;
  border-radius: 10px 10px 100px 10px;
  padding: 30px 30px 50px;

  @media all and (max-width: 979px) {
    padding: 50px 20px 70px;
  }
`, gb = l.div`
  position: relative;
  height: 60px;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background: #f5f5f5;
    opacity: 0.1;
  }
`, xb = l.div`
  .ttl {
    font-weight: 700;
    font-size: 12px;
    line-height: 26px;
    letter-spacing: 0.03em;
  }
`, vb = l.li`
  display: flex;
  align-items: center;
  padding: 7px 0;
  svg {
    width: 13px;
  }
  p {
    padding: 0 0 0 12px;
  }
`, bb = l.div`
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);

  letter-spacing: 0.1em;
  text-transform: uppercase;
  white-space: nowrap;

  display: block;
  padding: 10px 26px;
  background: ${(e) => e.theme.colors.highlight};
  border-radius: 99px;
`, wb = ({ customerId: e, paymentMethods: n }) => {
  const [i, o] = /* @__PURE__ */ m(null), [a, s] = /* @__PURE__ */ m(null), [r] = /* @__PURE__ */ Ee((p) => [p.getCustomerSubscription]);
  w(() => {
    (async () => {
      const h = (await r(e))?.result?.data?.[0];
      h && (o(h.id), s(h.plan?.active ? h : null));
    })();
  }, [e, r]);
  const c = /* @__PURE__ */ be(a?.plan?.product);
  return d(T, { children: [a?.status === "trialing" ? t(Xv, { currentPlan: a }) : null, d(ri, { children: [t(si, { title: "billing-plans-title" }), t("div", { children: t(hb, { title: "office", data: Ai, customerId: e, currentPlan: a, currentPlanItem: c, currentSubscriptionId: i, currentPlanTrialing: a?.status === "trialing", hasPaymentMethods: n.length > 0 }) })] })] });
}, yb = ({ workspaceDoc: e, customerId: n }) => {
  const i = /* @__PURE__ */ ve((c) => c.lang), [o, a] = /* @__PURE__ */ m([]), [s] = /* @__PURE__ */ Ee((c) => [c.getInvoices]);
  w(() => {
    (async () => {
      if (e?.docId && n) {
        const u = /* @__PURE__ */ Xt(`invoices-${e.docId}-${n}`, 14400);
        if (u?.data && (a(u.data), !u?.stale))
          return;
      }
      const p = await s(n);
      a(p?.result?.data), je(`invoices-${e.docId}-${n}`, p?.result?.data);
    })();
  }, [n, s]);
  const r = (c) => {
    switch (c) {
      case "en":
        return "en-US";
      case "fr":
        return "fr-FR";
      case "ja":
        return "ja-JP";
      default:
        return "en-US";
    }
  };
  return d(ri, { children: [t(si, { title: "invoices" }), t(Cb, { children: o.map((c) => c.status === "paid" ? t("li", { children: d(kb, { href: c.invoice_pdf, target: "_blank", rel: "noopener noreferrer", children: [d("p", { className: "secFontTxtSml", children: ["#", c.number, t("span", { children: new Date(c?.status_transitions?.paid_at * 1e3).toLocaleDateString(r(i), { year: "numeric", month: "long", day: "numeric" }) })] }), t("img", { src: nr["/icons/tools/download.svg"], alt: "download" })] }) }, c.id) : null) }), o.length === 0 ? t(ls, { title: "no-invoices" }) : null] });
}, Cb = l.ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, kb = l.a`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  p {
    display: flex;
    gap: 20px;
    align-items: center;
    font-size: 17px;
    letter-spacing: 0.3em;

    span {
      font-weight: 200;
    }
  }

  img {
    width: 34px;
    height: auto;
  }

  @media all and (pointer: fine) {
    img,
    p {
      position: relative;
      z-index: 1;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.05);
      z-index: 0;
      transform: scaleX(0) translateZ(0);
      transform-origin: left center;
      transition: transform 0.2s ease;
    }

    &:hover::before {
      transform: scaleX(1) translateZ(0);
    }
  }

  @media all and (max-width: 520px) {
    padding: 20px;
    p {
      gap: 15px;
      font-size: 15px;
      line-height: 15px;
      letter-spacing: 0.1em;
    }
  }
`, Sb = ({ workspace: e }) => {
  const [n, i] = /* @__PURE__ */ Ee((u) => [u.workspaceDoc, u.billingData]), [o, a] = /* @__PURE__ */ m(n?.customerId), [s, r] = /* @__PURE__ */ m([]), c = /* @__PURE__ */ z((u) => u.isAdmin), [p] = /* @__PURE__ */ Ee((u) => [u.getCustomerPaymentInfos]);
  return w(() => {
    o && (async () => {
      if (n?.docId && o) {
        const f = /* @__PURE__ */ Xt(`payment-methods-${n.docId}-${o}`, 300);
        if (f?.data && (r(f.data), !f?.stale))
          return;
      }
      const h = await p(o);
      r(h?.result?.data), je(`payment-methods-${n.docId}-${o}`, h?.result?.data);
    })();
  }, [o, p]), d(Lb, { children: [c ? t(Kv, { setCustomerId: a, workspace: e }) : null, o && n ? d(T, { children: [t(wb, { customerId: o, paymentMethods: s }), t(Wv, { workspaceDoc: n, paymentMethods: s, customerEmail: i?.email }), t(yb, { workspaceDoc: n, customerId: o })] }) : null] });
}, Mb = (e) => (w(() => {
  G({ currentSectionAdmin: e?.section });
}), d(T, { children: [t(De, {}), t(_e, { icon: "/icons/admin/billing.svg", title: "billing", actionButtonLabel: "", ...e, children: t(Sb, { workspace: e?.workspace }) })] })), Lb = l.div`
  width: 100%;
  max-width: 900px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 60px;
`, Xe = ({ head: e, members: n, bodyItem: i, filter: o }) => {
  const { t: a } = /* @__PURE__ */ x("office"), [s, r] = /* @__PURE__ */ m(false), [c, p] = /* @__PURE__ */ m("asc"), [u, h] = /* @__PURE__ */ m("name"), f = /* @__PURE__ */ Y(() => Xa(n, o), [n, o]), v = (g) => {
    p(u === g && c === "asc" ? "desc" : "asc"), h(g);
  };
  return w(() => {
    setTimeout(() => {
      r(true);
    }, 1);
  }, []), t(Tb, { children: d(Ib, { className: s ? "show" : "", children: [t(ns, { head: e, orderBy: u, order: c, handleSort: v }), t($b, { children: Qa(f, es(c, u)).map((g, y) => i(g, y, a)) })] }) });
}, Ib = l.table`
  width: 100%;
  opacity: 0;
  transition: opacity 0.6s ease;
  min-width: 720px;

  &.show {
    opacity: 1;
    transition-delay: 0.1s;
  }
`, $b = l.tbody`
  // last child no border
  tr:last-child {
    border-bottom: none;
  }
`, Tb = l.div`
  width: 100%;
  overflow: auto;
`, Nb = ({ title: e, value: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return t("li", { children: d(Pb, { children: [t("h6", { className: "secFontTxtSmlLight", children: i(e) }), t("p", { className: "secFontTxtSml", children: i(n) })] }) });
}, Ab = ({ user: e }) => {
  const [n, i, o, a] = /* @__PURE__ */ z((r) => {
    const c = r.usersById[e?.id];
    return [c?.name, c?.id, c?.hasProfilePic, c?.profilePicUid];
  }), s = e?.id === $().id;
  return i ? d(jb, { children: [t(_b, { children: s ? t(Ot, {}) : t(Ye, { alt: n, hasProfilePic: o, userId: i, profilePicUid: a }) }), t("h3", { className: "secFontTxtBig", children: n })] }) : null;
}, Eb = ({ user: e }) => e ? d(Db, { children: [t(Ab, { user: e }), t(zb, { children: [{ title: "email", value: "fake@google.fr" }, { title: "role", value: "fake admin" }, { title: "last-login", value: "fake date" }].map((i) => t(Nb, { title: i.title, value: i.value }, i.title)) })] }) : null, Db = l.div`
  display: flex;
  width: 100%;
  padding: 30px;
  gap: 40px;
  border-radius: 10px;
  background: #3a3a3a;
  margin-bottom: 10px;
  flex-wrap: wrap;

  @media all and (max-width: 767px) {
    flex-direction: column;
  }
`, zb = l.ul`
  li {
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    &:last-child {
      border-bottom: none;
    }
  }
`, Pb = l.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`, _b = l.div`
  position: relative;
  min-width: 54px;
  width: 54px;
  height: 54px;
  & > img {
    border-radius: 50%;
    overflow: hidden;
    clip-path: none;
  }
`, jb = l.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  text-transform: uppercase;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0 30px 0 0;
  min-width: 180px;

  @media all and (max-width: 767px) {
    border-right: none;
  }
`, ds = ({ x: e, y: n, payload: i, isDate: o }) => t("g", { transform: `translate(${e},${n})`, children: t("text", { x: 0, y: 0, dy: 10, textAnchor: "middle", fill: "#fff", style: { fontFamily: "Mundial", fontSize: "12px", fontWeight: "200" }, children: o ? me({ seconds: new Date(i.value).getTime() / 1e3 }, ae().lang, true, { day: "numeric", month: "short" }) : i.value }) }), ps = ({ x: e, y: n, payload: i }) => {
  const { t: o } = /* @__PURE__ */ x("office");
  return t("g", { transform: `translate(${e},${n})`, children: t("text", { x: 0, y: 0, dx: -15, textAnchor: "middle", fill: "#fff", style: { fontFamily: "Mundial", fontSize: "9px", fontWeight: "200" }, children: o("hours", { count: Math.round(i.value) }) }) });
}, us = ({ active: e, payload: n, label: i, isTime: o, isSquare: a }) => {
  const { t: s } = /* @__PURE__ */ x("office");
  return e && n && n.length ? d(Fb, { children: [t("p", { className: "label normalTxt", children: o ? me({ seconds: new Date(i).getTime() / 1e3 }, ae().lang, true, { day: "numeric", month: "long", year: "numeric" }) : i }), d(ms, { children: [t(li, { className: a ? "square" : "", style: { backgroundColor: n[0].color } }), t("p", { className: "secFontTxtSmlLight", children: s("active-hours", { value: s("hours", { count: n[0].value }) }) })] }), d(ms, { children: [t(li, { className: a ? "square" : "", style: { backgroundColor: n[1].color } }), t("p", { className: "secFontTxtSmlLight", children: s("conv-hours", { value: s("hours", { count: n[1].value }) }) })] })] }) : null;
}, hs = ({ legend: e, setActiveIndex: n, activeIndex: i, isSquare: o }) => {
  const { t: a } = /* @__PURE__ */ x("office");
  return t(Ob, { children: e.map((s, r) => d(Bb, { className: !i || i === s.index ? "" : "hide", onMouseEnter: () => n(s.index), onMouseLeave: () => n(null), children: [t(li, { className: o ? "square" : "", style: { backgroundColor: s.color } }), t("span", { className: "secFontTxtSml", children: a(s.title) })] }, `item-${r}`)) });
}, fs = ({ title: e, data: n, legend: i }) => {
  const { t: o } = /* @__PURE__ */ x("office"), [a, s] = /* @__PURE__ */ m(null), r = /* @__PURE__ */ Math.max(...n.map((f) => f.uv)), c = /* @__PURE__ */ Math.max(...n.map((f) => f.ut)), u = Math.max(r, c) * 1.1 / 8, h = /* @__PURE__ */ Array.from({ length: 9 }, (f, v) => v * u);
  return d(T, { children: [e ? t(gs, { children: t("h4", { className: "secFontTxtSml", children: o(e) }) }) : null, t(un, { width: "100%", height: 400, children: d(ki, { data: n, cursor: { stroke: "blue", strokeWidth: 2 }, children: [d("defs", { children: [d("linearGradient", { id: "colorUp1", x1: "0", y1: "0", x2: "0", y2: "1", children: [t("stop", { stopColor: "#49E162", stopOpacity: "0.3" }), t("stop", { offset: "1", stopColor: "#49E162", stopOpacity: "0" })] }), d("linearGradient", { id: "colorDown1", x1: "0", y1: "0", x2: "0", y2: "1", children: [t("stop", { stopColor: "#F3EC31", stopOpacity: 0.3 }), t("stop", { offset: "1", stopColor: "#F3EC31", stopOpacity: 0 })] })] }), [...Array(10)].map((f, v) => t(hn, { y: v * u, stroke: "rgba(255, 255, 255, 0.1)" }, v)), t(Si, { content: t(us, { isTime: true }), cursor: { stroke: "#fff", strokeWidth: 1.5 } }), t(Mi, { dataKey: "name", tickLine: false, axisLine: false, tickMargin: 15, tick: t(ds, { isDate: true }) }), t(Li, { ticks: h, tickLine: false, axisLine: false, tickMargin: 15, tick: t(ps, {}) }), t(fn, { type: "monotone", dataKey: "uv", stroke: "#49E162", strokeWidth: 2, dot: false, fill: "url(#colorUp1)", strokeOpacity: a === null || a === "uv" ? 1 : 0.1, fillOpacity: a === null || a === "uv" ? 1 : 0, activeDot: { strokeWidth: 0, r: 5 } }), t(fn, { type: "monotone", dataKey: "ut", stroke: "#F3EC31", strokeWidth: 2, dot: false, fill: "url(#colorDown1)", strokeOpacity: a === null || a === "ut" ? 1 : 0.1, fillOpacity: a === null || a === "ut" ? 1 : 0, activeDot: { strokeWidth: 0, r: 5 } })] }) }), t(hs, { legend: i, setActiveIndex: s, activeIndex: a })] });
}, Fb = l.div`
  display: inline-flex;
  padding: 17px 21px;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  border-radius: 10px;
  background: #222;
`, Ob = l.div`
  display: flex;
  gap: 20px;
  align-items: center;
  width: 100%;
  justify-content: center;
`, Bb = l.button`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 5px 10px;
  /* transition: opacity 0.1s ease; */
  div {
    width: 22px;
    height: 2px;
  }

  &.hide {
    opacity: 0.1;
  }
`, li = l.div`
  width: 22px;
  height: 2px;

  &.square {
    width: 9px;
    height: 9px;
  }
`, ms = l.div`
  display: flex;
  gap: 10px;
  align-items: center;
`, gs = l.div`
  display: flex;
  justify-content: center;
  text-transform: uppercase;
`, Ub = (e, n) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(Vb, { className: "secFontTxtSmlLight", children: [t("td", { children: me({ seconds: new Date(e.name).getTime() / 1e3 }, ae().lang, true, { day: "numeric", month: "short", year: "numeric" }) }), t("td", { children: e.mo }), t("td", { children: e.gi }), t("td", { children: i("hours", { count: e.uv }) }), t("td", { children: i("hours", { count: e.ut }) })] }, n);
}, Rb = ({ data: e }) => t(Xe, { head: [{ label: "date", sort: true }, { label: "login-time", sort: true, orderKey: "loginTime" }, { label: "active-time", sort: true, orderKey: "activeTime" }, { label: "conv-time", sort: true, orderKey: "convTime" }, { label: "message-sent", sort: true }, { label: "emotes-used", sort: true }], bodyItem: Ub, members: e, filter: "" }), Hb = ({ data: e }) => {
  const n = [{ title: "active-time", color: "#49E162", index: "uv" }, { title: "conv-time", color: "#FFC107", index: "ut" }], i = [{ name: "2023-07-09", uv: 278, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-10", uv: 389, ut: 20, mo: 120, gi: 7 }, { name: "2023-07-11", uv: 239, ut: 451, mo: 200, gi: 12 }, { name: "2023-07-01", uv: 400, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-02", uv: 300, ut: 230, mo: 200, gi: 12 }, { name: "2023-07-03", uv: 1200, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-04", uv: 278, ut: 20, mo: 200, gi: 12 }, { name: "2023-07-12", uv: 349, ut: 400, mo: 200, gi: 12 }, { name: "2023-07-13", uv: 200, ut: 500, mo: 200, gi: 12 }, { name: "2023-07-14", uv: 278, ut: 550, mo: 200, gi: 12 }, { name: "2023-07-15", uv: 189, ut: 120, mo: 200, gi: 12 }, { name: "2023-07-16", uv: 239, ut: 20, mo: 200, gi: 12 }, { name: "2023-07-17", uv: 149, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-05", uv: 189, ut: 180, mo: 200, gi: 12 }, { name: "2023-07-06", uv: 239, ut: 170, mo: 200, gi: 12 }, { name: "2023-07-07", uv: 349, ut: 120, mo: 200, gi: 12 }, { name: "2023-07-08", uv: 200, ut: 200, mo: 200, gi: 12 }];
  return d(Wb, { children: [t(Eb, { user: e?.user }), t(fs, { legend: n, data: i, title: "active-conv-title" }), t(Rb, { data: i })] });
}, Wb = l.div`
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  max-width: 920px;

  .btl {
    text-transform: uppercase;
  }
`, Vb = l.tr`
  td {
    height: 68px;
    vertical-align: middle;
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`, ci = ({ data: e, onChange: n, cls: i, currentValue: o, isTime: a = true }) => {
  const s = ae().lang, r = (c) => {
    const p = new Date(c);
    return me({ seconds: p.getTime() / 1e3 }, s, true, { month: "long", year: "numeric" });
  };
  return t(Zb, { className: `${i} ${e.length < 2 ? "disable" : ""}`, children: t("select", { value: o, onChange: (c) => {
    n(c.target.value);
  }, children: e.map((c) => t("option", { value: c.value, children: a ? r(c.value) : c.label }, c.value)) }) });
}, Zb = l.div`
  display: block;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: calc(50% + 2px);
    right: 20px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #fff;
    transform: translateY(-50%);
  }

  select {
    border: none;
    border-radius: 99px;
    background: rgba(0, 0, 0, 0.4);

    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.39px;
    color: #fff;

    text-transform: capitalize;

    outline: none;

    padding: 18px 45px 18px 30px;
    min-width: 140px;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    @media all and (pointer: fine) {
      transition: background-color 0.2s ease;
      &:hover {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.7);
      }
    }
  }

  &.white {
    &::after {
      border-top-color: #000;
    }

    select {
      background: #fff;
      color: #2d2d2d;

      @media all and (pointer: fine) {
        &:hover {
          background: #e3e3e3;
        }
      }
    }
  }

  &.disable {
    pointer-events: none;
    &::after {
      display: none;
    }
    select {
      text-align: center;
      padding: 18px 30px;
    }
  }
`, Gb = ({ children: e }) => t(Jb, { className: e ? "show" : "", children: e }), qb = ({ data: e, cls: n }) => {
  const i = /* @__PURE__ */ se((a) => a.currentTimeSelected);
  return t(ci, { cls: n, data: e, onChange: (a) => {
    G({ currentTimeSelected: a });
  }, currentValue: i });
}, en = ({ leftPart: e, searchBar: n, rightPart: i }) => d(Yb, { children: [e, d(Kb, { children: [t(Gb, { children: n }), i, t(qb, { data: [{ value: "2023-1", label: "January 2023" }, { value: "2023-2", label: "February 2023" }, { value: "2023-3", label: "March 2023" }, { value: "2023-4", label: "April 2023" }] })] })] }), Yb = l.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px 10px;

  @media all and (max-width: 767px) {
    flex-direction: column;
    & > div {
      justify-content: center;
    }
  }
`, Kb = l.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  justify-content: flex-end;

  @media all and (max-width: 767px) {
    flex-wrap: wrap;
  }

  @media all and (max-width: 460px) {
    & > div,
    select {
      width: 100%;
    }
  }
`, Jb = l.div`
  position: relative;
  width: 280px;
  opacity: 0;
  transform: translate3d(0, 30px, 0);
  transition: opacity 0.3s ease, transform 0.4s ease;
  pointer-events: none;

  &.show {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    pointer-events: all;
  }

  input {
    height: 54px;
  }

  & > div {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 99px;
    width: 100%;
  }

  @media all and (max-width: 1180px) {
    width: 250px;
  }
`, Xb = (e, n, i) => d(ew, { onClick: () => {
  G({ openAdminOverlay: true, analyticsDetails: { title: "member", data: e } });
}, children: [t("td", { children: t(xt, { user: e.user }) }), t("td", { className: "secFontTxtSmlLight", children: me({ seconds: new Date(e.lastLogin).getTime() / 1e3 }, ae().lang, true, { day: "numeric", month: "short", year: "numeric" }) }), t("td", { className: "secFontTxtSmlLight", children: i("hours", { count: e.activeTime }) }), t("td", { className: "secFontTxtSmlLight", children: i("hours", { count: e.convTime }) }), t("td", { className: "details", children: t("img", { src: M["/icons/admin/details.svg"], alt: "details" }) })] }, n), Qb = ({ filter: e }) => {
  const n = [{ label: "members", sort: true }, { label: "last-login", sort: true, orderKey: "lastLogin" }, { label: "active-time", sort: true, orderKey: "activeTime" }, { label: "conv-time", sort: true, orderKey: "convTime" }, { label: "details", cls: "center" }], i = [{ user: $(), lastLogin: "2021-09-01", activeTime: 22, convTime: 33 }, { user: $(), lastLogin: "2021-09-02", activeTime: 122, convTime: 433 }];
  return t(Xe, { head: n, bodyItem: Xb, members: i, filter: e });
}, ew = l.tr`
  position: relative;
  cursor: pointer;
  td {
    position: relative;
    padding: 20px 0;
    z-index: 1;
    vertical-align: middle;
  }

  img {
    width: 32px;
    height: auto;
    clip-path: none;
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .details {
    text-align: center;
  }

  @media all and (pointer: fine) {
    background: rgba(255, 255, 255, 0);
    transition: background-color 0.3s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`, tw = ({ page: e, display: n, setDisplay: i }) => {
  const { t: o } = /* @__PURE__ */ x("office");
  return t(ow, { className: n === e ? "active" : "", onClick: () => {
    i(e);
  }, children: o(e) });
}, nw = ({ pages: e, display: n, setDisplay: i }) => t(iw, { children: e.map((o) => t(tw, { page: o, display: n, setDisplay: i }, o)) }), iw = l.div`
  display: flex;
  margin: 0 0 0 -20px;

  @media all and (max-width: 1250px) {
    margin: 0 0 0 -12px;
  }

  @media all and (max-width: 767px) {
    margin: 0;
  }
`, ow = l.button`
  position: relative;
  padding: 10px 20px;

  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.64px;
  text-transform: uppercase;
  opacity: 0.6;
  transition: opacity 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 20px;
    width: calc(100% - 40px);
    height: 2px;
    background-color: ${(e) => e.theme.colors.highlight};
    transform: scaleX(0) translateZ(0);
    transition: transform 0.3s ease;
  }

  &.active {
    opacity: 1;
    pointer-events: none;
    &::after {
      transform: scaleX(1) translateZ(0);
    }
  }

  @media all and (pointer: fine) {
    &:hover {
      opacity: 1;
    }
  }

  @media all and (max-width: 1250px) {
    padding: 10px 12px;

    &::after {
      left: 12px;
      width: calc(100% - 24px);
    }
  }

  @media all and (max-width: 767px) {
    font-size: 14px;
  }
`, xs = (e) => e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), aw = ({ data: e, isUp: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = /* @__PURE__ */ ve((a) => a.lang);
  return d(dw, { className: `${n ? "up" : "down"}${o === "ja" ? "-ja" : ""}`, children: [t("img", { src: M[`/icons/admin/stats-${n ? "up" : "down"}.svg`], alt: n ? "up" : "down" }), t("p", { children: t("span", { className: "secFontTxtSmlLight", children: i("stats-month-before", { time: xs(e.previous) }) }) })] });
}, sw = ({ value: e }) => {
  const n = /* @__PURE__ */ Math.round(e * 0.95), [i, o] = /* @__PURE__ */ m(n), a = 800, s = /* @__PURE__ */ Math.round((e - n) / (a / 10));
  return w(() => {
    const r = /* @__PURE__ */ setInterval(() => {
      i >= e ? (o(e), clearInterval(r)) : o(i + s);
    }, 10);
    return () => clearInterval(r);
  }, [i, e, s]), xs(i);
}, rw = ({ data: e, isGreen: n }) => {
  const i = e.current >= e.previous, a = Math.max(...e.charts.map((s) => s.uv)) / 4;
  return d(nn, { as: "button", className: "btn", onClick: () => {
    G({ openAdminOverlay: true, analyticsDetails: { title: e.title, data: [] } });
  }, children: [t(di, { title: e.title, more: true }), d(lw, { children: [d(cw, { children: [d(pw, { children: [t("h5", { className: "secFontTxtSmlLight", children: t(sw, { value: e.current }) }), t("span", { children: "H" })] }), t(aw, { data: e, isUp: i })] }), t(uw, { children: t(un, { width: "100%", height: "100%", children: d(ki, { data: e.charts, children: [d("defs", { children: [d("linearGradient", { id: "colorUp", x1: "0", y1: "0", x2: "0", y2: "1", children: [t("stop", { stopColor: "#49E162", stopOpacity: "0.3" }), t("stop", { offset: "1", stopColor: "#49E162", stopOpacity: "0" })] }), d("linearGradient", { id: "colorDown", x1: "0", y1: "0", x2: "0", y2: "1", children: [t("stop", { stopColor: "#F3EC31", stopOpacity: 0.3 }), t("stop", { offset: "1", stopColor: "#F3EC31", stopOpacity: 0 })] })] }), [...Array(5)].map((s, r) => t(hn, { y: r * a, stroke: "rgba(255, 255, 255, 0.1)" }, r)), t(fn, { type: "basis", dataKey: "uv", stroke: n ? "#49E162" : "#F3EC31", strokeWidth: 2, dot: false, fill: `url(#${n ? "colorUp" : "colorDown"})` })] }) }) })] })] });
}, lw = l.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 0 0;

  @media all and (max-width: 1260px) {
    flex-direction: column;
    align-items: flex-start;
  }
`, cw = l.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, dw = l.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-items: center;

  img {
    width: 10px;
    height: 10px;
    clip-path: none;
  }

  &.down,
  &.up-ja {
    color: #f33182;
  }

  &.up,
  &.down-ja {
    color: #49e162;
  }
`, pw = l.div`
  display: flex;
  gap: 7px;
  align-items: flex-end;
  h5 {
    font-size: 49px;
    line-height: 49px;
    letter-spacing: 4.9px;
  }

  span {
    font-size: 20px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 2px;
  }
`, uw = l.div`
  pointer-events: none;
  width: 100%;
  max-width: 165px;
  height: 62px;

  @media all and (max-width: 1260px) {
    max-width: 100%;
    height: 100px;
  }
`, vs = ({ isPrevious: e, currentDate: n, setCurrentDate: i, disable: o }) => t(kw, { className: `${o ? "disable" : ""} ${e ? "" : "next"}`, onClick: () => {
  const a = /* @__PURE__ */ n.getDate();
  e ? n.setDate(a - 1) : n.setDate(a + 1);
  const s = new Date(n), r = `${s.getFullYear()}-${s.getMonth() + 1}`;
  i(s), r !== Kn().currentTimeSelected && G({ currentTimeSelected: r });
}, children: t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "47", height: "46", viewBox: "0 0 47 46", fill: "none", children: t("path", { d: "M26.7922 15.7078L19.5 23L26.7922 30.2922", stroke: "white", strokeWidth: "1.71792", strokeLinecap: "round" }) }) }), hw = ({ currentDate: e, setCurrentDate: n }) => {
  const i = /* @__PURE__ */ se((s) => s.workspaceCreationDate), o = () => {
    const s = /* @__PURE__ */ new Date(), r = /* @__PURE__ */ s.setDate(s.getDate() - 1);
    return e > r;
  };
  return d(Cw, { children: [t(vs, { isPrevious: true, currentDate: e, setCurrentDate: n, disable: (() => {
    const s = new Date(e);
    return s.setDate(s.getDate() - 1), s < new Date(i);
  })() }), t(bs, { className: "sl" }), t("p", { children: me({ seconds: e.getTime() / 1e3 }, ae().lang, true, { day: "numeric", month: "short", year: "numeric" }) }), t(bs, { className: "sl" }), t(vs, { currentDate: e, setCurrentDate: n, disable: o() })] });
}, fw = () => {
  const { t: e } = /* @__PURE__ */ x("office"), n = [{ label: "total-attendances" }, { label: "total-members" }, { label: "total-guests" }, { label: "total-active-time" }];
  return t(bw, { children: n.map((i, o) => d(T, { children: [d(yw, { className: "adsi", children: [t("div", { className: "secFontTxtSml", children: e(i.label) }), t("div", { className: "secFontTxtBig value", children: Math.floor(Math.random() * 1e3) })] }, i.label), o < n.length - 1 ? t(ww, {}, `split-${o}`) : null] })) });
}, mw = (e, n, i) => {
  const o = (a) => me({ seconds: a / 1e3 }, ae().lang, false, { hour: "numeric", minute: "numeric" });
  return d(vw, { onClick: () => {
    G({ openAdminOverlay: true, analyticsDetails: { title: "member", data: e } });
  }, children: [t("td", { children: t(xt, { user: e.user }) }), t("td", { className: "secFontTxtSmlLight", children: o((/* @__PURE__ */ new Date()).getTime()) }), t("td", { className: "secFontTxtSmlLight", children: o((/* @__PURE__ */ new Date()).getTime()) }), t("td", { className: "secFontTxtSmlLight", children: i("hours", { count: e.convTime }) }), t("td", { className: "details", children: t("img", { src: M["/icons/admin/details.svg"], alt: "details" }) })] }, n);
}, gw = ({ filter: e }) => {
  const n = /* @__PURE__ */ se((r) => r.currentTimeSelected), [i, o] = /* @__PURE__ */ m(/* @__PURE__ */ new Date(n + "-01"));
  w(() => {
    const r = new Date(i);
    if (`${r.getFullYear()}-${r.getMonth() + 1}` !== n) {
      const p = new Date(n), u = new Date(Kn().workspaceCreationDate);
      o(p >= u ? p : u);
    }
  }, [n, i]);
  const a = [{ label: "members", sort: true }, { label: "last-login", sort: true, orderKey: "lastLogin" }, { label: "last-logout", sort: true, orderKey: "convTime" }, { label: "active-time", sort: true, orderKey: "activeTime" }, { label: "details", cls: "center" }], s = [{ user: $(), lastLogin: "2021-09-01", activeTime: 22, convTime: 33 }, { user: $(), lastLogin: "2021-09-02", activeTime: 122, convTime: 433 }];
  return d(xw, { children: [t(hw, { currentDate: i, setCurrentDate: o }), t(fw, {}), t(Xe, { head: a, bodyItem: mw, members: s, filter: e })] });
}, xw = l.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`, vw = l.tr`
  position: relative;
  cursor: pointer;
  td {
    position: relative;
    padding: 20px 0;
    z-index: 1;
    vertical-align: middle;
  }

  img {
    width: 32px;
    height: auto;
    clip-path: none;
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .details {
    text-align: center;
  }

  @media all and (pointer: fine) {
    background: rgba(255, 255, 255, 0);
    transition: background-color 0.3s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`, bw = l.div`
  display: flex;
  padding: 30px;
  align-items: flex-start;
  gap: 15px;
  border-radius: 10px;
  background: #3a3a3a;
  justify-content: space-around;
  @media all and (max-width: 760px) {
    padding: 30px 15px;
    flex-wrap: wrap;
    gap: 20px 15px;
    & > div {
      &:nth-child(4) {
        display: none;
      }
    }
    .adsi {
      text-align: center;
      width: calc(50% - 16px);
      align-items: center;
    }
  }
`, ww = l.div`
  width: 1px;
  height: 68px;
  background: #fff;
  opacity: 0.1;
`, yw = l.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .value {
    font-weight: 200;
    font-size: 49px;
    line-height: 26px;
    letter-spacing: 4.9px;
  }

  @media all and (max-width: 1100px) {
    .value {
      font-size: 40px;
      line-height: 26px;
      letter-spacing: 4px;
    }
  }
`, Cw = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  p {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: 0.9px;
    min-width: 230px;
  }

  @media all and (max-width: 560px) {
    gap: 10px;
    p {
      font-size: 24px;
      line-height: 24px;
      letter-spacing: 0.72px;
      width: 100%;
    }
    .sl {
      display: none;
    }
  }
`, bs = l.div`
  width: 100%;
  max-width: 78px;
  height: 1px;
  background: #fff;
  opacity: 0.1;
`, kw = l.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  min-width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  isolation: isolate;

  &.next {
    svg {
      transform: rotate(180deg);
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #000;
    opacity: 0.2;
    z-index: 0;
  }

  svg {
    position: relative;
    z-index: 1;
  }

  &.disable {
    pointer-events: none;
    opacity: 0.2;
  }

  @media all and (pointer: fine) {
    &::before {
      transition: opacity 0.2s ease;
    }
    &:hover::before {
      opacity: 0.9;
    }
  }
`, Sw = ({ success: e, specId: n }) => d(Tw, { children: [d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "117", height: "63", viewBox: "0 0 117 63", fill: "none", children: [t("path", { d: "M104.117 47.0381L104.015 47.4417L104.267 47.773L115.199 62.1374H4.60892C2.35817 62.1374 0.709395 60.0182 1.26283 57.8365L15.0554 3.46627C15.4438 1.93517 16.8219 0.86302 18.4015 0.86302H111.394C113.644 0.86302 115.293 2.98228 114.74 5.16393L104.117 47.0381Z", stroke: `url(#paint0-${n})`, strokeWidth: "1.72604" }), t("defs", { children: d("linearGradient", { id: `paint0-${n}`, x1: "9.0625", y1: "-5.44751e-07", x2: "110.9", y2: "95.4296", gradientUnits: "userSpaceOnUse", children: [t("stop", { stopColor: e ? "#0066FF" : "#8A8A8A" }), t("stop", { offset: "1", stopColor: e ? "#FB47FF" : "#8A8A8A" })] }) })] }), d("svg", { className: "txt", width: "73", height: "42", viewBox: "0 0 73 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [t("path", { d: "M0.300927 28.9546V28.0916H-0.562093V28.9546H0.300927ZM9.54387 28.9546H10.4069V28.0916H9.54387V28.9546ZM11.0542 23.9404L10.9714 24.7995L11.4292 24.8436L11.721 24.4882L11.0542 23.9404ZM2.89862 23.1551L2.06137 22.9458L1.81829 23.9181L2.81589 24.0141L2.89862 23.1551ZM8.27523 1.64864V0.785624H7.60141L7.43798 1.43933L8.27523 1.64864ZM34.4938 1.64864L35.3419 1.80813L35.5342 0.785624H34.4938V1.64864ZM33.1647 8.71677V9.57979H33.8806L34.0129 8.87626L33.1647 8.71677ZM14.558 8.71677V7.85375H13.889L13.7222 8.50163L14.558 8.71677ZM12.9873 14.8183L12.1515 14.6032L11.6959 16.3734L13.3523 15.6004L12.9873 14.8183ZM31.1539 25.4507C31.1539 33.2865 24.6781 40.5967 14.4976 40.5967V42.3228C25.5819 42.3228 32.8799 34.2885 32.8799 25.4507H31.1539ZM14.4976 40.5967C10.4669 40.5967 7.13536 39.5593 4.82703 37.6265C2.53983 35.7113 1.16395 32.8403 1.16395 28.9546H-0.562093C-0.562093 33.2849 0.991971 36.6664 3.71892 38.9498C6.42474 41.2155 10.1916 42.3228 14.4976 42.3228V40.5967ZM0.300927 29.8176H9.54387V28.0916H0.300927V29.8176ZM8.68085 28.9546C8.68085 30.6721 9.2075 32.1779 10.3515 33.2474C11.4876 34.3097 13.1153 34.8318 15.1017 34.8318V33.1057C13.403 33.1057 12.2518 32.6612 11.5303 31.9866C10.8166 31.3194 10.4069 30.3181 10.4069 28.9546H8.68085ZM15.1017 34.8318C17.5898 34.8318 19.7013 33.9132 21.1844 32.2843C22.6605 30.6632 23.4557 28.4043 23.4557 25.8132H21.7297C21.7297 28.055 21.0449 29.8739 19.9082 31.1223C18.7785 32.363 17.1445 33.1057 15.1017 33.1057V34.8318ZM23.4557 25.8132C23.4557 24.2227 23.0409 22.7548 22.0158 21.6827C20.9837 20.6033 19.4595 20.0569 17.5182 20.0569V21.7829C19.1411 21.7829 20.1542 22.2333 20.7683 22.8755C21.3895 23.5252 21.7297 24.5039 21.7297 25.8132H23.4557ZM17.5182 20.0569C14.2017 20.0569 11.9152 21.5326 10.3873 23.3927L11.721 24.4882C12.972 22.9653 14.7935 21.7829 17.5182 21.7829V20.0569ZM11.1369 23.0814L2.98134 22.2961L2.81589 24.0141L10.9714 24.7995L11.1369 23.0814ZM3.73587 23.3644L9.11248 1.85796L7.43798 1.43933L2.06137 22.9458L3.73587 23.3644ZM8.27523 2.51166H34.4938V0.785624H8.27523V2.51166ZM33.6456 1.48916L32.3166 8.55729L34.0129 8.87626L35.3419 1.80813L33.6456 1.48916ZM33.1647 7.85375H14.558V9.57979H33.1647V7.85375ZM13.7222 8.50163L12.1515 14.6032L13.8231 15.0335L15.3938 8.93192L13.7222 8.50163ZM13.3523 15.6004C15.0346 14.8153 16.9007 14.4127 19.2097 14.4127V12.6867C16.6857 12.6867 14.5647 13.1298 12.6224 14.0363L13.3523 15.6004ZM19.2097 14.4127C23.3013 14.4127 26.2639 15.5992 28.2017 17.5095C30.1398 19.4203 31.1539 22.1548 31.1539 25.4507H32.8799C32.8799 21.7993 31.7494 18.5833 29.4134 16.2804C27.077 13.977 23.6361 12.6867 19.2097 12.6867V14.4127ZM52.3859 40.5967C48.3446 40.5967 45.2965 39.3332 43.2458 37.0142C41.1806 34.6787 40.0189 31.1507 40.0189 26.4173H38.2928C38.2928 31.4101 39.5173 35.4034 41.9528 38.1576C44.4028 40.9282 47.9697 42.3228 52.3859 42.3228V40.5967ZM40.0189 26.4173C40.0189 20.1627 41.7917 13.9076 45.0442 9.2404C48.2859 4.58864 52.9662 1.54508 58.8499 1.54508V-0.18096C52.289 -0.18096 47.1222 3.2395 43.6281 8.25356C40.1446 13.2522 38.2928 19.8647 38.2928 26.4173H40.0189ZM58.8499 1.54508C62.8913 1.54508 65.9394 2.80859 67.9901 5.12763C70.0553 7.46311 71.217 10.9911 71.217 15.7245H72.9431C72.9431 10.7317 71.7186 6.73843 69.2831 3.98425C66.8331 1.21363 63.2662 -0.18096 58.8499 -0.18096V1.54508ZM71.217 15.7245C71.217 21.9791 69.4441 28.2342 66.1917 32.9014C62.95 37.5532 58.2697 40.5967 52.3859 40.5967V42.3228C58.9469 42.3228 64.1136 38.9023 67.6078 33.8882C71.0912 28.8896 72.9431 22.2771 72.9431 15.7245H71.217ZM58.125 7.49129C54.8867 7.49129 52.2965 10.197 50.5699 13.6964C48.8122 17.2589 47.7774 21.9536 47.7774 26.5985H49.5034C49.5034 22.1818 50.4924 17.7543 52.1178 14.4601C53.7742 11.1029 55.9263 9.21733 58.125 9.21733V7.49129ZM47.7774 26.5985C47.7774 29.0208 48.161 31.007 49.0317 32.4142C49.9413 33.8842 51.341 34.6505 53.1109 34.6505V32.9245C51.9206 32.9245 51.085 32.4523 50.4995 31.506C49.875 30.4966 49.5034 28.8883 49.5034 26.5985H47.7774ZM53.1109 34.6505C56.3492 34.6505 58.9394 31.9448 60.666 28.4454C62.4237 24.8829 63.4585 20.1883 63.4585 15.5433H61.7324C61.7324 19.96 60.7434 24.3875 59.1181 27.6817C57.4616 31.0389 55.3095 32.9245 53.1109 32.9245V34.6505ZM63.4585 15.5433C63.4585 13.121 63.0749 11.1348 62.2042 9.72765C61.2946 8.25756 59.8949 7.49129 58.125 7.49129V9.21733C59.3153 9.21733 60.1508 9.68949 60.7364 10.6358C61.3609 11.6452 61.7324 13.2535 61.7324 15.5433H63.4585Z", fill: `url(#paint2-${n})` }), t("defs", { children: d("linearGradient", { id: `paint2-${n}`, x1: "-3.98828", y1: "-2.50684", x2: "114.223", y2: "58.9941", gradientUnits: "userSpaceOnUse", children: [t("stop", { stopColor: e ? "#0066FF" : "#8A8A8A" }), t("stop", { offset: "1", stopColor: e ? "#FB47FF" : "#8A8A8A" })] }) })] })] }), Mw = ({ percent: e, delta: n }) => {
  const [i, o] = /* @__PURE__ */ m(0);
  return w(() => {
    setTimeout(() => {
      o(e);
    }, 300 + 100 * n);
  }, [e, n]), d(Nw, { children: [t("div", { className: "pb", style: { transform: `scaleX(${1 - i}) translateZ(0)` } }), t("div", { className: "msk" })] });
}, Lw = ({ data: e, delta: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = e.current >= e.target, [a, s] = /* @__PURE__ */ m(false);
  return w(() => {
    const r = /* @__PURE__ */ setTimeout(() => {
      s(true);
    }, 50 + 70 * n);
    return () => clearTimeout(r);
  }, [n]), d(nn, { className: `awards anim ${a ? "show" : ""}`, children: [d(Iw, { children: [t(Sw, { success: o, specId: e.title }), d($w, { children: [t("h6", { className: "normalTxt", children: i(e.title, { target: e.target }) }), t("p", { className: "secFontTxtSmlLight", dangerouslySetInnerHTML: { __html: i("currently", { value: `${e.current}/${e.target}` }) } })] })] }), t(Mw, { percent: e.current / e.target, delta: n })] });
}, Iw = l.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 20px;
`, $w = l.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  text-align: center;

  h6 {
    line-height: 23px;
    letter-spacing: 0.42px;
  }

  p {
    font-size: 9px;
    line-height: 15px;
    letter-spacing: 0.9px;
    text-transform: uppercase;
  }
`, Tw = l.div`
  position: relative;

  .txt {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`, Nw = l.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  max-width: 168px;
  height: 9px;
  background: linear-gradient(90deg, #06f 0%, #fb47ff 90%);

  .pb {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #8a8a8a;
    right: 0;
    bottom: 0;
    z-index: 0;
    transition: transform 0.6s ease;
    transform-origin: right center;
  }

  &::before,
  &::after,
  .msk {
    content: '';
    position: absolute;
    bottom: 0;
    background: #3a3a3a;
    height: 100%;
    width: 3.57%;
    z-index: 1;
  }

  &::before {
    left: 30.95%;
  }

  &::after {
    right: 30.95%;
  }

  .msk {
    bottom: auto;
    top: 0;
    height: 3px;
    width: 100%;
    clip-path: polygon(0 0, 100% 0, 96% 100%, 0% 100%);
  }
`, ws = ({ title: e, data: n, legend: i, fromDetails: o, options: a = { barWidth: 15, barGap: 10 } }) => {
  const { t: s } = /* @__PURE__ */ x("office"), [r, c] = /* @__PURE__ */ m(null), p = o ? 10 : 6, u = o ? 300 : 500, h = /* @__PURE__ */ Math.max(...n.map((L) => L.uv)), f = /* @__PURE__ */ Math.max(...n.map((L) => L.ut)), g = Math.max(h, f) / (p - 2), y = /* @__PURE__ */ Array.from({ length: p - 1 }, (L, I) => I * g);
  return d(T, { children: [e ? t(gs, { children: t("h4", { className: "secFontTxtSml", children: s(e) }) }) : null, t(un, { width: "100%", height: o ? 400 : 200, children: d(or, { data: n, cursor: { stroke: "blue", strokeWidth: 2 }, children: [[...Array(p)].map((L, I) => t(hn, { y: I * g, stroke: "rgba(255, 255, 255, 0.1)" }, I)), t(Si, { content: t(us, { isSquare: true }), cursor: { strokeWidth: 0, fill: "#fff", fillOpacity: 0.1 } }), t(Ii, { dataKey: "uv", fill: "#49E162", fillOpacity: r === null || r === "uv" ? 1 : 0.1, barSize: a.barWidth, barGap: a.barGap, animationBegin: u }), t(Ii, { dataKey: "ut", fill: "#F3EC31", fillOpacity: r === null || r === "ut" ? 1 : 0.1, barSize: a.barWidth, barGap: a.barGap, animationBegin: u }), t(Mi, { dataKey: "name", tickLine: false, axisLine: false, tickMargin: 15, tick: t(ds, {}) }), t(Li, { ticks: y, tickLine: false, axisLine: false, tickMargin: 15, tick: t(ps, {}) })] }) }), t(hs, { legend: i, setActiveIndex: c, activeIndex: r, isSquare: true })] });
}, Aw = ({ data: e, title: n }) => {
  const i = [{ title: "stayed-time", color: "#49E162", index: "uv" }, { title: "chat-time", color: "#F3EC31", index: "ut" }], [o, a] = /* @__PURE__ */ m(false);
  return w(() => {
    const s = /* @__PURE__ */ setTimeout(() => {
      a(true);
    }, 400);
    return () => clearTimeout(s);
  }, []), d(nn, { as: "button", className: `btn anim ${o ? "show" : ""}`, onClick: () => {
    G({ openAdminOverlay: true, analyticsDetails: { title: n, data: [] } });
  }, children: [t(di, { title: n, more: true }), t(Ew, { children: t(Dw, { children: t(ws, { data: e, legend: i }) }) })] });
}, Ew = l.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 0 0;

  @media all and (max-width: 1260px) {
    flex-direction: column;
    align-items: flex-start;
  }

  pointer-events: none;
`, Dw = l.div`
  width: 100%;
  max-width: 100%;
`, di = ({ title: e, more: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(Ww, { children: [t("h5", { className: "secFontTxtSml", children: i(e) }), n ? t(Vw, { className: "odb secFontTxtSmlLight", children: t("span", { children: i("view-details") }) }) : null] });
}, tn = ({ title: e, children: n, cls: i }) => {
  const { t: o } = /* @__PURE__ */ x("office");
  return d(Hw, { className: i, children: [e ? t("h4", { className: "secFontTxtSml", children: o(e) }) : null, t("div", { children: n })] });
}, zw = () => t(tn, { cls: "sumstats", children: [{ title: "total-active-time", current: 3232, previous: 2422, green: true, charts: [{ name: "2023-07-01", uv: 400 }, { name: "2023-07-02", uv: 300 }, { name: "2023-07-03", uv: 200 }, { name: "2023-07-04", uv: 278 }, { name: "2023-07-05", uv: 189 }, { name: "2023-07-06", uv: 239 }, { name: "2023-07-07", uv: 349 }, { name: "2023-07-08", uv: 200 }, { name: "2023-07-09", uv: 278 }, { name: "2023-07-10", uv: 389 }, { name: "2023-07-11", uv: 39 }, { name: "2023-07-12", uv: 349 }] }, { title: "total-conv-time", current: 1224, previous: 2001, charts: [{ name: "2023-07-09", uv: 278 }, { name: "2023-07-10", uv: 389 }, { name: "2023-07-11", uv: 239 }, { name: "2023-07-01", uv: 400 }, { name: "2023-07-02", uv: 300 }, { name: "2023-07-03", uv: 1200 }, { name: "2023-07-04", uv: 278 }, { name: "2023-07-12", uv: 349 }, { name: "2023-07-13", uv: 200 }, { name: "2023-07-14", uv: 278 }, { name: "2023-07-15", uv: 189 }, { name: "2023-07-16", uv: 239 }, { name: "2023-07-17", uv: 149 }, { name: "2023-07-05", uv: 189 }, { name: "2023-07-06", uv: 239 }, { name: "2023-07-07", uv: 349 }, { name: "2023-07-08", uv: 200 }] }].map((n) => t(rw, { data: n, isGreen: n.green }, n.title)) }), Pw = () => {
  const e = [{ title: "most-conversational", valueTranslation: "hours", list: [{ user: $(), count: 46 }, { user: $(), count: 42 }, { user: $(), count: 40 }, { user: $(), count: 38 }, { user: $(), count: 1 }] }, { title: "most-expressive", valueTranslation: "emote", list: [{ user: $(), count: 172 }, { user: $(), count: 86 }, { user: $(), count: 30 }, { user: $(), count: 28 }, { user: $(), count: 1 }] }];
  return t(tn, { title: "top-active-members", cls: "tam", children: e.map((n) => t(qw, { data: n }, n.title)) });
}, _w = () => t(tn, { cls: "sumstats", children: t(Aw, { data: [{ name: "lobby", uv: 389, ut: 20, mo: 120, gi: 7 }, { name: "workspace", uv: 278, ut: 200, mo: 200, gi: 12 }, { name: "Main meeting room", uv: 239, ut: 451, mo: 200, gi: 12 }, { name: "Small Meeting Room", uv: 400, ut: 200, mo: 200, gi: 12 }, { name: "Break area", uv: 300, ut: 230, mo: 200, gi: 12 }], title: "activities-by-area" }) }), jw = () => t(tn, { title: "monthly-awards", cls: "mawards", children: [{ title: "awards-host-meeting", current: 50, target: 50 }, { title: "awards-send-msg", current: 12, target: 50 }, { title: "awards-celebrate", current: 33, target: 50 }, { title: "awards-emote", current: 28, target: 50 }].map((n, i) => t(Lw, { data: n, delta: i }, n.title)) }), Fw = () => d(T, { children: [t(zw, {}), t(jw, {}), t(_w, {}), t(Pw, {})] }), Ow = ({ display: e, setDisplay: n }) => t(nw, { pages: ["general", "members", "attendances"], display: e, setDisplay: n }), Bw = /* @__PURE__ */ Be(null), Uw = () => {
  const [e, n] = /* @__PURE__ */ m("general"), [i, o] = /* @__PURE__ */ m(""), a = /* @__PURE__ */ Y(() => ({ text: i }), [i]);
  return t(Rw, { children: d(Bw.Provider, { value: a, children: [t(en, { leftPart: t(Ow, { display: e, setDisplay: n }), searchBar: e === "general" ? null : t(At, { setText: o, placeholder: "search-name-email", tr: "office" }) }), e === "general" ? t(Fw, {}) : e === "members" ? t(Qb, { filter: i }) : e === "attendances" ? t(gw, { filter: i }) : null] }) });
}, Rw = l.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`, Hw = l.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > h4 {
    text-transform: uppercase;
  }

  & > div {
    display: flex;
    gap: 20px;
  }

  &.sumstats {
    & > div {
      flex-wrap: wrap;
      & > div {
        flex: 1;
        min-width: 385px;
      }
    }
  }

  &.mawards {
    & > div {
      flex-wrap: wrap;
      & > div {
        flex: 1;
        min-width: 180px;
      }
    }
  }

  &.tam {
    & > div {
      flex-wrap: wrap;
      & > div {
        flex: 1;
        min-width: 375px;
      }
    }
  }

  @media all and (max-width: 1279px) {
    & > div {
      gap: 10px;
    }

    .sumstats {
      flex-direction: column;
    }
  }

  @media all and (max-width: 660px) {
    &.tam .btn {
      min-width: 310px;
    }
  }

  @media all and (max-width: 600px) {
    &.tam,
    &.sumstats {
      & > div {
        & > div {
          min-width: 100%;
        }
      }
    }
  }

  @media all and (max-width: 360px) {
    &.tam .btn {
      min-width: 100%;
    }
  }
`, nn = l.div`
  position: relative;
  padding: 30px;
  gap: 20px;
  flex: 1 0 0;
  border-radius: 10px;
  background: #3a3a3a;
  width: 100%;

  &.awards {
    padding: 30px 10px;
  }

  &.anim {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
    transition: transform 0.5s ease, opacity 0.3s ease;
    &.show {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }

  @media all and (max-width: 1200px) {
    padding: 20px;
  }

  &.btn {
    @media all and (pointer: fine) {
      transition: background-color 0.3s ease;

      &.anim {
        transition: transform 0.5s ease, opacity 0.3s ease,
          background-color 0.3s ease;
      }

      &:hover {
        background-color: #4b4b4b;
        .odb {
          &::before {
            opacity: 1;
          }
        }
      }
    }
  }
`, Ww = l.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`, Vw = l.p`
  position: relative;
  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      width: calc(100% + 26px);
      height: calc(100% + 14px);
      top: -7px;
      left: -13px;
      border-radius: 20px;
      background: #2d2d2d;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    span {
      position: relative;
      z-index: 1;
    }
  }
`, Zw = (e) => {
  const n = ["th", "st", "nd", "rd"], i = e % 100;
  return n[(i - 20) % 10] || n[i] || n[0];
}, ys = ({ index: e }) => t(Yw, { children: d("p", { className: e === 1 ? "first" : e === 2 ? "second" : e === 3 ? "third" : "", children: [e, t("span", { children: Zw(e) })] }) }), Gw = ({ data: e, index: n, valueTranslation: i }) => {
  const { t: o } = /* @__PURE__ */ x("office");
  return d(Kw, { children: [d(Xw, { children: [t(ys, { index: n + 1 }), t(xt, { user: e.user, showEmail: false })] }), t("span", { children: o(i, { count: e.count }) })] });
}, qw = ({ data: e }) => d(nn, { as: "button", className: "btn", onClick: () => {
  G({ openAdminOverlay: true, analyticsDetails: { title: e.title, data: [] } });
}, children: [t(di, { title: e.title, more: true }), t(Jw, { children: e.list.map((n, i) => t(Gw, { data: n, index: i, valueTranslation: e.valueTranslation }, `${e.title + i}`)) })] }), Yw = l.div`
  min-width: 28px;
  p {
    color: #838383;
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.84px;
    text-transform: uppercase;

    span {
      font-size: 8px;
    }

    &.first {
      color: #ffd700;
    }
    &.second {
      color: #c0c0c0;
    }
    &.third {
      color: #cd7f32;
    }
  }
`, Kw = l.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 0;
`, Jw = l.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 0;

  & > div {
    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
`, Xw = l.div`
  display: flex;
  align-items: center;
  gap: 5px;
`, Qw = (e, n, i) => d(o4, { children: [t("td", { children: t(ys, { index: n + 1 }) }), t("td", { children: t(xt, { user: e.user }) }), t("td", { className: "secFontTxtSmlLight", children: e.count })] }, n), e4 = ({ data: e, filter: n }) => {
  const i = [{ label: "rank", sort: true }, { label: "members", sort: true }, { label: "conv-time", sort: true, orderKey: "count" }], o = [{ user: $(), count: 46 }, { user: $(), count: 42 }, { user: $(), count: 40 }, { user: $(), count: 38 }, { user: $(), count: 1 }, { user: $(), count: 1 }, { user: $(), count: 1 }, { user: $(), count: 1 }, { user: $(), count: 1 }, { user: $(), count: 1 }, { user: $(), count: 1 }, { user: $(), count: 1 }];
  return t(Xe, { head: i, bodyItem: Qw, members: o, filter: n });
}, t4 = /* @__PURE__ */ Be(null), n4 = ({ data: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), [i, o] = /* @__PURE__ */ m(""), a = /* @__PURE__ */ Y(() => ({ text: i }), [i]);
  return t(t4.Provider, { value: a, children: d(i4, { children: [t(en, { leftPart: t("h2", { className: "secFontTxtMed btl", children: n(e?.title) }), searchBar: t(At, { setText: o, placeholder: "search-name-email", tr: "office" }) }), t(e4, { data: e?.list, filter: i })] }) });
}, i4 = l.div`
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  max-width: 920px;

  .btl {
    text-transform: uppercase;
  }
`, o4 = l.tr`
  td {
    height: 68px;
    vertical-align: middle;
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`, a4 = (e, n) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(c4, { className: "secFontTxtSmlLight", children: [t("td", { children: me({ seconds: new Date(e.name).getTime() / 1e3 }, ae().lang, true, { day: "numeric", month: "long", year: "numeric" }) }), t("td", { children: e.mo }), t("td", { children: e.gi }), t("td", { children: i("hours", { count: e.uv }) }), t("td", { children: i("hours", { count: e.ut }) })] }, n);
}, s4 = ({ data: e }) => t(Xe, { head: [{ label: "date", sort: true }, { label: "members-online", sort: true, orderKey: "mo" }, { label: "guests-invited", sort: true, orderKey: "gi" }, { label: "active-time", sort: true, orderKey: "uv" }, { label: "conv-time", sort: true, orderKey: "ut" }], bodyItem: a4, members: e, filter: "" }), r4 = ({ data: e }) => {
  const n = [{ title: "active-time", color: "#49E162", index: "uv" }, { title: "conv-time", color: "#FFC107", index: "ut" }], i = [{ name: "2023-07-10", uv: 389, ut: 20, mo: 120, gi: 7 }, { name: "2023-07-09", uv: 278, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-11", uv: 239, ut: 451, mo: 200, gi: 12 }, { name: "2023-07-01", uv: 400, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-02", uv: 300, ut: 230, mo: 200, gi: 12 }, { name: "2023-07-03", uv: 1200, ut: 1200, mo: 200, gi: 12 }, { name: "2023-07-04", uv: 278, ut: 20, mo: 200, gi: 12 }, { name: "2023-07-12", uv: 349, ut: 400, mo: 200, gi: 12 }, { name: "2023-07-13", uv: 200, ut: 500, mo: 200, gi: 12 }, { name: "2023-07-14", uv: 278, ut: 550, mo: 200, gi: 12 }, { name: "2023-07-15", uv: 189, ut: 120, mo: 200, gi: 12 }, { name: "2023-07-16", uv: 239, ut: 20, mo: 200, gi: 12 }, { name: "2023-07-17", uv: 149, ut: 200, mo: 200, gi: 12 }, { name: "2023-07-05", uv: 189, ut: 180, mo: 200, gi: 12 }, { name: "2023-07-06", uv: 239, ut: 170, mo: 200, gi: 12 }, { name: "2023-07-07", uv: 349, ut: 120, mo: 200, gi: 12 }, { name: "2023-07-08", uv: 200, ut: 200, mo: 200, gi: 12 }], { t: o } = /* @__PURE__ */ x("office");
  return d(l4, { children: [t(en, { leftPart: t("h2", { className: "secFontTxtMed btl", children: o("active-conv-title") }) }), t(fs, { legend: n, data: i }), t(s4, { data: i })] });
}, l4 = l.div`
  padding: 60px 0;
  width: 100%;
  max-width: 920px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .btl {
    text-transform: uppercase;
  }
`, c4 = l.tr`
  td {
    height: 68px;
    vertical-align: middle;
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`, d4 = (e, n) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return d(m4, { className: "secFontTxtSmlLight", children: [t("td", { children: e.name }), t("td", { children: e.mo }), t("td", { children: i("hours", { count: e.gi }) }), t("td", { children: i("hours", { count: e.uv }) })] }, n);
}, p4 = ({ data: e }) => t(Xe, { head: [{ label: "areas", sort: true, orderKey: "name" }, { label: "members-entered", sort: true, orderKey: "mo" }, { label: "stayed-time", sort: true, orderKey: "gi" }, { label: "chat-time", sort: true, orderKey: "uv" }], bodyItem: d4, members: e, filter: "" }), u4 = ({ currentOffice: e, setCurrentOffice: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), o = [{ label: i("all-offices"), value: "all" }, { label: "beach-office", value: "beach" }, { label: "mountain-office", value: "mountain" }];
  return t(ci, { data: o, currentValue: e, onChange: (a) => {
    n(a);
  }, isTime: false });
}, h4 = ({ data: e, title: n }) => {
  const [i, o] = /* @__PURE__ */ m("all"), a = [{ title: "stayed-time", color: "#49E162", index: "uv" }, { title: "chat-time", color: "#F3EC31", index: "ut" }], s = [{ name: "lobby", uv: 389, ut: 20, mo: 120, gi: 7 }, { name: "workspace", uv: 278, ut: 200, mo: 200, gi: 12 }, { name: "Main meeting room", uv: 239, ut: 451, mo: 200, gi: 12 }, { name: "Small Meeting Room", uv: 400, ut: 200, mo: 200, gi: 12 }, { name: "Break area", uv: 300, ut: 230, mo: 200, gi: 12 }], { t: r } = /* @__PURE__ */ x("office");
  return d(f4, { children: [t(en, { leftPart: t("h2", { className: "secFontTxtMed btl", children: r(n) }), rightPart: t(u4, { currentOffice: i, setCurrentOffice: o }) }), t(ws, { legend: a, data: s, fromDetails: true }), t(p4, { data: s })] });
}, f4 = l.div`
  padding: 60px 0;
  width: 100%;
  max-width: 920px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .btl {
    text-transform: uppercase;
  }
`, m4 = l.tr`
  td {
    height: 68px;
    vertical-align: middle;
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`, g4 = () => {
  const [e, n] = /* @__PURE__ */ se((s) => [s.openAdminOverlay, s.analyticsDetails]), [i, o] = /* @__PURE__ */ m("2023-1"), a = () => ["total-active-time", "total-conv-time"].includes(n?.title) ? t(r4, { data: n }) : ["most-conversational", "most-expressive"].includes(n?.title) ? t(n4, { data: n }) : n?.title === "activities-by-area" ? t(h4, { data: n?.data, title: n?.title }) : t(Hb, { data: n?.data, filter: i });
  return t(_e, { cls: `create ${e ? "show" : ""}`, icon: "/icons/admin/stats.svg", title: n?.title, actionButtonLabel: "", backButton: true, rightActionDefault: n?.title !== "member" ? null : t(ci, { cls: "white", data: [{ label: "January 2023", value: "2023-1" }, { label: "February 2023", value: "2023-2" }], onChange: (s) => {
    o(s);
  } }), children: e ? a() : null });
}, x4 = (e) => {
  const n = /* @__PURE__ */ se((i) => i.openAdminOverlay);
  return w(() => {
    G({ currentSectionAdmin: e?.section });
  }), d(T, { children: [t(De, {}), t(_e, { cls: `${n ? "hide" : ""}`, icon: "/icons/admin/stats.svg", title: "activities", actionButtonLabel: "", ...e, children: t(v4, { children: t(Uw, {}) }) }), t(g4, {})] });
}, v4 = l.div`
  width: 100%;
  max-width: 900px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 60px;
`, Cs = ({ visual: e, children: n }) => d(T, { children: [t("img", { src: M[e], alt: "office", className: "bg" }), n] }), ks = ({ data: e }) => d(T, { children: [d(w4, { children: [e.icon ? t("img", { src: M["/icons/on.svg"], alt: "on" }) : null, t(te, { title: e.title, desc: e.desc, tr: "office" })] }), e.btn ? t(ye, { className: "center nopt", children: t(B, { label: e.btn, onClick: e.action, cls: "white", tr: "office" }) }) : null, e.subBtn ? e.subBtn : null] }), Ss = ({ leftPart: e, rightPart: n }) => t(xe, { className: "split-mdl", children: d(b4, { children: [t(C4, { children: e }), t(y4, { children: n })] }) }), b4 = l.div`
  display: flex;
  align-items: center;
  background: #2d2d2d;
  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
  }
`, w4 = l.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  justify-content: center;

  img {
    width: 50px;
    height: 50px;
    clip-path: none;
  }
`, y4 = l.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 50px;
  text-align: center;
  width: 100%;

  img {
    margin: 0 auto;
  }

  @media all and (max-width: 720px) {
    padding: 50px 30px;
  }
`, C4 = l.div`
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    clip-path: none;
    z-index: 0;
  }

  img,
  .num,
  .daysleft,
  svg,
  h4,
  .top-cntr-icn {
    position: absolute;
  }

  .top-cntr-icn {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .num,
  .daysleft,
  h4 {
    font-family: 'Mundial';
    z-index: 1;
  }

  .num {
    left: -98px;
    bottom: -14px;
    font-weight: 600;
    font-size: 387px;
    line-height: 367px;
  }

  .daysleft {
    font-weight: 700;
    font-size: 32px;
    line-height: 30px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    top: 70px;
    left: 74px;
  }

  svg {
    top: 40px;
    left: 40px;
    width: 24px;
    height: 24px;
    z-index: 1;
  }

  h4 {
    left: 0;
    width: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 118px;
    line-height: 97px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    top: 50%;
    transform: translateY(-50%);
  }
`, k4 = ({ accountType: e }) => {
  const n = e === 999;
  return t(Ss, { leftPart: t(Cs, { visual: "/office/bg-error.webp", children: t(S4, { className: "top-cntr-icn", children: t("img", { src: M["/office/lock-workspace.svg"], alt: "lock-workspace" }) }) }), rightPart: t(ks, { data: { icon: false, title: "trial-finished", desc: `trial-finished-desc${n ? "" : "-not-admin"}`, btn: n ? "upgrade-plan" : null, action: () => {
    window.open("/admin/billing", "_blank");
  }, subBtn: n ? t("div", { children: t(et, { label: "need-help", action: () => {
    let i = "com";
    const o = ae().lang;
    o === "fr" ? i = "fr" : o === "ja" && (i = "jp"), window.open(`https://www.konpi.${i}/contact-us`, "_blank");
  } }) }) : null } }) });
}, S4 = l.div`
  img {
    width: 155px;
    height: auto;
  }
`, M4 = ({ accountType: e }) => d(L4, { children: [t("img", { src: M["/workspace/background-disable.webp"], alt: "bg" }), t(k4, { accountType: e })] }), L4 = l.div`
  position: fixed;
  inset: 0;
  pointer-events: all;
  z-index: 2;
  background: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;

  & > img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  & > div {
    position: relative;
    z-index: 1;
  }
`, I4 = ({ title: e = "workspace-unavailable", desc: n = "workspace-unavailable-desc", help: i = "need-help-konpi-team", tr: o = "office" }) => {
  const { t: a } = /* @__PURE__ */ x(o);
  return t($4, { children: d("div", { children: [t(Kt, {}), t("h4", { dangerouslySetInnerHTML: { __html: a(e) } }), t("p", { dangerouslySetInnerHTML: { __html: a(n) } }), i ? t("p", { dangerouslySetInnerHTML: { __html: a(i) } }) : null] }) });
}, $4 = l.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #2d2d2d;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  pointer-events: all;

  & > div {
    max-width: 600px;
  }

  img {
    width: 120px;
    height: auto;
    clip-path: none;
    margin: 0 auto;
  }

  h4 {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 10px 0 10px;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.03em;
  }

  a {
    display: inline-block;
    padding: 10px 0;
    color: #f33182;
    font-weight: 600;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      bottom: 4px;
      left: 0;
      width: 100%;
      height: 1px;
      background: #f33182;
      transform: scaleX(1) translateZ(0);
      transition: transform 0.3s ease;
    }

    @media all and (pointer: fine) {
      &:hover::before {
        transform: scaleX(0) translateZ(0);
      }
    }
  }
`, Ms = ({ topUser: e, logout: n }) => {
  const { t: i } = /* @__PURE__ */ x("office");
  return t("div", { style: { position: "fixed", inset: 0, backgroundColor: "#2d2d2d", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1 }, children: d("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "0 20px" }, children: [t("div", { style: { width: "130px" }, children: t(Kt, {}) }), e?.email ? d(T, { children: [t("p", { style: { padding: "0 0 5px" }, dangerouslySetInnerHTML: { __html: i("connected-as", { email: e?.email }) } }), t("div", { style: { pointerEvents: "all" }, children: t(et, { action: () => n(true), label: "connect-other-acc", tr: "office" }) })] }) : null] }) });
}, T4 = ({ workspace: e, user: n, accountType: i, isAdmin: o }) => {
  const s = e === "sougen" ? i >= 899 : i >= 100 && n?.active || o;
  return d(_4, { children: [t(j4, { children: t(q, { fallback: null, children: t(Rt, {}) }) }), s ? t(O4, { children: t(B, { label: "admin", arrow: false, tr: "office", cls: "white bluehvr", onClick: () => {
    window.open("/admin", "_blank");
  } }) }) : null] });
}, N4 = () => {
  const { t: e } = /* @__PURE__ */ x("office");
  return t(B4, { children: t(gt, { icon: "/icons/admin/eye.svg", title: e("no-office"), desc: e("no-office-desc") }) });
}, A4 = ({ workspace: e, logout: n }) => {
  const { t: i } = /* @__PURE__ */ x("office"), [o] = /* @__PURE__ */ S((s) => [s.allMicroverses]);
  if (!o)
    return t(Ms, {});
  if (o.length === 1)
    try {
      window.location.href = `/${o[0].docId || o[0].slug}`;
    } catch (s) {
      console.error(s);
    }
  const a = e === "sougen";
  return d(z4, { children: [d(F4, { children: [t("img", { src: M["/icons/admin/office.svg"], alt: "office" }), t("h2", { children: i(a ? "microverses" : "offices") }), t("div", {})] }), t(P4, { children: o.length > 0 ? o.map((s) => t("li", { children: t(ai, { data: s }) }, s.docId || s.slug)) : a ? null : t(N4, {}) })] });
}, E4 = ({ workspace: e, logout: n }) => {
  const i = /* @__PURE__ */ z((p) => p.usersById), o = /* @__PURE__ */ O((p) => p.user), a = i[o?.uid], s = a?.accountType || 10, r = /* @__PURE__ */ z((p) => p.isAdmin);
  return s >= 100 && a?.active || r ? d(D4, { children: [t(T4, { workspace: e, user: a, accountType: s, isAdmin: r }), t(A4, { workspace: e, logout: n })] }) : t(Ms, { topUser: a, accountType: s, logout: n });
}, D4 = l.div`
  position: fixed;
  inset: 0;
  background: #2d2d2d;
  overflow: auto;
  pointer-events: all;
  z-index: 999;
`, z4 = l.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 900px;
  margin: 0 auto;
  padding: 160px 30px 60px;

  @media all and (max-width: 767px) {
    padding: 100px 20px 60px;
  }
`, P4 = l.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 30px 20px;

  li {
    width: calc(33.333% - 14px);
    & > div {
      width: 100% !important;
      max-width: 100% !important;
    }
  }

  @media all and (max-width: 820px) {
    li {
      width: calc(50% - 10px);
    }
  }

  @media all and (max-width: 530px) {
    li {
      width: 100%;
    }
  }
`, _4 = l.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: ${(e) => e.theme.colors.highlight};
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  @media all and (max-width: 767px) {
    height: 60px;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
  }
  &::before {
    width: 400px;
    height: 150px;
    right: -100px;
    top: -40px;
    border-radius: 80px;
    background: linear-gradient(
      262.62deg,
      rgb(255, 231, 162) 2.11%,
      rgb(191, 65, 237) 95.96%
    );
    transform: rotate(12deg);
    animation: levitationSettings2 10.3s ease-in-out infinite alternate;
  }

  &::after {
    width: 500px;
    height: 200px;
    right: 20px;
    bottom: -260px;
    border-radius: 120px;
    background: linear-gradient(
      12deg,
      rgb(255, 61, 157) 22.11%,
      rgb(255, 226, 153) 95.96%
    );
    transform: rotate(42deg);
    animation: levitationSettings1 11s ease-in-out infinite alternate;
  }

  @media all and (max-width: 890px) {
    &::before {
      width: 200px;
      height: 100px;
      right: -100px;
      top: -60px;
      border-radius: 80px;
    }
    &::after {
      width: 300px;
      height: 150px;
      right: -100px;
      bottom: -180px;
      border-radius: 120px;
    }
  }
`, j4 = l.div`
  & > div {
    display: flex;
    gap: 34px;
    align-items: center;
    div {
      width: 100px;
      height: 100px;
      border-radius: 0;
      border: none;

      img {
        border-radius: 0;
        border: none;
      }
    }

    h2 {
      padding: 0;
    }
  }

  @media all and (max-width: 767px) {
    & > div {
      gap: 20px;
      div {
        width: 60px;
        height: 60px;
      }
    }

    h2 {
      font-size: 16px;
      line-height: 22px;
    }
  }
`, F4 = l.div`
  display: flex;
  align-items: center;
  gap: 15px;

  img {
    clip-path: none;
    min-width: 29px;
    width: 29px;
    height: auto;
  }

  h2 {
    color: #eeeeee;
    font-family: 'Mundial', Helvetica;
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 1.9px;
    line-height: 26px;
    white-space: nowrap;
    padding: 0 10px 0 0;
    text-transform: uppercase;
  }

  div {
    height: 1px;
    width: 100%;
    background: #fff;
    opacity: 0.1;
  }
`, O4 = l.div`
  display: flex;
  height: 100px;
  align-items: center;
  padding: 0 45px 0 0;
  position: relative;
  z-index: 2;
  button {
    min-width: auto;
  }

  @media all and (max-width: 767px) {
    padding: 0 20px 0 0;
    height: 60px;
  }
`, B4 = l.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  & > div {
    background: none;
    max-width: 520px;
    padding: 0;
  }
`, U4 = () => t(Ss, { leftPart: t(Cs, { visual: "/office/bg-browser-support.webp", children: t(R4, { className: "top-cntr-icn", children: t("img", { src: M["/office/browser-support.svg"], alt: "browser-support" }) }) }), rightPart: t(ks, { data: { icon: false, title: "browser-not-supported", desc: "browser-not-supported-desc", btn: "dl-chrome", action: () => {
  window.open("https://www.google.com/chrome/", "_blank");
}, subBtn: t("div", { children: t(et, { label: "need-help", action: () => {
  let e = "com";
  const n = ae().lang;
  n === "fr" ? e = "fr" : n === "ja" && (e = "jp"), window.open(`https://www.konpi.${e}/contact-us`, "_blank");
} }) }) } }) }), R4 = l.div`
  img {
    width: 198px;
    height: auto;
  }
`, H4 = ({ error: e }) => {
  const { t: n } = /* @__PURE__ */ x("office"), o = /* @__PURE__ */ ((a) => {
    switch (a) {
      case "auth/invalid-email":
        return "error-invalid-email";
      case "auth/expired-action-code":
        return "error-invalid-action-code";
      case "auth/invalid-action-code":
        return "error-invalid-action-code";
      default:
        return "error-undefined-email";
    }
  })(e);
  return d(W4, { children: [o ? t("p", { className: "secFontTxtSml", dangerouslySetInnerHTML: { __html: n(o) } }) : null, t("p", { className: "sml", dangerouslySetInnerHTML: { __html: n("error-email-signin", { error: e }) } })] });
}, W4 = l.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  max-width: 500px;

  a {
    text-decoration: underline;
    pointer-events: all;
  }

  .sml {
    font-size: 11px;
    opacity: 0.5;
  }

  @media all and (pointer: fine) {
    a {
      &:hover {
        opacity: 0.7;
      }
    }
  }
`, V4 = ({ data: e }) => t(q4, { className: "secFontTxtSml", href: `https://${e.id}.konpi.app`, children: e.id }), Z4 = () => {
  const e = /* @__PURE__ */ S((n) => n.allWorkspaces);
  return e?.length >= 1 ? t(G4, { children: e.map((n, i) => t(V4, { data: n }, i)) }) : null;
}, G4 = l.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
`, q4 = l.a`
  pointer-events: all;
  display: flex;
  border: 1px solid #fff;
  padding: 2px 15px;
  border-radius: 20px;
`;
export {
  x4 as ActivitiesSettings,
  Ea as AdminFeatures,
  k5 as AdminModule,
  $5 as BackgroundModal,
  Mb as BillingSettings,
  U4 as BrowserNotSupportedModal,
  Hn as CallGrid,
  En as CameraSettingsModal,
  $a as Chat,
  ti as CheckKeyboard,
  ba as DemoCTA,
  wa as DemoComp,
  H4 as EmailSigninError,
  Xn as EmojiChat,
  Gt as Emote,
  Ca as EventListeners,
  Er as GUEST_ACCESS,
  pl as GateModal,
  Cl as GuestModal,
  Cm as HUD,
  No as HelpToastManager,
  ni as HideStyleLoader,
  ji as ImportCSS,
  xn as InputText,
  Fn as InternetConnectionStatus,
  Dr as LOGIN_ACCESS,
  Bx as Loader,
  ra as LoginModal,
  Kt as Logo,
  Ev as ManageMembersSettings,
  E5 as MediaDeviceRequest,
  ei as Menu,
  ko as MenuShortcuts,
  Ao as MessageToast,
  Fi as NotificationsDispatcher,
  Ut as NotificationsToastManager,
  Dx as OfficeHUD,
  vv as OfficeSettings,
  M5 as Onboarding,
  R3 as OverviewSettings,
  zi as PASSWORD_ACCESS,
  Bn as PaintModal,
  qo as PaintTutorialMobile,
  vo as PortalButton,
  xa as PortalModal,
  Eo as PoweredBy,
  kv as PrivacySettings,
  Je as RadioSettings,
  On as RangeSettings,
  _i as Reset,
  ya as Reticle,
  ga as SPContainer,
  qn as SocialBar,
  De as SpinnerLoader,
  Xi as TutorialDesktop,
  $o as TutorialMobile,
  Zi as UI,
  Ba as URLSharingModal,
  Jn as UserModal,
  jn as VideoSourceScreenModal,
  M4 as WorkspaceDisabled,
  B5 as WorkspaceSettings,
  E4 as WorkspaceTop,
  I4 as WorkspaceUnavailable,
  Z4 as WorkspacesList,
  M as assets,
  zr as configKeyboard,
  lc as convertEmojiToUnicode,
  Sn as getEmojiById,
  ac as getEmojiByIdPromised,
  no as getEmojiByUnicode,
  Xt as getLocalStorageAndStaleStatus,
  be as getPlanByProductId,
  N as getStoreUI,
  je as setLocalStorage,
  C as setStoreUI,
  Pi as theme,
  yn as useCanControlStream,
  S as useStoreUI
};
